{
  "level": "mt08",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt08",
    "objects": "AREAS.E3:mt08.e3",
    "mesh": "TREES.E3:mt08.e3"
  },
  "spawn_point": {
    "position": [
      -222.8605725865654,
      -2221.51156116313,
      601.5
    ],
    "facing_rad": 0.0,
    "look_point": [
      -222.8605725865654,
      -2121.51156116313,
      601.5
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -437.0,
      -3014.869140625,
      577.5
    ],
    "bbox_max": [
      149.87228393554688,
      -1828.0,
      1342.4395751953125
    ],
    "vertex_count": 2564,
    "vertices": [
      [
        -230.9855194091797,
        -3014.869140625,
        707.4029541015625
      ],
      [
        -230.9855194091797,
        -3014.869140625,
        707.4029541015625
      ],
      [
        -230.6397247314453,
        -3014.8623046875,
        699.0181884765625
      ],
      [
        -270.7467041015625,
        -2996.92822265625,
        1342.4395751953125
      ],
      [
        -315.93524169921875,
        -2945.18115234375,
        1218.4539794921875
      ],
      [
        -315.93524169921875,
        -2945.18115234375,
        1218.4541015625
      ],
      [
        -327.83526611328125,
        -2930.564453125,
        1184.6998291015625
      ],
      [
        -327.83526611328125,
        -2930.564453125,
        1184.6998291015625
      ],
      [
        -345.41558837890625,
        -2877.887939453125,
        1100.168212890625
      ],
      [
        -345.41558837890625,
        -2877.887939453125,
        1100.168212890625
      ],
      [
        -356.36492919921875,
        -2850.83837890625,
        1053.942626953125
      ],
      [
        -356.36492919921875,
        -2850.83837890625,
        1053.942626953125
      ],
      [
        -409.263671875,
        -2829.429443359375,
        952.4835205078125
      ],
      [
        -314.7309265136719,
        -2645.003662109375,
        885.4474487304688
      ],
      [
        -326.8089904785156,
        -2632.289306640625,
        853.5537109375
      ],
      [
        -195.5,
        -2417.08935546875,
        780.0
      ],
      [
        -210.5,
        -2417.08935546875,
        780.0
      ],
      [
        -215.0,
        -2419.0,
        779.6654663085938
      ],
      [
        -214.77191162109375,
        -2419.0,
        780.0
      ],
      [
        -191.0,
        -2419.0,
        780.0
      ],
      [
        -195.04437255859375,
        -2419.0,
        775.6296997070312
      ],
      [
        -211.29266357421875,
        -2419.0,
        775.6296997070312
      ],
      [
        -215.0,
        -2424.0,
        780.0
      ],
      [
        -191.0,
        -2424.0,
        780.0
      ],
      [
        -197.0,
        -2419.71240234375,
        774.0
      ],
      [
        -209.5,
        -2419.71240234375,
        774.0
      ],
      [
        -191.0,
        -2419.0,
        779.4000244140625
      ],
      [
        -191.0,
        -2419.0,
        780.0
      ],
      [
        -191.0,
        -2424.0,
        780.0
      ],
      [
        -191.0,
        -2424.0,
        779.4000244140625
      ],
      [
        -215.0,
        -2424.0,
        779.4000244140625
      ],
      [
        -215.0,
        -2424.0,
        780.0
      ],
      [
        -215.0,
        -2419.300048828125,
        780.0
      ],
      [
        -215.0,
        -2419.0,
        779.6654663085938
      ],
      [
        -215.0,
        -2419.0,
        779.4000244140625
      ],
      [
        -197.0,
        -2419.71240234375,
        774.0
      ],
      [
        -195.04437255859375,
        -2419.0,
        775.6296997070312
      ],
      [
        -211.29266357421875,
        -2419.0,
        775.6296997070312
      ],
      [
        -209.5,
        -2419.71240234375,
        774.0
      ],
      [
        -193.0,
        -2461.5,
        797.0
      ],
      [
        -193.0,
        -2498.5,
        797.0
      ],
      [
        -193.0,
        -2419.0,
        800.1666870117188
      ],
      [
        -193.0,
        -2424.0,
        800.1666870117188
      ],
      [
        -191.0,
        -2419.0,
        797.0
      ],
      [
        -191.0,
        -2424.0,
        797.0
      ],
      [
        -191.0,
        -2424.0,
        797.0
      ],
      [
        -193.0,
        -2424.0,
        798.0555419921875
      ],
      [
        -193.0,
        -2424.0,
        797.0
      ],
      [
        -193.0,
        -2424.0,
        798.0555419921875
      ],
      [
        -193.0,
        -2424.0,
        798.5
      ],
      [
        -193.0,
        -2424.0,
        798.5
      ],
      [
        -193.0,
        -2424.0,
        800.1666870117188
      ],
      [
        -193.0,
        -2419.0,
        798.0555419921875
      ],
      [
        -191.0,
        -2419.0,
        797.0
      ],
      [
        -193.0,
        -2419.0,
        797.0
      ],
      [
        -193.0,
        -2419.0,
        798.5
      ],
      [
        -193.0,
        -2419.0,
        798.0555419921875
      ],
      [
        -193.0,
        -2419.0,
        798.5
      ],
      [
        -193.0,
        -2419.0,
        800.1666870117188
      ],
      [
        -193.0,
        -2424.0,
        780.0
      ],
      [
        -193.0,
        -2419.0,
        780.0
      ],
      [
        -219.5,
        -2485.113037109375,
        804.0
      ],
      [
        -214.0,
        -2496.06201171875,
        797.0
      ],
      [
        -226.5,
        -2495.68896484375,
        797.0
      ],
      [
        -214.0,
        -2496.06201171875,
        797.0
      ],
      [
        -218.74610900878906,
        -2508.24609375,
        789.0
      ],
      [
        -219.26951599121094,
        -2508.23046875,
        789.0
      ],
      [
        -210.2396697998047,
        -2508.5,
        789.0
      ],
      [
        -218.74610900878906,
        -2508.24609375,
        789.0
      ],
      [
        -204.0,
        -2496.3603515625,
        797.0
      ],
      [
        -193.0,
        -2496.68896484375,
        797.0
      ],
      [
        -194.5,
        -2500.603271484375,
        794.362060546875
      ],
      [
        -194.5,
        -2500.603271484375,
        794.0
      ],
      [
        -193.84786987304688,
        -2499.90625,
        794.0
      ],
      [
        -193.0,
        -2499.0,
        794.0
      ],
      [
        -193.84786987304688,
        -2499.90625,
        794.0
      ],
      [
        -194.5,
        -2500.603271484375,
        794.362060546875
      ],
      [
        -194.5,
        -2499.479248046875,
        795.1597900390625
      ],
      [
        -194.5,
        -2500.408935546875,
        794.5
      ],
      [
        -197.40908813476562,
        -2500.408935546875,
        794.5
      ],
      [
        -225.74203491210938,
        -2498.717041015625,
        794.5
      ],
      [
        -224.8181915283203,
        -2499.591064453125,
        794.5
      ],
      [
        -226.5,
        -2498.0,
        794.5
      ],
      [
        -225.74203491210938,
        -2498.717041015625,
        794.5
      ],
      [
        -224.60009765625,
        -2494.0,
        795.4999389648438
      ],
      [
        -225.0000457763672,
        -2494.0,
        794.5
      ],
      [
        -225.0000457763672,
        -2496.5,
        794.5
      ],
      [
        -194.89990234375,
        -2496.5,
        794.5
      ],
      [
        -194.89990234375,
        -2498.5,
        794.5
      ],
      [
        -194.89990234375,
        -2496.5,
        794.5
      ],
      [
        -194.5,
        -2496.5,
        794.5
      ],
      [
        -194.97727966308594,
        -2501.113525390625,
        794.0
      ],
      [
        -199.61363220214844,
        -2501.113525390625,
        794.0
      ],
      [
        -225.36305236816406,
        -2499.075439453125,
        794.0
      ],
      [
        -223.97727966308594,
        -2500.386474609375,
        794.0
      ],
      [
        -226.5,
        -2498.0,
        794.0
      ],
      [
        -225.36305236816406,
        -2499.075439453125,
        794.0
      ],
      [
        -225.20004272460938,
        -2494.0,
        794.0
      ],
      [
        -225.20004272460938,
        -2496.5,
        794.0
      ],
      [
        -194.97727966308594,
        -2501.113525390625,
        794.0
      ],
      [
        -194.89990234375,
        -2496.5,
        794.0
      ],
      [
        -194.89990234375,
        -2498.5,
        794.0
      ],
      [
        -194.89990234375,
        -2496.5,
        794.0
      ],
      [
        -225.0000457763672,
        -2493.10009765625,
        794.5
      ],
      [
        -226.5,
        -2493.10009765625,
        794.5
      ],
      [
        -225.0000457763672,
        -2493.10009765625,
        794.5
      ],
      [
        -225.0000457763672,
        -2494.0,
        794.5
      ],
      [
        -225.20004272460938,
        -2493.10009765625,
        794.0
      ],
      [
        -226.5,
        -2493.10009765625,
        794.0
      ],
      [
        -225.20004272460938,
        -2493.10009765625,
        794.0
      ],
      [
        -198.67579650878906,
        -2508.15869140625,
        789.0
      ],
      [
        -199.2437286376953,
        -2508.15869140625,
        789.0
      ],
      [
        -218.65879821777344,
        -2508.15869140625,
        789.0
      ],
      [
        -219.3412322998047,
        -2508.15869140625,
        789.0
      ],
      [
        -199.2437286376953,
        -2508.15869140625,
        789.0
      ],
      [
        -218.65879821777344,
        -2508.15869140625,
        789.0
      ],
      [
        -197.33750915527344,
        -2506.75,
        782.5
      ],
      [
        -220.75,
        -2506.75,
        782.5
      ],
      [
        -197.33753967285156,
        -2506.75,
        789.0
      ],
      [
        -220.7499542236328,
        -2506.75,
        789.0
      ],
      [
        -225.2498321533203,
        -2499.1826171875,
        780.0
      ],
      [
        -225.2498321533203,
        -2499.1826171875,
        792.0631103515625
      ],
      [
        -222.5,
        -2437.0,
        788.7403564453125
      ],
      [
        -218.6526336669922,
        -2437.0,
        794.3829956054688
      ],
      [
        -218.6526336669922,
        -2437.0,
        794.3829956054688
      ],
      [
        -217.8910675048828,
        -2437.0,
        795.5
      ],
      [
        -210.5,
        -2429.07373046875,
        797.5
      ],
      [
        -210.5,
        -2424.0,
        791.8414916992188
      ],
      [
        -210.5,
        -2419.0,
        786.2654418945312
      ],
      [
        -210.5,
        -2415.8740234375,
        782.7793579101562
      ],
      [
        -210.5,
        -2417.08935546875,
        780.0
      ],
      [
        -210.5,
        -2424.0,
        791.841552734375
      ],
      [
        -215.0,
        -2424.0,
        785.2416381835938
      ],
      [
        -210.5,
        -2419.0,
        786.2654418945312
      ],
      [
        -215.0,
        -2424.0,
        785.2416381835938
      ],
      [
        -206.64186096191406,
        -2424.0,
        797.5
      ],
      [
        -205.9599609375,
        -2424.0,
        798.5
      ],
      [
        -205.9599609375,
        -2424.0,
        798.5
      ],
      [
        -202.55084228515625,
        -2424.0,
        803.5
      ],
      [
        -206.6417999267578,
        -2424.0,
        797.5
      ],
      [
        -210.5,
        -2429.07373046875,
        797.5
      ],
      [
        -210.5,
        -2428.0,
        796.3027954101562
      ],
      [
        -209.6836700439453,
        -2428.0,
        797.5
      ],
      [
        -202.15794372558594,
        -2419.0,
        798.5
      ],
      [
        -202.83982849121094,
        -2419.0,
        797.5
      ],
      [
        -202.15794372558594,
        -2419.0,
        798.5
      ],
      [
        -198.748779296875,
        -2419.0,
        803.5
      ],
      [
        -195.5,
        -2417.08935546875,
        780.0
      ],
      [
        -195.5,
        -2409.43798828125,
        797.5
      ],
      [
        -195.5,
        -2409.43798828125,
        797.5
      ],
      [
        -195.5688934326172,
        -2409.43798828125,
        797.5
      ],
      [
        -202.83982849121094,
        -2419.0,
        797.5
      ],
      [
        -199.7275848388672,
        -2414.5,
        797.0459594726562
      ],
      [
        -199.41799926757812,
        -2414.5,
        797.5
      ],
      [
        -197.0,
        -2411.6240234375,
        792.5
      ],
      [
        -197.85647583007812,
        -2411.0,
        793.927490234375
      ],
      [
        -198.48182678222656,
        -2411.0,
        794.9697265625
      ],
      [
        -199.7275848388672,
        -2414.5,
        797.0459594726562
      ],
      [
        -196.75656127929688,
        -2411.0,
        797.5
      ],
      [
        -198.48182678222656,
        -2411.0,
        794.9697265625
      ],
      [
        -197.85647583007812,
        -2411.0,
        793.927490234375
      ],
      [
        -195.5,
        -2411.0,
        793.9273681640625
      ],
      [
        -197.0,
        -2411.6240234375,
        792.5
      ],
      [
        -195.5,
        -2411.6240234375,
        792.5
      ],
      [
        -198.748779296875,
        -2419.0,
        803.5
      ],
      [
        -202.55084228515625,
        -2424.0,
        803.5
      ],
      [
        -222.5,
        -2443.06103515625,
        795.5
      ],
      [
        -220.090087890625,
        -2439.891845703125,
        795.5
      ],
      [
        -217.8910675048828,
        -2437.0,
        795.5
      ],
      [
        -220.090087890625,
        -2439.891845703125,
        795.5
      ],
      [
        -217.49688720703125,
        -2445.0,
        805.0
      ],
      [
        -223.4630584716797,
        -2445.0,
        796.25
      ],
      [
        -220.0,
        -2440.0,
        795.752685546875
      ],
      [
        -219.660888671875,
        -2440.0,
        796.25
      ],
      [
        -219.660888671875,
        -2440.0,
        796.25
      ],
      [
        -215.0,
        -2440.0,
        803.0858154296875
      ],
      [
        -220.0,
        -2440.446044921875,
        796.25
      ],
      [
        -220.0,
        -2440.0,
        795.752685546875
      ],
      [
        -217.49688720703125,
        -2445.0,
        805.0
      ],
      [
        -215.0,
        -2441.71630859375,
        805.0
      ],
      [
        -222.5,
        -2443.06103515625,
        795.5
      ],
      [
        -222.5,
        -2437.0,
        788.7403564453125
      ],
      [
        -100.87622833251953,
        -2129.135498046875,
        623.77197265625
      ],
      [
        -68.70887756347656,
        -2083.657958984375,
        620.230712890625
      ],
      [
        -100.876220703125,
        -2129.135498046875,
        623.77197265625
      ],
      [
        -101.89482116699219,
        -2130.56005859375,
        623.8667602539062
      ],
      [
        -63.337127685546875,
        -2075.657958984375,
        619.1871337890625
      ],
      [
        -68.70887756347656,
        -2083.657958984375,
        620.230712890625
      ],
      [
        -195.5,
        -2371.5,
        628.93701171875
      ],
      [
        -195.5,
        -2360.5,
        629.30078125
      ],
      [
        -198.0314483642578,
        -2360.5,
        590.0
      ],
      [
        -198.0314483642578,
        -2360.5,
        577.5
      ],
      [
        -195.5,
        -2360.5,
        629.30078125
      ],
      [
        -198.0314483642578,
        -2360.5,
        590.0
      ],
      [
        -198.0314483642578,
        -2360.5,
        629.6533813476562
      ],
      [
        -198.0314483642578,
        -2371.5,
        588.9151000976562
      ],
      [
        -198.0314483642578,
        -2371.5,
        577.5
      ],
      [
        -198.0314483642578,
        -2371.5,
        590.0
      ],
      [
        -198.0314483642578,
        -2371.5,
        588.9151000976562
      ],
      [
        -198.0314483642578,
        -2371.5,
        590.0
      ],
      [
        -195.5,
        -2371.5,
        628.93701171875
      ],
      [
        -198.0314483642578,
        -2371.5,
        629.2896118164062
      ],
      [
        -210.5,
        -2360.5,
        589.5012817382812
      ],
      [
        -210.5,
        -2371.5,
        589.5012817382812
      ],
      [
        -210.5,
        -2360.5,
        631.3900146484375
      ],
      [
        -210.5,
        -2371.5,
        631.0262451171875
      ],
      [
        -198.0314483642578,
        -2360.5,
        589.5012817382812
      ],
      [
        -210.5,
        -2360.5,
        589.5012817382812
      ],
      [
        -210.5,
        -2360.5,
        631.3900146484375
      ],
      [
        -209.33631896972656,
        -2371.5,
        589.5012817382812
      ],
      [
        -210.5,
        -2371.5,
        589.5012817382812
      ],
      [
        -209.33631896972656,
        -2371.5,
        589.5012817382812
      ],
      [
        -198.0314483642578,
        -2371.5,
        589.5012817382812
      ],
      [
        -210.5,
        -2371.5,
        631.0262451171875
      ],
      [
        -208.0314483642578,
        -2360.5,
        577.5
      ],
      [
        -208.0314483642578,
        -2360.5,
        589.5012817382812
      ],
      [
        -208.0314483642578,
        -2371.5,
        588.9420776367188
      ],
      [
        -208.0314483642578,
        -2371.5,
        577.5
      ],
      [
        -208.0314483642578,
        -2371.5,
        588.9420776367188
      ],
      [
        -208.0314483642578,
        -2371.5,
        589.5012817382812
      ],
      [
        149.87228393554688,
        -2063.799072265625,
        590.357177734375
      ],
      [
        -63.337120056152344,
        -2075.657958984375,
        619.1871337890625
      ],
      [
        -62.87744140625,
        -2075.41357421875,
        619.5888061523438
      ],
      [
        149.87228393554688,
        -2063.799072265625,
        590.357177734375
      ],
      [
        27.273828506469727,
        -2132.59033203125,
        605.9542846679688
      ],
      [
        -245.0,
        -2331.42626953125,
        638.0
      ],
      [
        -245.05609130859375,
        -2331.5,
        638.0
      ],
      [
        -233.64976501464844,
        -2316.5,
        638.0
      ],
      [
        -230.79248046875,
        -2316.5,
        638.0
      ],
      [
        -232.6060028076172,
        -2329.0,
        638.0
      ],
      [
        -243.15501403808594,
        -2329.0,
        638.0
      ],
      [
        -195.5,
        -2360.5,
        632.2279663085938
      ],
      [
        -210.5,
        -2360.5,
        634.305419921875
      ],
      [
        26.906936645507812,
        -2132.77880859375,
        606.0013427734375
      ],
      [
        26.063034057617188,
        -2132.764404296875,
        606.1185302734375
      ],
      [
        26.906936645507812,
        -2132.77880859375,
        606.0013427734375
      ],
      [
        27.273826599121094,
        -2132.59033203125,
        605.9542846679688
      ],
      [
        -210.5,
        -2371.5,
        634.0844116210938
      ],
      [
        -195.5,
        -2371.5,
        632.0069580078125
      ],
      [
        -195.5,
        -2371.5,
        632.0069580078125
      ],
      [
        -195.5,
        -2360.5,
        632.2279663085938
      ],
      [
        -210.5,
        -2360.5,
        634.305419921875
      ],
      [
        -210.5,
        -2371.5,
        634.0844116210938
      ],
      [
        -243.15501403808594,
        -2329.0,
        638.0
      ],
      [
        -232.6060028076172,
        -2329.0,
        638.0
      ],
      [
        -242.95896911621094,
        -2330.009765625,
        639.41357421875
      ],
      [
        -245.0,
        -2331.5,
        638.082275390625
      ],
      [
        -245.0,
        -2331.42626953125,
        638.0
      ],
      [
        -245.05609130859375,
        -2331.5,
        638.0
      ],
      [
        -245.0,
        -2331.5,
        638.082275390625
      ],
      [
        -230.79248046875,
        -2316.5,
        638.0
      ],
      [
        -233.64976501464844,
        -2316.5,
        638.0
      ],
      [
        -233.2301788330078,
        -2316.25537109375,
        638.342529296875
      ],
      [
        -101.89482116699219,
        -2130.56005859375,
        623.8667602539062
      ],
      [
        -101.90265655517578,
        -2130.586669921875,
        623.885009765625
      ],
      [
        -51.790863037109375,
        -2069.520751953125,
        629.2767333984375
      ],
      [
        -51.79084777832031,
        -2069.520751953125,
        629.2767333984375
      ],
      [
        -10.330429077148438,
        -2037.8157958984375,
        654.72509765625
      ],
      [
        -10.330429077148438,
        -2037.8157958984375,
        654.72509765625
      ],
      [
        21.569732666015625,
        -2010.56591796875,
        671.1203002929688
      ],
      [
        21.569725036621094,
        -2010.56591796875,
        671.1203002929688
      ],
      [
        29.802236557006836,
        -2007.1263427734375,
        679.3583374023438
      ],
      [
        59.157798767089844,
        -1994.8612060546875,
        708.733642578125
      ],
      [
        59.157798767089844,
        -1994.8612060546875,
        708.733642578125
      ],
      [
        62.469017028808594,
        -1997.8653564453125,
        716.9403686523438
      ],
      [
        79.27383422851562,
        -2011.9405517578125,
        718.1834716796875
      ],
      [
        79.27383422851562,
        -2011.9405517578125,
        718.1834716796875
      ],
      [
        62.469017028808594,
        -1997.8653564453125,
        716.9403686523438
      ],
      [
        64.07967376708984,
        -2000.97314453125,
        722.7684936523438
      ],
      [
        71.77665710449219,
        -2008.5992431640625,
        727.1661987304688
      ],
      [
        71.77666473388672,
        -2008.5992431640625,
        727.1661987304688
      ],
      [
        64.07967376708984,
        -2000.97314453125,
        722.7684936523438
      ],
      [
        65.21472930908203,
        -2007.3287353515625,
        731.521240234375
      ],
      [
        -56.1781005859375,
        -2191.024658203125,
        758.349365234375
      ],
      [
        -14.74359130859375,
        -2191.132080078125,
        819.2384033203125
      ],
      [
        -84.91627502441406,
        -2180.041748046875,
        626.0
      ],
      [
        -82.51862335205078,
        -2179.62158203125,
        626.0
      ],
      [
        -82.51862335205078,
        -2179.62158203125,
        626.0
      ],
      [
        -80.0,
        -2179.179931640625,
        626.0
      ],
      [
        -84.91627502441406,
        -2180.041748046875,
        626.0
      ],
      [
        -98.93994903564453,
        -2182.5,
        626.0
      ],
      [
        -98.0,
        -2182.7587890625,
        629.5
      ],
      [
        -97.24935150146484,
        -2182.5,
        628.4490966796875
      ],
      [
        -100.5,
        -2229.0,
        633.0
      ],
      [
        -100.5,
        -2229.0,
        633.0
      ],
      [
        -100.5,
        -2215.0,
        633.0
      ],
      [
        -100.5,
        -2215.0,
        633.0
      ],
      [
        -98.93990325927734,
        -2182.5,
        626.0
      ],
      [
        -97.24935150146484,
        -2182.5,
        628.4490966796875
      ],
      [
        -98.0,
        -2183.121826171875,
        632.5
      ],
      [
        -98.0,
        -2182.7587890625,
        629.5
      ],
      [
        -100.5,
        -2215.0,
        638.0
      ],
      [
        -100.5,
        -2219.0,
        638.0
      ],
      [
        -100.5,
        -2219.0,
        638.0
      ],
      [
        -98.0,
        -2239.0,
        638.0
      ],
      [
        -98.0,
        -2222.0,
        629.5
      ],
      [
        -98.0,
        -2215.0,
        636.0
      ],
      [
        -98.0,
        -2215.0,
        636.0
      ],
      [
        -100.5,
        -2215.0,
        638.0
      ],
      [
        -98.0,
        -2215.0,
        638.0
      ],
      [
        -95.5,
        -2183.107421875,
        636.0
      ],
      [
        -98.0,
        -2183.121826171875,
        632.5
      ],
      [
        -95.5,
        -2235.0,
        636.0
      ],
      [
        -98.0,
        -2228.0,
        632.5
      ],
      [
        -94.07142639160156,
        -2239.0,
        638.0
      ],
      [
        -95.5,
        -2235.0,
        636.0
      ],
      [
        -95.5,
        -2215.0,
        636.0
      ],
      [
        -94.07142639160156,
        -2215.0,
        638.0
      ],
      [
        -92.03517150878906,
        -2182.5,
        636.0
      ],
      [
        -95.5,
        -2183.107421875,
        636.0
      ],
      [
        -78.0,
        -2219.0,
        638.0
      ],
      [
        -78.0,
        -2215.0,
        638.0
      ],
      [
        -78.0,
        -2219.0,
        638.0
      ],
      [
        -78.0,
        -2235.0,
        636.0
      ],
      [
        -78.0,
        -2215.0,
        638.0
      ],
      [
        -80.31578826904297,
        -2182.5,
        636.0
      ],
      [
        -80.21052551269531,
        -2182.5,
        638.0
      ],
      [
        -82.0,
        -2182.5,
        638.0
      ],
      [
        -80.0,
        -2182.5,
        636.0
      ],
      [
        -80.0,
        -2182.5,
        638.0
      ],
      [
        -80.21052551269531,
        -2182.5,
        638.0
      ],
      [
        -80.31578826904297,
        -2182.5,
        636.0
      ],
      [
        -82.0,
        -2182.5,
        638.0
      ],
      [
        -90.65372467041016,
        -2182.5,
        638.0
      ],
      [
        -92.03466033935547,
        -2182.5,
        636.0
      ],
      [
        -80.0,
        -2182.5,
        638.0
      ],
      [
        -80.0,
        -2182.5,
        636.0
      ],
      [
        -80.0,
        -2180.390380859375,
        636.0
      ],
      [
        -80.0,
        -2180.632568359375,
        638.0
      ],
      [
        -83.0,
        -2235.0,
        636.0
      ],
      [
        -78.0,
        -2235.0,
        636.0
      ],
      [
        -83.0,
        -2235.0,
        636.0
      ],
      [
        -78.0,
        -2215.0,
        629.0
      ],
      [
        -78.0,
        -2221.0,
        629.0
      ],
      [
        -78.0,
        -2221.0,
        629.0
      ],
      [
        -78.0,
        -2215.0,
        629.0
      ],
      [
        -80.0,
        -2182.5,
        631.7999877929688
      ],
      [
        -80.0,
        -2179.882080078125,
        631.7999877929688
      ],
      [
        -80.0,
        -2182.5,
        631.7999877929688
      ],
      [
        -80.5,
        -2215.0,
        626.0
      ],
      [
        -80.5,
        -2228.0,
        632.5
      ],
      [
        -80.5,
        -2182.5,
        626.0
      ],
      [
        -80.5,
        -2215.0,
        626.0
      ],
      [
        -80.0,
        -2179.179931640625,
        626.0
      ],
      [
        -80.5,
        -2222.0,
        629.4999389648438
      ],
      [
        -242.6696014404297,
        -2331.5,
        641.5
      ],
      [
        -240.62411499023438,
        -2331.5,
        644.5
      ],
      [
        -205.92559814453125,
        -2371.5,
        740.0
      ],
      [
        -195.5,
        -2371.5,
        755.2904663085938
      ],
      [
        -205.925537109375,
        -2371.5,
        740.0
      ],
      [
        -210.5,
        -2371.5,
        733.2909545898438
      ],
      [
        -191.0,
        -2402.0,
        795.9053955078125
      ],
      [
        -191.0,
        -2404.326416015625,
        798.5
      ],
      [
        -191.0,
        -2386.841552734375,
        779.0
      ],
      [
        -191.0,
        -2390.0,
        782.5226440429688
      ],
      [
        -193.3961639404297,
        -2407.0,
        797.967529296875
      ],
      [
        -195.5,
        -2407.0,
        794.8819580078125
      ],
      [
        -193.3961639404297,
        -2407.0,
        797.967529296875
      ],
      [
        -193.03309631347656,
        -2407.0,
        798.5
      ],
      [
        -205.64712524414062,
        -2407.0,
        780.0
      ],
      [
        -206.3289031982422,
        -2407.0,
        779.0
      ],
      [
        -193.03309631347656,
        -2407.0,
        798.5
      ],
      [
        -192.29644775390625,
        -2407.0,
        799.5803833007812
      ],
      [
        -206.3289031982422,
        -2407.0,
        779.0
      ],
      [
        -209.64697265625,
        -2407.0,
        774.1336059570312
      ],
      [
        -210.5,
        -2413.382080078125,
        780.0
      ],
      [
        -205.64706420898438,
        -2407.0,
        780.0
      ],
      [
        -195.5,
        -2407.0,
        794.8819580078125
      ],
      [
        -195.5,
        -2409.347412109375,
        797.5
      ],
      [
        -210.5,
        -2413.3818359375,
        780.0
      ],
      [
        -195.5,
        -2409.347412109375,
        797.5
      ],
      [
        -195.5,
        -2402.0,
        789.3055419921875
      ],
      [
        -191.0,
        -2402.0,
        795.9053955078125
      ],
      [
        -202.52679443359375,
        -2402.0,
        779.0
      ],
      [
        -201.84490966796875,
        -2402.0,
        780.0
      ],
      [
        -202.52679443359375,
        -2402.0,
        779.0
      ],
      [
        -205.9358673095703,
        -2402.0,
        774.0
      ],
      [
        -191.0,
        -2386.841552734375,
        779.0
      ],
      [
        -196.56219482421875,
        -2390.0,
        774.3648681640625
      ],
      [
        -195.5,
        -2393.656005859375,
        780.0
      ],
      [
        -195.5,
        -2402.0,
        789.3055419921875
      ],
      [
        -193.0858154296875,
        -2390.0,
        779.4635009765625
      ],
      [
        -191.0,
        -2390.0,
        782.5226440429688
      ],
      [
        -193.40188598632812,
        -2390.0,
        779.0
      ],
      [
        -193.0858154296875,
        -2390.0,
        779.4635009765625
      ],
      [
        -193.40188598632812,
        -2390.0,
        779.0
      ],
      [
        -195.5,
        -2390.0,
        775.9227294921875
      ],
      [
        -195.5,
        -2390.0,
        775.25
      ],
      [
        -195.5,
        -2393.656005859375,
        780.0
      ],
      [
        -201.84490966796875,
        -2402.0,
        780.0
      ],
      [
        -196.56219482421875,
        -2390.0,
        774.3648681640625
      ],
      [
        -209.5,
        -2406.68701171875,
        774.0
      ],
      [
        -205.9358673095703,
        -2402.0,
        774.0
      ],
      [
        -202.2539825439453,
        -2402.0,
        779.4000244140625
      ],
      [
        -206.0561981201172,
        -2407.0,
        779.4000244140625
      ],
      [
        -205.64712524414062,
        -2407.0,
        780.0
      ],
      [
        -201.84490966796875,
        -2402.0,
        780.0
      ],
      [
        -191.0,
        -2404.326416015625,
        798.5
      ],
      [
        -192.29644775390625,
        -2407.0,
        799.5803833007812
      ],
      [
        -209.5,
        -2406.68701171875,
        774.0
      ],
      [
        -209.64697265625,
        -2407.0,
        774.1336059570312
      ],
      [
        -210.5,
        -2360.5,
        721.0234985351562
      ],
      [
        -197.56109619140625,
        -2360.5,
        740.0
      ],
      [
        -195.5,
        -2360.5,
        743.0228881835938
      ],
      [
        -197.5611114501953,
        -2360.5,
        740.0
      ],
      [
        -195.5,
        -2360.5,
        743.0228881835938
      ],
      [
        -195.5,
        -2371.5,
        755.2904663085938
      ],
      [
        -210.5,
        -2371.5,
        733.2910766601562
      ],
      [
        -210.5,
        -2360.5,
        721.0234985351562
      ],
      [
        -166.0,
        -2331.5,
        638.0
      ],
      [
        -166.0,
        -2331.5,
        648.0
      ],
      [
        -171.0,
        -2331.5,
        638.0
      ],
      [
        -171.0,
        -2331.5,
        648.0
      ],
      [
        -166.0,
        -2331.5,
        648.0
      ],
      [
        -171.0,
        -2331.5,
        648.0
      ],
      [
        -154.19993591308594,
        -2352.0,
        642.1799926757812
      ],
      [
        -152.60008239746094,
        -2350.800048828125,
        642.5
      ],
      [
        -154.19993591308594,
        -2350.800048828125,
        642.1799926757812
      ],
      [
        -154.19993591308594,
        -2351.2001953125,
        642.1799926757812
      ],
      [
        -153.80003356933594,
        -2351.2001953125,
        642.260009765625
      ],
      [
        -153.80003356933594,
        -2351.2001953125,
        642.260009765625
      ],
      [
        -153.80003356933594,
        -2350.800048828125,
        642.260009765625
      ],
      [
        -153.39988708496094,
        -2350.800048828125,
        641.5
      ],
      [
        -154.19993591308594,
        -2351.60009765625,
        641.5
      ],
      [
        -154.10006713867188,
        -2351.2001953125,
        642.199951171875
      ],
      [
        -154.19993591308594,
        -2350.0,
        642.1799926757812
      ],
      [
        -154.19993591308594,
        -2350.400146484375,
        641.5
      ],
      [
        -199.0,
        -2371.5,
        638.0
      ],
      [
        -199.0,
        -2371.5,
        651.0
      ],
      [
        -199.0,
        -2360.5,
        651.0
      ],
      [
        -177.0,
        -2331.5,
        638.0
      ],
      [
        -177.0,
        -2331.5,
        648.0
      ],
      [
        -182.0,
        -2331.5,
        638.0
      ],
      [
        -182.0,
        -2331.5,
        648.0
      ],
      [
        -177.0,
        -2331.5,
        648.0
      ],
      [
        -182.0,
        -2331.5,
        648.0
      ],
      [
        -194.80006408691406,
        -2351.2001953125,
        642.1799926757812
      ],
      [
        -194.80006408691406,
        -2350.800048828125,
        642.1799926757812
      ],
      [
        -194.80006408691406,
        -2350.800048828125,
        642.1799926757812
      ],
      [
        -195.19996643066406,
        -2350.800048828125,
        642.260009765625
      ],
      [
        -194.80006408691406,
        -2351.079833984375,
        642.1799926757812
      ],
      [
        -207.0,
        -2371.5,
        638.0
      ],
      [
        -207.0,
        -2371.5,
        651.0
      ],
      [
        -207.0,
        -2360.5,
        651.0
      ],
      [
        -199.0,
        -2371.5,
        649.0
      ],
      [
        -207.0,
        -2371.5,
        649.0
      ],
      [
        -242.6696014404297,
        -2331.5,
        641.5
      ],
      [
        -80.0,
        -2182.5,
        651.0
      ],
      [
        -80.0,
        -2182.5,
        653.428466796875
      ],
      [
        -81.67677307128906,
        -2182.5,
        651.0
      ],
      [
        -80.0,
        -2182.5,
        653.4286499023438
      ],
      [
        -80.0,
        -2182.5,
        651.0
      ],
      [
        -80.0,
        -2182.2060546875,
        651.0
      ],
      [
        -236.33673095703125,
        -2329.0,
        648.0
      ],
      [
        -240.62411499023438,
        -2331.5,
        644.5
      ],
      [
        -197.0,
        -2328.285888671875,
        649.0
      ],
      [
        -209.0,
        -2328.285888671875,
        649.0
      ],
      [
        -197.0,
        -2328.285888671875,
        649.0
      ],
      [
        -209.0,
        -2328.285888671875,
        649.0
      ],
      [
        -87.891845703125,
        -2182.5,
        642.0
      ],
      [
        -87.8909683227539,
        -2182.5,
        642.0
      ],
      [
        -80.0,
        -2181.11669921875,
        642.0
      ],
      [
        -80.0,
        -2181.11669921875,
        642.0
      ],
      [
        -78.0,
        -2239.0,
        639.9872436523438
      ],
      [
        -78.0,
        -2231.863525390625,
        638.0
      ],
      [
        -79.4195327758789,
        -2239.0,
        638.0
      ],
      [
        -78.70974731445312,
        -2239.0,
        638.99365234375
      ],
      [
        -78.0,
        -2239.0,
        639.9872436523438
      ],
      [
        -78.70974731445312,
        -2239.0,
        638.99365234375
      ],
      [
        -79.41975402832031,
        -2239.0,
        648.0
      ],
      [
        -78.0,
        -2231.862060546875,
        648.0
      ],
      [
        -78.0,
        -2231.862060546875,
        648.0
      ],
      [
        -78.0,
        -2236.44677734375,
        646.723388671875
      ],
      [
        -78.0,
        -2236.44677734375,
        646.723388671875
      ],
      [
        -78.0,
        -2239.0,
        646.012451171875
      ],
      [
        -78.7098617553711,
        -2239.0,
        647.0061645507812
      ],
      [
        -79.41976928710938,
        -2239.0,
        648.0
      ],
      [
        -78.0,
        -2239.0,
        646.012451171875
      ],
      [
        -78.7098617553711,
        -2239.0,
        647.0061645507812
      ],
      [
        -236.33665466308594,
        -2329.0,
        648.0
      ],
      [
        -226.8314208984375,
        -2316.5,
        648.0
      ],
      [
        -199.0,
        -2314.0,
        648.0
      ],
      [
        -207.0,
        -2314.0,
        648.0
      ],
      [
        -199.0,
        -2314.0,
        648.0
      ],
      [
        -207.0,
        -2314.0,
        648.0
      ],
      [
        -197.0,
        -2314.0,
        641.5
      ],
      [
        -229.36236572265625,
        -2314.0,
        641.5
      ],
      [
        -197.0,
        -2314.0,
        641.5
      ],
      [
        -197.0,
        -2314.0,
        644.5
      ],
      [
        -227.31687927246094,
        -2314.0,
        644.5
      ],
      [
        -229.36236572265625,
        -2314.0,
        641.5
      ],
      [
        -197.0,
        -2314.0,
        644.5
      ],
      [
        -226.8314208984375,
        -2316.5,
        648.0
      ],
      [
        -227.31687927246094,
        -2314.0,
        644.5
      ],
      [
        -175.0,
        -2329.0,
        648.0
      ],
      [
        -173.0,
        -2329.0,
        648.0
      ],
      [
        -173.0,
        -2316.5,
        648.0
      ],
      [
        -175.0,
        -2316.5,
        648.0
      ],
      [
        -175.0,
        -2316.5,
        648.0
      ],
      [
        -173.0,
        -2316.5,
        648.0
      ],
      [
        -173.0,
        -2314.0,
        644.5
      ],
      [
        -175.0,
        -2314.0,
        644.5
      ],
      [
        -173.0,
        -2316.5,
        638.0
      ],
      [
        -175.0,
        -2316.5,
        638.0
      ],
      [
        -175.0,
        -2314.0,
        641.5
      ],
      [
        -173.0,
        -2314.0,
        641.5
      ],
      [
        -173.0,
        -2314.0,
        641.5
      ],
      [
        -175.0,
        -2314.0,
        641.5
      ],
      [
        -175.0,
        -2314.0,
        644.5
      ],
      [
        -173.0,
        -2314.0,
        644.5
      ],
      [
        -177.0,
        -2312.0,
        641.7000732421875
      ],
      [
        -182.0,
        -2312.0,
        641.7000732421875
      ],
      [
        -177.0,
        -2312.928466796875,
        642.9998779296875
      ],
      [
        -182.0,
        -2312.928466796875,
        642.9998779296875
      ],
      [
        -194.80006408691406,
        -2294.5,
        642.1799926757812
      ],
      [
        -196.39991760253906,
        -2295.699951171875,
        642.5
      ],
      [
        -194.80006408691406,
        -2295.699951171875,
        642.1799926757812
      ],
      [
        -194.80006408691406,
        -2295.2998046875,
        642.1799926757812
      ],
      [
        -195.19996643066406,
        -2295.2998046875,
        642.260009765625
      ],
      [
        -195.19996643066406,
        -2295.699951171875,
        642.260009765625
      ],
      [
        -195.19996643066406,
        -2295.2998046875,
        642.260009765625
      ],
      [
        -195.60011291503906,
        -2295.699951171875,
        641.5
      ],
      [
        -194.80006408691406,
        -2294.89990234375,
        641.5
      ],
      [
        -194.89996337890625,
        -2295.2998046875,
        642.2000122070312
      ],
      [
        -194.80006408691406,
        -2296.5,
        642.1799926757812
      ],
      [
        -194.80006408691406,
        -2296.099853515625,
        641.5
      ],
      [
        -152.0,
        -2312.0,
        648.0
      ],
      [
        -152.0,
        -2290.0,
        648.0
      ],
      [
        -173.0,
        -2290.0,
        648.0
      ],
      [
        -152.0,
        -2290.0,
        648.0
      ],
      [
        -173.0,
        -2312.0,
        648.0
      ],
      [
        -152.0,
        -2312.0,
        648.0
      ],
      [
        -152.0,
        -2315.9033203125,
        648.0
      ],
      [
        -152.0,
        -2313.4033203125,
        644.5
      ],
      [
        -103.58889770507812,
        -2285.097412109375,
        648.0
      ],
      [
        -111.64396667480469,
        -2292.7392578125,
        641.5
      ],
      [
        -111.64397430419922,
        -2292.7392578125,
        641.5
      ],
      [
        -103.48628234863281,
        -2284.58154296875,
        638.2872314453125
      ],
      [
        -98.0,
        -2239.0,
        648.0
      ],
      [
        -98.0,
        -2239.0,
        638.0
      ],
      [
        -95.5,
        -2244.431640625,
        638.0
      ],
      [
        -95.5,
        -2244.431640625,
        648.0
      ],
      [
        -102.75687408447266,
        -2283.85205078125,
        638.0
      ],
      [
        -78.0,
        -2239.0,
        644.9999389648438
      ],
      [
        -79.4285659790039,
        -2239.0,
        643.0
      ],
      [
        -152.0,
        -2313.4033203125,
        644.5
      ],
      [
        -138.57159423828125,
        -2310.732177734375,
        641.5
      ],
      [
        -152.0,
        -2313.4033203125,
        641.5
      ],
      [
        -152.0,
        -2313.4033203125,
        641.5
      ],
      [
        -138.57159423828125,
        -2310.732177734375,
        641.5
      ],
      [
        -150.18222045898438,
        -2315.541748046875,
        638.0
      ],
      [
        -152.0,
        -2315.9033203125,
        638.0
      ],
      [
        -135.87977600097656,
        -2310.19677734375,
        642.999755859375
      ],
      [
        -113.16923522949219,
        -2295.02197265625,
        642.9998168945312
      ],
      [
        -152.0,
        -2313.4033203125,
        643.66455078125
      ],
      [
        -152.0,
        -2313.4033203125,
        642.3353271484375
      ],
      [
        -154.19993591308594,
        -2295.2998046875,
        642.1799926757812
      ],
      [
        -154.19993591308594,
        -2295.699951171875,
        642.1799926757812
      ],
      [
        -154.19993591308594,
        -2295.699951171875,
        642.1799926757812
      ],
      [
        -153.80003356933594,
        -2295.699951171875,
        642.260009765625
      ],
      [
        -153.80003356933594,
        -2295.2998046875,
        642.260009765625
      ],
      [
        -154.19993591308594,
        -2295.2998046875,
        642.1799926757812
      ],
      [
        -154.19993591308594,
        -2295.5,
        642.100341796875
      ],
      [
        -154.19993591308594,
        -2295.42041015625,
        642.1799926757812
      ],
      [
        -106.50012969970703,
        -2167.327880859375,
        658.11767578125
      ],
      [
        -99.88831329345703,
        -2170.441162109375,
        671.286865234375
      ],
      [
        -82.03690338134766,
        -2178.84765625,
        706.843505859375
      ],
      [
        -56.1781005859375,
        -2191.024658203125,
        758.349365234375
      ],
      [
        -101.5,
        -2166.0,
        649.2981567382812
      ],
      [
        -101.5,
        -2161.430908203125,
        626.0
      ],
      [
        -108.95764923095703,
        -2166.21435546875,
        653.271728515625
      ],
      [
        -101.5,
        -2167.3662109375,
        656.210693359375
      ],
      [
        -101.5,
        -2167.66796875,
        657.8052978515625
      ],
      [
        -106.5001220703125,
        -2167.327880859375,
        658.11767578125
      ],
      [
        -101.5,
        -2181.199951171875,
        656.222900390625
      ],
      [
        -101.5,
        -2181.199951171875,
        652.7044067382812
      ],
      [
        -109.39362335205078,
        -2165.965576171875,
        652.3548583984375
      ],
      [
        -108.95764923095703,
        -2166.21435546875,
        653.271728515625
      ],
      [
        -78.5,
        -2166.0,
        639.882080078125
      ],
      [
        -80.35640716552734,
        -2166.0,
        640.6420288085938
      ],
      [
        -95.0,
        -2166.0,
        646.6368408203125
      ],
      [
        -101.5,
        -2166.0,
        649.2981567382812
      ],
      [
        -80.35640716552734,
        -2166.0,
        640.6420288085938
      ],
      [
        -93.44420623779297,
        -2166.0,
        646.0
      ],
      [
        -81.60009765625,
        -2172.677978515625,
        675.2044067382812
      ],
      [
        -97.92192840576172,
        -2171.367919921875,
        675.2044067382812
      ],
      [
        -98.89990234375,
        -2172.654052734375,
        675.2044067382812
      ],
      [
        -81.60009765625,
        -2169.029541015625,
        656.5999755859375
      ],
      [
        -81.60009765625,
        -2170.0,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2170.0,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2167.640869140625,
        656.5999755859375
      ],
      [
        -95.0,
        -2166.659423828125,
        650.0
      ],
      [
        -85.0,
        -2167.46240234375,
        650.0
      ],
      [
        -101.07923889160156,
        -2167.473388671875,
        656.5999755859375
      ],
      [
        -101.5,
        -2167.43994140625,
        656.5999755859375
      ],
      [
        -93.44419860839844,
        -2166.0,
        646.0
      ],
      [
        -85.0,
        -2166.677978515625,
        646.0
      ],
      [
        -95.0,
        -2166.0,
        646.636962890625
      ],
      [
        -95.0,
        -2166.659423828125,
        650.0
      ],
      [
        -85.0,
        -2167.46240234375,
        650.0
      ],
      [
        -85.0,
        -2166.677978515625,
        646.0
      ],
      [
        -98.89990234375,
        -2169.22998046875,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2170.0,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2170.0,
        665.7044067382812
      ],
      [
        -98.89990234375,
        -2169.42626953125,
        665.7044067382812
      ],
      [
        -98.89990234375,
        -2167.640625,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2170.0,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2170.0,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2168.24951171875,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2168.24951171875,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2170.0,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2170.0,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2169.22998046875,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2169.42626953125,
        665.7044067382812
      ],
      [
        -98.89990234375,
        -2170.0,
        665.7044067382812
      ],
      [
        -98.89990234375,
        -2170.0,
        668.6296997070312
      ],
      [
        -81.60009765625,
        -2169.638427734375,
        659.7044067382812
      ],
      [
        -81.60009765625,
        -2170.0,
        659.7044067382812
      ],
      [
        -81.60009765625,
        -2170.0,
        656.5999755859375
      ],
      [
        -81.60009765625,
        -2169.029541015625,
        656.5999755859375
      ],
      [
        -81.60009765625,
        -2170.0,
        659.7044067382812
      ],
      [
        -81.60009765625,
        -2169.638427734375,
        659.7044067382812
      ],
      [
        -81.60009765625,
        -2170.0,
        661.5482788085938
      ],
      [
        -100.5,
        -2181.199951171875,
        657.1488037109375
      ],
      [
        -100.5,
        -2181.199951171875,
        652.7044067382812
      ],
      [
        -94.64644622802734,
        -2179.646484375,
        626.0
      ],
      [
        -96.14644622802734,
        -2178.146484375,
        626.0
      ],
      [
        -90.49994659423828,
        -2172.5,
        626.0
      ],
      [
        -87.49991607666016,
        -2172.5,
        626.0
      ],
      [
        -87.49991607666016,
        -2172.5,
        626.0
      ],
      [
        -90.49994659423828,
        -2172.5,
        626.0
      ],
      [
        -87.99988555908203,
        -2170.0,
        626.0
      ],
      [
        -84.99983978271484,
        -2170.0,
        626.0
      ],
      [
        -84.99983978271484,
        -2170.0,
        654.5999755859375
      ],
      [
        -87.99988555908203,
        -2170.0,
        654.5999755859375
      ],
      [
        -90.49994659423828,
        -2172.5,
        654.5999755859375
      ],
      [
        -87.49991607666016,
        -2172.5,
        654.5999755859375
      ],
      [
        -89.49999237060547,
        -2171.5,
        656.5999755859375
      ],
      [
        -86.49996185302734,
        -2171.5,
        656.5999755859375
      ],
      [
        -87.49991607666016,
        -2172.5,
        656.5999755859375
      ],
      [
        -90.49994659423828,
        -2172.5,
        656.5999755859375
      ],
      [
        -86.49996185302734,
        -2171.5,
        656.5999755859375
      ],
      [
        -89.49999237060547,
        -2171.5,
        656.5999755859375
      ],
      [
        -87.9999771118164,
        -2170.0,
        656.5999755859375
      ],
      [
        -84.99994659423828,
        -2170.0,
        656.5999755859375
      ],
      [
        -87.49991607666016,
        -2172.5,
        654.5999755859375
      ],
      [
        -90.49994659423828,
        -2172.5,
        654.5999755859375
      ],
      [
        -90.49994659423828,
        -2172.5,
        656.5999755859375
      ],
      [
        -87.49991607666016,
        -2172.5,
        656.5999755859375
      ],
      [
        -91.199951171875,
        -2173.199951171875,
        674.4000244140625
      ],
      [
        -91.199951171875,
        -2176.199951171875,
        674.4000244140625
      ],
      [
        -89.199951171875,
        -2174.199951171875,
        674.4000244140625
      ],
      [
        -89.199951171875,
        -2171.91015625,
        674.4000244140625
      ],
      [
        -89.8573989868164,
        -2171.857421875,
        674.4000244140625
      ],
      [
        -91.199951171875,
        -2176.199951171875,
        674.4000244140625
      ],
      [
        -91.199951171875,
        -2173.199951171875,
        674.4000244140625
      ],
      [
        -92.0,
        -2174.0,
        675.2000122070312
      ],
      [
        -92.0,
        -2177.0,
        675.2000122070312
      ],
      [
        -88.39990234375,
        -2173.39990234375,
        675.2000122070312
      ],
      [
        -88.39990234375,
        -2172.13134765625,
        675.2000122070312
      ],
      [
        -89.199951171875,
        -2171.91015625,
        674.4000244140625
      ],
      [
        -89.199951171875,
        -2174.199951171875,
        674.4000244140625
      ],
      [
        -85.35346984863281,
        -2179.646484375,
        626.0
      ],
      [
        -83.85346984863281,
        -2178.146484375,
        626.0
      ],
      [
        -89.99991607666016,
        -2175.0,
        626.0
      ],
      [
        -88.4999008178711,
        -2173.5,
        626.0
      ],
      [
        -88.39990234375,
        -2176.60009765625,
        675.2000122070312
      ],
      [
        -88.39990234375,
        -2173.60009765625,
        675.2000122070312
      ],
      [
        -88.49995422363281,
        -2173.5,
        675.0999755859375
      ],
      [
        -89.199951171875,
        -2175.800048828125,
        674.4000244140625
      ],
      [
        -89.199951171875,
        -2175.800048828125,
        674.4000244140625
      ],
      [
        -90.0,
        -2175.0,
        674.4000244140625
      ],
      [
        -85.06825256347656,
        -2180.068359375,
        626.0
      ],
      [
        -93.46050262451172,
        -2181.53955078125,
        626.0
      ],
      [
        -94.00003814697266,
        -2181.0,
        664.7044067382812
      ],
      [
        -86.00001525878906,
        -2181.0,
        664.7044067382812
      ],
      [
        -86.00001525878906,
        -2181.0,
        665.7044067382812
      ],
      [
        -94.00003814697266,
        -2181.0,
        665.7044067382812
      ],
      [
        -86.00001525878906,
        -2181.0,
        659.7044067382812
      ],
      [
        -94.00003814697266,
        -2181.0,
        659.7044067382812
      ],
      [
        -94.00003814697266,
        -2181.0,
        656.5999755859375
      ],
      [
        -86.00001525878906,
        -2181.0,
        656.5999755859375
      ],
      [
        -94.00003814697266,
        -2181.0,
        659.7044067382812
      ],
      [
        -86.00001525878906,
        -2181.0,
        659.7044067382812
      ],
      [
        -86.00001525878906,
        -2181.0,
        664.7044067382812
      ],
      [
        -94.00003814697266,
        -2181.0,
        664.7044067382812
      ],
      [
        -94.00003814697266,
        -2181.0,
        665.7044067382812
      ],
      [
        -86.00001525878906,
        -2181.0,
        665.7044067382812
      ],
      [
        -86.00001525878906,
        -2181.0,
        675.2044067382812
      ],
      [
        -94.00003814697266,
        -2181.0,
        675.2044067382812
      ],
      [
        -93.79989624023438,
        -2181.199951171875,
        657.7044067382812
      ],
      [
        -86.2000503540039,
        -2181.199951171875,
        657.7044067382812
      ],
      [
        -86.20011138916016,
        -2181.199951171875,
        652.7044067382812
      ],
      [
        -93.79993438720703,
        -2181.199951171875,
        652.7044067382812
      ],
      [
        -93.9999771118164,
        -2181.0,
        654.5999755859375
      ],
      [
        -93.80001831054688,
        -2181.199951171875,
        654.5999755859375
      ],
      [
        -86.19991302490234,
        -2181.199951171875,
        654.5999755859375
      ],
      [
        -85.99996948242188,
        -2181.0,
        654.5999755859375
      ],
      [
        -92.49994659423828,
        -2182.5,
        654.5999755859375
      ],
      [
        -87.49993133544922,
        -2182.5,
        654.5999755859375
      ],
      [
        -86.00001525878906,
        -2181.0,
        656.5999755859375
      ],
      [
        -94.00003814697266,
        -2181.0,
        656.5999755859375
      ],
      [
        -80.0,
        -2182.0,
        649.2973022460938
      ],
      [
        -80.0,
        -2182.0,
        654.5999755859375
      ],
      [
        -82.39921569824219,
        -2179.6005859375,
        626.0
      ],
      [
        -80.0,
        -2182.0,
        654.5999755859375
      ],
      [
        -80.7999038696289,
        -2181.199951171875,
        657.7044067382812
      ],
      [
        -80.7999496459961,
        -2181.199951171875,
        654.5999755859375
      ],
      [
        -86.20008850097656,
        -2181.199951171875,
        654.5999755859375
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        665.7044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        664.7044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        659.7044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        656.5999755859375
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        664.7044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        659.7044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        675.2044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        665.7044067382812
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        656.5999755859375
      ],
      [
        -80.79997253417969,
        -2181.199951171875,
        652.7044067382812
      ],
      [
        -83.85347747802734,
        -2174.353515625,
        626.0
      ],
      [
        -85.35348510742188,
        -2172.853515625,
        626.0
      ],
      [
        -85.75001525878906,
        -2176.25,
        626.0
      ],
      [
        -87.25003051757812,
        -2174.75,
        626.0
      ],
      [
        -80.0,
        -2177.500244140625,
        642.0
      ],
      [
        -80.0,
        -2177.5,
        654.5999755859375
      ],
      [
        -80.0,
        -2177.5,
        626.0
      ],
      [
        -80.0,
        -2177.500244140625,
        642.0
      ],
      [
        -80.0,
        -2181.199951171875,
        657.0562744140625
      ],
      [
        -76.30010223388672,
        -2181.199951171875,
        653.63037109375
      ],
      [
        -76.30010986328125,
        -2181.199951171875,
        652.7044067382812
      ],
      [
        -80.0,
        -2181.199951171875,
        652.7044067382812
      ],
      [
        -80.0,
        -2177.5,
        626.0
      ],
      [
        -81.60009765625,
        -2175.900146484375,
        665.7044067382812
      ],
      [
        -81.60009765625,
        -2175.89990234375,
        664.7044067382812
      ],
      [
        -81.60009765625,
        -2175.900146484375,
        659.7044067382812
      ],
      [
        -81.60009765625,
        -2175.900146484375,
        656.5999755859375
      ],
      [
        -81.60009765625,
        -2175.89990234375,
        664.7044067382812
      ],
      [
        -81.60009765625,
        -2175.900146484375,
        659.7044067382812
      ],
      [
        -81.60009765625,
        -2175.89990234375,
        675.2044067382812
      ],
      [
        -81.60009765625,
        -2175.900146484375,
        665.7044067382812
      ],
      [
        -80.0,
        -2177.5,
        654.5999755859375
      ],
      [
        -81.60009765625,
        -2175.89990234375,
        654.5999755859375
      ],
      [
        -81.60009765625,
        -2180.39990234375,
        654.5999755859375
      ],
      [
        -80.0,
        -2181.199951171875,
        654.5999755859375
      ],
      [
        -80.7999496459961,
        -2181.199951171875,
        654.5999755859375
      ],
      [
        -81.60009765625,
        -2175.900146484375,
        656.5999755859375
      ],
      [
        -82.49992370605469,
        -2170.0,
        654.5999755859375
      ],
      [
        -81.60009765625,
        -2170.81494140625,
        665.7044067382812
      ],
      [
        -81.60009765625,
        -2170.618896484375,
        664.7044067382812
      ],
      [
        -81.60009765625,
        -2170.618896484375,
        664.7044067382812
      ],
      [
        -81.60009765625,
        -2172.677978515625,
        675.2044067382812
      ],
      [
        -81.60009765625,
        -2170.81494140625,
        665.7044067382812
      ],
      [
        -84.00005340576172,
        -2171.5,
        656.5999755859375
      ],
      [
        -84.00005340576172,
        -2171.5,
        656.5999755859375
      ],
      [
        -82.50003814697266,
        -2170.0,
        656.5999755859375
      ],
      [
        -82.49992370605469,
        -2170.0,
        626.0
      ],
      [
        -94.64644622802734,
        -2172.853515625,
        626.0
      ],
      [
        -96.14645385742188,
        -2174.353515625,
        626.0
      ],
      [
        -92.74996948242188,
        -2174.75,
        626.0
      ],
      [
        -94.25003051757812,
        -2176.25,
        626.0
      ],
      [
        -98.7499771118164,
        -2176.25,
        654.5999755859375
      ],
      [
        -98.74996948242188,
        -2176.25,
        656.5999755859375
      ],
      [
        -98.7499771118164,
        -2176.25,
        626.0
      ],
      [
        -92.49994659423828,
        -2170.0,
        654.5999755859375
      ],
      [
        -94.00003814697266,
        -2171.5,
        656.5999755859375
      ],
      [
        -94.00003814697266,
        -2171.5,
        656.5999755859375
      ],
      [
        -92.5000228881836,
        -2170.0,
        656.5999755859375
      ],
      [
        -91.199951171875,
        -2171.749755859375,
        674.4000244140625
      ],
      [
        -92.0,
        -2171.84228515625,
        675.2000122070312
      ],
      [
        -91.199951171875,
        -2171.749755859375,
        674.4000244140625
      ],
      [
        -92.49994659423828,
        -2170.0,
        626.0
      ],
      [
        -100.5,
        -2178.0,
        626.0
      ],
      [
        -100.5,
        -2178.0,
        654.5999755859375
      ],
      [
        -93.79991912841797,
        -2181.199951171875,
        654.5999755859375
      ],
      [
        -100.5,
        -2181.199951171875,
        654.5999755859375
      ],
      [
        -98.89990234375,
        -2176.39990234375,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2176.39990234375,
        665.7044067382812
      ],
      [
        -98.89990234375,
        -2176.39990234375,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2176.39990234375,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2176.39990234375,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2176.39990234375,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2176.39990234375,
        665.7044067382812
      ],
      [
        -98.89990234375,
        -2176.39990234375,
        675.2034301757812
      ],
      [
        -98.89990234375,
        -2176.39990234375,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2172.65234375,
        675.20263671875
      ],
      [
        -98.89990234375,
        -2170.907470703125,
        673.2566528320312
      ],
      [
        -101.5,
        -2163.88232421875,
        638.5
      ],
      [
        -78.5,
        -2165.72900390625,
        638.5
      ],
      [
        -101.5,
        -2162.5,
        631.4511108398438
      ],
      [
        -88.1837158203125,
        -2162.5,
        626.0
      ],
      [
        -78.5,
        -2163.277587890625,
        626.0
      ],
      [
        -78.5,
        -2165.72900390625,
        638.5
      ],
      [
        -78.5,
        -2166.0,
        638.5
      ],
      [
        -88.18306732177734,
        -2162.5,
        626.0
      ],
      [
        -101.5,
        -2161.430908203125,
        626.0
      ],
      [
        -78.5,
        -2166.0,
        639.8824462890625
      ],
      [
        -70.3514404296875,
        -2150.10498046875,
        631.6541748046875
      ],
      [
        26.063024520874023,
        -2132.764404296875,
        606.1185302734375
      ],
      [
        -78.5,
        -2162.5,
        626.0
      ],
      [
        -78.5,
        -2162.5,
        638.5
      ],
      [
        -78.5,
        -2165.72900390625,
        638.5
      ],
      [
        -101.5,
        -2162.5,
        631.451416015625
      ],
      [
        -101.5,
        -2163.88232421875,
        638.5
      ],
      [
        -101.5,
        -2162.5,
        638.5
      ],
      [
        -101.5,
        -2151.82421875,
        626.0
      ],
      [
        -88.99479675292969,
        -2150.5,
        626.0
      ],
      [
        -78.5,
        -2150.5,
        629.979248046875
      ],
      [
        -78.5,
        -2151.570556640625,
        633.812255859375
      ],
      [
        -78.5,
        -2158.89404296875,
        638.5
      ],
      [
        -101.5,
        -2155.31494140625,
        638.5
      ],
      [
        -101.5,
        -2151.82421875,
        626.0
      ],
      [
        -78.5,
        -2150.5,
        629.979248046875
      ],
      [
        -88.99424743652344,
        -2150.5,
        626.0
      ],
      [
        -101.5,
        -2155.70703125,
        639.9039916992188
      ],
      [
        -101.5,
        -2165.370849609375,
        646.0895385742188
      ],
      [
        -78.5,
        -2166.0,
        643.0485229492188
      ],
      [
        -83.0298080444336,
        -2166.0,
        643.7266845703125
      ],
      [
        -83.0298080444336,
        -2166.0,
        643.7266845703125
      ],
      [
        -90.69471740722656,
        -2166.0,
        644.8743896484375
      ],
      [
        -78.5,
        -2166.0,
        643.0485229492188
      ],
      [
        -78.5,
        -2151.823486328125,
        634.7183837890625
      ],
      [
        -76.08811950683594,
        -2151.31494140625,
        633.8114013671875
      ],
      [
        -109.31500244140625,
        -2165.56201171875,
        652.0198974609375
      ],
      [
        -109.18191528320312,
        -2164.8779296875,
        651.4520874023438
      ],
      [
        -101.5,
        -2156.67431640625,
        643.3672485351562
      ],
      [
        -109.18191528320312,
        -2164.8779296875,
        651.4520874023438
      ],
      [
        -107.84700012207031,
        -2158.012939453125,
        645.7538452148438
      ],
      [
        -70.3514404296875,
        -2150.10498046875,
        631.6541748046875
      ],
      [
        -76.08811950683594,
        -2151.31494140625,
        633.8114013671875
      ],
      [
        -109.31500244140625,
        -2165.56201171875,
        652.0198974609375
      ],
      [
        -109.3934097290039,
        -2165.965576171875,
        652.3548583984375
      ],
      [
        -78.5,
        -2151.82373046875,
        634.7183837890625
      ],
      [
        -78.5,
        -2166.0,
        645.9078979492188
      ],
      [
        -101.5,
        -2165.077880859375,
        650.0
      ],
      [
        -101.5,
        -2156.674072265625,
        643.3668823242188
      ],
      [
        -78.5,
        -2166.0,
        645.9078979492188
      ],
      [
        -85.0,
        -2166.0,
        647.2700805664062
      ],
      [
        -95.0,
        -2166.0,
        649.36572265625
      ],
      [
        -98.02664184570312,
        -2166.0,
        650.0
      ],
      [
        -95.0,
        -2166.0,
        649.36572265625
      ],
      [
        -95.0,
        -2166.633056640625,
        649.8652954101562
      ],
      [
        -85.0,
        -2166.0,
        647.2700805664062
      ],
      [
        -85.0,
        -2167.0966796875,
        648.1356811523438
      ],
      [
        -101.5,
        -2165.07763671875,
        650.0
      ],
      [
        -98.02632904052734,
        -2166.0,
        650.0
      ],
      [
        -78.5,
        -2156.09130859375,
        650.0
      ],
      [
        -101.5,
        -2158.52685546875,
        650.0
      ],
      [
        -81.60009765625,
        -2158.262451171875,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2160.094482421875,
        656.5999755859375
      ],
      [
        -81.60009765625,
        -2163.458251953125,
        675.2044067382812
      ],
      [
        -92.80992126464844,
        -2164.645263671875,
        675.2044067382812
      ],
      [
        -81.60009765625,
        -2160.804931640625,
        665.7044067382812
      ],
      [
        -81.60009765625,
        -2160.52587890625,
        664.7044067382812
      ],
      [
        -81.60009765625,
        -2160.52587890625,
        664.7044067382812
      ],
      [
        -81.60009765625,
        -2160.0,
        662.8216552734375
      ],
      [
        -81.60009765625,
        -2163.4580078125,
        675.2044067382812
      ],
      [
        -81.60009765625,
        -2160.804931640625,
        665.7044067382812
      ],
      [
        -98.89990234375,
        -2163.239013671875,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2164.1357421875,
        665.7044067382812
      ],
      [
        -98.89990234375,
        -2160.094482421875,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2160.96142578125,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2160.96142578125,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2163.239013671875,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2161.959228515625,
        663.2769775390625
      ],
      [
        -98.89990234375,
        -2164.1357421875,
        665.7044067382812
      ],
      [
        -88.39990234375,
        -2164.177001953125,
        675.2000122070312
      ],
      [
        -89.199951171875,
        -2164.038330078125,
        674.4000244140625
      ],
      [
        -91.199951171875,
        -2164.250244140625,
        674.4000244140625
      ],
      [
        -89.199951171875,
        -2164.038330078125,
        674.4000244140625
      ],
      [
        -91.199951171875,
        -2164.250244140625,
        674.4000244140625
      ],
      [
        -92.0,
        -2164.55810546875,
        675.2000122070312
      ],
      [
        -81.60009765625,
        -2160.0,
        662.8214721679688
      ],
      [
        -83.60009765625,
        -2160.0,
        662.0626831054688
      ],
      [
        -94.0,
        -2160.0,
        658.1193237304688
      ],
      [
        -98.00824737548828,
        -2160.0,
        656.5999755859375
      ],
      [
        -83.60009765625,
        -2159.826171875,
        661.4400024414062
      ],
      [
        -86.60009765625,
        -2159.2724609375,
        658.3200073242188
      ],
      [
        -86.60009765625,
        -2159.2724609375,
        658.3200073242188
      ],
      [
        -86.60009765625,
        -2158.7919921875,
        656.5999755859375
      ],
      [
        -94.0,
        -2159.57568359375,
        656.5999755859375
      ],
      [
        -94.0,
        -2160.0,
        658.119384765625
      ],
      [
        -83.60009765625,
        -2160.0,
        662.0630493164062
      ],
      [
        -83.60009765625,
        -2159.825927734375,
        661.4400024414062
      ],
      [
        -78.5,
        -2156.09130859375,
        650.0
      ],
      [
        -101.5,
        -2158.526611328125,
        650.0
      ],
      [
        -103.7078857421875,
        -2136.7275390625,
        628.0859375
      ],
      [
        -78.5,
        -2150.5,
        633.1271362304688
      ],
      [
        -101.5,
        -2150.5,
        636.5709228515625
      ],
      [
        -101.5,
        -2150.5,
        636.5709228515625
      ],
      [
        -101.5,
        -2155.70703125,
        639.9039916992188
      ],
      [
        -78.5,
        -2150.5,
        633.1271362304688
      ],
      [
        -78.5,
        -2151.570556640625,
        633.8123168945312
      ],
      [
        70.50594329833984,
        -2036.956298828125,
        772.3233642578125
      ],
      [
        -103.96110534667969,
        -2138.029541015625,
        629.166748046875
      ],
      [
        -105.52120208740234,
        -2146.05224609375,
        635.825927734375
      ],
      [
        -105.52120208740234,
        -2146.05224609375,
        635.825927734375
      ],
      [
        -103.7078857421875,
        -2136.7275390625,
        628.0859375
      ],
      [
        -103.96110534667969,
        -2138.029541015625,
        629.166748046875
      ],
      [
        -78.5,
        -2150.5,
        633.6736450195312
      ],
      [
        -101.5,
        -2150.5,
        638.4938354492188
      ],
      [
        -101.5,
        -2150.5,
        638.4938354492188
      ],
      [
        -101.5,
        -2156.674072265625,
        643.3670043945312
      ],
      [
        -78.5,
        -2150.5,
        633.6736450195312
      ],
      [
        -78.5,
        -2151.823486328125,
        634.71826171875
      ],
      [
        -99.23894500732422,
        -2150.5,
        650.0
      ],
      [
        -101.5,
        -2153.473388671875,
        650.0
      ],
      [
        -81.7981948852539,
        -2150.1640625,
        675.2044067382812
      ],
      [
        -82.1713638305664,
        -2150.65478515625,
        675.2044067382812
      ],
      [
        -82.17135620117188,
        -2150.65478515625,
        675.2044067382812
      ],
      [
        -88.5723648071289,
        -2142.390625,
        656.5999755859375
      ],
      [
        -94.85648345947266,
        -2150.65478515625,
        656.5999755859375
      ],
      [
        -94.85648345947266,
        -2150.65478515625,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2155.97216796875,
        656.5999755859375
      ],
      [
        -79.4952163696289,
        -2150.27197265625,
        656.5999755859375
      ],
      [
        -82.6537094116211,
        -2142.64697265625,
        656.5999755859375
      ],
      [
        -82.6537094116211,
        -2142.64697265625,
        656.5999755859375
      ],
      [
        -87.30269622802734,
        -2140.72119140625,
        656.5999755859375
      ],
      [
        -86.8844223022461,
        -2136.677978515625,
        652.7044067382812
      ],
      [
        -88.1531982421875,
        -2137.033203125,
        651.2399291992188
      ],
      [
        -89.07524871826172,
        -2138.245849609375,
        651.2399291992188
      ],
      [
        -75.32080078125,
        -2139.14013671875,
        650.0
      ],
      [
        -72.33890533447266,
        -2146.3388671875,
        650.0
      ],
      [
        -71.8232192993164,
        -2147.5068359375,
        650.0
      ],
      [
        -72.33890533447266,
        -2146.3388671875,
        650.0
      ],
      [
        -97.14186096191406,
        -2158.0,
        661.4400024414062
      ],
      [
        -97.0,
        -2158.0,
        661.6480712890625
      ],
      [
        -98.89990234375,
        -2158.0,
        658.8616333007812
      ],
      [
        -97.14177703857422,
        -2158.0,
        661.4400024414062
      ],
      [
        -88.39990234375,
        -2158.841796875,
        675.2000122070312
      ],
      [
        -89.199951171875,
        -2159.176513671875,
        674.4000244140625
      ],
      [
        -91.199951171875,
        -2161.806884765625,
        674.4000244140625
      ],
      [
        -89.199951171875,
        -2159.176513671875,
        674.4000244140625
      ],
      [
        -91.199951171875,
        -2161.806884765625,
        674.4000244140625
      ],
      [
        -92.0,
        -2163.576171875,
        675.2000122070312
      ],
      [
        -97.0,
        -2160.0,
        663.8783569335938
      ],
      [
        -98.66267395019531,
        -2160.0,
        661.4400024414062
      ],
      [
        -98.89990234375,
        -2160.0,
        661.0919799804688
      ],
      [
        -98.66259765625,
        -2160.0,
        661.4400024414062
      ],
      [
        -98.89990234375,
        -2158.755859375,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2158.0,
        658.8614501953125
      ],
      [
        -98.89990234375,
        -2158.0,
        656.5999755859375
      ],
      [
        -97.0,
        -2158.0,
        661.64794921875
      ],
      [
        -97.0,
        -2160.0,
        663.8783569335938
      ],
      [
        -98.89990234375,
        -2160.0,
        661.092041015625
      ],
      [
        -83.79174041748047,
        -2143.370849609375,
        664.7044067382812
      ],
      [
        -84.37006378173828,
        -2144.13134765625,
        664.7044067382812
      ],
      [
        -84.0444107055664,
        -2144.599609375,
        665.7044067382812
      ],
      [
        -84.2060546875,
        -2144.19921875,
        665.020751953125
      ],
      [
        -81.7981948852539,
        -2150.1640625,
        675.2044067382812
      ],
      [
        -84.0444107055664,
        -2144.599609375,
        665.7044067382812
      ],
      [
        -84.2060546875,
        -2144.19921875,
        665.0208129882812
      ],
      [
        -84.37012481689453,
        -2144.13134765625,
        664.7044067382812
      ],
      [
        -98.89990234375,
        -2155.97216796875,
        656.5999755859375
      ],
      [
        -81.60009765625,
        -2148.076416015625,
        657.7044067382812
      ],
      [
        -81.60009765625,
        -2145.1904296875,
        656.5999755859375
      ],
      [
        -81.60009765625,
        -2148.076416015625,
        659.7044067382812
      ],
      [
        -84.69075775146484,
        -2142.99853515625,
        659.7044067382812
      ],
      [
        -84.69073486328125,
        -2142.99853515625,
        657.7044067382812
      ],
      [
        -85.2701644897461,
        -2141.563232421875,
        656.5999755859375
      ],
      [
        -86.96266174316406,
        -2143.057373046875,
        659.7044067382812
      ],
      [
        -88.57234954833984,
        -2142.390625,
        656.5999755859375
      ],
      [
        -84.37006378173828,
        -2144.13134765625,
        664.7044067382812
      ],
      [
        -86.96266174316406,
        -2143.057373046875,
        659.7044067382812
      ],
      [
        -87.42127990722656,
        -2141.867431640625,
        657.7044067382812
      ],
      [
        -86.38430786132812,
        -2142.296875,
        659.7044067382812
      ],
      [
        -86.96266174316406,
        -2143.057373046875,
        659.7044067382812
      ],
      [
        -101.5,
        -2150.5,
        646.683837890625
      ],
      [
        -99.23894500732422,
        -2150.5,
        650.0
      ],
      [
        -101.5,
        -2153.473388671875,
        650.0
      ],
      [
        -101.5,
        -2150.5,
        646.683837890625
      ],
      [
        -321.0328369140625,
        -2940.99951171875,
        1249.1207275390625
      ],
      [
        -320.3917236328125,
        -2939.707275390625,
        1205.8133544921875
      ],
      [
        -322.538330078125,
        -2941.982666015625,
        1318.00390625
      ],
      [
        -321.0328369140625,
        -2940.99951171875,
        1249.1207275390625
      ],
      [
        -215.0,
        -2386.7958984375,
        798.5
      ],
      [
        -215.0,
        -2386.4384765625,
        779.0
      ],
      [
        -204.51670837402344,
        -2390.0,
        779.0
      ],
      [
        -204.5704345703125,
        -2390.0,
        780.0
      ],
      [
        -205.51467895507812,
        -2390.0,
        797.5
      ],
      [
        -205.5689697265625,
        -2390.0,
        798.5
      ],
      [
        -205.56895446777344,
        -2390.0,
        798.5
      ],
      [
        -205.83834838867188,
        -2390.0,
        803.5
      ],
      [
        -204.51670837402344,
        -2390.0,
        779.0
      ],
      [
        -204.2466278076172,
        -2390.0,
        774.0
      ],
      [
        -195.5,
        -2393.081787109375,
        780.0
      ],
      [
        -195.5,
        -2393.402587890625,
        797.5
      ],
      [
        -195.5,
        -2393.402587890625,
        797.5
      ],
      [
        -205.51467895507812,
        -2390.0,
        797.5
      ],
      [
        -195.5,
        -2393.081787109375,
        780.0
      ],
      [
        -204.5704345703125,
        -2390.0,
        780.0
      ],
      [
        -215.0,
        -2386.4384765625,
        779.0
      ],
      [
        -209.5,
        -2388.21533203125,
        774.0
      ],
      [
        -215.0,
        -2386.7958984375,
        798.5
      ],
      [
        -209.5,
        -2388.756103515625,
        803.5
      ],
      [
        -210.5,
        -2387.974365234375,
        779.4000244140625
      ],
      [
        -204.5377960205078,
        -2390.0,
        779.4000244140625
      ],
      [
        -204.5704345703125,
        -2390.0,
        780.0
      ],
      [
        -210.5,
        -2387.9853515625,
        780.0
      ],
      [
        -210.5,
        -2387.974365234375,
        779.4000244140625
      ],
      [
        -210.5,
        -2387.9853515625,
        780.0
      ],
      [
        -209.5,
        -2388.756103515625,
        803.5
      ],
      [
        -205.83834838867188,
        -2390.0,
        803.5
      ],
      [
        -204.2466278076172,
        -2390.0,
        774.0
      ],
      [
        -209.5,
        -2388.21533203125,
        774.0
      ],
      [
        -222.5,
        -2440.0,
        795.5
      ],
      [
        -222.5,
        -2440.0,
        792.0861206054688
      ],
      [
        -222.5,
        -2440.0,
        795.5
      ],
      [
        -220.17233276367188,
        -2440.0,
        795.5
      ],
      [
        -363.3003234863281,
        -2334.769287109375,
        709.0
      ],
      [
        -363.2171325683594,
        -2334.8525390625,
        712.0
      ],
      [
        -363.106201171875,
        -2334.96337890625,
        716.0
      ],
      [
        -363.2171325683594,
        -2334.8525390625,
        712.0
      ],
      [
        -363.3003234863281,
        -2334.769287109375,
        709.0
      ],
      [
        -364.328125,
        -2333.74169921875,
        672.0
      ],
      [
        -351.334228515625,
        -2346.7353515625,
        672.0
      ],
      [
        -363.8105773925781,
        -2354.9443359375,
        749.9570922851562
      ],
      [
        -363.7572937011719,
        -2354.89111328125,
        750.2584838867188
      ],
      [
        -367.3408203125,
        -2358.474609375,
        729.9871215820312
      ],
      [
        -363.8105773925781,
        -2354.9443359375,
        749.9570922851562
      ],
      [
        -373.0028076171875,
        -2345.751708984375,
        749.9569702148438
      ],
      [
        -372.94940185546875,
        -2345.698486328125,
        750.2590942382812
      ],
      [
        -376.53302001953125,
        -2349.281982421875,
        729.987060546875
      ],
      [
        -373.0028076171875,
        -2345.751708984375,
        749.9569702148438
      ],
      [
        -371.63214111328125,
        -2332.965087890625,
        765.0
      ],
      [
        -371.9085998535156,
        -2332.86767578125,
        764.8101196289062
      ],
      [
        -363.80303955078125,
        -2354.936767578125,
        749.999755859375
      ],
      [
        -356.7624206542969,
        -2347.896240234375,
        764.9353637695312
      ],
      [
        -356.7623596191406,
        -2347.896240234375,
        764.935302734375
      ],
      [
        -356.67095947265625,
        -2347.8046875,
        765.129150390625
      ],
      [
        -372.9951477050781,
        -2345.744140625,
        750.000244140625
      ],
      [
        -365.9547424316406,
        -2338.703857421875,
        764.935302734375
      ],
      [
        -365.9547424316406,
        -2338.703857421875,
        764.935302734375
      ],
      [
        -365.86334228515625,
        -2338.6123046875,
        765.129150390625
      ],
      [
        -331.8025817871094,
        -2366.266845703125,
        756.0728149414062
      ],
      [
        -342.80230712890625,
        -2355.26708984375,
        765.0
      ],
      [
        -384.47674560546875,
        -2328.32568359375,
        750.0
      ],
      [
        -390.9516906738281,
        -2325.759521484375,
        730.0
      ],
      [
        -390.9516906738281,
        -2325.759521484375,
        730.0
      ],
      [
        -391.1108093261719,
        -2325.375244140625,
        712.0
      ],
      [
        -371.9085998535156,
        -2332.86767578125,
        764.8101196289062
      ],
      [
        -384.47674560546875,
        -2328.32568359375,
        750.0
      ],
      [
        -351.3341064453125,
        -2346.735107421875,
        768.0775146484375
      ],
      [
        -361.6596984863281,
        -2336.40966796875,
        768.0773315429688
      ],
      [
        -371.63214111328125,
        -2332.965087890625,
        765.0
      ],
      [
        -356.7318115234375,
        -2347.86572265625,
        765.0001220703125
      ],
      [
        -353.46783447265625,
        -2344.6015625,
        768.1460571289062
      ],
      [
        -353.46783447265625,
        -2344.6015625,
        768.0775146484375
      ],
      [
        -365.92431640625,
        -2338.67333984375,
        764.9998168945312
      ],
      [
        -363.14764404296875,
        -2335.896728515625,
        767.6869506835938
      ],
      [
        -363.1466979980469,
        -2335.895751953125,
        767.6184692382812
      ],
      [
        -353.46795654296875,
        -2344.6015625,
        764.5992431640625
      ],
      [
        -363.1000671386719,
        -2335.848876953125,
        764.1880493164062
      ],
      [
        -363.1000671386719,
        -2335.848876953125,
        764.1880493164062
      ],
      [
        -365.4127197265625,
        -2335.05029296875,
        763.480224609375
      ],
      [
        -353.46795654296875,
        -2344.6015625,
        764.5992431640625
      ],
      [
        -355.0235595703125,
        -2343.045654296875,
        764.5992431640625
      ],
      [
        -351.3341064453125,
        -2346.735107421875,
        768.0775146484375
      ],
      [
        -342.80230712890625,
        -2355.26708984375,
        765.0
      ],
      [
        -331.8025817871094,
        -2366.266845703125,
        756.0728149414062
      ],
      [
        -327.7540588378906,
        -2370.3154296875,
        750.0
      ],
      [
        -323.39990234375,
        -2374.669677734375,
        729.9205322265625
      ],
      [
        -323.39990234375,
        -2374.669677734375,
        732.5827026367188
      ],
      [
        -329.699951171875,
        -2355.699951171875,
        672.0
      ],
      [
        -306.300048828125,
        -2355.699951171875,
        672.0
      ],
      [
        -298.9615478515625,
        -2357.6552734375,
        765.0
      ],
      [
        -284.24261474609375,
        -2362.380859375,
        750.0
      ],
      [
        -306.2999267578125,
        -2355.699951171875,
        768.0769653320312
      ],
      [
        -329.7000427246094,
        -2355.699951171875,
        768.0769653320312
      ],
      [
        -310.39990234375,
        -2355.699951171875,
        764.5275268554688
      ],
      [
        -310.39990234375,
        -2355.699951171875,
        768.0737915039062
      ],
      [
        -323.39990234375,
        -2355.699951171875,
        764.5275268554688
      ],
      [
        -323.39990234375,
        -2355.699951171875,
        768.0738525390625
      ],
      [
        -331.64117431640625,
        -2365.45556640625,
        757.2897338867188
      ],
      [
        -332.439697265625,
        -2365.629638671875,
        756.58984375
      ],
      [
        -341.75762939453125,
        -2355.699951171875,
        765.0
      ],
      [
        -342.36944580078125,
        -2355.699951171875,
        764.648681640625
      ],
      [
        -329.7000427246094,
        -2355.699951171875,
        768.0769653320312
      ],
      [
        -335.3817138671875,
        -2355.699951171875,
        766.6270751953125
      ],
      [
        -339.1446228027344,
        -2356.78271484375,
        765.0
      ],
      [
        -341.75762939453125,
        -2355.699951171875,
        765.0
      ],
      [
        -323.39990234375,
        -2355.699951171875,
        764.5275268554688
      ],
      [
        -325.60009765625,
        -2355.699951171875,
        764.5275268554688
      ],
      [
        -310.39990234375,
        -2355.699951171875,
        764.5275268554688
      ],
      [
        -312.60009765625,
        -2355.699951171875,
        764.5275268554688
      ],
      [
        -306.2999267578125,
        -2355.699951171875,
        768.0769653320312
      ],
      [
        -298.9615478515625,
        -2357.6552734375,
        765.0
      ],
      [
        -304.86285400390625,
        -2355.699951171875,
        767.710205078125
      ],
      [
        -329.699951171875,
        -2355.699951171875,
        672.0
      ],
      [
        -351.334228515625,
        -2346.7353515625,
        672.0
      ],
      [
        -304.225341796875,
        -2354.84033203125,
        709.0
      ],
      [
        -304.29815673828125,
        -2354.870361328125,
        712.0
      ],
      [
        -304.3952941894531,
        -2354.91064453125,
        716.0
      ],
      [
        -304.29815673828125,
        -2354.870361328125,
        712.0
      ],
      [
        -304.225341796875,
        -2354.84033203125,
        709.0
      ],
      [
        -306.300048828125,
        -2355.699951171875,
        672.0
      ],
      [
        -303.3257141113281,
        -2354.467529296875,
        672.0
      ],
      [
        -305.6617126464844,
        -2355.435302734375,
        768.0770874023438
      ],
      [
        -306.4013671875,
        -2355.190185546875,
        768.4168090820312
      ],
      [
        -328.14630126953125,
        -2347.89111328125,
        773.2828369140625
      ],
      [
        -328.14630126953125,
        -2347.89111328125,
        773.2828369140625
      ],
      [
        -347.664306640625,
        -2341.24365234375,
        772.3961181640625
      ],
      [
        -315.1764831542969,
        -2355.37353515625,
        672.0
      ],
      [
        -315.0,
        -2355.699951171875,
        672.0
      ],
      [
        -321.3235168457031,
        -2355.37353515625,
        672.0
      ],
      [
        -315.1764831542969,
        -2355.37353515625,
        672.0
      ],
      [
        -347.664306640625,
        -2341.24365234375,
        772.3961181640625
      ],
      [
        -353.46783447265625,
        -2344.6015625,
        768.0775146484375
      ],
      [
        -349.4827575683594,
        -2340.616455078125,
        771.8993530273438
      ],
      [
        -349.48187255859375,
        -2340.615478515625,
        771.8353271484375
      ],
      [
        -323.39990234375,
        -2349.41943359375,
        768.6799926757812
      ],
      [
        -325.60009765625,
        -2348.680908203125,
        769.168212890625
      ],
      [
        -323.39990234375,
        -2349.41943359375,
        768.6799926757812
      ],
      [
        -323.39990234375,
        -2349.484130859375,
        772.2135009765625
      ],
      [
        -349.43475341796875,
        -2340.568359375,
        768.370361328125
      ],
      [
        -349.43475341796875,
        -2340.568359375,
        768.370361328125
      ],
      [
        -351.7474365234375,
        -2339.76953125,
        767.6625366210938
      ],
      [
        -319.5,
        -2349.256103515625,
        687.5
      ],
      [
        -318.2544250488281,
        -2349.67919921875,
        687.5
      ],
      [
        -310.39990234375,
        -2353.783447265625,
        765.794677734375
      ],
      [
        -310.39990234375,
        -2353.84765625,
        769.307373046875
      ],
      [
        -310.39990234375,
        -2353.783447265625,
        765.794677734375
      ],
      [
        -312.60009765625,
        -2353.044921875,
        766.2828979492188
      ],
      [
        -317.0,
        -2350.1513671875,
        690.0
      ],
      [
        -317.0,
        -2350.10546875,
        687.5
      ],
      [
        -317.0,
        -2350.10546875,
        687.5
      ],
      [
        -306.4013671875,
        -2355.190185546875,
        768.4168090820312
      ],
      [
        -384.6997375488281,
        -2326.178466796875,
        637.0
      ],
      [
        -391.0,
        -2324.037841796875,
        637.0
      ],
      [
        -391.0,
        -2324.037841796875,
        637.0
      ],
      [
        -400.5,
        -2320.81005859375,
        637.0
      ],
      [
        -384.6997375488281,
        -2326.178466796875,
        637.0
      ],
      [
        -372.102783203125,
        -2330.45849609375,
        637.0
      ],
      [
        -423.48785400390625,
        -2313.0,
        637.0
      ],
      [
        -402.5,
        -2320.130859375,
        637.0
      ],
      [
        -365.3004150390625,
        -2332.769287109375,
        637.0
      ],
      [
        -365.7722473144531,
        -2332.297607421875,
        620.0
      ],
      [
        -365.14208984375,
        -2354.35791015625,
        637.0
      ],
      [
        -351.0,
        -2348.5,
        637.0
      ],
      [
        -371.0,
        -2368.5,
        637.0
      ],
      [
        -365.14208984375,
        -2354.35791015625,
        637.0
      ],
      [
        -371.0,
        -2368.5,
        637.0
      ],
      [
        -370.3333435058594,
        -2368.5,
        637.0
      ],
      [
        -351.0,
        -2346.873779296875,
        620.0
      ],
      [
        -351.0,
        -2346.3076171875,
        620.0
      ],
      [
        -365.7722473144531,
        -2332.297607421875,
        620.0
      ],
      [
        -351.0,
        -2337.316650390625,
        620.0
      ],
      [
        -351.0,
        -2346.3076171875,
        620.0
      ],
      [
        -351.0,
        -2346.873779296875,
        620.0
      ],
      [
        -351.0,
        -2346.873779296875,
        637.0
      ],
      [
        -365.3004150390625,
        -2332.769287109375,
        637.0
      ],
      [
        -364.85589599609375,
        -2333.2138671875,
        653.0
      ],
      [
        -364.85589599609375,
        -2333.2138671875,
        653.0
      ],
      [
        -400.5,
        -2320.810302734375,
        637.0
      ],
      [
        -400.5,
        -2320.82275390625,
        637.6726684570312
      ],
      [
        -400.5,
        -2321.0048828125,
        647.6056518554688
      ],
      [
        -400.5,
        -2320.973876953125,
        645.9136962890625
      ],
      [
        -400.5,
        -2321.130859375,
        654.5
      ],
      [
        -400.5,
        -2321.0048828125,
        647.6056518554688
      ],
      [
        -400.5,
        -2320.82275390625,
        637.6726684570312
      ],
      [
        -402.5,
        -2320.150390625,
        638.0569458007812
      ],
      [
        -400.5,
        -2320.973876953125,
        645.9136962890625
      ],
      [
        -402.5,
        -2320.287353515625,
        645.5213012695312
      ],
      [
        -351.0,
        -2346.873779296875,
        637.0
      ],
      [
        -351.0,
        -2346.873779296875,
        643.0
      ],
      [
        -351.0,
        -2346.873779296875,
        659.0
      ],
      [
        -351.0,
        -2346.873779296875,
        672.0
      ],
      [
        -351.0,
        -2346.235107421875,
        643.4210815429688
      ],
      [
        -351.0,
        -2346.873779296875,
        643.0
      ],
      [
        -351.0,
        -2355.699951171875,
        660.5
      ],
      [
        -338.199951171875,
        -2355.699951171875,
        660.5
      ],
      [
        -336.302001953125,
        -2355.699951171875,
        660.5
      ],
      [
        -338.199951171875,
        -2355.699951171875,
        660.5
      ],
      [
        -336.302001953125,
        -2355.699951171875,
        664.5
      ],
      [
        -336.302001953125,
        -2355.699951171875,
        660.5
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        656.0
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        649.5
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        656.0
      ],
      [
        -347.8773193359375,
        -2348.16796875,
        649.5
      ],
      [
        -307.2218322753906,
        -2352.0126953125,
        610.304443359375
      ],
      [
        -327.108154296875,
        -2345.332763671875,
        614.4794921875
      ],
      [
        -327.1314697265625,
        -2345.426025390625,
        620.0
      ],
      [
        -345.447509765625,
        -2339.203125,
        620.0
      ],
      [
        -302.06170654296875,
        -2353.943603515625,
        620.0
      ],
      [
        -307.17327880859375,
        -2352.20703125,
        620.0
      ],
      [
        -345.447509765625,
        -2339.203125,
        620.0
      ],
      [
        -327.123046875,
        -2345.392333984375,
        618.0
      ],
      [
        -327.1314697265625,
        -2345.426025390625,
        620.0
      ],
      [
        -327.123046875,
        -2345.392333984375,
        618.0
      ],
      [
        -327.108154296875,
        -2345.332763671875,
        614.4794921875
      ],
      [
        -302.75445556640625,
        -2354.249267578125,
        649.5
      ],
      [
        -306.87176513671875,
        -2352.85009765625,
        649.5
      ],
      [
        -312.9171447753906,
        -2350.796142578125,
        649.5
      ],
      [
        -306.87176513671875,
        -2352.85009765625,
        649.5
      ],
      [
        -348.55615234375,
        -2342.578125,
        649.5
      ],
      [
        -317.74371337890625,
        -2350.796142578125,
        649.5
      ],
      [
        -312.7554626464844,
        -2350.796142578125,
        646.5
      ],
      [
        -306.88702392578125,
        -2352.76416015625,
        645.0952758789062
      ],
      [
        -312.9171447753906,
        -2350.796142578125,
        649.5
      ],
      [
        -312.7554626464844,
        -2350.796142578125,
        646.5
      ],
      [
        -302.47479248046875,
        -2354.114990234375,
        637.0
      ],
      [
        -302.6208190917969,
        -2354.17529296875,
        643.0
      ],
      [
        -302.06170654296875,
        -2353.943603515625,
        620.0
      ],
      [
        -302.47479248046875,
        -2354.114990234375,
        637.0
      ],
      [
        -306.88702392578125,
        -2352.76416015625,
        645.0952758789062
      ],
      [
        -302.6208190917969,
        -2354.17529296875,
        643.0
      ],
      [
        -302.9136657714844,
        -2354.314208984375,
        656.0
      ],
      [
        -306.8463439941406,
        -2352.97802734375,
        656.0
      ],
      [
        -306.8463439941406,
        -2352.97802734375,
        656.0
      ],
      [
        -313.267822265625,
        -2350.796142578125,
        656.0
      ],
      [
        -348.55615234375,
        -2342.578125,
        656.0
      ],
      [
        -316.8883972167969,
        -2355.699951171875,
        670.5
      ],
      [
        -317.6763610839844,
        -2355.37353515625,
        672.0
      ],
      [
        -313.267822265625,
        -2350.796142578125,
        656.0
      ],
      [
        -313.42950439453125,
        -2350.796142578125,
        659.0
      ],
      [
        -303.0096435546875,
        -2354.33642578125,
        659.0
      ],
      [
        -359.0,
        -1833.0,
        892.0
      ],
      [
        -359.0,
        -1828.0,
        892.0
      ],
      [
        -437.0,
        -1833.0,
        892.0
      ],
      [
        -359.0,
        -1833.0,
        895.0
      ],
      [
        -359.5,
        -1833.0,
        900.5
      ],
      [
        -359.0,
        -1880.0,
        892.0
      ],
      [
        -362.2030029296875,
        -1875.2969970703125,
        910.022216796875
      ],
      [
        -362.2658996582031,
        -1872.765869140625,
        914.6759033203125
      ],
      [
        -364.7569885253906,
        -1875.2569580078125,
        912.9827880859375
      ],
      [
        -362.2030029296875,
        -1875.2969970703125,
        910.022216796875
      ],
      [
        -364.8952941894531,
        -1864.295654296875,
        932.9844360351562
      ],
      [
        -373.3090515136719,
        -1866.6461181640625,
        938.2431030273438
      ],
      [
        -364.4206237792969,
        -1863.548583984375,
        933.8004150390625
      ],
      [
        -364.8952941894531,
        -1864.2957763671875,
        932.9844360351562
      ],
      [
        -406.8780822753906,
        -1972.0,
        778.7999267578125
      ],
      [
        -401.2017822265625,
        -1968.8211669921875,
        778.7999267578125
      ],
      [
        -369.9740295410156,
        -1950.0,
        778.7999267578125
      ],
      [
        -369.0,
        -1949.4129638671875,
        778.7999267578125
      ],
      [
        -369.0,
        -1939.0,
        800.2040405273438
      ],
      [
        -369.0,
        -1939.0,
        778.7999267578125
      ],
      [
        -406.8780822753906,
        -1972.0,
        778.7999267578125
      ],
      [
        -414.0,
        -1972.0,
        788.1215209960938
      ],
      [
        -360.0,
        -1939.0,
        789.0540771484375
      ],
      [
        -360.0,
        -1939.0,
        778.7999267578125
      ],
      [
        -369.0,
        -1939.0,
        778.7999267578125
      ],
      [
        -369.0,
        -1939.0,
        800.2040405273438
      ],
      [
        -360.0,
        -1939.0,
        778.7999267578125
      ],
      [
        -360.0,
        -1939.0,
        789.0540771484375
      ],
      [
        -359.0,
        -1938.0833740234375,
        789.699462890625
      ],
      [
        -359.0,
        -1938.0833740234375,
        778.7999267578125
      ],
      [
        -359.0,
        -1833.5,
        892.0
      ],
      [
        -359.0,
        -1833.5,
        889.0
      ],
      [
        -369.0,
        -1950.0,
        777.59326171875
      ],
      [
        -359.0,
        -1938.0833740234375,
        766.0
      ],
      [
        -348.0,
        -1928.0,
        796.7987060546875
      ],
      [
        -348.0,
        -1920.8800048828125,
        811.4339599609375
      ],
      [
        -348.0,
        -1894.5,
        859.1949462890625
      ],
      [
        -348.0,
        -1928.0,
        796.7986450195312
      ],
      [
        -348.0,
        -1894.5,
        865.658935546875
      ],
      [
        -379.3593444824219,
        -1926.0172119140625,
        839.7249145507812
      ],
      [
        -384.9010009765625,
        -1911.1502685546875,
        877.1497802734375
      ],
      [
        -362.3826904296875,
        -1875.1173095703125,
        923.3193359375
      ],
      [
        -362.444091796875,
        -1872.944091796875,
        927.862548828125
      ],
      [
        -364.5794677734375,
        -1875.0794677734375,
        926.1187133789062
      ],
      [
        -362.3826904296875,
        -1875.1173095703125,
        923.3193359375
      ],
      [
        -369.2062072753906,
        -1873.2171630859375,
        935.6788330078125
      ],
      [
        -373.079833984375,
        -1874.3739013671875,
        938.0999755859375
      ],
      [
        -369.2062072753906,
        -1873.2171630859375,
        935.6788330078125
      ],
      [
        -364.63897705078125,
        -1871.853271484375,
        932.82421875
      ],
      [
        -364.1619873046875,
        -1871.16943359375,
        933.638916015625
      ],
      [
        -364.63897705078125,
        -1871.853271484375,
        932.82421875
      ],
      [
        -379.3593444824219,
        -1926.0172119140625,
        839.7249755859375
      ],
      [
        -382.8941650390625,
        -1927.9453125,
        840.140869140625
      ],
      [
        -348.0,
        -1928.0,
        804.5711059570312
      ],
      [
        -348.0,
        -1894.5,
        882.864990234375
      ],
      [
        -366.15032958984375,
        -1939.5062255859375,
        801.43603515625
      ],
      [
        -365.4545593261719,
        -1907.9791259765625,
        874.2081909179688
      ],
      [
        -369.0,
        -1950.0,
        778.6005859375
      ],
      [
        -369.0,
        -1939.0,
        804.11962890625
      ],
      [
        -369.0,
        -1873.2073974609375,
        935.5499267578125
      ],
      [
        -369.0,
        -1874.79248046875,
        935.5499877929688
      ],
      [
        -369.0,
        -1874.79248046875,
        935.5499877929688
      ],
      [
        -373.3367004394531,
        -1882.1689453125,
        938.2603759765625
      ],
      [
        -369.0,
        -1882.347412109375,
        935.5498657226562
      ],
      [
        -369.0,
        -1873.2073974609375,
        935.5499267578125
      ],
      [
        -369.0,
        -1873.1556396484375,
        935.5499267578125
      ],
      [
        -369.37664794921875,
        -1950.0,
        778.7999267578125
      ],
      [
        -370.3382263183594,
        -1950.219482421875,
        778.7999267578125
      ],
      [
        -360.0,
        -1939.0,
        794.5689697265625
      ],
      [
        -348.0,
        -1928.0,
        804.571044921875
      ],
      [
        -360.0,
        -1939.0,
        794.5689697265625
      ],
      [
        -369.0,
        -1939.0,
        804.11962890625
      ],
      [
        -366.1399230957031,
        -1939.0,
        802.60498046875
      ],
      [
        -364.8546142578125,
        -1882.5050048828125,
        932.958984375
      ],
      [
        -364.3332214355469,
        -1881.876220703125,
        933.745849609375
      ],
      [
        -364.8932800292969,
        -1882.516357421875,
        932.983154296875
      ],
      [
        -364.8546142578125,
        -1882.5050048828125,
        932.958984375
      ],
      [
        -366.15032958984375,
        -1939.5062255859375,
        801.4360961914062
      ],
      [
        -373.719970703125,
        -1942.5078125,
        804.3279418945312
      ],
      [
        -369.0,
        -1950.787353515625,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        780.6400146484375
      ],
      [
        -369.0,
        -1950.7550048828125,
        778.8754272460938
      ],
      [
        -369.0,
        -1950.7550048828125,
        778.8754272460938
      ],
      [
        -369.0,
        -1950.787353515625,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        780.639892578125
      ],
      [
        -369.0,
        -1940.6357421875,
        802.5252685546875
      ],
      [
        -369.0,
        -1939.0,
        805.428955078125
      ],
      [
        -369.0,
        -1949.9140625,
        778.7999267578125
      ],
      [
        -369.0,
        -1939.0,
        805.4291381835938
      ],
      [
        -366.646484375,
        -1939.0,
        802.8732299804688
      ],
      [
        -372.1861572265625,
        -1884.650146484375,
        937.541259765625
      ],
      [
        -372.1861572265625,
        -1884.650146484375,
        937.541259765625
      ],
      [
        -373.0823669433594,
        -1884.592041015625,
        938.8501586914062
      ],
      [
        -369.0,
        -1939.0,
        806.3482666015625
      ],
      [
        -369.0,
        -1939.0,
        806.3482666015625
      ],
      [
        -407.14849853515625,
        -1972.0,
        781.3280029296875
      ],
      [
        -348.0,
        -1928.0,
        808.5042724609375
      ],
      [
        -348.0,
        -1912.8416748046875,
        844.2811889648438
      ],
      [
        -348.0,
        -1897.6322021484375,
        875.5444946289062
      ],
      [
        -361.89312744140625,
        -1943.8536376953125,
        789.0957641601562
      ],
      [
        -365.66552734375,
        -1917.5384521484375,
        852.142822265625
      ],
      [
        -360.9438781738281,
        -1925.7882080078125,
        830.5034790039062
      ],
      [
        -360.0,
        -1939.0,
        798.0972900390625
      ],
      [
        -348.0,
        -1928.0,
        808.5042724609375
      ],
      [
        -360.0,
        -1939.0,
        798.0972900390625
      ],
      [
        -366.1399230957031,
        -1939.0,
        802.60498046875
      ],
      [
        -361.6381530761719,
        -1939.0,
        800.2208251953125
      ],
      [
        -405.1983337402344,
        -1972.0,
        778.7999267578125
      ],
      [
        -369.0,
        -1952.119140625,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        783.801513671875
      ],
      [
        -369.0,
        -1952.032958984375,
        779.0032348632812
      ],
      [
        -369.0,
        -1952.032958984375,
        779.0032348632812
      ],
      [
        -369.0,
        -1952.119140625,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        783.8016967773438
      ],
      [
        -369.0,
        -1939.0,
        809.7638549804688
      ],
      [
        -369.0,
        -1946.408447265625,
        792.2781982421875
      ],
      [
        -370.8448181152344,
        -1947.0716552734375,
        793.1043090820312
      ],
      [
        -369.0,
        -1940.63623046875,
        802.5247802734375
      ],
      [
        -405.1983337402344,
        -1972.0,
        778.7999267578125
      ],
      [
        -407.1487121582031,
        -1972.0,
        781.3281860351562
      ],
      [
        -361.89312744140625,
        -1943.8536376953125,
        789.0957641601562
      ],
      [
        -369.0,
        -1939.0,
        809.7638549804688
      ],
      [
        -299.8731384277344,
        -1920.0,
        765.0
      ],
      [
        -300.0,
        -1920.0697021484375,
        765.0
      ],
      [
        -348.0,
        -1894.5,
        887.5716552734375
      ],
      [
        -359.96099853515625,
        -1907.083251953125,
        873.377197265625
      ],
      [
        -364.85504150390625,
        -1882.5179443359375,
        932.959228515625
      ],
      [
        -364.3394470214844,
        -1882.059326171875,
        933.749755859375
      ],
      [
        -364.85504150390625,
        -1882.5177001953125,
        932.959228515625
      ],
      [
        -364.89288330078125,
        -1882.5162353515625,
        932.98291015625
      ],
      [
        -414.0,
        -1972.0,
        790.2094116210938
      ],
      [
        -366.27044677734375,
        -1884.9293212890625,
        933.8439331054688
      ],
      [
        -364.9238586425781,
        -1884.54638671875,
        933.0022583007812
      ],
      [
        -366.27044677734375,
        -1884.9293212890625,
        933.8439331054688
      ],
      [
        -367.6210021972656,
        -1884.842041015625,
        935.8007202148438
      ],
      [
        -364.9238586425781,
        -1884.54638671875,
        933.0022583007812
      ],
      [
        -364.4028015136719,
        -1883.9267578125,
        933.789306640625
      ],
      [
        -395.6517639160156,
        -2040.9208984375,
        657.1885986328125
      ],
      [
        -275.0,
        -1979.0,
        639.3761596679688
      ],
      [
        -275.0,
        -1983.0689697265625,
        635.0
      ],
      [
        -281.0429992675781,
        -1987.0,
        635.0
      ],
      [
        -283.0,
        -1987.0,
        636.369140625
      ],
      [
        -388.1932373046875,
        -2051.136962890625,
        640.9827270507812
      ],
      [
        -395.6521911621094,
        -2040.92138671875,
        657.188232421875
      ],
      [
        -388.1926574707031,
        -2051.13671875,
        640.9827270507812
      ],
      [
        -409.1650085449219,
        -2066.103271484375,
        639.5584106445312
      ],
      [
        -412.73211669921875,
        -2068.68115234375,
        639.28125
      ],
      [
        -413.2454833984375,
        -2069.01513671875,
        639.28125
      ],
      [
        -417.841796875,
        -2072.005126953125,
        639.28125
      ],
      [
        -128.39727783203125,
        -2205.357421875,
        861.0
      ],
      [
        -264.70697021484375,
        -2194.4140625,
        861.0
      ],
      [
        -268.8742980957031,
        -2186.179443359375,
        820.716796875
      ],
      [
        -259.47210693359375,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -124.02082061767578,
        -2197.67236328125,
        820.0211791992188
      ],
      [
        -259.47210693359375,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -235.0,
        -2189.739013671875,
        825.0
      ],
      [
        -235.0,
        -2189.739013671875,
        825.0
      ],
      [
        -197.5,
        -2192.749755859375,
        825.0
      ],
      [
        -210.5,
        -2371.5,
        825.0
      ],
      [
        -195.5,
        -2371.5,
        825.0
      ],
      [
        -195.5,
        -2371.5,
        809.5
      ],
      [
        -210.5,
        -2371.5,
        809.5
      ],
      [
        -210.5,
        -2360.5,
        825.0
      ],
      [
        -195.5,
        -2360.5,
        825.0
      ],
      [
        -195.5,
        -2360.5,
        810.165771484375
      ],
      [
        -210.5,
        -2360.5,
        810.165771484375
      ],
      [
        -195.5,
        -2371.5,
        825.0
      ],
      [
        -195.5,
        -2360.5,
        825.0
      ],
      [
        -195.5,
        -2360.5,
        810.165771484375
      ],
      [
        -195.5,
        -2371.5,
        809.5
      ],
      [
        -210.5,
        -2360.5,
        825.0
      ],
      [
        -210.5,
        -2371.5,
        825.0
      ],
      [
        -210.5,
        -2360.5,
        810.165771484375
      ],
      [
        -210.5,
        -2371.5,
        809.5
      ],
      [
        -267.8311767578125,
        -2189.358642578125,
        836.5
      ],
      [
        -266.46173095703125,
        -2192.99853515625,
        854.5
      ],
      [
        -267.8814392089844,
        -2189.648681640625,
        838.0
      ],
      [
        -267.8814392089844,
        -2189.648681640625,
        838.0
      ],
      [
        -267.8311767578125,
        -2189.358642578125,
        836.5
      ],
      [
        -228.0,
        -2297.300048828125,
        834.7999877929688
      ],
      [
        -228.0,
        -2311.300048828125,
        834.7999877929688
      ],
      [
        -198.0,
        -2371.5,
        825.0
      ],
      [
        -198.0,
        -2371.5,
        838.0
      ],
      [
        -198.0,
        -2360.5,
        838.0
      ],
      [
        -198.0,
        -2360.5,
        836.5714111328125
      ],
      [
        -198.0,
        -2360.5,
        825.0
      ],
      [
        -198.0,
        -2360.5,
        836.5714111328125
      ],
      [
        -198.0,
        -2371.5,
        838.0
      ],
      [
        -198.0,
        -2360.5,
        838.0
      ],
      [
        -228.0,
        -2313.199951171875,
        834.7999877929688
      ],
      [
        -198.0,
        -2313.199951171875,
        834.7999877929688
      ],
      [
        -368.33984375,
        -2147.656005859375,
        665.0
      ],
      [
        -369.8477478027344,
        -2147.13037109375,
        662.9379272460938
      ],
      [
        -419.7129211425781,
        -2313.0,
        637.0
      ],
      [
        -419.7129211425781,
        -2314.282470703125,
        637.0
      ],
      [
        -429.2311096191406,
        -2137.723876953125,
        639.28125
      ],
      [
        -431.97802734375,
        -2137.503173828125,
        639.28125
      ],
      [
        -376.8476257324219,
        -2232.569091796875,
        629.0
      ],
      [
        -376.8477478027344,
        -2232.569091796875,
        660.0
      ],
      [
        -412.5399475097656,
        -2313.0,
        637.0
      ],
      [
        -413.2330017089844,
        -2316.484130859375,
        637.0
      ],
      [
        -396.3184509277344,
        -2312.802978515625,
        637.0
      ],
      [
        -395.49114990234375,
        -2314.800048828125,
        637.0
      ],
      [
        -391.77362060546875,
        -2323.77490234375,
        637.0
      ],
      [
        -395.49114990234375,
        -2314.800048828125,
        637.0
      ],
      [
        -392.1309509277344,
        -2304.60009765625,
        724.8782348632812
      ],
      [
        -392.13092041015625,
        -2304.60009765625,
        712.0
      ],
      [
        -392.1309509277344,
        -2304.60009765625,
        735.076171875
      ],
      [
        -392.1308898925781,
        -2304.60009765625,
        747.3280029296875
      ],
      [
        -392.1309509277344,
        -2304.60009765625,
        735.076171875
      ],
      [
        -392.5685729980469,
        -2302.39990234375,
        733.3175659179688
      ],
      [
        -392.1309509277344,
        -2304.60009765625,
        724.8782348632812
      ],
      [
        -392.56854248046875,
        -2302.39990234375,
        726.4146118164062
      ],
      [
        -390.1296081542969,
        -2314.6611328125,
        654.5
      ],
      [
        -390.1296081542969,
        -2314.6611328125,
        637.0
      ],
      [
        -395.2126770019531,
        -2315.472412109375,
        637.0
      ],
      [
        -390.79290771484375,
        -2311.326416015625,
        751.0049438476562
      ],
      [
        -390.1364440917969,
        -2314.662109375,
        750.0
      ],
      [
        -390.1296081542969,
        -2314.6611328125,
        750.0100708007812
      ],
      [
        -390.1296081542969,
        -2314.6611328125,
        637.0
      ],
      [
        -388.06610107421875,
        -2325.03466796875,
        637.0
      ],
      [
        -390.1228942871094,
        -2314.69482421875,
        750.0
      ],
      [
        -376.84747314453125,
        -2258.8076171875,
        660.0
      ],
      [
        -376.84747314453125,
        -2259.277587890625,
        660.0
      ],
      [
        -376.84747314453125,
        -2258.466796875,
        660.0
      ],
      [
        -376.84747314453125,
        -2258.8076171875,
        660.0
      ],
      [
        -376.84747314453125,
        -2258.12060546875,
        660.0
      ],
      [
        -376.84747314453125,
        -2258.466796875,
        660.0
      ],
      [
        -376.84747314453125,
        -2257.629150390625,
        660.0
      ],
      [
        -376.84747314453125,
        -2258.12060546875,
        660.0
      ],
      [
        -376.8477478027344,
        -2232.569091796875,
        660.0
      ],
      [
        -376.8475036621094,
        -2256.471435546875,
        660.0
      ],
      [
        -376.8475036621094,
        -2256.471435546875,
        660.0
      ],
      [
        -376.84747314453125,
        -2257.629150390625,
        660.0
      ],
      [
        -376.8479309082031,
        -2251.802978515625,
        750.0
      ],
      [
        -376.8479309082031,
        -2244.73193359375,
        730.0
      ],
      [
        -376.8472900390625,
        -2320.61376953125,
        765.0
      ],
      [
        -376.84716796875,
        -2331.0830078125,
        758.9906005859375
      ],
      [
        -376.8479309082031,
        -2244.73193359375,
        730.0
      ],
      [
        -376.8478698730469,
        -2244.73193359375,
        712.0
      ],
      [
        -376.8474426269531,
        -2308.552734375,
        768.0769653320312
      ],
      [
        -376.8472900390625,
        -2320.61376953125,
        765.0
      ],
      [
        -376.847900390625,
        -2257.5263671875,
        756.070556640625
      ],
      [
        -376.8479309082031,
        -2251.802978515625,
        750.0
      ],
      [
        -390.1006774902344,
        -2314.806640625,
        637.0
      ],
      [
        -376.84771728515625,
        -2235.569091796875,
        658.5
      ],
      [
        -376.8477478027344,
        -2232.569091796875,
        655.0
      ],
      [
        -376.84771728515625,
        -2235.569091796875,
        660.0
      ],
      [
        -376.84771728515625,
        -2235.569091796875,
        658.5
      ],
      [
        -376.84674072265625,
        -2319.006103515625,
        637.0
      ],
      [
        -376.8466491699219,
        -2328.8466796875,
        637.0
      ],
      [
        -376.8468017578125,
        -2314.728515625,
        638.002197265625
      ],
      [
        -376.84686279296875,
        -2314.728515625,
        652.0
      ],
      [
        -376.8467712402344,
        -2319.006103515625,
        638.002197265625
      ],
      [
        -376.8468017578125,
        -2314.728515625,
        638.002197265625
      ],
      [
        -376.84686279296875,
        -2314.728515625,
        652.0
      ],
      [
        -376.8468322753906,
        -2319.005859375,
        652.0
      ],
      [
        -329.705322265625,
        -2238.0,
        641.8458862304688
      ],
      [
        -331.98974609375,
        -2238.9462890625,
        637.0
      ],
      [
        -331.98974609375,
        -2238.9462890625,
        637.0
      ],
      [
        -340.00372314453125,
        -2242.265625,
        620.0
      ],
      [
        -370.54498291015625,
        -2233.6845703125,
        660.0
      ],
      [
        -376.4303283691406,
        -2236.122314453125,
        660.0
      ],
      [
        -376.4303283691406,
        -2236.122314453125,
        660.0
      ],
      [
        -376.84771728515625,
        -2236.295166015625,
        660.0
      ],
      [
        -375.43804931640625,
        -2235.711181640625,
        658.5
      ],
      [
        -370.54498291015625,
        -2233.6845703125,
        655.0
      ],
      [
        -375.43804931640625,
        -2235.711181640625,
        660.0
      ],
      [
        -375.43804931640625,
        -2235.711181640625,
        658.5
      ],
      [
        -376.84771728515625,
        -2235.569091796875,
        658.6612548828125
      ],
      [
        -318.5620422363281,
        -2233.38427734375,
        765.0
      ],
      [
        -304.1925964355469,
        -2227.43212890625,
        756.0718994140625
      ],
      [
        -368.1852722167969,
        -2236.066650390625,
        729.9921875
      ],
      [
        -368.22998046875,
        -2236.02197265625,
        729.7393188476562
      ],
      [
        -364.6529846191406,
        -2239.5986328125,
        749.97412109375
      ],
      [
        -368.1852722167969,
        -2236.066650390625,
        729.9921875
      ],
      [
        -362.4776916503906,
        -2251.574951171875,
        765.0
      ],
      [
        -351.33404541015625,
        -2246.958984375,
        768.0772705078125
      ],
      [
        -329.7054138183594,
        -2238.0,
        768.0771484375
      ],
      [
        -375.40972900390625,
        -2256.931396484375,
        660.0
      ],
      [
        -376.0252685546875,
        -2257.186279296875,
        660.0
      ],
      [
        -376.0252685546875,
        -2257.186279296875,
        660.0
      ],
      [
        -376.4715881347656,
        -2257.371337890625,
        660.0
      ],
      [
        -376.4715881347656,
        -2257.371337890625,
        660.0
      ],
      [
        -376.84747314453125,
        -2257.527099609375,
        660.0
      ],
      [
        -368.1839599609375,
        -2236.06787109375,
        712.0
      ],
      [
        -298.90374755859375,
        -2225.241455078125,
        750.0
      ],
      [
        -292.3707580566406,
        -2222.535400390625,
        730.0
      ],
      [
        -357.7478332519531,
        -2249.615478515625,
        762.7328491210938
      ],
      [
        -357.5143737792969,
        -2249.518798828125,
        762.878173828125
      ],
      [
        -310.39990234375,
        -2230.00341796875,
        759.9286499023438
      ],
      [
        -310.39990234375,
        -2230.00341796875,
        754.6104736328125
      ],
      [
        -323.39990234375,
        -2235.388427734375,
        762.9950561523438
      ],
      [
        -323.39990234375,
        -2235.388427734375,
        762.70263671875
      ],
      [
        -323.39990234375,
        -2235.38818359375,
        766.3345336914062
      ],
      [
        -323.39990234375,
        -2235.388427734375,
        762.9950561523438
      ],
      [
        -323.6819152832031,
        -2235.505126953125,
        762.878173828125
      ],
      [
        -323.39990234375,
        -2235.388427734375,
        762.70263671875
      ],
      [
        -329.7054138183594,
        -2238.0,
        768.0771484375
      ],
      [
        -323.39990234375,
        -2235.38818359375,
        766.3359375
      ],
      [
        -323.39990234375,
        -2233.38427734375,
        765.0
      ],
      [
        -323.6819152832031,
        -2235.505126953125,
        762.878173828125
      ],
      [
        -325.60009765625,
        -2236.299560546875,
        763.4034423828125
      ],
      [
        -312.60009765625,
        -2230.914794921875,
        755.97998046875
      ],
      [
        -310.39990234375,
        -2230.00341796875,
        754.6104736328125
      ],
      [
        -318.5620422363281,
        -2233.38427734375,
        765.0
      ],
      [
        -304.1925964355469,
        -2227.43212890625,
        756.0718994140625
      ],
      [
        -298.90374755859375,
        -2225.241455078125,
        750.0
      ],
      [
        -326.0,
        -2233.132080078125,
        653.0
      ],
      [
        -326.0,
        -2234.0,
        652.1422119140625
      ],
      [
        -367.88818359375,
        -2330.18115234375,
        768.0772094726562
      ],
      [
        -367.88818359375,
        -2330.18115234375,
        768.0772094726562
      ],
      [
        -365.9174499511719,
        -2334.93896484375,
        766.7634887695312
      ],
      [
        -275.2143249511719,
        -2337.283935546875,
        637.0
      ],
      [
        -269.2889404296875,
        -2331.3583984375,
        653.0
      ],
      [
        -275.21429443359375,
        -2337.283935546875,
        637.0
      ],
      [
        -281.51007080078125,
        -2343.57958984375,
        620.0
      ],
      [
        -269.2888488769531,
        -2331.3583984375,
        653.0
      ],
      [
        -268.11181640625,
        -2330.181396484375,
        656.17822265625
      ],
      [
        -210.5,
        -2360.5,
        724.837158203125
      ],
      [
        -201.64259338378906,
        -2360.5,
        740.0
      ],
      [
        -195.5,
        -2360.5,
        750.515380859375
      ],
      [
        -201.64260864257812,
        -2360.5,
        740.0
      ],
      [
        -268.1116638183594,
        -2330.181396484375,
        768.0770874023438
      ],
      [
        -284.66571044921875,
        -2346.7353515625,
        768.0772705078125
      ],
      [
        -293.1972961425781,
        -2355.266845703125,
        765.0
      ],
      [
        -296.4061279296875,
        -2358.475830078125,
        762.395751953125
      ],
      [
        -290.1011657714844,
        -2360.5,
        755.9703979492188
      ],
      [
        -279.7031555175781,
        -2360.5,
        750.0
      ],
      [
        -280.2835388183594,
        -2342.353271484375,
        764.48828125
      ],
      [
        -280.2834777832031,
        -2342.35302734375,
        768.0343017578125
      ],
      [
        -284.66571044921875,
        -2346.7353515625,
        768.0772705078125
      ],
      [
        -288.933349609375,
        -2351.0029296875,
        766.5379638671875
      ],
      [
        -290.7259521484375,
        -2354.242919921875,
        765.0
      ],
      [
        -293.1972961425781,
        -2355.266845703125,
        765.0
      ],
      [
        -280.2835388183594,
        -2342.353271484375,
        764.48828125
      ],
      [
        -281.8392028808594,
        -2343.908935546875,
        764.48828125
      ],
      [
        -268.1116638183594,
        -2330.181396484375,
        768.0770874023438
      ],
      [
        -260.60626220703125,
        -2324.123046875,
        765.0
      ],
      [
        -263.84490966796875,
        -2325.91455078125,
        766.5376586914062
      ],
      [
        -271.0910949707031,
        -2333.16064453125,
        768.0343017578125
      ],
      [
        -271.09112548828125,
        -2333.16064453125,
        766.5380859375
      ],
      [
        -248.5850372314453,
        -2310.654541015625,
        756.0718994140625
      ],
      [
        -244.537109375,
        -2306.606689453125,
        750.0
      ],
      [
        -259.58306884765625,
        -2321.65283203125,
        765.0
      ],
      [
        -271.0911560058594,
        -2333.160888671875,
        764.48828125
      ],
      [
        -271.0911560058594,
        -2333.160888671875,
        764.48828125
      ],
      [
        -272.6468200683594,
        -2334.716552734375,
        764.48828125
      ],
      [
        -210.5,
        -2360.5,
        724.837158203125
      ],
      [
        -210.5,
        -2362.31298828125,
        723.0453491210938
      ],
      [
        -195.5,
        -2360.5,
        750.515380859375
      ],
      [
        -195.5,
        -2364.061767578125,
        746.9951171875
      ],
      [
        -361.6597595214844,
        -2336.40966796875,
        768.0773315429688
      ],
      [
        -363.146728515625,
        -2335.895751953125,
        767.6185913085938
      ],
      [
        -362.6601257324219,
        -2335.4091796875,
        768.1461181640625
      ],
      [
        -362.6601257324219,
        -2335.4091796875,
        768.0773315429688
      ],
      [
        -362.6602783203125,
        -2335.4091796875,
        764.5992431640625
      ],
      [
        -362.6602783203125,
        -2335.4091796875,
        764.5992431640625
      ],
      [
        -364.2159423828125,
        -2333.853515625,
        764.5992431640625
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        657.0
      ],
      [
        -363.2724304199219,
        -2252.36962890625,
        765.0
      ],
      [
        -363.0396423339844,
        -2251.8076171875,
        764.6508178710938
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        649.0
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        649.0
      ],
      [
        -375.0616760253906,
        -2280.831298828125,
        657.0
      ],
      [
        -354.5302734375,
        -2250.155029296875,
        657.0
      ],
      [
        -354.5302734375,
        -2250.155029296875,
        649.0
      ],
      [
        -305.6617431640625,
        -2355.435302734375,
        768.0771484375
      ],
      [
        -288.1221923828125,
        -2348.16748046875,
        656.0
      ],
      [
        -302.9367980957031,
        -2354.306396484375,
        656.0
      ],
      [
        -302.7793273925781,
        -2354.24072265625,
        649.5
      ],
      [
        -288.1221923828125,
        -2348.16748046875,
        649.5
      ],
      [
        -329.705322265625,
        -2238.0,
        641.8458862304688
      ],
      [
        -327.0,
        -2238.0,
        646.4769897460938
      ],
      [
        -323.773681640625,
        -2238.0,
        652.0
      ],
      [
        -323.18951416015625,
        -2238.0,
        653.0
      ],
      [
        -306.294677734375,
        -2238.0,
        681.921875
      ],
      [
        -323.1895751953125,
        -2238.0,
        653.0
      ],
      [
        -275.0711364746094,
        -2232.599609375,
        740.710205078125
      ],
      [
        -285.4931640625,
        -2225.38427734375,
        730.0
      ],
      [
        -294.2331237792969,
        -2238.0,
        765.0
      ],
      [
        -278.6796875,
        -2238.0,
        756.0718994140625
      ],
      [
        -306.2945861816406,
        -2238.0,
        768.0771484375
      ],
      [
        -306.2945861816406,
        -2238.0,
        768.0771484375
      ],
      [
        -294.2331237792969,
        -2238.0,
        765.0
      ],
      [
        -275.0711364746094,
        -2232.599609375,
        740.710205078125
      ],
      [
        -272.955078125,
        -2238.0,
        750.0
      ],
      [
        -270.53131103515625,
        -2238.0,
        743.144287109375
      ],
      [
        -310.39990234375,
        -2238.0,
        768.073974609375
      ],
      [
        -310.39990234375,
        -2238.0,
        764.5277099609375
      ],
      [
        -323.39990234375,
        -2238.0,
        768.073974609375
      ],
      [
        -323.39990234375,
        -2238.0,
        766.6275024414062
      ],
      [
        -327.0,
        -2238.0,
        646.4769287109375
      ],
      [
        -327.0,
        -2237.0,
        647.4650268554688
      ],
      [
        -323.39990234375,
        -2238.0,
        764.5277099609375
      ],
      [
        -325.60009765625,
        -2238.0,
        764.5277099609375
      ],
      [
        -323.39990234375,
        -2238.0,
        764.5277099609375
      ],
      [
        -327.0,
        -2237.0,
        647.4650268554688
      ],
      [
        -324.3509826660156,
        -2237.0,
        652.0
      ],
      [
        -324.3509521484375,
        -2237.0,
        652.0
      ],
      [
        -323.773681640625,
        -2238.0,
        652.0
      ],
      [
        -312.60009765625,
        -2238.0,
        764.5277099609375
      ],
      [
        -310.39990234375,
        -2238.0,
        764.5277099609375
      ],
      [
        -278.6796875,
        -2238.0,
        756.0718994140625
      ],
      [
        -272.955078125,
        -2238.0,
        750.0
      ],
      [
        -327.0,
        -2247.5888671875,
        637.0
      ],
      [
        -309.0,
        -2278.765380859375,
        637.0
      ],
      [
        -299.84228515625,
        -2294.626953125,
        637.0
      ],
      [
        -285.05804443359375,
        -2320.234130859375,
        637.0
      ],
      [
        -309.0,
        -2286.84716796875,
        629.0125122070312
      ],
      [
        -309.0,
        -2278.765625,
        637.0
      ],
      [
        -305.317138671875,
        -2292.359130859375,
        629.869140625
      ],
      [
        -309.0,
        -2286.84716796875,
        629.012451171875
      ],
      [
        -281.51007080078125,
        -2343.57958984375,
        620.0
      ],
      [
        -296.254638671875,
        -2318.041259765625,
        620.0
      ],
      [
        -259.15283203125,
        -2308.552490234375,
        692.8920288085938
      ],
      [
        -268.11181640625,
        -2330.181396484375,
        656.178466796875
      ],
      [
        -248.58514404296875,
        -2283.039794921875,
        756.0720825195312
      ],
      [
        -254.537109375,
        -2297.4091796875,
        765.0
      ],
      [
        -259.15289306640625,
        -2308.552490234375,
        768.0772094726562
      ],
      [
        -256.6043701171875,
        -2302.39990234375,
        762.8057250976562
      ],
      [
        -256.652587890625,
        -2302.516357421875,
        762.878173828125
      ],
      [
        -251.21954345703125,
        -2289.39990234375,
        754.7135009765625
      ],
      [
        -252.1309051513672,
        -2291.60009765625,
        756.0830688476562
      ],
      [
        -259.15289306640625,
        -2308.552490234375,
        768.0772094726562
      ],
      [
        -254.537109375,
        -2297.4091796875,
        765.0
      ],
      [
        -252.1309051513672,
        -2291.60009765625,
        761.3987426757812
      ],
      [
        -252.1309051513672,
        -2291.60009765625,
        756.0830688476562
      ],
      [
        -248.58514404296875,
        -2283.039794921875,
        756.0720825195312
      ],
      [
        -246.3943634033203,
        -2277.750732421875,
        750.0
      ],
      [
        -257.5157165527344,
        -2304.60009765625,
        766.9873046875
      ],
      [
        -257.5157165527344,
        -2304.60009765625,
        764.1752319335938
      ],
      [
        -256.652587890625,
        -2302.516357421875,
        762.878173828125
      ],
      [
        -257.5157165527344,
        -2304.60009765625,
        763.4488525390625
      ],
      [
        -257.5157165527344,
        -2304.60009765625,
        763.4488525390625
      ],
      [
        -355.1276550292969,
        -2320.260009765625,
        768.4163818359375
      ],
      [
        -327.6992492675781,
        -2254.058349609375,
        768.3970336914062
      ],
      [
        -331.69427490234375,
        -2250.063720703125,
        775.0
      ],
      [
        -360.75799560546875,
        -2320.260009765625,
        775.0
      ],
      [
        -355.1276550292969,
        -2320.260009765625,
        768.4163818359375
      ],
      [
        -327.6992492675781,
        -2254.058349609375,
        768.3970336914062
      ],
      [
        -294.6983947753906,
        -2302.448974609375,
        704.0
      ],
      [
        -294.6982116699219,
        -2295.487548828125,
        704.0
      ],
      [
        -296.69622802734375,
        -2298.024658203125,
        702.0020751953125
      ],
      [
        -360.75799560546875,
        -2320.260009765625,
        775.0
      ],
      [
        -371.6578674316406,
        -2307.5205078125,
        771.5366821289062
      ],
      [
        -362.1115417480469,
        -2320.260009765625,
        774.1663208007812
      ],
      [
        -300.55328369140625,
        -2289.483154296875,
        698.1448364257812
      ],
      [
        -310.8764343261719,
        -2279.160400390625,
        698.1448364257812
      ],
      [
        -331.69427490234375,
        -2250.063720703125,
        775.0
      ],
      [
        -339.64227294921875,
        -2242.115966796875,
        768.0772094726562
      ],
      [
        -310.8764343261719,
        -2279.160400390625,
        698.1448364257812
      ],
      [
        -323.843994140625,
        -2273.304931640625,
        704.0
      ],
      [
        -300.55328369140625,
        -2289.483154296875,
        698.1448364257812
      ],
      [
        -371.99786376953125,
        -2320.260009765625,
        768.0770874023438
      ],
      [
        -372.79205322265625,
        -2275.351806640625,
        657.0
      ],
      [
        -351.334228515625,
        -2246.958984375,
        657.0
      ],
      [
        -348.556396484375,
        -2251.1162109375,
        657.0
      ],
      [
        -372.79205322265625,
        -2275.351806640625,
        649.0
      ],
      [
        -351.334228515625,
        -2246.958984375,
        649.0
      ],
      [
        -348.556396484375,
        -2251.1162109375,
        649.0
      ],
      [
        -372.7919921875,
        -2275.351806640625,
        644.0
      ],
      [
        -317.0,
        -2264.757080078125,
        687.5
      ],
      [
        -319.5,
        -2262.25732421875,
        687.5
      ],
      [
        -317.0,
        -2264.757080078125,
        687.5
      ],
      [
        -317.0,
        -2264.757080078125,
        690.0
      ],
      [
        -317.0,
        -2283.30517578125,
        694.0
      ],
      [
        -317.0,
        -2276.395263671875,
        700.9097900390625
      ],
      [
        -312.59326171875,
        -2283.30517578125,
        687.5
      ],
      [
        -311.19805908203125,
        -2284.700439453125,
        687.5
      ],
      [
        -304.6982421875,
        -2291.199951171875,
        687.5
      ],
      [
        -304.6982421875,
        -2293.1728515625,
        687.5
      ],
      [
        -304.6982421875,
        -2291.199951171875,
        687.5
      ],
      [
        -306.1867370605469,
        -2289.71142578125,
        684.0
      ],
      [
        -311.77496337890625,
        -2281.32958984375,
        674.1215209960938
      ],
      [
        -304.6982421875,
        -2291.9443359375,
        686.6312255859375
      ],
      [
        -304.6982421875,
        -2292.18994140625,
        687.5
      ],
      [
        -306.1867370605469,
        -2289.71142578125,
        684.0
      ],
      [
        -304.6982421875,
        -2291.199951171875,
        686.10498046875
      ],
      [
        -304.6982421875,
        -2291.199951171875,
        686.10498046875
      ],
      [
        -324.47882080078125,
        -2278.30517578125,
        663.0
      ],
      [
        -325.4339599609375,
        -2279.26025390625,
        663.0
      ],
      [
        -323.75830078125,
        -2310.260009765625,
        686.10498046875
      ],
      [
        -305.0262451171875,
        -2290.871826171875,
        685.64111328125
      ],
      [
        -304.6982421875,
        -2300.0078125,
        692.3330078125
      ],
      [
        -302.6981506347656,
        -2298.5,
        687.5
      ],
      [
        -302.6981201171875,
        -2296.0,
        687.5
      ],
      [
        -302.6981506347656,
        -2298.5,
        687.5
      ],
      [
        -302.6981506347656,
        -2298.5,
        690.0
      ],
      [
        -310.5927429199219,
        -2308.259765625,
        694.0
      ],
      [
        -299.6982421875,
        -2298.5,
        687.5
      ],
      [
        -299.6982421875,
        -2298.5,
        690.0
      ],
      [
        -299.6982421875,
        -2298.5,
        687.5
      ],
      [
        -299.6982421875,
        -2296.0,
        687.5
      ],
      [
        -294.698486328125,
        -2298.5,
        687.5
      ],
      [
        -294.69842529296875,
        -2296.0,
        687.5
      ],
      [
        -294.698486328125,
        -2298.5,
        687.5
      ],
      [
        -294.6984558105469,
        -2298.5,
        690.0
      ],
      [
        -319.5,
        -2315.26025390625,
        687.5
      ],
      [
        -317.0,
        -2315.26025390625,
        687.5
      ],
      [
        -317.0,
        -2315.26025390625,
        690.0
      ],
      [
        -317.0,
        -2315.26025390625,
        687.5
      ],
      [
        -319.5,
        -2320.260009765625,
        687.5
      ],
      [
        -317.0,
        -2320.260009765625,
        687.5
      ],
      [
        -317.0,
        -2320.260009765625,
        690.0
      ],
      [
        -317.0,
        -2320.260009765625,
        687.5
      ],
      [
        -284.97320556640625,
        -2296.7822265625,
        757.2086181640625
      ],
      [
        -286.69134521484375,
        -2298.5,
        687.5
      ],
      [
        -284.973388671875,
        -2296.781982421875,
        687.5
      ],
      [
        -285.75537109375,
        -2296.0,
        687.5
      ],
      [
        -286.6913146972656,
        -2298.5,
        687.5
      ],
      [
        -286.6912841796875,
        -2298.5,
        690.0
      ],
      [
        -275.3641052246094,
        -2287.172607421875,
        768.283935546875
      ],
      [
        -271.2539367675781,
        -2283.0625,
        775.0
      ],
      [
        -275.3641052246094,
        -2287.172607421875,
        768.283935546875
      ],
      [
        -287.1449890136719,
        -2259.893798828125,
        774.40380859375
      ],
      [
        -286.8111877441406,
        -2259.56005859375,
        774.9500122070312
      ],
      [
        -323.39990234375,
        -2248.452880859375,
        774.9201049804688
      ],
      [
        -323.39990234375,
        -2248.389892578125,
        774.9934692382812
      ],
      [
        -310.39990234375,
        -2248.452880859375,
        774.9201049804688
      ],
      [
        -310.39990234375,
        -2248.389892578125,
        774.9934692382812
      ],
      [
        -277.9519348144531,
        -2269.08544921875,
        774.4052734375
      ],
      [
        -277.61895751953125,
        -2268.75244140625,
        774.9501342773438
      ],
      [
        -332.6547546386719,
        -2249.103271484375,
        774.1633911132812
      ],
      [
        -271.2539367675781,
        -2283.0625,
        775.0
      ],
      [
        -268.6414794921875,
        -2280.449951171875,
        772.7244262695312
      ],
      [
        -298.52166748046875,
        -2249.794677734375,
        773.3587036132812
      ],
      [
        -307.3294677734375,
        -2243.202880859375,
        771.545654296875
      ],
      [
        -316.771728515625,
        -2238.0,
        768.0771484375
      ],
      [
        -312.60009765625,
        -2242.70654296875,
        767.6395874023438
      ],
      [
        -310.39990234375,
        -2243.923583984375,
        768.4441528320312
      ],
      [
        -307.3294677734375,
        -2243.202880859375,
        771.545654296875
      ],
      [
        -310.39990234375,
        -2241.5146484375,
        770.4146728515625
      ],
      [
        -310.39990234375,
        -2243.923583984375,
        768.4441528320312
      ],
      [
        -284.665771484375,
        -2246.958984375,
        710.093017578125
      ],
      [
        -285.50494384765625,
        -2246.611328125,
        709.0
      ],
      [
        -285.50494384765625,
        -2246.611328125,
        709.0
      ],
      [
        -306.294677734375,
        -2238.0,
        681.9216918945312
      ],
      [
        -273.5221862792969,
        -2251.574951171875,
        765.0
      ],
      [
        -259.1528015136719,
        -2257.52685546875,
        756.0718994140625
      ],
      [
        -256.0746765136719,
        -2255.469970703125,
        750.62548828125
      ],
      [
        -257.74468994140625,
        -2253.21044921875,
        750.0
      ],
      [
        -257.74468994140625,
        -2253.21044921875,
        750.0
      ],
      [
        -284.666015625,
        -2246.958984375,
        768.0773315429688
      ],
      [
        -277.2724609375,
        -2250.021484375,
        763.548583984375
      ],
      [
        -277.2724609375,
        -2250.021484375,
        761.87109375
      ],
      [
        -277.2724609375,
        -2250.021484375,
        765.9661865234375
      ],
      [
        -277.2724609375,
        -2250.021484375,
        763.548583984375
      ],
      [
        -268.1687927246094,
        -2240.917724609375,
        744.3046875
      ],
      [
        -269.6319274902344,
        -2242.380859375,
        740.353759765625
      ],
      [
        -278.89019775390625,
        -2249.351318359375,
        762.878173828125
      ],
      [
        -277.2724609375,
        -2250.021484375,
        761.87109375
      ],
      [
        -271.0533752441406,
        -2240.69091796875,
        739.5908813476562
      ],
      [
        -269.6319274902344,
        -2242.380859375,
        740.353759765625
      ],
      [
        -278.89019775390625,
        -2249.351318359375,
        762.878173828125
      ],
      [
        -279.47259521484375,
        -2249.110107421875,
        763.0377197265625
      ],
      [
        -264.2724609375,
        -2255.40625,
        759.0989990234375
      ],
      [
        -264.2724304199219,
        -2255.40625,
        753.77880859375
      ],
      [
        -266.4726257324219,
        -2254.494873046875,
        755.1486206054688
      ],
      [
        -264.2724304199219,
        -2255.40625,
        753.77880859375
      ],
      [
        -262.65435791015625,
        -2250.676513671875,
        744.0996704101562
      ],
      [
        -261.23291015625,
        -2252.36669921875,
        744.8624877929688
      ],
      [
        -256.0746765136719,
        -2255.469970703125,
        750.62548828125
      ],
      [
        -259.1528015136719,
        -2257.52685546875,
        756.0718994140625
      ],
      [
        -253.9504852294922,
        -2259.681640625,
        750.0993041992188
      ],
      [
        -259.7735290527344,
        -2271.581787109375,
        765.0
      ],
      [
        -317.0,
        -2238.0,
        692.0
      ],
      [
        -317.0,
        -2238.0,
        670.5
      ],
      [
        -315.0,
        -2238.0,
        768.0771484375
      ],
      [
        -315.4066162109375,
        -2238.752197265625,
        768.57861328125
      ],
      [
        -259.7735290527344,
        -2271.581787109375,
        765.0
      ],
      [
        -252.11990356445312,
        -2263.927978515625,
        750.0
      ],
      [
        -253.54966735839844,
        -2260.476318359375,
        750.0
      ],
      [
        -277.2724609375,
        -2250.021484375,
        762.4357299804688
      ],
      [
        -284.665771484375,
        -2246.958984375,
        710.093017578125
      ],
      [
        -282.0301208496094,
        -2249.5947265625,
        712.0
      ],
      [
        -276.5016784667969,
        -2255.123046875,
        716.0
      ],
      [
        -282.0301208496094,
        -2249.5947265625,
        712.0
      ],
      [
        -284.1914367675781,
        -2296.0,
        687.5
      ],
      [
        -280.9521179199219,
        -2320.260009765625,
        768.4164428710938
      ],
      [
        -275.24200439453125,
        -2320.260009765625,
        775.0
      ],
      [
        -280.9521179199219,
        -2320.260009765625,
        768.4164428710938
      ],
      [
        -269.5799560546875,
        -2291.60009765625,
        774.95068359375
      ],
      [
        -269.54083251953125,
        -2291.60009765625,
        774.9957885742188
      ],
      [
        -269.5799560546875,
        -2304.60009765625,
        774.95068359375
      ],
      [
        -269.54083251953125,
        -2304.60009765625,
        774.9957885742188
      ],
      [
        -270.276123046875,
        -2282.084716796875,
        774.1482543945312
      ],
      [
        -275.24200439453125,
        -2320.260009765625,
        775.0
      ],
      [
        -271.52398681640625,
        -2320.260009765625,
        772.7099609375
      ],
      [
        -259.15283203125,
        -2292.254638671875,
        709.0
      ],
      [
        -259.15283203125,
        -2289.219482421875,
        712.0
      ],
      [
        -259.15283203125,
        -2285.172119140625,
        716.0
      ],
      [
        -259.15283203125,
        -2289.219482421875,
        712.0
      ],
      [
        -259.15283203125,
        -2292.254638671875,
        709.0
      ],
      [
        -259.15283203125,
        -2308.552490234375,
        692.8920288085938
      ],
      [
        -259.15283203125,
        -2291.60009765625,
        768.0775756835938
      ],
      [
        -259.15283203125,
        -2291.60009765625,
        764.53125
      ],
      [
        -259.15283203125,
        -2289.39990234375,
        764.53125
      ],
      [
        -259.15283203125,
        -2291.60009765625,
        764.53125
      ],
      [
        -259.15283203125,
        -2304.60009765625,
        768.0775756835938
      ],
      [
        -259.15283203125,
        -2304.60009765625,
        764.53125
      ],
      [
        -259.15283203125,
        -2302.39990234375,
        764.53125
      ],
      [
        -259.15283203125,
        -2304.60009765625,
        764.53125
      ],
      [
        -268.1064453125,
        -2298.5,
        687.5
      ],
      [
        -266.6460876464844,
        -2298.5,
        690.0
      ],
      [
        -268.1064758300781,
        -2298.5,
        687.5
      ],
      [
        -269.5498046875,
        -2296.0,
        687.5
      ],
      [
        -264.002197265625,
        -2320.260009765625,
        768.0771484375
      ],
      [
        -287.645751953125,
        -2334.990966796875,
        774.96826171875
      ],
      [
        -287.85504150390625,
        -2334.78173828125,
        774.6270751953125
      ],
      [
        -323.39990234375,
        -2345.309814453125,
        774.9935302734375
      ],
      [
        -323.39990234375,
        -2345.24853515625,
        774.922607421875
      ],
      [
        -310.39990234375,
        -2345.309814453125,
        774.9935302734375
      ],
      [
        -310.39990234375,
        -2345.24853515625,
        774.922607421875
      ],
      [
        -278.453369140625,
        -2325.798583984375,
        774.96826171875
      ],
      [
        -278.66265869140625,
        -2325.58935546875,
        774.6270751953125
      ],
      [
        -362.111328125,
        -2320.260009765625,
        774.1664428710938
      ],
      [
        -273.8943176269531,
        -2320.260009765625,
        774.169921875
      ],
      [
        -298.5257568359375,
        -2343.8994140625,
        773.3609619140625
      ],
      [
        -287.61065673828125,
        -2342.32861328125,
        771.5429077148438
      ],
      [
        -277.26458740234375,
        -2339.334228515625,
        768.0772094726562
      ],
      [
        -283.6685791015625,
        -2338.96826171875,
        767.6533813476562
      ],
      [
        -286.0847473144531,
        -2339.663330078125,
        768.4580078125
      ],
      [
        -287.61065673828125,
        -2342.32861328125,
        771.5429077148438
      ],
      [
        -283.6685791015625,
        -2338.96826171875,
        767.6533813476562
      ],
      [
        -281.9682922363281,
        -2340.668212890625,
        769.62109375
      ],
      [
        -337.4929504394531,
        -2343.896728515625,
        773.3577880859375
      ],
      [
        -335.5086975097656,
        -2345.383544921875,
        772.9483642578125
      ],
      [
        -362.6601257324219,
        -2335.4091796875,
        768.0773315429688
      ],
      [
        -355.3629150390625,
        -2328.11181640625,
        774.9572143554688
      ],
      [
        -349.48187255859375,
        -2340.615478515625,
        771.8353271484375
      ],
      [
        -346.1705322265625,
        -2337.30419921875,
        774.9572143554688
      ],
      [
        -309.9782409667969,
        -2351.913818359375,
        656.0
      ],
      [
        -287.44775390625,
        -2342.578125,
        656.0
      ],
      [
        -284.665771484375,
        -2346.7353515625,
        656.0
      ],
      [
        -309.8203430175781,
        -2351.848388671875,
        649.5
      ],
      [
        -287.44775390625,
        -2342.578125,
        649.5
      ],
      [
        -284.665771484375,
        -2346.7353515625,
        649.5
      ],
      [
        -312.8372497558594,
        -2350.796142578125,
        648.017578125
      ],
      [
        -322.4810485839844,
        -2238.0,
        637.0
      ],
      [
        -309.0,
        -2261.349853515625,
        637.0
      ],
      [
        -286.626953125,
        -2300.10107421875,
        637.0
      ],
      [
        -271.8426208496094,
        -2325.708251953125,
        637.0
      ],
      [
        -291.7740478515625,
        -2281.471435546875,
        620.0
      ],
      [
        -293.556640625,
        -2278.3837890625,
        620.0
      ],
      [
        -293.556640625,
        -2278.3837890625,
        620.0
      ],
      [
        -298.0791320800781,
        -2270.550537109375,
        620.0
      ],
      [
        -287.602783203125,
        -2288.6962890625,
        620.0
      ],
      [
        -291.7740478515625,
        -2281.471435546875,
        620.0
      ],
      [
        -306.5559387207031,
        -2255.868408203125,
        620.0
      ],
      [
        -307.0,
        -2255.09912109375,
        620.0
      ],
      [
        -281.1927490234375,
        -2299.798828125,
        620.0
      ],
      [
        -287.602783203125,
        -2288.6962890625,
        620.0
      ],
      [
        -298.0791320800781,
        -2270.550537109375,
        620.0
      ],
      [
        -306.5559387207031,
        -2255.868408203125,
        620.0
      ],
      [
        -307.0,
        -2255.09912109375,
        620.0
      ],
      [
        -309.0,
        -2255.06396484375,
        626.0
      ],
      [
        -309.0,
        -2255.06396484375,
        626.0
      ],
      [
        -309.0,
        -2261.349853515625,
        637.0
      ],
      [
        -268.11181640625,
        -2330.181396484375,
        633.5195922851562
      ],
      [
        -268.83978271484375,
        -2330.909423828125,
        637.0
      ],
      [
        -268.11181640625,
        -2330.181396484375,
        633.5195922851562
      ],
      [
        -297.349609375,
        -2274.0,
        623.8251953125
      ],
      [
        -301.3143615722656,
        -2266.0,
        621.8427734375
      ],
      [
        -297.2080078125,
        -2274.0,
        623.39599609375
      ],
      [
        -297.349609375,
        -2274.0,
        623.8251953125
      ],
      [
        -305.712646484375,
        -2266.0,
        635.1737060546875
      ],
      [
        -308.9999694824219,
        -2261.349853515625,
        637.0
      ],
      [
        -305.5107116699219,
        -2266.0,
        634.5615234375
      ],
      [
        -305.712646484375,
        -2266.0,
        635.1737060546875
      ],
      [
        -268.83978271484375,
        -2330.909423828125,
        637.0
      ],
      [
        -271.140625,
        -2333.210205078125,
        648.0
      ],
      [
        -326.68756103515625,
        -2237.0,
        647.9998779296875
      ],
      [
        -324.0,
        -2237.0,
        639.8541259765625
      ],
      [
        -326.0,
        -2232.133544921875,
        637.4000244140625
      ],
      [
        -326.0,
        -2234.0,
        640.666259765625
      ],
      [
        -324.0,
        -2237.0,
        639.8541259765625
      ],
      [
        -324.0,
        -2235.94189453125,
        638.002197265625
      ],
      [
        -326.0,
        -2232.133544921875,
        637.4000244140625
      ],
      [
        -324.92236328125,
        -2234.0,
        637.4000244140625
      ],
      [
        -324.0,
        -2235.94189453125,
        638.002197265625
      ],
      [
        -323.38897705078125,
        -2237.0,
        638.002197265625
      ],
      [
        -322.4810485839844,
        -2238.0,
        637.0
      ],
      [
        -322.811767578125,
        -2238.0,
        638.002197265625
      ],
      [
        -323.3890686035156,
        -2237.0,
        638.002197265625
      ],
      [
        -322.811767578125,
        -2238.0,
        638.002197265625
      ],
      [
        -365.06195068359375,
        -2143.212646484375,
        641.0
      ],
      [
        -364.6510314941406,
        -2143.24560546875,
        641.0
      ],
      [
        -363.30609130859375,
        -2143.353515625,
        641.0
      ],
      [
        -357.38592529296875,
        -2143.828857421875,
        641.0
      ],
      [
        -259.5,
        -2232.5,
        637.0
      ],
      [
        -269.067138671875,
        -2234.403076171875,
        637.0
      ],
      [
        -306.294677734375,
        -2238.0,
        635.4971313476562
      ],
      [
        -290.0999450683594,
        -2274.0,
        626.5
      ],
      [
        -268.11181640625,
        -2263.512939453125,
        641.0
      ],
      [
        -284.665771484375,
        -2246.958984375,
        641.0
      ],
      [
        -259.5,
        -2232.5,
        641.0
      ],
      [
        -269.067138671875,
        -2234.403076171875,
        641.0
      ],
      [
        -284.665771484375,
        -2246.958984375,
        641.0
      ],
      [
        -306.294677734375,
        -2238.0,
        641.0
      ],
      [
        -326.0,
        -2229.837646484375,
        637.4000244140625
      ],
      [
        -315.95172119140625,
        -2234.0,
        637.4000244140625
      ],
      [
        -326.0,
        -2227.60009765625,
        641.0
      ],
      [
        -328.39990234375,
        -2222.39990234375,
        641.0
      ],
      [
        -326.0,
        -2227.60009765625,
        641.0
      ],
      [
        -326.0,
        -2229.837646484375,
        637.4000244140625
      ],
      [
        -326.0,
        -2229.837890625,
        641.0
      ],
      [
        -328.39990234375,
        -2222.39990234375,
        641.0
      ],
      [
        -315.9515075683594,
        -2234.0,
        638.002197265625
      ],
      [
        -312.0,
        -2235.636962890625,
        638.002197265625
      ],
      [
        -259.15283203125,
        -2308.552490234375,
        641.0
      ],
      [
        -259.15283203125,
        -2285.141845703125,
        641.0
      ],
      [
        -259.15283203125,
        -2314.728759765625,
        638.001220703125
      ],
      [
        -259.15283203125,
        -2319.005126953125,
        638.0
      ],
      [
        -259.15283203125,
        -2328.595703125,
        638.0
      ],
      [
        -259.15283203125,
        -2319.005126953125,
        638.0
      ],
      [
        -245.0,
        -2313.5,
        641.0
      ],
      [
        -255.0,
        -2313.5,
        641.0
      ],
      [
        -245.0,
        -2331.5,
        641.0
      ],
      [
        -255.0,
        -2331.5,
        641.0
      ],
      [
        -245.0,
        -2320.0,
        641.0
      ],
      [
        -245.0,
        -2313.5,
        641.0
      ],
      [
        -245.0,
        -2325.0,
        641.0
      ],
      [
        -245.0,
        -2331.5,
        641.0
      ],
      [
        -229.974853515625,
        -2314.357177734375,
        641.0
      ],
      [
        -243.39990234375,
        -2314.357177734375,
        641.0
      ],
      [
        -243.39990234375,
        -2314.357177734375,
        641.0
      ],
      [
        -243.39990234375,
        -2320.0,
        641.0
      ],
      [
        -243.39990234375,
        -2331.142822265625,
        641.0
      ],
      [
        -243.39990234375,
        -2325.0,
        641.0
      ],
      [
        -245.0,
        -2325.0,
        641.0
      ],
      [
        -243.39990234375,
        -2325.0,
        641.0
      ],
      [
        -243.39990234375,
        -2320.0,
        641.0
      ],
      [
        -245.0,
        -2320.0,
        641.0
      ],
      [
        -242.73895263671875,
        -2331.142822265625,
        641.0
      ],
      [
        -243.39990234375,
        -2331.142822265625,
        641.0
      ],
      [
        -259.15283203125,
        -2328.595703125,
        638.0
      ],
      [
        -255.0,
        -2331.5,
        641.0
      ],
      [
        -259.15283203125,
        -2328.595703125,
        641.0
      ],
      [
        -257.640869140625,
        -2315.35498046875,
        641.0
      ],
      [
        -255.0,
        -2313.5,
        641.0
      ],
      [
        -259.15283203125,
        -2314.728759765625,
        641.0
      ],
      [
        -257.640869140625,
        -2315.35498046875,
        641.0
      ],
      [
        -259.15283203125,
        -2314.728759765625,
        638.001220703125
      ],
      [
        -259.15283203125,
        -2285.141845703125,
        641.0
      ],
      [
        -268.11181640625,
        -2263.512939453125,
        641.0
      ],
      [
        -267.07666015625,
        -2327.682373046875,
        641.0
      ],
      [
        -268.11181640625,
        -2330.181396484375,
        641.0
      ],
      [
        -259.15283203125,
        -2308.552490234375,
        641.0
      ],
      [
        -260.188232421875,
        -2311.052490234375,
        641.0
      ],
      [
        -262.233154296875,
        -2326.44140625,
        641.0
      ],
      [
        -265.004638671875,
        -2325.29345703125,
        641.0
      ],
      [
        -266.15283203125,
        -2328.06494140625,
        641.0
      ],
      [
        -262.233154296875,
        -2326.44140625,
        641.0
      ],
      [
        -265.004638671875,
        -2325.29345703125,
        641.0
      ],
      [
        -266.15283203125,
        -2328.06494140625,
        641.0
      ],
      [
        -267.07666015625,
        -2327.682373046875,
        641.0
      ],
      [
        -259.264404296875,
        -2311.435302734375,
        641.0
      ],
      [
        -260.41259765625,
        -2314.206787109375,
        641.0
      ],
      [
        -260.41259765625,
        -2314.206787109375,
        641.0
      ],
      [
        -260.188232421875,
        -2311.052490234375,
        641.0
      ],
      [
        -259.264404296875,
        -2311.435302734375,
        641.0
      ],
      [
        -309.0,
        -2238.0,
        641.0
      ],
      [
        -306.294677734375,
        -2238.0,
        641.0
      ],
      [
        -326.0,
        -2232.4775390625,
        638.002197265625
      ],
      [
        -326.0,
        -2229.837646484375,
        638.002197265625
      ],
      [
        -326.0,
        -2234.0,
        641.0
      ],
      [
        -312.0,
        -2237.0,
        641.0
      ],
      [
        -309.0,
        -2237.0,
        641.0
      ],
      [
        -324.0,
        -2237.0,
        641.0
      ],
      [
        -324.3780517578125,
        -2237.0,
        641.0
      ],
      [
        -324.0,
        -2237.0,
        641.0
      ],
      [
        -324.0,
        -2234.0,
        641.0
      ],
      [
        -268.11181640625,
        -2330.181396484375,
        641.0
      ],
      [
        -269.67645263671875,
        -2331.74609375,
        641.0
      ],
      [
        -98.89990234375,
        -2170.90673828125,
        673.2559204101562
      ],
      [
        -98.89990234375,
        -2171.28857421875,
        675.2023315429688
      ],
      [
        -98.89990234375,
        -2171.2890625,
        675.2044067382812
      ],
      [
        -97.92158508300781,
        -2171.367431640625,
        675.2044067382812
      ],
      [
        -364.9443359375,
        -2153.537109375,
        660.0
      ],
      [
        -367.13494873046875,
        -2154.8017578125,
        660.0
      ],
      [
        -358.4848937988281,
        -2149.807861328125,
        660.0
      ],
      [
        -360.700927734375,
        -2151.087158203125,
        660.0
      ],
      [
        -371.1348876953125,
        -2147.87353515625,
        660.0
      ],
      [
        -369.92108154296875,
        -2147.172607421875,
        662.7705078125
      ],
      [
        -369.123291015625,
        -2146.712158203125,
        660.0
      ],
      [
        -354.9443359375,
        -2170.857666015625,
        660.0
      ],
      [
        -357.13494873046875,
        -2172.122314453125,
        660.0
      ],
      [
        -348.4848937988281,
        -2167.12841796875,
        660.0
      ],
      [
        -350.700927734375,
        -2168.40771484375,
        660.0
      ],
      [
        -364.53326416015625,
        -2144.06201171875,
        644.0625610351562
      ],
      [
        -363.6513977050781,
        -2143.552734375,
        641.0
      ],
      [
        -366.5311279296875,
        -2145.21533203125,
        651.0
      ],
      [
        -368.7496032714844,
        -2146.496337890625,
        658.7023315429688
      ],
      [
        -368.7496032714844,
        -2146.496337890625,
        658.7023315429688
      ],
      [
        -364.5332336425781,
        -2144.06201171875,
        644.062255859375
      ],
      [
        -364.513427734375,
        -2143.48388671875,
        641.0
      ],
      [
        -358.63592529296875,
        -2172.98876953125,
        654.0
      ],
      [
        -358.63592529296875,
        -2172.98876953125,
        656.5740966796875
      ],
      [
        -359.3679504394531,
        -2172.2568359375,
        654.0
      ],
      [
        -358.63592529296875,
        -2172.98876953125,
        654.0
      ],
      [
        -281.46978759765625,
        -2250.155029296875,
        649.0
      ],
      [
        -281.46978759765625,
        -2250.155029296875,
        657.0
      ],
      [
        -268.4111633300781,
        -2235.98681640625,
        657.0
      ],
      [
        -275.9655456542969,
        -2241.034423828125,
        657.0
      ],
      [
        -275.9655456542969,
        -2241.034423828125,
        657.0
      ],
      [
        -277.177734375,
        -2239.822265625,
        657.0
      ],
      [
        -264.6871337890625,
        -2236.531982421875,
        660.0
      ],
      [
        -259.5,
        -2234.21435546875,
        657.0
      ],
      [
        -268.4111633300781,
        -2235.98681640625,
        657.0
      ],
      [
        -281.46978759765625,
        -2250.155029296875,
        649.0
      ],
      [
        -281.46978759765625,
        -2250.155029296875,
        657.0
      ],
      [
        -326.0,
        -2229.837890625,
        653.0
      ],
      [
        -326.0,
        -2229.837890625,
        641.0
      ],
      [
        -325.60491943359375,
        -2218.606689453125,
        651.0
      ],
      [
        -312.0,
        -2235.636962890625,
        652.0
      ],
      [
        -315.9515075683594,
        -2234.0,
        652.0
      ],
      [
        -259.15283203125,
        -2319.005126953125,
        653.0
      ],
      [
        -259.15283203125,
        -2328.595703125,
        653.0
      ],
      [
        -259.15283203125,
        -2328.595703125,
        653.0
      ],
      [
        -259.15283203125,
        -2328.595703125,
        641.0
      ],
      [
        -259.15283203125,
        -2314.728759765625,
        652.0
      ],
      [
        -259.15283203125,
        -2314.728759765625,
        641.0
      ],
      [
        -259.15283203125,
        -2319.005126953125,
        652.0
      ],
      [
        -259.15283203125,
        -2314.728759765625,
        652.0
      ],
      [
        -259.15283203125,
        -2319.005126953125,
        653.0
      ],
      [
        -259.15283203125,
        -2319.005126953125,
        652.0
      ],
      [
        -260.9382629394531,
        -2280.831298828125,
        657.0
      ],
      [
        -260.9382629394531,
        -2280.831298828125,
        649.0
      ],
      [
        -262.233154296875,
        -2326.44140625,
        652.0
      ],
      [
        -259.15283203125,
        -2328.595703125,
        652.0
      ],
      [
        -326.0,
        -2229.837890625,
        652.0
      ],
      [
        -326.0,
        -2234.0,
        652.0
      ],
      [
        -284.937255859375,
        -2253.62255859375,
        651.1942749023438
      ],
      [
        -287.443603515625,
        -2251.1162109375,
        652.0241088867188
      ],
      [
        -278.30975341796875,
        -2260.25,
        649.0
      ],
      [
        -263.2077941894531,
        -2275.35205078125,
        657.0
      ],
      [
        -263.2077941894531,
        -2275.35205078125,
        649.0
      ],
      [
        -278.3096923828125,
        -2260.25,
        649.0
      ],
      [
        -282.19207763671875,
        -2250.877197265625,
        649.0
      ],
      [
        -282.19207763671875,
        -2250.87744140625,
        649.0
      ],
      [
        -284.937255859375,
        -2253.62255859375,
        651.1942749023438
      ],
      [
        -267.4749755859375,
        -2296.0,
        687.5
      ],
      [
        -364.66168212890625,
        -2144.13623046875,
        645.5453491210938
      ],
      [
        -363.3061828613281,
        -2143.353515625,
        641.0
      ],
      [
        -366.2882385253906,
        -2145.0751953125,
        651.0
      ],
      [
        -368.7686767578125,
        -2146.50732421875,
        659.3187866210938
      ],
      [
        -369.8477478027344,
        -2147.13037109375,
        662.9379272460938
      ],
      [
        -368.7686767578125,
        -2146.50732421875,
        659.3187866210938
      ],
      [
        -364.6617126464844,
        -2144.13623046875,
        645.5458374023438
      ],
      [
        -364.65106201171875,
        -2143.24560546875,
        641.0
      ],
      [
        -215.28790283203125,
        -1920.0,
        765.0
      ],
      [
        -170.0,
        -1936.797119140625,
        765.0
      ],
      [
        -170.0,
        -1936.2301025390625,
        770.0
      ],
      [
        -170.0,
        -1936.797119140625,
        765.0
      ],
      [
        -198.0,
        -1927.659423828125,
        754.0
      ],
      [
        -184.0,
        -1932.8519287109375,
        754.0
      ],
      [
        -184.0,
        -1931.6046142578125,
        765.0
      ],
      [
        -184.0,
        -1932.8519287109375,
        754.0
      ],
      [
        68.57462310791016,
        -2026.14208984375,
        757.430419921875
      ],
      [
        14.773176193237305,
        -2016.3717041015625,
        667.627197265625
      ],
      [
        -128.44635009765625,
        -2205.07421875,
        861.0
      ],
      [
        -264.4729309082031,
        -2193.06298828125,
        861.0
      ],
      [
        -268.6394958496094,
        -2184.9228515625,
        820.7928466796875
      ],
      [
        -245.69189453125,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -124.04474639892578,
        -2197.54248046875,
        820.029052734375
      ],
      [
        -245.69189453125,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -249.2655487060547,
        -2187.44677734375,
        825.0
      ],
      [
        -263.5,
        -2186.18994140625,
        825.0
      ],
      [
        -249.2655487060547,
        -2187.44677734375,
        825.0
      ],
      [
        -235.0,
        -2188.70654296875,
        825.0
      ],
      [
        -235.0,
        -2188.70654296875,
        825.0
      ],
      [
        -197.5,
        -2192.017578125,
        825.0
      ],
      [
        -266.2284240722656,
        -2191.65185546875,
        854.5
      ],
      [
        -267.6540832519531,
        -2188.336181640625,
        838.0
      ],
      [
        -267.6045837402344,
        -2188.050537109375,
        836.5
      ],
      [
        -266.188720703125,
        -2187.44677734375,
        832.7301025390625
      ],
      [
        -263.5,
        -2186.18994140625,
        825.0
      ],
      [
        -266.188720703125,
        -2187.44677734375,
        832.7301025390625
      ],
      [
        -267.6540832519531,
        -2188.336181640625,
        838.0
      ],
      [
        -267.6045837402344,
        -2188.050537109375,
        836.5
      ],
      [
        -363.734375,
        -2143.600830078125,
        650.4729614257812
      ],
      [
        -360.9834899902344,
        -2142.0126953125,
        641.0
      ],
      [
        -367.9532775878906,
        -2146.03662109375,
        665.0
      ],
      [
        -365.0140380859375,
        -2144.339599609375,
        654.8792114257812
      ],
      [
        -365.0140380859375,
        -2144.339599609375,
        654.8790893554688
      ],
      [
        -363.734375,
        -2143.600830078125,
        650.4729614257812
      ],
      [
        -426.1673278808594,
        -2135.9248046875,
        639.28125
      ],
      [
        -431.5350646972656,
        -2135.450927734375,
        639.28125
      ],
      [
        -360.98345947265625,
        -2142.0126953125,
        641.0
      ],
      [
        -358.2976379394531,
        -2142.249755859375,
        641.0
      ],
      [
        -401.5849609375,
        -2082.965576171875,
        639.28125
      ],
      [
        -419.1666564941406,
        -2078.143798828125,
        639.28125
      ],
      [
        -254.15249633789062,
        -2181.5,
        821.0
      ],
      [
        -234.2333221435547,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -235.50311279296875,
        -2186.517333984375,
        820.6963500976562
      ],
      [
        -234.2333221435547,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -229.9622802734375,
        -2188.29833984375,
        820.5885620117188
      ],
      [
        -258.8155822753906,
        -2181.5,
        825.0
      ],
      [
        -237.13143920898438,
        -2187.44677734375,
        825.0
      ],
      [
        -237.13143920898438,
        -2187.44677734375,
        825.0
      ],
      [
        -235.0,
        -2188.031494140625,
        825.0
      ],
      [
        -235.0,
        -2188.031494140625,
        825.0
      ],
      [
        -233.3797149658203,
        -2188.475830078125,
        825.0
      ],
      [
        -231.81451416015625,
        -2188.98779296875,
        825.0
      ],
      [
        -269.2121276855469,
        -2181.5,
        825.0
      ],
      [
        -258.81561279296875,
        -2181.5,
        825.0
      ],
      [
        -254.15249633789062,
        -2181.5,
        821.0
      ],
      [
        -261.0,
        -2179.781982421875,
        821.5
      ],
      [
        -254.73513793945312,
        -2181.5,
        821.5
      ],
      [
        -265.49188232421875,
        -2181.5,
        830.7266845703125
      ],
      [
        -272.8636169433594,
        -2181.5,
        837.0499267578125
      ],
      [
        -265.7732238769531,
        -2189.02392578125,
        854.5
      ],
      [
        -266.0673522949219,
        -2187.44677734375,
        849.8194580078125
      ],
      [
        -267.5,
        -2183.27490234375,
        838.0
      ],
      [
        -266.0673522949219,
        -2187.44677734375,
        849.8194580078125
      ],
      [
        -267.5,
        -2182.795166015625,
        836.5
      ],
      [
        -267.5,
        -2186.3974609375,
        836.5
      ],
      [
        -267.5,
        -2183.27490234375,
        838.0
      ],
      [
        -267.5,
        -2186.397216796875,
        836.5
      ],
      [
        -267.5,
        -2182.795166015625,
        836.5
      ],
      [
        -266.9954528808594,
        -2182.4697265625,
        835.0494384765625
      ],
      [
        -264.2076416015625,
        -2191.531494140625,
        861.0
      ],
      [
        -255.84568786621094,
        -2193.82470703125,
        861.0
      ],
      [
        -265.49188232421875,
        -2181.5,
        830.7266845703125
      ],
      [
        -267.61553955078125,
        -2188.11376953125,
        836.8322143554688
      ],
      [
        -329.551025390625,
        -2111.903076171875,
        667.9999389648438
      ],
      [
        -328.260009765625,
        -2113.5361328125,
        671.9999389648438
      ],
      [
        -254.70298767089844,
        -2181.5,
        825.0
      ],
      [
        -236.52528381347656,
        -2187.44677734375,
        825.0
      ],
      [
        -236.52528381347656,
        -2187.44677734375,
        825.0
      ],
      [
        -235.0,
        -2187.94580078125,
        825.0
      ],
      [
        -235.0,
        -2187.94580078125,
        825.0
      ],
      [
        -251.11251831054688,
        -2181.5,
        821.0
      ],
      [
        -254.70306396484375,
        -2181.5,
        825.0
      ],
      [
        -251.11251831054688,
        -2181.5,
        821.0
      ],
      [
        -257.3690185546875,
        -2179.60009765625,
        821.5
      ],
      [
        -251.56141662597656,
        -2181.5,
        821.5
      ],
      [
        -405.8373718261719,
        -2077.516357421875,
        639.28125
      ],
      [
        -418.1611022949219,
        -2073.484619140625,
        639.28125
      ],
      [
        -330.61334228515625,
        -2110.559326171875,
        667.9999389648438
      ],
      [
        -329.3607177734375,
        -2112.143798828125,
        671.9999389648438
      ],
      [
        -263.7865295410156,
        -2189.100830078125,
        861.0
      ],
      [
        -246.9434814453125,
        -2194.61083984375,
        861.0
      ],
      [
        -265.5,
        -2186.631591796875,
        854.5
      ],
      [
        -267.3659362792969,
        -2181.5,
        839.1060791015625
      ],
      [
        -267.6778869628906,
        -2181.5,
        836.5323486328125
      ],
      [
        -268.1094665527344,
        -2181.5,
        832.9719848632812
      ],
      [
        -300.0,
        -1945.20947265625,
        765.0
      ],
      [
        -245.41427612304688,
        -1948.9671630859375,
        765.0
      ],
      [
        -224.35635375976562,
        -1948.4483642578125,
        765.0
      ],
      [
        -170.0,
        -1944.1578369140625,
        765.0
      ],
      [
        -170.0,
        -1941.3096923828125,
        770.0
      ],
      [
        -170.0,
        -1944.1578369140625,
        765.0
      ],
      [
        -187.0,
        -1987.0,
        692.1473388671875
      ],
      [
        -187.0,
        -1979.0,
        706.1912231445312
      ],
      [
        -275.0,
        -1987.0,
        688.9052124023438
      ],
      [
        -275.0,
        -1979.0,
        704.09765625
      ],
      [
        -283.0,
        -1987.0,
        687.8590087890625
      ],
      [
        -275.0,
        -1987.0,
        688.9052124023438
      ],
      [
        -275.0,
        -1920.0,
        754.0
      ],
      [
        -286.0,
        -1951.9654541015625,
        754.0
      ],
      [
        -275.0,
        -1952.72265625,
        754.0
      ],
      [
        -195.0,
        -1987.0,
        693.2556762695312
      ],
      [
        -187.0,
        -1987.0,
        692.1473388671875
      ],
      [
        -272.0,
        -1952.92919921875,
        754.0
      ],
      [
        -198.0,
        -1952.634033203125,
        754.0
      ],
      [
        -187.0,
        -1951.7657470703125,
        754.0
      ],
      [
        -187.0,
        -1931.7392578125,
        754.0
      ],
      [
        -272.0,
        -1947.136962890625,
        765.0
      ],
      [
        -272.0,
        -1952.92919921875,
        754.0
      ],
      [
        -184.0,
        -1945.2628173828125,
        765.0
      ],
      [
        -184.0,
        -1951.5289306640625,
        754.0
      ],
      [
        -184.0,
        -1951.5289306640625,
        754.0
      ],
      [
        -237.67677307128906,
        -1949.499755859375,
        765.0
      ],
      [
        -102.61023712158203,
        -1997.278564453125,
        691.9224853515625
      ],
      [
        12.043344497680664,
        -2018.70361328125,
        666.2241821289062
      ],
      [
        -102.61023712158203,
        -1997.278564453125,
        691.9224853515625
      ],
      [
        -187.0,
        -1987.0,
        700.22021484375
      ],
      [
        -187.0,
        -1979.3470458984375,
        705.5819702148438
      ],
      [
        -195.0,
        -1987.0,
        699.363525390625
      ],
      [
        -188.31881713867188,
        -1987.0,
        700.2373046875
      ],
      [
        -187.0,
        -1987.0,
        700.22021484375
      ],
      [
        -187.0,
        -1987.0,
        700.4097900390625
      ],
      [
        -187.0,
        -1981.5091552734375,
        710.8372192382812
      ],
      [
        -187.0,
        -1979.0,
        712.6160888671875
      ],
      [
        -187.0,
        -1987.0,
        700.4097900390625
      ],
      [
        -170.0,
        -1954.15869140625,
        765.0
      ],
      [
        -170.0,
        -1951.52587890625,
        770.0
      ],
      [
        -170.0,
        -1954.15869140625,
        765.0
      ],
      [
        -198.0,
        -1958.0234375,
        754.0
      ],
      [
        -184.0,
        -1958.9871826171875,
        754.0
      ],
      [
        -184.0,
        -1953.1949462890625,
        765.0
      ],
      [
        -184.0,
        -1958.9871826171875,
        754.0
      ],
      [
        -187.0,
        -1979.0,
        715.6021728515625
      ],
      [
        -253.8267364501953,
        -2192.359130859375,
        861.0
      ],
      [
        -244.94610595703125,
        -2194.787109375,
        861.0
      ],
      [
        -235.5003662109375,
        -2186.518310546875,
        820.6962890625
      ],
      [
        -233.986572265625,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -233.986572265625,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -228.36619567871094,
        -2188.437744140625,
        820.5801391601562
      ],
      [
        -236.34214782714844,
        -2187.44677734375,
        825.0
      ],
      [
        -237.45729064941406,
        -2187.141845703125,
        825.0
      ],
      [
        -236.34214782714844,
        -2187.44677734375,
        825.0
      ],
      [
        -235.0,
        -2187.81396484375,
        825.0
      ],
      [
        -235.0,
        -2187.81396484375,
        825.0
      ],
      [
        -230.1781005859375,
        -2189.13232421875,
        825.0
      ],
      [
        -348.0,
        -1894.5,
        896.2352294921875
      ],
      [
        -348.0,
        -1896.3245849609375,
        892.0023193359375
      ],
      [
        -348.0,
        -1928.0,
        818.5177001953125
      ],
      [
        -348.0,
        -1896.3245849609375,
        892.0023193359375
      ],
      [
        -360.0,
        -1939.0,
        799.3532104492188
      ],
      [
        -348.0,
        -1928.0,
        818.5177001953125
      ],
      [
        -360.0,
        -1939.0,
        799.3532104492188
      ],
      [
        -361.6381530761719,
        -1939.0,
        800.2208251953125
      ],
      [
        -324.68878173828125,
        -2021.324462890625,
        644.844482421875
      ],
      [
        -315.411865234375,
        -2027.576171875,
        645.0999755859375
      ],
      [
        -277.33551025390625,
        -2067.337890625,
        645.7384643554688
      ],
      [
        -292.2315673828125,
        -2043.1973876953125,
        645.7384643554688
      ],
      [
        -408.5467529296875,
        -2076.6298828125,
        639.28125
      ],
      [
        -413.2454833984375,
        -2069.01513671875,
        639.28125
      ],
      [
        -324.6888122558594,
        -2021.324462890625,
        644.844482421875
      ],
      [
        -388.58135986328125,
        -2032.8753662109375,
        663.3584594726562
      ],
      [
        -304.71929931640625,
        -2035.7083740234375,
        645.7384643554688
      ],
      [
        -315.411865234375,
        -2027.576171875,
        645.0999755859375
      ],
      [
        -304.71929931640625,
        -2035.7083740234375,
        645.7384643554688
      ],
      [
        -388.5813293457031,
        -2032.875244140625,
        663.3585205078125
      ],
      [
        -412.54541015625,
        -2039.072998046875,
        670.9950561523438
      ],
      [
        -114.99471282958984,
        -2097.310302734375,
        626.3668212890625
      ],
      [
        -108.57621765136719,
        -2161.762939453125,
        648.8665771484375
      ],
      [
        -114.99471282958984,
        -2097.310302734375,
        626.3668212890625
      ],
      [
        -83.20115661621094,
        -2104.146728515625,
        621.826171875
      ],
      [
        -101.90265655517578,
        -2130.586669921875,
        623.885009765625
      ],
      [
        -404.5986328125,
        -1972.0,
        778.7999267578125
      ],
      [
        -375.3880310058594,
        -1957.9093017578125,
        778.7999267578125
      ],
      [
        -369.0,
        -1954.0013427734375,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        785.90283203125
      ],
      [
        -369.0,
        -1953.787841796875,
        779.1787109375
      ],
      [
        -369.0,
        -1953.787841796875,
        779.1787109375
      ],
      [
        -369.0,
        -1954.0013427734375,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        785.9027099609375
      ],
      [
        -369.0,
        -1946.408935546875,
        792.2772827148438
      ],
      [
        -404.5986328125,
        -1972.0,
        778.7999267578125
      ],
      [
        -407.1495056152344,
        -1972.0,
        781.3291625976562
      ],
      [
        -369.0,
        -1950.0,
        788.7233276367188
      ],
      [
        -369.0,
        -1954.6036376953125,
        779.2603149414062
      ],
      [
        -369.0,
        -1954.6036376953125,
        779.2603149414062
      ],
      [
        -369.0,
        -1954.8277587890625,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        788.7232666015625
      ],
      [
        -369.0,
        -1939.0,
        811.334228515625
      ],
      [
        -369.0,
        -1954.8277587890625,
        778.7999267578125
      ],
      [
        -360.0,
        -1939.0,
        802.4100341796875
      ],
      [
        -369.0,
        -1939.0,
        811.334228515625
      ],
      [
        -360.0,
        -1939.0,
        802.4100341796875
      ],
      [
        -355.6596984863281,
        -1935.0213623046875,
        806.2848510742188
      ],
      [
        -360.0,
        -1939.0,
        861.0
      ],
      [
        -369.0,
        -1939.0,
        861.0
      ],
      [
        -348.0,
        -1928.0,
        861.0
      ],
      [
        -348.0,
        -1909.68798828125,
        861.0
      ],
      [
        -360.0,
        -1939.0,
        861.0
      ],
      [
        -348.0,
        -1928.0,
        861.0
      ],
      [
        -369.0,
        -1948.777587890625,
        896.0
      ],
      [
        -369.0,
        -1951.2220458984375,
        892.0
      ],
      [
        -369.0,
        -1951.2220458984375,
        892.0
      ],
      [
        -369.0,
        -1950.0,
        861.0
      ],
      [
        -369.0,
        -1970.16650390625,
        861.0
      ],
      [
        -369.0,
        -1950.0,
        861.0
      ],
      [
        -369.0,
        -1939.0,
        861.0
      ],
      [
        -369.0,
        -1972.0,
        861.0
      ],
      [
        -414.0,
        -1972.0,
        861.0
      ],
      [
        -369.0,
        -1972.0,
        861.0
      ],
      [
        -86.32891082763672,
        -2208.73486328125,
        861.0
      ],
      [
        -73.71693420410156,
        -2206.524169921875,
        861.0
      ],
      [
        -369.0,
        -1972.0,
        857.0
      ],
      [
        -414.0,
        -1972.0,
        857.0
      ],
      [
        -369.0,
        -1950.0,
        857.0
      ],
      [
        -369.0,
        -1972.0,
        857.0
      ],
      [
        -369.0,
        -1950.0,
        857.0
      ],
      [
        -369.0,
        -1939.0,
        857.0
      ],
      [
        -348.0,
        -1928.0,
        857.0
      ],
      [
        -348.0,
        -1911.4122314453125,
        857.0
      ],
      [
        -360.0,
        -1939.0,
        857.0
      ],
      [
        -348.0,
        -1928.0,
        857.0
      ],
      [
        -360.0,
        -1939.0,
        857.0
      ],
      [
        -369.0,
        -1939.0,
        857.0
      ],
      [
        -85.15402221679688,
        -2208.044677734375,
        857.0
      ],
      [
        -68.068359375,
        -2205.0498046875,
        857.0
      ],
      [
        69.5562515258789,
        -2031.6385498046875,
        765.0
      ],
      [
        45.69890594482422,
        -2016.7991943359375,
        765.0
      ],
      [
        -74.22229766845703,
        -2201.62353515625,
        819.7821655273438
      ],
      [
        -16.371803283691406,
        -2191.55712890625,
        820.3914184570312
      ],
      [
        -58.13154220581055,
        -2192.172119140625,
        765.0
      ],
      [
        -51.65239334106445,
        -2191.036376953125,
        765.0
      ],
      [
        -170.0,
        -1972.0,
        770.0
      ],
      [
        -170.0,
        -1972.0,
        765.0
      ],
      [
        -349.0,
        -1972.0,
        778.7999267578125
      ],
      [
        -349.0,
        -1972.0,
        780.0
      ],
      [
        -349.0,
        -1972.0,
        778.7999267578125
      ],
      [
        -300.0,
        -1987.0,
        768.5
      ],
      [
        -170.0,
        -2022.0,
        768.5
      ],
      [
        -180.0,
        -2032.0,
        768.5
      ],
      [
        -240.5909881591797,
        -2021.4366455078125,
        645.9365234375
      ],
      [
        -63.10908508300781,
        -2075.536865234375,
        619.3864135742188
      ],
      [
        -305.740966796875,
        -2034.931396484375,
        645.6774291992188
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        621.8704833984375
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        619.8964233398438
      ],
      [
        -109.34033203125,
        -2064.5546875,
        626.2376098632812
      ],
      [
        -108.29034423828125,
        -2066.72607421875,
        626.0420532226562
      ],
      [
        -108.29034423828125,
        -2066.72607421875,
        618.412841796875
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        619.8964233398438
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        619.7420654296875
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.8348999023438
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.909423828125
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.2986450195312
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.2986450195312
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        621.8704833984375
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        618.5244140625
      ],
      [
        -92.5,
        -2071.60009765625,
        623.6787109375
      ],
      [
        -92.20443725585938,
        -2073.7763671875,
        623.5911254882812
      ],
      [
        -88.0,
        -2071.60009765625,
        623.0339965820312
      ],
      [
        -88.27062225341797,
        -2073.7421875,
        618.5244140625
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        623.0282592773438
      ],
      [
        -88.4703369140625,
        -2075.322998046875,
        618.5244140625
      ],
      [
        -88.47034454345703,
        -2075.322998046875,
        623.0239868164062
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.909423828125
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.8348999023438
      ],
      [
        -91.45051574707031,
        -2079.3271484375,
        618.5244140625
      ],
      [
        -91.7616195678711,
        -2077.03662109375,
        623.4599609375
      ],
      [
        -88.93833923339844,
        -2079.02734375,
        618.5244140625
      ],
      [
        -88.6663589477539,
        -2076.87451171875,
        623.0198364257812
      ],
      [
        -327.486328125,
        -2021.8302001953125,
        645.6550903320312
      ],
      [
        -66.13585662841797,
        -2079.825927734375,
        619.7308349609375
      ],
      [
        -91.10107421875,
        -2081.89990234375,
        623.2642211914062
      ],
      [
        -91.75544738769531,
        -2077.08203125,
        623.362060546875
      ],
      [
        -91.51126861572266,
        -2078.8798828125,
        623.3858032226562
      ],
      [
        -89.30126953125,
        -2081.89990234375,
        623.00634765625
      ],
      [
        -88.93164825439453,
        -2078.974365234375,
        623.0142211914062
      ],
      [
        -88.67304992675781,
        -2076.927490234375,
        622.9092407226562
      ],
      [
        -327.7740478515625,
        -2021.8822021484375,
        645.7384643554688
      ],
      [
        -314.21600341796875,
        -2007.10302734375,
        656.7817993164062
      ],
      [
        -385.0126037597656,
        -2028.814453125,
        666.47265625
      ],
      [
        -240.59097290039062,
        -2021.4366455078125,
        645.9365234375
      ],
      [
        -296.6871337890625,
        -2009.82958984375,
        654.2139892578125
      ],
      [
        -314.21600341796875,
        -2007.10302734375,
        656.7817993164062
      ],
      [
        -296.6871337890625,
        -2009.82958984375,
        654.2139892578125
      ],
      [
        -316.01904296875,
        -2003.9818115234375,
        661.4907836914062
      ],
      [
        -382.3850402832031,
        -2025.824462890625,
        668.7655639648438
      ],
      [
        -291.2506103515625,
        -2007.9521484375,
        657.6783447265625
      ],
      [
        -62.7277717590332,
        -2075.334228515625,
        619.7196044921875
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        622.5484008789062
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        620.512451171875
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        620.512451171875
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        620.6177368164062
      ],
      [
        -109.34033203125,
        -2064.5546875,
        627.1937866210938
      ],
      [
        -108.29034423828125,
        -2066.72607421875,
        626.850830078125
      ],
      [
        -108.29034423828125,
        -2066.72607421875,
        626.0420532226562
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.6292724609375
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        622.5484008789062
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        625.5057373046875
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.6292724609375
      ],
      [
        -92.2044448852539,
        -2073.776123046875,
        623.5911865234375
      ],
      [
        -92.5,
        -2071.60009765625,
        624.208251953125
      ],
      [
        -92.20443725585938,
        -2073.776123046875,
        623.9700927734375
      ],
      [
        -88.0,
        -2071.60009765625,
        623.5809326171875
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        623.0282592773438
      ],
      [
        -88.27063751220703,
        -2073.7421875,
        623.4247436523438
      ],
      [
        -108.0561294555664,
        -2067.21044921875,
        626.7743530273438
      ],
      [
        -108.0561294555664,
        -2067.21044921875,
        625.9984130859375
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        625.5057373046875
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        626.487548828125
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        626.487548828125
      ],
      [
        -91.99930572509766,
        -2075.28662109375,
        623.5303955078125
      ],
      [
        -91.9992904663086,
        -2075.28662109375,
        623.8047485351562
      ],
      [
        -88.66636657714844,
        -2076.87451171875,
        623.0198364257812
      ],
      [
        -88.6552963256836,
        -2076.786865234375,
        623.2027587890625
      ],
      [
        -91.7616195678711,
        -2077.03662109375,
        623.4599609375
      ],
      [
        -91.77179718017578,
        -2076.961669921875,
        623.6213989257812
      ],
      [
        -66.43791198730469,
        -2080.27587890625,
        619.7894897460938
      ],
      [
        -88.9316635131836,
        -2078.974365234375,
        623.01416015625
      ],
      [
        -88.98394012451172,
        -2079.38818359375,
        623.0130615234375
      ],
      [
        -88.96121215820312,
        -2079.208251953125,
        623.0261840820312
      ],
      [
        -91.4609146118164,
        -2079.25048828125,
        623.370849609375
      ],
      [
        -91.51126861572266,
        -2078.8798828125,
        623.3857421875
      ],
      [
        -91.48284912109375,
        -2079.0888671875,
        623.3885498046875
      ],
      [
        -316.01904296875,
        -2003.9818115234375,
        661.4907836914062
      ],
      [
        -291.2506103515625,
        -2007.9521484375,
        657.6783447265625
      ],
      [
        -55.8358154296875,
        -2070.095703125,
        629.0819091796875
      ],
      [
        -55.83583068847656,
        -2070.095703125,
        629.0819091796875
      ],
      [
        -61.5699348449707,
        -2074.71875,
        620.7313842773438
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        623.4908447265625
      ],
      [
        -76.6781005859375,
        -2070.5419921875,
        622.0982666015625
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        623.4908447265625
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        629.1729736328125
      ],
      [
        -195.0,
        -1987.0,
        700.3240966796875
      ],
      [
        -188.31881713867188,
        -1987.0,
        700.2373046875
      ],
      [
        -187.0,
        -1987.0,
        707.8583984375
      ],
      [
        -187.0,
        -1979.0,
        719.287353515625
      ],
      [
        -195.0,
        -1987.0,
        705.4226684570312
      ],
      [
        -187.0,
        -1987.0,
        707.8583984375
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        630.9338989257812
      ],
      [
        -67.10551452636719,
        -2071.697509765625,
        628.5385131835938
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        628.0416259765625
      ],
      [
        -109.34033203125,
        -2064.5546875,
        638.447021484375
      ],
      [
        -108.29034423828125,
        -2066.72607421875,
        636.38916015625
      ],
      [
        -108.29034423828125,
        -2066.72607421875,
        626.850830078125
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        628.0410766601562
      ],
      [
        -66.0083236694336,
        -2071.541259765625,
        628.591796875
      ],
      [
        -64.5244140625,
        -2068.18017578125,
        631.5252685546875
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        634.208984375
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        627.8012084960938
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        630.9338989257812
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        632.651123046875
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        627.8012084960938
      ],
      [
        -88.0,
        -2071.60009765625,
        630.3185424804688
      ],
      [
        -88.27063751220703,
        -2073.7421875,
        623.4247436523438
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        628.394287109375
      ],
      [
        -92.20443725585938,
        -2073.776123046875,
        623.9700927734375
      ],
      [
        -92.5,
        -2071.60009765625,
        630.682861328125
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        628.6818237304688
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        632.651123046875
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        634.208984375
      ],
      [
        -91.99928283691406,
        -2075.28662109375,
        623.8047485351562
      ],
      [
        -92.00619506835938,
        -2075.23583984375,
        627.3397827148438
      ],
      [
        -91.99928283691406,
        -2075.286865234375,
        627.2301025390625
      ],
      [
        -88.6552963256836,
        -2076.786865234375,
        623.2027587890625
      ],
      [
        -88.39450073242188,
        -2074.72265625,
        627.5135498046875
      ],
      [
        -91.77178955078125,
        -2076.961669921875,
        623.6213989257812
      ],
      [
        -67.05274963378906,
        -2081.191650390625,
        619.908935546875
      ],
      [
        -88.96121215820312,
        -2079.208251953125,
        623.0261840820312
      ],
      [
        -89.02759552001953,
        -2079.733642578125,
        623.0121459960938
      ],
      [
        -89.02214050292969,
        -2079.6904296875,
        623.0509033203125
      ],
      [
        -91.4180679321289,
        -2079.56591796875,
        623.358154296875
      ],
      [
        -91.48284912109375,
        -2079.0888671875,
        623.3885498046875
      ],
      [
        -91.42340850830078,
        -2079.526611328125,
        623.394287109375
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        628.3524780273438
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        628.3524780273438
      ],
      [
        -76.63468170166016,
        -2094.86328125,
        621.103271484375
      ],
      [
        -91.10107421875,
        -2081.89990234375,
        623.3673095703125
      ],
      [
        -91.42340850830078,
        -2079.526611328125,
        623.394287109375
      ],
      [
        -91.25300598144531,
        -2080.78125,
        623.4108276367188
      ],
      [
        -89.02214050292969,
        -2079.6904296875,
        623.0509033203125
      ],
      [
        -89.30126953125,
        -2081.89990234375,
        623.1181030273438
      ],
      [
        -89.19314575195312,
        -2081.0439453125,
        623.1203002929688
      ],
      [
        -91.10107421875,
        -2081.89990234375,
        623.4255981445312
      ],
      [
        -89.30126953125,
        -2081.89990234375,
        623.1641845703125
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        641.6576538085938
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        643.7562255859375
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        643.7562255859375
      ],
      [
        -65.88987731933594,
        -2071.27294921875,
        644.2874145507812
      ],
      [
        -73.17527770996094,
        -2061.257080078125,
        651.0582275390625
      ],
      [
        -65.88987731933594,
        -2071.27294921875,
        644.2874145507812
      ],
      [
        -109.34033203125,
        -2064.5546875,
        638.8286743164062
      ],
      [
        -108.29034423828125,
        -2066.72607421875,
        637.2233276367188
      ],
      [
        -108.29034423828125,
        -2066.72607421875,
        636.38916015625
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        635.1083984375
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        641.6576538085938
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        636.1566772460938
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        635.1083984375
      ],
      [
        -88.0,
        -2071.60009765625,
        638.270751953125
      ],
      [
        -88.24480438232422,
        -2073.537841796875,
        636.5319213867188
      ],
      [
        -88.27063751220703,
        -2073.7421875,
        628.394287109375
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        636.3485107421875
      ],
      [
        -88.24480438232422,
        -2073.537841796875,
        636.5319213867188
      ],
      [
        -92.40634155273438,
        -2072.28955078125,
        636.5319213867188
      ],
      [
        -92.5,
        -2071.60009765625,
        637.1038818359375
      ],
      [
        -92.20443725585938,
        -2073.776123046875,
        628.681884765625
      ],
      [
        -92.40634155273438,
        -2072.28955078125,
        636.5319213867188
      ],
      [
        -92.20442962646484,
        -2073.776123046875,
        635.2988891601562
      ],
      [
        -108.0561294555664,
        -2067.21044921875,
        636.865234375
      ],
      [
        -108.0561294555664,
        -2067.21044921875,
        635.9301147460938
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        636.1566772460938
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        635.5226440429688
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        635.5226440429688
      ],
      [
        -91.99928283691406,
        -2075.28662109375,
        627.2930297851562
      ],
      [
        -91.99928283691406,
        -2075.28662109375,
        634.0460815429688
      ],
      [
        -89.30126953125,
        -2081.89990234375,
        629.0275268554688
      ],
      [
        -91.10107421875,
        -2081.89990234375,
        628.5608520507812
      ],
      [
        -275.0,
        -1987.0,
        692.0352783203125
      ],
      [
        -275.0,
        -1979.0,
        704.5525512695312
      ],
      [
        -283.0,
        -1987.0,
        691.2600708007812
      ],
      [
        -275.0,
        -1987.0,
        692.0352783203125
      ],
      [
        -286.0,
        -1987.0,
        754.0
      ],
      [
        -275.0,
        -1987.0,
        754.0
      ],
      [
        -275.0,
        -1952.72265625,
        754.0
      ],
      [
        -272.0,
        -1987.0,
        765.0
      ],
      [
        -272.0,
        -1987.0,
        754.0
      ],
      [
        -272.0,
        -1987.0,
        754.0
      ],
      [
        -198.0,
        -1987.0,
        754.0
      ],
      [
        -187.0,
        -1987.0,
        754.0
      ],
      [
        -187.0,
        -1958.7806396484375,
        754.0
      ],
      [
        -184.0,
        -1987.0,
        765.0
      ],
      [
        -184.0,
        -1987.0,
        754.0
      ],
      [
        -184.0,
        -1987.0,
        754.0
      ],
      [
        -89.7894287109375,
        -2068.95947265625,
        657.7044067382812
      ],
      [
        -87.16264343261719,
        -2067.871337890625,
        657.7044067382812
      ],
      [
        -98.60043334960938,
        -2067.895751953125,
        655.6896362304688
      ],
      [
        -91.1700210571289,
        -2068.792724609375,
        657.7044067382812
      ],
      [
        -108.29034423828125,
        -2066.72607421875,
        644.2874145507812
      ],
      [
        -108.29034423828125,
        -2066.72607421875,
        637.2233276367188
      ],
      [
        -65.89373779296875,
        -2071.28173828125,
        644.2788696289062
      ],
      [
        -92.20443725585938,
        -2073.7763671875,
        652.7044067382812
      ],
      [
        -92.20443725585938,
        -2073.7763671875,
        635.2987060546875
      ],
      [
        -92.20443725585938,
        -2073.7763671875,
        652.7044067382812
      ],
      [
        -92.90979766845703,
        -2068.582763671875,
        657.232666015625
      ],
      [
        -88.2706069946289,
        -2073.7421875,
        641.2166748046875
      ],
      [
        -88.2706069946289,
        -2073.7421875,
        645.4983520507812
      ],
      [
        -88.2706069946289,
        -2073.7421875,
        645.4983520507812
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        648.5706787109375
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        636.5319213867188
      ],
      [
        -88.2706069946289,
        -2073.7421875,
        641.2166748046875
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        648.5706787109375
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        651.2399291992188
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        636.5319213867188
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        636.3485107421875
      ],
      [
        -92.20443725585938,
        -2073.776123046875,
        651.2399291992188
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        651.2399291992188
      ],
      [
        -90.27850341796875,
        -2074.573974609375,
        651.2399291992188
      ],
      [
        -91.9992904663086,
        -2075.28662109375,
        651.2399291992188
      ],
      [
        -90.278564453125,
        -2141.683837890625,
        674.4000244140625
      ],
      [
        -88.39550018310547,
        -2142.4638671875,
        675.2044067382812
      ],
      [
        -89.19995880126953,
        -2142.130615234375,
        674.4000244140625
      ],
      [
        -92.00436401367188,
        -2142.398681640625,
        675.2044067382812
      ],
      [
        -90.278564453125,
        -2141.683837890625,
        674.4000244140625
      ],
      [
        -91.19991302490234,
        -2142.0654296875,
        674.4000244140625
      ],
      [
        -90.278564453125,
        -2141.683837890625,
        673.478759765625
      ],
      [
        -90.1999282836914,
        -2141.71630859375,
        673.400146484375
      ],
      [
        -90.278564453125,
        -2141.683837890625,
        673.478759765625
      ],
      [
        -83.74978637695312,
        -2145.329345703125,
        666.950439453125
      ],
      [
        -84.2060546875,
        -2144.19921875,
        667.4066772460938
      ],
      [
        -84.2060546875,
        -2144.19921875,
        667.4066772460938
      ],
      [
        -85.80389404296875,
        -2144.61962890625,
        669.00439453125
      ],
      [
        -85.80387115478516,
        -2143.537353515625,
        669.00439453125
      ],
      [
        -85.5126953125,
        -2144.740234375,
        668.7131958007812
      ],
      [
        -85.1298828125,
        -2143.81640625,
        668.3304443359375
      ],
      [
        -85.80389404296875,
        -2144.61962890625,
        669.00439453125
      ],
      [
        -85.5126953125,
        -2144.740234375,
        668.7131958007812
      ],
      [
        -98.89990234375,
        -2158.0,
        659.7044067382812
      ],
      [
        -98.89990234375,
        -2158.0,
        658.8614501953125
      ],
      [
        -95.8794174194336,
        -2143.00390625,
        657.7044067382812
      ],
      [
        -93.32514190673828,
        -2136.533935546875,
        652.7044067382812
      ],
      [
        -95.8794174194336,
        -2143.00390625,
        659.7044067382812
      ],
      [
        -90.278564453125,
        -2139.488525390625,
        656.5999755859375
      ],
      [
        -95.31521606445312,
        -2141.57470703125,
        656.5999755859375
      ],
      [
        -90.278564453125,
        -2139.488525390625,
        656.5999755859375
      ],
      [
        -87.30269622802734,
        -2140.72119140625,
        656.5999755859375
      ],
      [
        -89.07133483886719,
        -2141.183837890625,
        659.7044067382812
      ],
      [
        -89.07144165039062,
        -2141.183837890625,
        657.7044067382812
      ],
      [
        -87.62838745117188,
        -2140.586181640625,
        656.5999755859375
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.6996034383773804,
        0.5319893956184387,
        0.4770140051841736
      ],
      "plane_d": 764.5562133789062,
      "bbox_min": [
        -2708.39404296875,
        -3171.47509765625,
        -22.699951171875
      ],
      "bbox_max": [
        6306.5068359375,
        7450.0,
        1913.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9162540435791016,
        0.4005979001522064
      ],
      "plane_d": 2051.624755859375,
      "bbox_min": [
        -409.263671875,
        -3171.47509765625,
        567.475341796875
      ],
      "bbox_max": [
        1321.548828125,
        -1994.8612060546875,
        1428.406005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5784722566604614,
        0.815333366394043,
        0.024523701518774033
      ],
      "plane_d": 2574.393798828125,
      "bbox_min": [
        -409.263671875,
        -3171.47509765625,
        651.6136474609375
      ],
      "bbox_max": [
        -22.141357421875,
        -2615.420654296875,
        1428.406005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5775443911552429,
        0.8160061836242676,
        0.024013595655560493
      ],
      "plane_d": 2576.89306640625,
      "bbox_min": [
        -244.5576171875,
        -3164.78857421875,
        699.0181884765625
      ],
      "bbox_max": [
        -22.141357421875,
        -3014.8623046875,
        1354.7957763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -244.5576171875,
        -3024.712158203125,
        699.0181884765625
      ],
      "bbox_max": [
        -229.613525390625,
        -3014.8623046875,
        1354.7957763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388457655906677,
        0.6731600761413574,
        0.031021639704704285
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -230.9855194091797,
        -3015.99462890625,
        699.0181884765625
      ],
      "bbox_max": [
        -229.613525390625,
        -3014.8623046875,
        707.4029541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -409.263671875,
        -3024.712158203125,
        651.6136474609375
      ],
      "bbox_max": [
        -126.417724609375,
        -2615.420654296875,
        1354.7957763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -409.263671875,
        -2930.564453125,
        651.6136474609375
      ],
      "bbox_max": [
        -126.417724609375,
        -2615.420654296875,
        1184.6998291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910527229309082,
        0.41264408826828003,
        0.025789525359869003
      ],
      "plane_d": 1473.680908203125,
      "bbox_min": [
        -409.263671875,
        -2924.27294921875,
        651.6136474609375
      ],
      "bbox_max": [
        -312.7353515625,
        -2829.429443359375,
        1100.168212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3401496112346649,
        0.9401360750198364,
        0.02103203907608986
      ],
      "plane_d": 2779.226806640625,
      "bbox_min": [
        -409.263671875,
        -2850.83837890625,
        651.6136474609375
      ],
      "bbox_max": [
        -347.613525390625,
        -2829.429443359375,
        1053.942626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26160192489624023,
        0.9247593879699707,
        0.27637779712677
      ],
      "plane_d": 2175.628173828125,
      "bbox_min": [
        -326.8089904785156,
        -2675.23974609375,
        749.8496704101562
      ],
      "bbox_max": [
        -126.417724609375,
        -2615.420654296875,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14437326788902283,
        0.977375328540802,
        0.1545761078596115
      ],
      "plane_d": 2438.747314453125,
      "bbox_min": [
        -326.8089904785156,
        -2675.23974609375,
        749.8496704101562
      ],
      "bbox_max": [
        -132.919921875,
        -2632.289306640625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5633555054664612,
        0.8184596300125122,
        0.11293553560972214
      ],
      "plane_d": 2242.135498046875,
      "bbox_min": [
        -326.8089904785156,
        -2675.23974609375,
        749.8496704101562
      ],
      "bbox_max": [
        -270.802978515625,
        -2632.289306640625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9162545204162598,
        -0.400596559047699
      ],
      "plane_d": 2527.13427734375,
      "bbox_min": [
        -372.79998779296875,
        -2508.5,
        567.475341796875
      ],
      "bbox_max": [
        1321.548828125,
        -1994.8612060546875,
        819.2384033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -226.5,
        -2508.5,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2409.43798828125,
        805.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2419.0,
      "bbox_min": [
        -215.0,
        -2424.0,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        780.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -215.0,
        -2424.0,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        780.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -210.5,
      "bbox_min": [
        -215.0,
        -2424.0,
        779.4000244140625
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 195.5,
      "bbox_min": [
        -195.5,
        -2424.0,
        779.4000244140625
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -191.0,
      "bbox_min": [
        -191.0,
        -2424.0,
        779.4000244140625
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        -215.0,
        -2424.0,
        779.4000244140625
      ],
      "bbox_max": [
        -215.0,
        -2419.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726728081703186,
        0.0,
        0.7399401068687439
      ],
      "plane_d": -431.7886962890625,
      "bbox_min": [
        -215.0,
        -2424.0,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        779.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        -215.0,
        -2424.0,
        779.0
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        779.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -191.0,
      "bbox_min": [
        -191.0,
        -2424.0,
        779.0
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        779.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 226.5,
      "bbox_min": [
        -226.5,
        -2508.5,
        780.0
      ],
      "bbox_max": [
        -191.0,
        -2409.43798828125,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -193.0,
      "bbox_min": [
        -226.5,
        -2508.5,
        780.0
      ],
      "bbox_max": [
        -191.0,
        -2409.43798828125,
        805.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 797.0,
      "bbox_min": [
        -193.0,
        -2498.5,
        780.0
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        800.1666870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.0,
        -0.768221378326416
      ],
      "plane_d": 491.1495361328125,
      "bbox_min": [
        -193.0,
        -2424.0,
        797.0
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        800.1666870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -191.0,
      "bbox_min": [
        -193.0,
        -2424.0,
        797.0
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        800.1666870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -193.0,
        -2424.0,
        797.0
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        800.1666870117188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2419.0,
      "bbox_min": [
        -193.0,
        -2419.0,
        797.0
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        800.1666870117188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -193.0,
        -2424.0,
        780.0
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2419.0,
      "bbox_min": [
        -193.0,
        -2419.0,
        780.0
      ],
      "bbox_max": [
        -191.0,
        -2419.0,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01624949462711811,
        0.5443580746650696,
        -0.8386954665184021
      ],
      "plane_d": 2030.669189453125,
      "bbox_min": [
        -226.5,
        -2508.5,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2409.43798828125,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7863183617591858,
        -0.0,
        0.6178215742111206
      ],
      "plane_d": -324.1316833496094,
      "bbox_min": [
        -226.5,
        -2508.5,
        789.0
      ],
      "bbox_max": [
        -193.0,
        -2485.113037109375,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 797.0,
      "bbox_min": [
        -226.5,
        -2508.5,
        789.0
      ],
      "bbox_max": [
        -210.2396697998047,
        -2495.68896484375,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 789.0,
      "bbox_min": [
        -219.26951599121094,
        -2508.5,
        789.0
      ],
      "bbox_max": [
        -210.2396697998047,
        -2508.23046875,
        789.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 797.0,
      "bbox_min": [
        -204.0,
        -2498.5,
        797.0
      ],
      "bbox_max": [
        -193.0,
        -2496.3603515625,
        797.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2452.0,
      "bbox_min": [
        -226.5,
        -2508.5,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2409.43798828125,
        805.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 797.0,
      "bbox_min": [
        -226.5,
        -2508.5,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2452.0,
        804.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7863183617591858,
        -0.0,
        0.6178215742111206
      ],
      "plane_d": -324.1316833496094,
      "bbox_min": [
        -219.5,
        -2496.06201171875,
        797.0
      ],
      "bbox_max": [
        -214.0,
        -2461.5,
        804.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.0,
      "bbox_min": [
        -226.5,
        -2508.5,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2452.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -194.5,
      "bbox_min": [
        -226.5,
        -2501.113525390625,
        794.0
      ],
      "bbox_max": [
        -193.0,
        -2455.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7302713990211487,
        0.6831571459770203,
        0.0
      ],
      "plane_d": 1566.267333984375,
      "bbox_min": [
        -194.5,
        -2500.603271484375,
        794.0
      ],
      "bbox_max": [
        -193.0,
        -2499.0,
        795.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5787469744682312,
        -0.8155071139335632
      ],
      "plane_d": 2095.0244140625,
      "bbox_min": [
        -194.5,
        -2500.603271484375,
        794.362060546875
      ],
      "bbox_max": [
        -193.0,
        -2499.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2477.999755859375,
      "bbox_min": [
        -226.5,
        -2501.113525390625,
        794.0
      ],
      "bbox_max": [
        -194.5,
        -2462.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2493.999755859375,
      "bbox_min": [
        -226.5,
        -2501.113525390625,
        794.0
      ],
      "bbox_max": [
        -194.5,
        -2478.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.5,
      "bbox_min": [
        -226.5,
        -2501.113525390625,
        794.0
      ],
      "bbox_max": [
        -194.5,
        -2494.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5787469744682312,
        -0.8155071139335632
      ],
      "plane_d": 2095.0244140625,
      "bbox_min": [
        -226.5,
        -2500.408935546875,
        794.5
      ],
      "bbox_max": [
        -194.5,
        -2494.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6872039437294006,
        0.7264645099639893,
        1.1068995263485704e-05
      ],
      "plane_d": 1970.351318359375,
      "bbox_min": [
        -226.5,
        -2499.591064453125,
        794.5
      ],
      "bbox_max": [
        -224.60009765625,
        -2494.0,
        795.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -225.0000457763672,
        -2496.5,
        794.5
      ],
      "bbox_max": [
        -224.60009765625,
        -2494.0,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2496.5,
      "bbox_min": [
        -194.89990234375,
        -2496.5,
        794.5
      ],
      "bbox_max": [
        -194.5,
        -2496.5,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5787469744682312,
        -0.8155071139335632
      ],
      "plane_d": 2095.0244140625,
      "bbox_min": [
        -226.5,
        -2501.113525390625,
        794.0
      ],
      "bbox_max": [
        -194.5,
        -2494.0,
        794.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6872039437294006,
        0.7264645099639893,
        1.1068995263485704e-05
      ],
      "plane_d": 1970.351318359375,
      "bbox_min": [
        -226.5,
        -2501.113525390625,
        794.0
      ],
      "bbox_max": [
        -194.5,
        -2494.0,
        794.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -225.20004272460938,
        -2501.113525390625,
        794.0
      ],
      "bbox_max": [
        -194.5,
        -2494.0,
        794.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7302713990211487,
        0.6831571459770203,
        0.0
      ],
      "plane_d": 1566.267333984375,
      "bbox_min": [
        -194.97727966308594,
        -2501.113525390625,
        794.0
      ],
      "bbox_max": [
        -194.5,
        -2496.5,
        794.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2496.5,
      "bbox_min": [
        -194.89990234375,
        -2496.5,
        794.0
      ],
      "bbox_max": [
        -194.5,
        -2496.5,
        794.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -225.0000457763672,
        -2494.0,
        794.5
      ],
      "bbox_max": [
        -224.60009765625,
        -2493.10009765625,
        795.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -225.20004272460938,
        -2494.0,
        794.0
      ],
      "bbox_max": [
        -225.0000457763672,
        -2493.10009765625,
        794.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2461.999755859375,
      "bbox_min": [
        -221.5,
        -2463.5,
        794.5
      ],
      "bbox_max": [
        -197.5,
        -2462.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 794.5,
      "bbox_min": [
        -220.5,
        -2463.5,
        794.5
      ],
      "bbox_max": [
        -197.5,
        -2462.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 702.1571044921875,
      "bbox_min": [
        -198.5,
        -2463.5,
        794.5
      ],
      "bbox_max": [
        -197.5,
        -2462.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5787469744682312,
        -0.8155071139335632
      ],
      "plane_d": 2095.0244140625,
      "bbox_min": [
        -226.5,
        -2508.5,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2452.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 789.0,
      "bbox_min": [
        -219.3412322998047,
        -2508.5,
        789.0
      ],
      "bbox_max": [
        -198.67579650878906,
        -2508.15869140625,
        789.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2506.75,
      "bbox_min": [
        -226.5,
        -2508.5,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2452.0,
        794.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -782.4999389648438,
      "bbox_min": [
        -220.75,
        -2508.5,
        782.5
      ],
      "bbox_max": [
        -197.33750915527344,
        -2506.75,
        789.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 789.0,
      "bbox_min": [
        -220.7499542236328,
        -2508.15869140625,
        789.0
      ],
      "bbox_max": [
        -197.33753967285156,
        -2506.75,
        789.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7302743196487427,
        0.6831540465354919,
        0.0
      ],
      "plane_d": 1566.2589111328125,
      "bbox_min": [
        -226.5,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2452.0,
        794.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -782.4999389648438,
      "bbox_min": [
        -200.25,
        -2506.75,
        782.5
      ],
      "bbox_max": [
        -195.192138671875,
        -2502.927490234375,
        789.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -781.5,
      "bbox_min": [
        -197.0,
        -2498.5,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2479.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.5,
      "bbox_min": [
        -197.0,
        -2494.0,
        780.0
      ],
      "bbox_max": [
        -194.0,
        -2479.0,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2479.0,
      "bbox_min": [
        -197.0,
        -2479.0,
        780.0
      ],
      "bbox_max": [
        -195.0,
        -2479.0,
        780.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -196.0,
      "bbox_min": [
        -196.0,
        -2494.0,
        781.0
      ],
      "bbox_max": [
        -194.0,
        -2479.0,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2479.0,
      "bbox_min": [
        -196.0,
        -2479.0,
        781.0
      ],
      "bbox_max": [
        -194.0,
        -2479.0,
        781.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -782.5,
      "bbox_min": [
        -195.0,
        -2498.5,
        782.0
      ],
      "bbox_max": [
        -193.0,
        -2479.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -2494.0,
        782.0
      ],
      "bbox_max": [
        -193.0,
        -2479.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2479.0,
      "bbox_min": [
        -195.0,
        -2479.0,
        782.0
      ],
      "bbox_max": [
        -193.0,
        -2479.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 793.5999755859375,
      "bbox_min": [
        -194.89990234375,
        -2498.5,
        793.5999755859375
      ],
      "bbox_max": [
        -193.0,
        -2496.5,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2496.5,
      "bbox_min": [
        -194.89990234375,
        -2498.5,
        793.5999755859375
      ],
      "bbox_max": [
        -193.0,
        -2496.5,
        794.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -194.89990234375,
      "bbox_min": [
        -194.89990234375,
        -2498.5,
        793.5999755859375
      ],
      "bbox_max": [
        -194.89990234375,
        -2496.5,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6871962547302246,
        0.7264718413352966,
        -0.0
      ],
      "plane_d": 1970.3765869140625,
      "bbox_min": [
        -226.5,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -199.114013671875,
        -2452.0,
        794.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7313312292098999,
        0.6820225119590759,
        0.0
      ],
      "plane_d": 1539.7666015625,
      "bbox_min": [
        -225.618408203125,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -217.25,
        -2499.1826171875,
        792.0631103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 789.0,
      "bbox_min": [
        -223.162109375,
        -2506.75,
        789.0
      ],
      "bbox_max": [
        -217.25,
        -2502.660400390625,
        789.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6820065379142761,
        0.7313461899757385,
        0.0
      ],
      "plane_d": 1979.729736328125,
      "bbox_min": [
        -225.2498321533203,
        -2500.151123046875,
        780.0
      ],
      "bbox_max": [
        -221.777587890625,
        -2498.514404296875,
        792.0631103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7313312292098999,
        0.6820225119590759,
        0.0
      ],
      "plane_d": 1539.7666015625,
      "bbox_min": [
        -225.2498321533203,
        -2499.1826171875,
        780.0
      ],
      "bbox_max": [
        -224.936279296875,
        -2498.846435546875,
        792.0631103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.18855784833431244,
        0.9820621609687805
      ],
      "plane_d": -295.1087951660156,
      "bbox_min": [
        -218.885986328125,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -199.114013671875,
        -2498.701416015625,
        792.1793212890625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2500.5,
      "bbox_min": [
        -215.199951171875,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -202.800048828125,
        -2500.5,
        781.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9432709813117981,
        0.3320240080356598,
        0.0
      ],
      "plane_d": 629.309326171875,
      "bbox_min": [
        -215.199951171875,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -202.800048828125,
        -2500.5,
        781.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9432709813117981,
        0.3320240080356598,
        0.0
      ],
      "plane_d": 1023.5966186523438,
      "bbox_min": [
        -205.0,
        -2506.75,
        780.0
      ],
      "bbox_max": [
        -202.800048828125,
        -2500.5,
        781.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32006049156188965,
        0.7540068626403809,
        -0.5736156702041626
      ],
      "plane_d": 2273.6181640625,
      "bbox_min": [
        -218.885986328125,
        -2503.299560546875,
        787.7225952148438
      ],
      "bbox_max": [
        -199.114013671875,
        -2498.701416015625,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13979671895503998,
        0.3293367922306061,
        0.9338063597679138
      ],
      "plane_d": 56.2548828125,
      "bbox_min": [
        -204.582275390625,
        -2503.299560546875,
        787.7225952148438
      ],
      "bbox_max": [
        -199.114013671875,
        -2498.9013671875,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9205074906349182,
        0.39072492718696594,
        -0.00012679665815085173
      ],
      "plane_d": 1161.4134521484375,
      "bbox_min": [
        -200.900146484375,
        -2503.109619140625,
        787.7225952148438
      ],
      "bbox_max": [
        -199.114013671875,
        -2498.9013671875,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3200828433036804,
        0.7540095448493958,
        -0.573599636554718
      ],
      "plane_d": 2407.25146484375,
      "bbox_min": [
        -218.885986328125,
        -2503.099609375,
        787.7225952148438
      ],
      "bbox_max": [
        -213.417724609375,
        -2498.701416015625,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13979671895503998,
        0.3293367922306061,
        0.9338063597679138
      ],
      "plane_d": 114.62408447265625,
      "bbox_min": [
        -218.885986328125,
        -2503.099609375,
        787.7225952148438
      ],
      "bbox_max": [
        -213.417724609375,
        -2498.701416015625,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9205191135406494,
        0.39069756865501404,
        1.6525180399185047e-05
      ],
      "plane_d": 776.37890625,
      "bbox_min": [
        -218.885986328125,
        -2502.90966796875,
        787.7225952148438
      ],
      "bbox_max": [
        -217.099853515625,
        -2498.701416015625,
        792.1793212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 209.0,
      "bbox_min": [
        -226.5,
        -2496.5,
        780.0
      ],
      "bbox_max": [
        -200.0,
        -2452.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        -0.0,
        0.3713776469230652
      ],
      "plane_d": -81.13743591308594,
      "bbox_min": [
        -226.5,
        -2496.5,
        780.0
      ],
      "bbox_max": [
        -224.60009765625,
        -2493.10009765625,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -783.0,
      "bbox_min": [
        -226.5,
        -2496.5,
        780.0
      ],
      "bbox_max": [
        -224.60009765625,
        -2493.10009765625,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2493.10009765625,
      "bbox_min": [
        -226.5,
        -2493.10009765625,
        780.0
      ],
      "bbox_max": [
        -224.60009765625,
        -2493.10009765625,
        783.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284818768501282,
        0.0,
        -0.3713776469230652
      ],
      "plane_d": 503.968017578125,
      "bbox_min": [
        -226.5,
        -2496.5,
        792.4999389648438
      ],
      "bbox_max": [
        -225.20004272460938,
        -2493.10009765625,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 792.4999389648438,
      "bbox_min": [
        -226.5,
        -2496.5,
        792.4999389648438
      ],
      "bbox_max": [
        -225.20004272460938,
        -2493.10009765625,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2493.10009765625,
      "bbox_min": [
        -226.5,
        -2493.10009765625,
        792.4999389648438
      ],
      "bbox_max": [
        -225.20004272460938,
        -2493.10009765625,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        -209.0,
        -2453.5,
        780.0
      ],
      "bbox_max": [
        -200.0,
        -2452.0,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7848846912384033,
        0.0,
        -0.6196418404579163
      ],
      "plane_d": 331.81719970703125,
      "bbox_min": [
        -209.0,
        -2453.5,
        788.8333129882812
      ],
      "bbox_max": [
        -200.0,
        -2452.0,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7848846912384033,
        0.0,
        -0.6196418404579163
      ],
      "plane_d": 652.8350219726562,
      "bbox_min": [
        -209.0,
        -2453.5,
        788.8333129882812
      ],
      "bbox_max": [
        -202.5,
        -2452.0,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.0,
      "bbox_min": [
        -206.5,
        -2453.5,
        792.0
      ],
      "bbox_max": [
        -202.5,
        -2452.0,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -2436.999755859375,
      "bbox_min": [
        -223.4630584716797,
        -2452.0,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2409.43798828125,
        805.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -215.0,
        -2437.0,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2409.43798828125,
        803.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        -215.0,
        -2424.0,
        780.0
      ],
      "bbox_max": [
        -215.0,
        -2419.300048828125,
        785.2416381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -210.5,
        -2437.0,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2409.43798828125,
        803.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2437.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2424.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -210.5,
        -2437.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2424.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2436.0,
      "bbox_min": [
        -210.5,
        -2437.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2428.0,
        797.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.0,
      "bbox_min": [
        -207.0,
        -2437.0,
        780.0
      ],
      "bbox_max": [
        -199.0,
        -2436.0,
        791.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 207.0,
      "bbox_min": [
        -207.0,
        -2437.0,
        780.0
      ],
      "bbox_max": [
        -199.0,
        -2436.0,
        791.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 791.0,
      "bbox_min": [
        -207.0,
        -2437.0,
        791.0
      ],
      "bbox_max": [
        -199.0,
        -2436.0,
        791.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857492983341217,
        0.0,
        -0.5144957900047302
      ],
      "plane_d": 586.9539794921875,
      "bbox_min": [
        -210.5,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2428.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2431.5,
      "bbox_min": [
        -210.5,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -206.0,
        -2428.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2428.0,
      "bbox_min": [
        -210.5,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -206.0,
        -2428.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -210.5,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -209.0,
        -2428.0,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 238.81179809570312,
      "bbox_min": [
        -200.0,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2428.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2428.0,
      "bbox_min": [
        -200.0,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2428.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2431.5,
      "bbox_min": [
        -200.0,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2428.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -197.0,
        -2431.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2428.0,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2419.0,
      "bbox_min": [
        -202.83982849121094,
        -2424.0,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2409.43798828125,
        803.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -202.83982849121094,
        -2419.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2409.43798828125,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -202.83982849121094,
        -2419.0,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2409.43798828125,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 238.81179809570312,
      "bbox_min": [
        -199.7275848388672,
        -2414.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2411.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2411.0,
      "bbox_min": [
        -198.48182678222656,
        -2414.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2411.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -197.0,
        -2414.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2411.6240234375,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.0,
        -0.768221378326416
      ],
      "plane_d": 491.1495361328125,
      "bbox_min": [
        -202.55084228515625,
        -2424.0,
        800.1666870117188
      ],
      "bbox_max": [
        -193.0,
        -2419.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 803.5,
      "bbox_min": [
        -202.55084228515625,
        -2424.0,
        803.5
      ],
      "bbox_max": [
        -197.0,
        -2419.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -223.4630584716797,
        -2452.0,
        780.0
      ],
      "bbox_max": [
        -193.0,
        -2437.0,
        805.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2445.0,
      "bbox_min": [
        -223.4630584716797,
        -2445.0,
        795.5
      ],
      "bbox_max": [
        -215.0,
        -2440.0,
        805.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2440.0,
      "bbox_min": [
        -220.0,
        -2445.0,
        795.5
      ],
      "bbox_max": [
        -215.0,
        -2440.0,
        805.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        -220.0,
        -2445.0,
        795.5
      ],
      "bbox_max": [
        -215.0,
        -2440.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 805.0,
      "bbox_min": [
        -217.49688720703125,
        -2445.0,
        805.0
      ],
      "bbox_max": [
        -215.0,
        -2441.71630859375,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 222.5,
      "bbox_min": [
        -222.5,
        -2452.0,
        780.0
      ],
      "bbox_max": [
        -213.0,
        -2437.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -788.5,
      "bbox_min": [
        -221.5,
        -2447.0,
        780.0
      ],
      "bbox_max": [
        -213.0,
        -2438.0,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 213.0,
      "bbox_min": [
        -221.5,
        -2447.0,
        780.0
      ],
      "bbox_max": [
        -213.0,
        -2438.0,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2447.0,
      "bbox_min": [
        -221.5,
        -2447.0,
        780.0
      ],
      "bbox_max": [
        -213.0,
        -2438.0,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2438.0,
      "bbox_min": [
        -221.5,
        -2438.0,
        780.0
      ],
      "bbox_max": [
        -213.0,
        -2438.0,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.64405757188797,
        0.7649770975112915
      ],
      "plane_d": 1162.98095703125,
      "bbox_min": [
        -372.79998779296875,
        -2491.634765625,
        567.475341796875
      ],
      "bbox_max": [
        1321.548828125,
        -1994.8612060546875,
        819.2384033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.137159526348114,
        -0.01990017108619213,
        0.9903489947319031
      ],
      "plane_d": -646.2860107421875,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        577.5
      ],
      "bbox_max": [
        162.44873046875,
        -1994.8612060546875,
        819.2384033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13787776231765747,
        -0.03273407742381096,
        0.9899080991744995
      ],
      "plane_d": -673.2636108398438,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        577.5
      ],
      "bbox_max": [
        162.44873046875,
        -2063.799072265625,
        639.41357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        577.5
      ],
      "bbox_max": [
        162.44873046875,
        -2063.799072265625,
        631.3900146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -577.501220703125,
      "bbox_min": [
        -272.79998779296875,
        -2457.56298828125,
        577.5
      ],
      "bbox_max": [
        -172.5685577392578,
        -2360.5,
        631.3900146484375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0314483642578,
      "bbox_min": [
        -210.5,
        -2434.0,
        577.5
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        631.3900146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -198.0314483642578,
        -2371.5,
        577.5
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        629.6533813476562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -198.0314483642578,
        -2371.5,
        577.5
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        629.6533813476562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -198.0314483642578,
        -2371.5,
        577.5
      ],
      "bbox_max": [
        -195.5,
        -2371.5,
        629.2896118164062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 589.5012817382812,
      "bbox_min": [
        -210.5,
        -2434.0,
        577.5
      ],
      "bbox_max": [
        -198.0314483642578,
        -2360.5,
        631.3900146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        589.5012817382812
      ],
      "bbox_max": [
        -198.0314483642578,
        -2360.5,
        631.3900146484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        589.5012817382812
      ],
      "bbox_max": [
        -198.0314483642578,
        -2360.5,
        631.3900146484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        577.5
      ],
      "bbox_max": [
        -208.0314483642578,
        -2360.5,
        589.5012817382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        577.5
      ],
      "bbox_max": [
        -208.0314483642578,
        -2371.5,
        589.5012817382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -208.0314483642578,
        -2373.0,
        577.5
      ],
      "bbox_max": [
        -198.0314483642578,
        -2360.5,
        589.5012817382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2373.0,
      "bbox_min": [
        -208.0314483642578,
        -2373.0,
        577.5
      ],
      "bbox_max": [
        -198.0314483642578,
        -2371.5,
        589.5012817382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -208.0314483642578,
        -2373.0,
        577.5
      ],
      "bbox_max": [
        -198.0314483642578,
        -2371.5,
        589.5012817382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        577.5
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        588.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 207.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        577.5
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        588.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 588.5,
      "bbox_min": [
        -207.0,
        -2373.0,
        588.5
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        588.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10736268758773804,
        -0.8992251753807068,
        0.42410773038864136
      ],
      "plane_d": -2122.285888671875,
      "bbox_min": [
        -63.337120056152344,
        -2113.157470703125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2063.799072265625,
        619.5888061523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -245.05609130859375,
        -2371.5,
        605.8223876953125
      ],
      "bbox_max": [
        27.273826599121094,
        -2132.563232421875,
        639.41357421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        605.8223876953125
      ],
      "bbox_max": [
        27.273826599121094,
        -2132.563232421875,
        634.305419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        26.063034057617188,
        -2132.77880859375,
        605.8223876953125
      ],
      "bbox_max": [
        27.273826599121094,
        -2132.563232421875,
        606.1185302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        26.906936645507812,
        -2132.77880859375,
        605.8223876953125
      ],
      "bbox_max": [
        27.273826599121094,
        -2132.563232421875,
        606.0013427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        628.93701171875
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        634.305419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        628.93701171875
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        634.305419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        631.0262451171875
      ],
      "bbox_max": [
        -210.5,
        -2360.5,
        634.305419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": 1524.355224609375,
      "bbox_min": [
        -245.05609130859375,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -230.79248046875,
        -2316.25537109375,
        639.41357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2331.5,
      "bbox_min": [
        -245.05609130859375,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -245.0,
        -2331.5,
        638.082275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": -2255.843505859375,
      "bbox_min": [
        -233.64976501464844,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -230.79248046875,
        -2316.25537109375,
        638.342529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -101.90265655517578,
        -2132.764404296875,
        605.8223876953125
      ],
      "bbox_max": [
        27.180908203125,
        -2130.56005859375,
        623.885009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05980534851551056,
        -0.671236515045166,
        0.7388266921043396
      ],
      "plane_d": -1850.9669189453125,
      "bbox_min": [
        -51.79084777832031,
        -2069.520751953125,
        629.2767333984375
      ],
      "bbox_max": [
        121.512451171875,
        -1994.8612060546875,
        731.521240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        -10.330429077148438,
        -2044.892578125,
        637.62353515625
      ],
      "bbox_max": [
        121.512451171875,
        -2007.1263427734375,
        679.3583374023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13131414353847504,
        -0.8612962365150452,
        0.4908413887023926
      ],
      "plane_d": -2058.27392578125,
      "bbox_min": [
        21.569725036621094,
        -2044.892578125,
        637.62353515625
      ],
      "bbox_max": [
        121.512451171875,
        -2007.1263427734375,
        679.3583374023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13131414353847504,
        -0.8612962365150452,
        0.4908413887023926
      ],
      "plane_d": -2058.27392578125,
      "bbox_min": [
        29.802236557006836,
        -2044.892578125,
        637.62353515625
      ],
      "bbox_max": [
        121.512451171875,
        -1994.8612060546875,
        731.521240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6409735679626465,
        -0.767240583896637,
        -0.02224147506058216
      ],
      "plane_d": -1476.856689453125,
      "bbox_min": [
        59.157798767089844,
        -2044.892578125,
        637.62353515625
      ],
      "bbox_max": [
        121.512451171875,
        -1994.8612060546875,
        731.521240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46316424012184143,
        -0.7446286082267761,
        -0.4806317985057831
      ],
      "plane_d": -1112.9168701171875,
      "bbox_min": [
        64.07967376708984,
        -2008.5992431640625,
        722.7684936523438
      ],
      "bbox_max": [
        71.77666473388672,
        -2000.97314453125,
        731.521240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -242.95896911621094,
        -2419.71240234375,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2007.3287353515625,
        819.2384033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -242.95896911621094,
        -2419.71240234375,
        626.0
      ],
      "bbox_max": [
        -78.0,
        -2179.179931640625,
        799.5803833007812
      ],
      "face_count": 19
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -210.5,
        -2371.5,
        626.0
      ],
      "bbox_max": [
        -78.0,
        -2179.179931640625,
        638.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": -286.1435852050781,
      "bbox_min": [
        -210.5,
        -2371.5,
        626.0
      ],
      "bbox_max": [
        -78.0,
        -2179.179931640625,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 430.66668701171875,
      "bbox_min": [
        -210.5,
        -2371.5,
        626.0
      ],
      "bbox_max": [
        -95.5,
        -2182.5,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        632.0069580078125
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        632.0069580078125
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        634.0844116210938
      ],
      "bbox_max": [
        -210.5,
        -2360.5,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 100.5,
      "bbox_min": [
        -100.5,
        -2229.0,
        626.0
      ],
      "bbox_max": [
        -95.5,
        -2182.5,
        633.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2215.0,
      "bbox_min": [
        -100.5,
        -2215.0,
        626.0
      ],
      "bbox_max": [
        -95.5,
        -2182.5,
        633.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2182.5,
      "bbox_min": [
        -98.93990325927734,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -95.5,
        -2182.5,
        628.4490966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        -100.5,
        -2239.0,
        626.0
      ],
      "bbox_max": [
        -78.0,
        -2179.179931640625,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": 447.3790588378906,
      "bbox_min": [
        -98.0,
        -2239.0,
        626.0
      ],
      "bbox_max": [
        -78.0,
        -2179.179931640625,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 430.66668701171875,
      "bbox_min": [
        -98.0,
        -2239.0,
        632.5
      ],
      "bbox_max": [
        -94.07142639160156,
        -2215.0,
        638.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2215.0,
      "bbox_min": [
        -98.0,
        -2215.0,
        632.5
      ],
      "bbox_max": [
        -94.07142639160156,
        -2215.0,
        638.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -95.5,
        -2239.0,
        636.0
      ],
      "bbox_max": [
        -78.0,
        -2180.390380859375,
        638.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2215.0,
      "bbox_min": [
        -95.5,
        -2239.0,
        636.0
      ],
      "bbox_max": [
        -78.0,
        -2180.390380859375,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2182.5,
      "bbox_min": [
        -92.03466033935547,
        -2182.5,
        636.0
      ],
      "bbox_max": [
        -80.0,
        -2180.390380859375,
        638.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        -80.0,
        -2182.5,
        636.0
      ],
      "bbox_max": [
        -80.0,
        -2180.390380859375,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        -0.0,
        -0.5812382102012634
      ],
      "plane_d": 302.12762451171875,
      "bbox_min": [
        -98.0,
        -2235.0,
        626.0
      ],
      "bbox_max": [
        -78.0,
        -2179.179931640625,
        636.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -83.0,
        -2235.0,
        629.0
      ],
      "bbox_max": [
        -78.0,
        -2179.882080078125,
        636.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 430.66668701171875,
      "bbox_min": [
        -83.0,
        -2235.0,
        629.0
      ],
      "bbox_max": [
        -78.0,
        -2179.882080078125,
        636.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2215.0,
      "bbox_min": [
        -83.0,
        -2215.0,
        629.0
      ],
      "bbox_max": [
        -78.0,
        -2179.882080078125,
        636.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -80.5,
      "bbox_min": [
        -98.0,
        -2235.0,
        626.0
      ],
      "bbox_max": [
        -78.0,
        -2179.179931640625,
        636.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 430.66668701171875,
      "bbox_min": [
        -80.5,
        -2228.0,
        626.0
      ],
      "bbox_max": [
        -78.0,
        -2179.179931640625,
        632.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2215.0,
      "bbox_min": [
        -80.5,
        -2215.0,
        626.0
      ],
      "bbox_max": [
        -78.0,
        -2215.0,
        632.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 430.66668701171875,
      "bbox_min": [
        -83.0,
        -2222.0,
        626.0
      ],
      "bbox_max": [
        -80.5,
        -2182.5,
        629.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2215.0,
      "bbox_min": [
        -83.0,
        -2215.0,
        626.0
      ],
      "bbox_max": [
        -80.5,
        -2182.5,
        629.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2182.5,
      "bbox_min": [
        -83.0,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -80.5,
        -2182.5,
        629.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 430.66668701171875,
      "bbox_min": [
        -98.0,
        -2235.0,
        626.0
      ],
      "bbox_max": [
        -80.5,
        -2215.0,
        636.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2331.5,
      "bbox_min": [
        -242.95896911621094,
        -2419.71240234375,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2180.632568359375,
        799.5803833007812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -211.29266357421875,
        -2419.71240234375,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2331.5,
        799.5803833007812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -211.29266357421875,
        -2419.71240234375,
        651.0
      ],
      "bbox_max": [
        -191.0,
        -2360.5,
        799.5803833007812
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -191.0,
      "bbox_min": [
        -211.29266357421875,
        -2419.71240234375,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2386.841552734375,
        799.5803833007812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2407.0,
      "bbox_min": [
        -211.29266357421875,
        -2419.71240234375,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2386.841552734375,
        799.5803833007812
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -211.29266357421875,
        -2419.71240234375,
        774.0
      ],
      "bbox_max": [
        -195.04437255859375,
        -2407.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2419.0,
      "bbox_min": [
        -211.29266357421875,
        -2419.71240234375,
        774.0
      ],
      "bbox_max": [
        -195.04437255859375,
        -2419.0,
        775.6296997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -774.0,
      "bbox_min": [
        -211.29266357421875,
        -2419.71240234375,
        774.0
      ],
      "bbox_max": [
        -195.04437255859375,
        -2419.0,
        775.6296997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        0.768221378326416
      ],
      "plane_d": -720.7196655273438,
      "bbox_min": [
        -211.29266357421875,
        -2419.71240234375,
        774.0
      ],
      "bbox_max": [
        -195.04437255859375,
        -2419.0,
        775.6296997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726728081703186,
        0.0,
        0.7399401068687439
      ],
      "plane_d": -431.7886962890625,
      "bbox_min": [
        -211.29266357421875,
        -2419.71240234375,
        774.0
      ],
      "bbox_max": [
        -209.5,
        -2419.0,
        775.6296997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2417.08935546875,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2407.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2417.08935546875,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2409.347412109375,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 238.81179809570312,
      "bbox_min": [
        -197.85647583007812,
        -2411.6240234375,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2411.0,
        793.927490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -197.0,
        -2411.6240234375,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2411.0,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -195.5688934326172,
        -2409.43798828125,
        797.5
      ],
      "bbox_max": [
        -195.5,
        -2409.347412109375,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2402.0,
      "bbox_min": [
        -209.64697265625,
        -2407.0,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2386.841552734375,
        799.5803833007812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        0.768221378326416
      ],
      "plane_d": -720.7196655273438,
      "bbox_min": [
        -201.84490966796875,
        -2402.0,
        774.3648681640625
      ],
      "bbox_max": [
        -191.0,
        -2386.841552734375,
        789.3055419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -201.84490966796875,
        -2402.0,
        774.3648681640625
      ],
      "bbox_max": [
        -191.0,
        -2390.0,
        789.3055419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -201.84490966796875,
        -2402.0,
        774.3648681640625
      ],
      "bbox_max": [
        -195.5,
        -2390.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2390.0,
      "bbox_min": [
        -196.56219482421875,
        -2390.0,
        774.3648681640625
      ],
      "bbox_max": [
        -195.5,
        -2390.0,
        775.9227294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 779.4000244140625,
      "bbox_min": [
        -209.64697265625,
        -2407.0,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2402.0,
        799.5803833007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -205.64712524414062,
        -2407.0,
        779.4000244140625
      ],
      "bbox_max": [
        -191.0,
        -2402.0,
        799.5803833007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 195.5,
      "bbox_min": [
        -195.5,
        -2407.0,
        779.4000244140625
      ],
      "bbox_max": [
        -195.5,
        -2402.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.0,
        -0.768221378326416
      ],
      "plane_d": 491.1495361328125,
      "bbox_min": [
        -192.29644775390625,
        -2407.0,
        798.5
      ],
      "bbox_max": [
        -191.0,
        -2404.326416015625,
        799.5803833007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        0.768221378326416
      ],
      "plane_d": -720.7196655273438,
      "bbox_min": [
        -209.64697265625,
        -2407.0,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2402.0,
        779.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726728081703186,
        0.0,
        0.7399401068687439
      ],
      "plane_d": -431.7886962890625,
      "bbox_min": [
        -209.64697265625,
        -2407.0,
        774.0
      ],
      "bbox_max": [
        -209.5,
        -2406.68701171875,
        774.1336059570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        651.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        755.2904663085938
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        651.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        755.2904663085938
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        651.0
      ],
      "bbox_max": [
        -210.5,
        -2360.5,
        733.2910766601562
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.0,
      "bbox_min": [
        -210.5,
        -2371.5,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2331.5,
        651.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        -199.0,
        -2371.5,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2331.5,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -152.0,
      "bbox_min": [
        -173.0,
        -2356.5,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2331.5,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 173.0,
      "bbox_min": [
        -173.0,
        -2356.5,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2331.5,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2356.5,
      "bbox_min": [
        -173.0,
        -2356.5,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2331.5,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2333.5,
      "bbox_min": [
        -173.0,
        -2356.5,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2331.5,
        651.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -166.0,
      "bbox_min": [
        -171.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -166.0,
        -2331.5,
        648.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 171.0,
      "bbox_min": [
        -171.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -166.0,
        -2331.5,
        648.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        -171.0,
        -2333.5,
        648.0
      ],
      "bbox_max": [
        -166.0,
        -2331.5,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.5,
      "bbox_min": [
        -161.99998474121094,
        -2356.5,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2341.5,
        644.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2345.5,
      "bbox_min": [
        -161.99998474121094,
        -2356.5,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2341.5,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -155.49998474121094,
      "bbox_min": [
        -155.49998474121094,
        -2345.5,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2341.5,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2341.5,
      "bbox_min": [
        -155.49998474121094,
        -2341.5,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2341.5,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 641.0,
      "bbox_min": [
        -161.99998474121094,
        -2356.5,
        641.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2346.5,
        641.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -155.49998474121094,
      "bbox_min": [
        -161.99998474121094,
        -2356.5,
        641.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2346.5,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2346.5,
      "bbox_min": [
        -155.49998474121094,
        -2346.5,
        641.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2346.5,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2353.0,
      "bbox_min": [
        -161.99998474121094,
        -2356.5,
        641.0
      ],
      "bbox_max": [
        -155.49998474121094,
        -2353.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -161.99998474121094,
      "bbox_min": [
        -161.99998474121094,
        -2356.5,
        641.0
      ],
      "bbox_max": [
        -161.99998474121094,
        -2353.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -155.49998474121094,
      "bbox_min": [
        -155.49998474121094,
        -2352.39990234375,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2349.699951171875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -155.19993591308594,
      "bbox_min": [
        -155.19993591308594,
        -2352.0,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2350.0,
        644.0999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.19609886407852173,
        0.0,
        0.9805841445922852
      ],
      "plane_d": -601.27734375,
      "bbox_min": [
        -155.19993591308594,
        -2352.0,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2350.0,
        644.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2350.0,
      "bbox_min": [
        -155.19993591308594,
        -2352.0,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2350.0,
        644.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2352.0,
      "bbox_min": [
        -155.19993591308594,
        -2352.0,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2350.0,
        644.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -644.0999755859375,
      "bbox_min": [
        -155.19993591308594,
        -2352.0,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2350.0,
        644.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -154.19993591308594,
      "bbox_min": [
        -155.19993591308594,
        -2352.0,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2350.0,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.800048828125,
      "bbox_min": [
        -154.19993591308594,
        -2352.0,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2350.0,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19612763822078705,
        0.0,
        -0.9805783629417419
      ],
      "plane_d": 659.95068359375,
      "bbox_min": [
        -154.19993591308594,
        -2352.0,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2350.800048828125,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 153.80003356933594,
      "bbox_min": [
        -153.80003356933594,
        -2351.2001953125,
        642.260009765625
      ],
      "bbox_max": [
        -153.80003356933594,
        -2350.800048828125,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.706998884677887,
        0.0,
        0.7072146534919739
      ],
      "plane_d": -345.2246398925781,
      "bbox_min": [
        -154.19993591308594,
        -2351.60009765625,
        641.5
      ],
      "bbox_max": [
        -153.39988708496094,
        -2350.800048828125,
        642.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7072147130966187,
        0.706998884677887
      ],
      "plane_d": -2116.6259765625,
      "bbox_min": [
        -154.19993591308594,
        -2351.60009765625,
        641.5
      ],
      "bbox_max": [
        -153.39988708496094,
        -2351.2001953125,
        642.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2351.2001953125,
      "bbox_min": [
        -154.19993591308594,
        -2351.2001953125,
        641.9000244140625
      ],
      "bbox_max": [
        -153.80003356933594,
        -2351.2001953125,
        642.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 153.80003356933594,
      "bbox_min": [
        -154.10006713867188,
        -2351.2001953125,
        641.9000244140625
      ],
      "bbox_max": [
        -153.80003356933594,
        -2350.800048828125,
        642.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2351.2001953125,
      "bbox_min": [
        -154.10006713867188,
        -2351.2001953125,
        641.9000244140625
      ],
      "bbox_max": [
        -153.80003356933594,
        -2351.2001953125,
        642.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7072147130966187,
        0.706998884677887
      ],
      "plane_d": 1208.69775390625,
      "bbox_min": [
        -154.19993591308594,
        -2350.800048828125,
        641.5
      ],
      "bbox_max": [
        -153.39988708496094,
        -2350.400146484375,
        641.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19612763822078705,
        0.0,
        -0.9805783629417419
      ],
      "plane_d": 659.95068359375,
      "bbox_min": [
        -154.60008239746094,
        -2352.0,
        642.0999755859375
      ],
      "bbox_max": [
        -154.19993591308594,
        -2350.0,
        642.1799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.706998884677887,
        0.0,
        0.7072146534919739
      ],
      "plane_d": -562.9802856445312,
      "bbox_min": [
        -154.60008239746094,
        -2351.60009765625,
        641.5
      ],
      "bbox_max": [
        -154.19993591308594,
        -2350.400146484375,
        641.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7072147130966187,
        0.706998884677887
      ],
      "plane_d": 1208.69775390625,
      "bbox_min": [
        -154.60008239746094,
        -2351.60009765625,
        641.5
      ],
      "bbox_max": [
        -154.19993591308594,
        -2350.400146484375,
        641.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -199.0,
        -2371.5,
        638.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -199.0,
        -2371.5,
        638.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -199.0,
        -2360.5,
        638.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        651.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 197.0,
      "bbox_min": [
        -197.00001525878906,
        -2356.5,
        638.0
      ],
      "bbox_max": [
        -175.0,
        -2331.5,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2333.5,
      "bbox_min": [
        -197.00001525878906,
        -2356.5,
        638.0
      ],
      "bbox_max": [
        -175.0,
        -2331.5,
        651.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -177.0,
      "bbox_min": [
        -182.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -177.0,
        -2331.5,
        648.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 182.0,
      "bbox_min": [
        -182.0,
        -2333.5,
        638.0
      ],
      "bbox_max": [
        -177.0,
        -2331.5,
        648.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        -182.0,
        -2333.5,
        648.0
      ],
      "bbox_max": [
        -177.0,
        -2331.5,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.5,
      "bbox_min": [
        -197.00001525878906,
        -2356.5,
        638.0
      ],
      "bbox_max": [
        -187.00001525878906,
        -2341.5,
        644.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2345.5,
      "bbox_min": [
        -197.00001525878906,
        -2356.5,
        638.0
      ],
      "bbox_max": [
        -187.00001525878906,
        -2341.5,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 193.50001525878906,
      "bbox_min": [
        -197.00001525878906,
        -2345.5,
        638.0
      ],
      "bbox_max": [
        -193.50001525878906,
        -2341.5,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2341.5,
      "bbox_min": [
        -197.00001525878906,
        -2341.5,
        638.0
      ],
      "bbox_max": [
        -193.50001525878906,
        -2341.5,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 641.0,
      "bbox_min": [
        -197.00001525878906,
        -2356.5,
        641.0
      ],
      "bbox_max": [
        -187.00001525878906,
        -2346.5,
        641.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 193.50001525878906,
      "bbox_min": [
        -197.00001525878906,
        -2356.5,
        641.0
      ],
      "bbox_max": [
        -187.00001525878906,
        -2346.5,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2346.5,
      "bbox_min": [
        -197.00001525878906,
        -2346.5,
        641.0
      ],
      "bbox_max": [
        -193.50001525878906,
        -2346.5,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2353.0,
      "bbox_min": [
        -193.50001525878906,
        -2356.5,
        641.0
      ],
      "bbox_max": [
        -187.00001525878906,
        -2353.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.00001525878906,
      "bbox_min": [
        -187.00001525878906,
        -2356.5,
        641.0
      ],
      "bbox_max": [
        -187.00001525878906,
        -2353.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 193.50001525878906,
      "bbox_min": [
        -196.39991760253906,
        -2352.39990234375,
        641.5
      ],
      "bbox_max": [
        -193.50001525878906,
        -2349.699951171875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 193.80006408691406,
      "bbox_min": [
        -196.39991760253906,
        -2352.0,
        641.5
      ],
      "bbox_max": [
        -193.80006408691406,
        -2350.0,
        644.0999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.19609886407852173,
        0.0,
        0.9805841445922852
      ],
      "plane_d": -669.7158203125,
      "bbox_min": [
        -196.39991760253906,
        -2352.0,
        641.5
      ],
      "bbox_max": [
        -193.80006408691406,
        -2350.0,
        644.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.0,
      "bbox_min": [
        -196.39991760253906,
        -2352.0,
        641.5
      ],
      "bbox_max": [
        -193.80006408691406,
        -2350.0,
        644.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2352.0,
      "bbox_min": [
        -196.39991760253906,
        -2352.0,
        641.5
      ],
      "bbox_max": [
        -193.80006408691406,
        -2350.0,
        644.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -644.0999755859375,
      "bbox_min": [
        -196.39991760253906,
        -2352.0,
        641.5
      ],
      "bbox_max": [
        -193.80006408691406,
        -2350.0,
        644.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19612763822078705,
        -0.0,
        -0.9805783629417419
      ],
      "plane_d": 591.5021362304688,
      "bbox_min": [
        -196.39991760253906,
        -2352.0,
        641.5
      ],
      "bbox_max": [
        -193.80006408691406,
        -2350.0,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 642.0999755859375,
      "bbox_min": [
        -195.19996643066406,
        -2352.0,
        642.0999755859375
      ],
      "bbox_max": [
        -193.80006408691406,
        -2350.0,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 194.80006408691406,
      "bbox_min": [
        -195.19996643066406,
        -2351.2001953125,
        642.1799926757812
      ],
      "bbox_max": [
        -194.80006408691406,
        -2350.800048828125,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2350.800048828125,
      "bbox_min": [
        -195.19996643066406,
        -2350.800048828125,
        642.1799926757812
      ],
      "bbox_max": [
        -194.80006408691406,
        -2350.800048828125,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7072147130966187,
        0.706998884677887
      ],
      "plane_d": 1208.69775390625,
      "bbox_min": [
        -195.60011291503906,
        -2351.60009765625,
        641.5
      ],
      "bbox_max": [
        -194.39991760253906,
        -2350.400146484375,
        642.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.706998884677887,
        -0.0,
        0.7072146534919739
      ],
      "plane_d": -316.2376708984375,
      "bbox_min": [
        -195.60011291503906,
        -2351.60009765625,
        641.5
      ],
      "bbox_max": [
        -194.39991760253906,
        -2350.400146484375,
        642.1799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7072147130966187,
        0.706998884677887
      ],
      "plane_d": -2116.6259765625,
      "bbox_min": [
        -195.60011291503906,
        -2351.60009765625,
        641.5
      ],
      "bbox_max": [
        -194.39991760253906,
        -2350.400146484375,
        641.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.706998884677887,
        0.0,
        0.7072146534919739
      ],
      "plane_d": -591.96728515625,
      "bbox_min": [
        -195.60011291503906,
        -2351.60009765625,
        641.5
      ],
      "bbox_max": [
        -195.19996643066406,
        -2350.400146484375,
        641.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 194.80006408691406,
      "bbox_min": [
        -194.80006408691406,
        -2351.2001953125,
        641.9000244140625
      ],
      "bbox_max": [
        -194.80006408691406,
        -2350.800048828125,
        642.1799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2350.800048828125,
      "bbox_min": [
        -195.19996643066406,
        -2351.079833984375,
        641.9000244140625
      ],
      "bbox_max": [
        -194.80006408691406,
        -2350.800048828125,
        642.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 194.80006408691406,
      "bbox_min": [
        -194.80006408691406,
        -2351.079833984375,
        641.9000244140625
      ],
      "bbox_max": [
        -194.80006408691406,
        -2350.800048828125,
        642.1799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 207.0,
      "bbox_min": [
        -210.5,
        -2371.5,
        638.0
      ],
      "bbox_max": [
        -199.0,
        -2331.5,
        651.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        638.0
      ],
      "bbox_max": [
        -207.0,
        -2360.5,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        638.0
      ],
      "bbox_max": [
        -207.0,
        -2360.5,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2360.5,
        638.0
      ],
      "bbox_max": [
        -207.0,
        -2360.5,
        651.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -207.0,
        -2371.5,
        649.0
      ],
      "bbox_max": [
        -199.0,
        -2360.5,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -207.0,
        -2360.5,
        649.0
      ],
      "bbox_max": [
        -199.0,
        -2360.5,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -207.0,
        -2371.5,
        638.0
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": 1524.355224609375,
      "bbox_min": [
        -242.95896911621094,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2180.632568359375,
        653.4286499023438
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 171.0,
      "bbox_min": [
        -171.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -171.0,
        -2329.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 182.0,
      "bbox_min": [
        -182.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -182.0,
        -2329.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.6246950626373291,
        -0.0
      ],
      "plane_d": 1618.1163330078125,
      "bbox_min": [
        -209.0,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -207.0,
        -2329.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -240.62411499023438,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2180.632568359375,
        653.4286499023438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2182.5,
      "bbox_min": [
        -81.67677307128906,
        -2182.5,
        651.0
      ],
      "bbox_max": [
        -80.0,
        -2182.2060546875,
        653.4286499023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807859063148499,
        0.19508717954158783,
        0.0
      ],
      "plane_d": 361.3584899902344,
      "bbox_min": [
        -240.62411499023438,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2180.632568359375,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314670920372009,
        0.5555739998817444,
        0.0
      ],
      "plane_d": 1198.1217041015625,
      "bbox_min": [
        -240.62411499023438,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2180.632568359375,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555739998817444,
        0.8314670920372009,
        0.0
      ],
      "plane_d": 1863.5758056640625,
      "bbox_min": [
        -240.62411499023438,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2180.632568359375,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15977948904037476,
        0.8032792210578918,
        0.5737708806991577
      ],
      "plane_d": 1480.005615234375,
      "bbox_min": [
        -240.62411499023438,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2180.632568359375,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6809776425361633,
        0.4550192058086395,
        -0.5737830400466919
      ],
      "plane_d": 1351.0736083984375,
      "bbox_min": [
        -240.62411499023438,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2180.632568359375,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6809787154197693,
        0.4550178647041321,
        0.5737828612327576
      ],
      "plane_d": 613.1856079101562,
      "bbox_min": [
        -240.62411499023438,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2180.632568359375,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4550155997276306,
        0.6809723377227783,
        -0.5737922191619873
      ],
      "plane_d": 1896.0794677734375,
      "bbox_min": [
        -240.62411499023438,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2180.632568359375,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4550141394138336,
        0.6809731721878052,
        0.5737923979759216
      ],
      "plane_d": 1158.1846923828125,
      "bbox_min": [
        -240.62411499023438,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2180.632568359375,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": 2271.82763671875,
      "bbox_min": [
        -240.62411499023438,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2180.632568359375,
        651.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 649.0,
      "bbox_min": [
        -209.0,
        -2331.5,
        644.5
      ],
      "bbox_max": [
        -166.0,
        -2328.285888671875,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.6246950626373291,
        0.0
      ],
      "plane_d": 1301.0836181640625,
      "bbox_min": [
        -209.0,
        -2331.5,
        644.5
      ],
      "bbox_max": [
        -166.0,
        -2328.285888671875,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        -182.0,
        -2331.5,
        644.5
      ],
      "bbox_max": [
        -166.0,
        -2329.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7808687686920166,
        0.6246950626373291,
        -0.0
      ],
      "plane_d": 1618.1163330078125,
      "bbox_min": [
        -209.0,
        -2331.5,
        644.5
      ],
      "bbox_max": [
        -197.0,
        -2328.285888671875,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 209.0,
      "bbox_min": [
        -209.0,
        -2329.0,
        648.0
      ],
      "bbox_max": [
        -209.0,
        -2328.285888671875,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        -80.0,
        -2182.5,
        638.0
      ],
      "bbox_max": [
        -80.0,
        -2180.632568359375,
        651.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.0,
      "bbox_min": [
        -79.4195327758789,
        -2239.0,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2239.0,
        639.9872436523438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8032656908035278,
        0.15977679193019867,
        -0.5737905502319336
      ],
      "plane_d": 665.7613525390625,
      "bbox_min": [
        -236.33665466308594,
        -2329.0,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2215.0,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        -79.41976928710938,
        -2239.0,
        646.012451171875
      ],
      "bbox_max": [
        -78.0,
        -2231.862060546875,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -79.41976928710938,
        -2239.0,
        646.012451171875
      ],
      "bbox_max": [
        -78.0,
        -2231.862060546875,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.0,
      "bbox_min": [
        -79.41976928710938,
        -2239.0,
        646.012451171875
      ],
      "bbox_max": [
        -78.0,
        -2239.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 173.0,
      "bbox_min": [
        -236.33665466308594,
        -2329.0,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2215.0,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2290.0,
      "bbox_min": [
        -236.33665466308594,
        -2329.0,
        638.0
      ],
      "bbox_max": [
        -173.0,
        -2290.0,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 197.0,
      "bbox_min": [
        -236.33665466308594,
        -2329.0,
        638.0
      ],
      "bbox_max": [
        -173.0,
        -2290.0,
        651.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 649.0,
      "bbox_min": [
        -209.0,
        -2329.0,
        648.0
      ],
      "bbox_max": [
        -197.0,
        -2314.0,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 209.0,
      "bbox_min": [
        -209.0,
        -2329.0,
        648.0
      ],
      "bbox_max": [
        -197.0,
        -2314.0,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        -0.6246950626373291,
        -0.0
      ],
      "plane_d": -1600.937255859375,
      "bbox_min": [
        -209.0,
        -2316.5,
        648.0
      ],
      "bbox_max": [
        -197.0,
        -2314.0,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        -0.6246950626373291,
        0.0
      ],
      "plane_d": -1283.904541015625,
      "bbox_min": [
        -209.0,
        -2316.5,
        648.0
      ],
      "bbox_max": [
        -207.0,
        -2314.0,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": -2255.843505859375,
      "bbox_min": [
        -233.2301788330078,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -197.0,
        -2314.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7808687686920166,
        -0.6246950626373291,
        0.0
      ],
      "plane_d": -1283.904541015625,
      "bbox_min": [
        -209.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -207.0,
        -2314.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2314.0,
      "bbox_min": [
        -229.36236572265625,
        -2316.5,
        641.5
      ],
      "bbox_max": [
        -197.0,
        -2314.0,
        648.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        -0.6246950626373291,
        -0.0
      ],
      "plane_d": -1600.937255859375,
      "bbox_min": [
        -209.0,
        -2316.5,
        644.5
      ],
      "bbox_max": [
        -197.0,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        -175.0,
        -2329.0,
        638.0
      ],
      "bbox_max": [
        -173.0,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": -1508.3712158203125,
      "bbox_min": [
        -175.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -173.0,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": -2255.843505859375,
      "bbox_min": [
        -175.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -173.0,
        -2314.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2314.0,
      "bbox_min": [
        -175.0,
        -2314.0,
        641.5
      ],
      "bbox_max": [
        -173.0,
        -2314.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2312.0,
      "bbox_min": [
        -197.00001525878906,
        -2329.0,
        638.0
      ],
      "bbox_max": [
        -175.0,
        -2290.0,
        651.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        -197.0,
        -2329.0,
        638.0
      ],
      "bbox_max": [
        -175.0,
        -2312.0,
        648.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": -1508.3712158203125,
      "bbox_min": [
        -197.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -175.0,
        -2312.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -177.0,
      "bbox_min": [
        -182.0,
        -2316.5,
        641.7000732421875
      ],
      "bbox_max": [
        -177.0,
        -2312.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 182.0,
      "bbox_min": [
        -182.0,
        -2316.5,
        641.7000732421875
      ],
      "bbox_max": [
        -182.0,
        -2312.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": -2255.843505859375,
      "bbox_min": [
        -197.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -175.0,
        -2312.0,
        644.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -177.0,
      "bbox_min": [
        -182.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -177.0,
        -2312.0,
        642.9998779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 182.0,
      "bbox_min": [
        -182.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -182.0,
        -2312.0,
        642.9998779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2314.0,
      "bbox_min": [
        -197.0,
        -2314.0,
        641.5
      ],
      "bbox_max": [
        -175.0,
        -2312.928466796875,
        644.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -177.0,
      "bbox_min": [
        -182.0,
        -2314.0,
        641.5
      ],
      "bbox_max": [
        -177.0,
        -2312.928466796875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 182.0,
      "bbox_min": [
        -182.0,
        -2314.0,
        641.5
      ],
      "bbox_max": [
        -182.0,
        -2312.928466796875,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -641.5,
      "bbox_min": [
        -197.00001525878906,
        -2305.0,
        638.0
      ],
      "bbox_max": [
        -187.00001525878906,
        -2290.0,
        644.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2301.0,
      "bbox_min": [
        -197.00001525878906,
        -2305.0,
        638.0
      ],
      "bbox_max": [
        -187.00001525878906,
        -2290.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 193.50001525878906,
      "bbox_min": [
        -197.00001525878906,
        -2305.0,
        638.0
      ],
      "bbox_max": [
        -193.50001525878906,
        -2301.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2305.0,
      "bbox_min": [
        -197.00001525878906,
        -2305.0,
        638.0
      ],
      "bbox_max": [
        -193.50001525878906,
        -2305.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 641.0,
      "bbox_min": [
        -197.00001525878906,
        -2300.0,
        641.0
      ],
      "bbox_max": [
        -187.00001525878906,
        -2290.0,
        641.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 193.50001525878906,
      "bbox_min": [
        -197.00001525878906,
        -2300.0,
        641.0
      ],
      "bbox_max": [
        -187.00001525878906,
        -2290.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2300.0,
      "bbox_min": [
        -197.00001525878906,
        -2300.0,
        641.0
      ],
      "bbox_max": [
        -193.50001525878906,
        -2300.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2293.5,
      "bbox_min": [
        -193.50001525878906,
        -2293.5,
        641.0
      ],
      "bbox_max": [
        -187.00001525878906,
        -2290.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 187.00001525878906,
      "bbox_min": [
        -187.00001525878906,
        -2293.5,
        641.0
      ],
      "bbox_max": [
        -187.00001525878906,
        -2290.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 193.50001525878906,
      "bbox_min": [
        -196.39991760253906,
        -2296.800048828125,
        641.5
      ],
      "bbox_max": [
        -193.50001525878906,
        -2294.300048828125,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 193.80006408691406,
      "bbox_min": [
        -196.39991760253906,
        -2296.5,
        641.5
      ],
      "bbox_max": [
        -193.80006408691406,
        -2294.5,
        644.0999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.19609887897968292,
        0.0,
        0.9805841445922852
      ],
      "plane_d": -669.7158203125,
      "bbox_min": [
        -196.39991760253906,
        -2296.5,
        641.5
      ],
      "bbox_max": [
        -193.80006408691406,
        -2294.5,
        644.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2296.5,
      "bbox_min": [
        -196.39991760253906,
        -2296.5,
        641.5
      ],
      "bbox_max": [
        -193.80006408691406,
        -2294.5,
        644.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2294.5,
      "bbox_min": [
        -196.39991760253906,
        -2296.5,
        641.5
      ],
      "bbox_max": [
        -193.80006408691406,
        -2294.5,
        644.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -196.39991760253906,
      "bbox_min": [
        -196.39991760253906,
        -2296.5,
        641.5
      ],
      "bbox_max": [
        -193.80006408691406,
        -2294.5,
        644.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -644.0999755859375,
      "bbox_min": [
        -196.39991760253906,
        -2296.5,
        641.5
      ],
      "bbox_max": [
        -193.80006408691406,
        -2294.5,
        644.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 194.80006408691406,
      "bbox_min": [
        -196.39991760253906,
        -2296.5,
        641.5
      ],
      "bbox_max": [
        -193.80006408691406,
        -2294.5,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2295.699951171875,
      "bbox_min": [
        -196.39991760253906,
        -2296.5,
        641.5
      ],
      "bbox_max": [
        -194.80006408691406,
        -2294.5,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19612763822078705,
        -0.0,
        -0.9805783629417419
      ],
      "plane_d": 591.5021362304688,
      "bbox_min": [
        -196.39991760253906,
        -2295.699951171875,
        641.5
      ],
      "bbox_max": [
        -194.80006408691406,
        -2294.5,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.19996643066406,
      "bbox_min": [
        -195.19996643066406,
        -2295.699951171875,
        642.260009765625
      ],
      "bbox_max": [
        -195.19996643066406,
        -2295.2998046875,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7069989442825317,
        0.0,
        0.7072146534919739
      ],
      "plane_d": -591.96728515625,
      "bbox_min": [
        -195.60011291503906,
        -2295.699951171875,
        641.5
      ],
      "bbox_max": [
        -194.80006408691406,
        -2294.89990234375,
        642.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7072147130966187,
        0.706998884677887
      ],
      "plane_d": 1169.4471435546875,
      "bbox_min": [
        -195.60011291503906,
        -2295.2998046875,
        641.5
      ],
      "bbox_max": [
        -194.80006408691406,
        -2294.89990234375,
        642.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2295.2998046875,
      "bbox_min": [
        -195.19996643066406,
        -2295.2998046875,
        641.9000244140625
      ],
      "bbox_max": [
        -194.80006408691406,
        -2295.2998046875,
        642.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.19996643066406,
      "bbox_min": [
        -195.19996643066406,
        -2295.699951171875,
        641.9000244140625
      ],
      "bbox_max": [
        -194.89996337890625,
        -2295.2998046875,
        642.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2295.2998046875,
      "bbox_min": [
        -195.19996643066406,
        -2295.2998046875,
        641.9000244140625
      ],
      "bbox_max": [
        -194.89996337890625,
        -2295.2998046875,
        642.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7072147130966187,
        0.706998884677887
      ],
      "plane_d": -2077.37548828125,
      "bbox_min": [
        -195.60011291503906,
        -2296.099853515625,
        641.5
      ],
      "bbox_max": [
        -194.80006408691406,
        -2295.699951171875,
        641.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19612763822078705,
        -0.0,
        -0.9805783629417419
      ],
      "plane_d": 591.5021362304688,
      "bbox_min": [
        -194.80006408691406,
        -2296.5,
        642.0999755859375
      ],
      "bbox_max": [
        -194.39991760253906,
        -2294.5,
        642.1799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.706998884677887,
        -0.0,
        0.7072146534919739
      ],
      "plane_d": -316.2376708984375,
      "bbox_min": [
        -194.80006408691406,
        -2296.099853515625,
        641.5
      ],
      "bbox_max": [
        -194.39991760253906,
        -2294.89990234375,
        641.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7072147130966187,
        0.706998884677887
      ],
      "plane_d": 1169.4471435546875,
      "bbox_min": [
        -194.80006408691406,
        -2295.2998046875,
        641.5
      ],
      "bbox_max": [
        -194.39991760253906,
        -2294.89990234375,
        641.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        -173.0,
        -2329.0,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2215.0,
        651.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -152.0,
      "bbox_min": [
        -173.0,
        -2312.0,
        648.0
      ],
      "bbox_max": [
        -152.0,
        -2290.0,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2290.0,
      "bbox_min": [
        -173.0,
        -2312.0,
        648.0
      ],
      "bbox_max": [
        -152.0,
        -2290.0,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2312.0,
      "bbox_min": [
        -173.0,
        -2312.0,
        648.0
      ],
      "bbox_max": [
        -152.0,
        -2312.0,
        651.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.1597747504711151,
        -0.8032662272453308,
        -0.5737903714179993
      ],
      "plane_d": -1464.1849365234375,
      "bbox_min": [
        -152.0,
        -2315.9033203125,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2215.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -114.69482421875,
        -2299.07275390625,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2215.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.681004524230957,
        -0.4550451934337616,
        -0.57373046875
      ],
      "plane_d": -597.5006713867188,
      "bbox_min": [
        -114.69482421875,
        -2299.07275390625,
        638.2872314453125
      ],
      "bbox_max": [
        -102.3388671875,
        -2278.81298828125,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": -1180.939697265625,
      "bbox_min": [
        -114.69482421875,
        -2297.30517578125,
        638.2872314453125
      ],
      "bbox_max": [
        -102.3388671875,
        -2278.81298828125,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.681013286113739,
        -0.4550338089466095,
        0.5737291574478149
      ],
      "plane_d": -1335.2900390625,
      "bbox_min": [
        -111.64397430419922,
        -2292.7392578125,
        638.2872314453125
      ],
      "bbox_max": [
        -102.3388671875,
        -2278.81298828125,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        -100.5,
        -2257.0,
        638.0
      ],
      "bbox_max": [
        -95.5,
        -2239.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2239.0,
      "bbox_min": [
        -100.5,
        -2239.0,
        638.0
      ],
      "bbox_max": [
        -98.0,
        -2239.0,
        648.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.803279459476471,
        -0.15977738797664642,
        -0.573771059513092
      ],
      "plane_d": 87.8992691040039,
      "bbox_min": [
        -103.58889770507812,
        -2285.097412109375,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2239.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": 454.3539123535156,
      "bbox_min": [
        -103.58889770507812,
        -2285.097412109375,
        644.5
      ],
      "bbox_max": [
        -95.5,
        -2244.431640625,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": -293.1184387207031,
      "bbox_min": [
        -103.48628234863281,
        -2284.58154296875,
        638.0
      ],
      "bbox_max": [
        -95.5,
        -2244.431640625,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.681013286113739,
        -0.4550338089466095,
        0.5737291574478149
      ],
      "plane_d": -1335.2900390625,
      "bbox_min": [
        -103.48628234863281,
        -2284.58154296875,
        638.0
      ],
      "bbox_max": [
        -100.029052734375,
        -2278.81298828125,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": -438.3698425292969,
      "bbox_min": [
        -83.0,
        -2257.0,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2239.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.0,
      "bbox_min": [
        -83.0,
        -2239.0,
        638.0
      ],
      "bbox_max": [
        -78.0,
        -2239.0,
        644.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": 309.10247802734375,
      "bbox_min": [
        -83.0,
        -2257.0,
        641.5
      ],
      "bbox_max": [
        -78.0,
        -2239.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.0,
      "bbox_min": [
        -83.0,
        -2239.0,
        643.0
      ],
      "bbox_max": [
        -78.0,
        -2239.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -80.5,
      "bbox_min": [
        -80.5,
        -2257.0,
        641.5
      ],
      "bbox_max": [
        -79.4285659790039,
        -2239.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.0,
      "bbox_min": [
        -80.5,
        -2239.0,
        641.5
      ],
      "bbox_max": [
        -79.4285659790039,
        -2239.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509007036685944,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": -2239.29833984375,
      "bbox_min": [
        -152.0,
        -2315.9033203125,
        638.0
      ],
      "bbox_max": [
        -133.18701171875,
        -2309.6611328125,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15978190302848816,
        -0.803278923034668,
        0.5737706422805786
      ],
      "plane_d": -2202.09521484375,
      "bbox_min": [
        -152.0,
        -2315.9033203125,
        638.0
      ],
      "bbox_max": [
        -138.57159423828125,
        -2310.732177734375,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45500898361206055,
        -0.680976152420044,
        0.5737929344177246
      ],
      "plane_d": -1880.31103515625,
      "bbox_min": [
        -150.18222045898438,
        -2315.541748046875,
        638.0
      ],
      "bbox_max": [
        -102.75687408447266,
        -2283.85205078125,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.681013286113739,
        -0.4550338089466095,
        0.5737291574478149
      ],
      "plane_d": -1335.2900390625,
      "bbox_min": [
        -150.18222045898438,
        -2315.541748046875,
        638.0
      ],
      "bbox_max": [
        -102.75687408447266,
        -2283.85205078125,
        642.9998168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15978190302848816,
        -0.803278923034668,
        0.5737706422805786
      ],
      "plane_d": -2202.09521484375,
      "bbox_min": [
        -150.18222045898438,
        -2315.541748046875,
        638.0
      ],
      "bbox_max": [
        -132.230224609375,
        -2309.6611328125,
        642.999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509007036685944,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": -2239.29833984375,
      "bbox_min": [
        -138.57159423828125,
        -2310.732177734375,
        641.5
      ],
      "bbox_max": [
        -133.18701171875,
        -2309.6611328125,
        642.999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": -1180.939697265625,
      "bbox_min": [
        -114.69482421875,
        -2297.30517578125,
        641.5
      ],
      "bbox_max": [
        -111.64396667480469,
        -2292.7392578125,
        642.9998168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555662512779236,
        -0.8314722776412964,
        0.0
      ],
      "plane_d": -1846.425048828125,
      "bbox_min": [
        -135.87977600097656,
        -2310.19677734375,
        641.5
      ],
      "bbox_max": [
        -113.16923522949219,
        -2295.02197265625,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2290.0,
      "bbox_min": [
        -173.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2290.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2312.0,
      "bbox_min": [
        -173.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2290.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -166.0,
      "bbox_min": [
        -173.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -152.0,
        -2312.0,
        648.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": -1508.3712158203125,
      "bbox_min": [
        -166.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -152.0,
        -2313.4033203125,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1597747504711151,
        -0.8032662272453308,
        -0.5737903714179993
      ],
      "plane_d": -1464.1849365234375,
      "bbox_min": [
        -155.0,
        -2316.5,
        643.66455078125
      ],
      "bbox_max": [
        -152.0,
        -2313.4033203125,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509007036685944,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": -2239.29833984375,
      "bbox_min": [
        -155.0,
        -2314.0,
        643.66455078125
      ],
      "bbox_max": [
        -152.0,
        -2313.4033203125,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": -2255.843505859375,
      "bbox_min": [
        -166.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -152.0,
        -2313.4033203125,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15978190302848816,
        -0.803278923034668,
        0.5737706422805786
      ],
      "plane_d": -2202.09521484375,
      "bbox_min": [
        -155.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -152.0,
        -2313.4033203125,
        642.3353271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509007036685944,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": -2239.29833984375,
      "bbox_min": [
        -155.0,
        -2314.0,
        641.5
      ],
      "bbox_max": [
        -152.0,
        -2313.4033203125,
        642.3353271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2314.0,
      "bbox_min": [
        -166.0,
        -2314.0,
        641.5
      ],
      "bbox_max": [
        -152.0,
        -2313.4033203125,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509007036685944,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": -2239.29833984375,
      "bbox_min": [
        -155.0,
        -2314.0,
        641.5
      ],
      "bbox_max": [
        -152.0,
        -2313.4033203125,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 171.0,
      "bbox_min": [
        -173.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -171.0,
        -2312.0,
        648.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": -1508.3712158203125,
      "bbox_min": [
        -173.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -171.0,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": -2255.843505859375,
      "bbox_min": [
        -173.0,
        -2316.5,
        638.0
      ],
      "bbox_max": [
        -171.0,
        -2314.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2314.0,
      "bbox_min": [
        -173.0,
        -2314.0,
        641.5
      ],
      "bbox_max": [
        -171.0,
        -2314.0,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.5,
      "bbox_min": [
        -161.99998474121094,
        -2305.0,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2290.0,
        644.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2301.0,
      "bbox_min": [
        -161.99998474121094,
        -2305.0,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2290.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -155.49998474121094,
      "bbox_min": [
        -155.49998474121094,
        -2305.0,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2301.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2305.0,
      "bbox_min": [
        -155.49998474121094,
        -2305.0,
        638.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2305.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 641.0,
      "bbox_min": [
        -161.99998474121094,
        -2300.0,
        641.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2290.0,
        641.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -155.49998474121094,
      "bbox_min": [
        -161.99998474121094,
        -2300.0,
        641.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2290.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2300.0,
      "bbox_min": [
        -155.49998474121094,
        -2300.0,
        641.0
      ],
      "bbox_max": [
        -151.99998474121094,
        -2300.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2293.5,
      "bbox_min": [
        -161.99998474121094,
        -2293.5,
        641.0
      ],
      "bbox_max": [
        -155.49998474121094,
        -2290.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -161.99998474121094,
      "bbox_min": [
        -161.99998474121094,
        -2293.5,
        641.0
      ],
      "bbox_max": [
        -161.99998474121094,
        -2290.0,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -155.49998474121094,
      "bbox_min": [
        -155.49998474121094,
        -2296.800048828125,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2294.300048828125,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -155.19993591308594,
      "bbox_min": [
        -155.19993591308594,
        -2296.5,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2294.5,
        644.0999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.19609886407852173,
        0.0,
        0.9805841445922852
      ],
      "plane_d": -601.27734375,
      "bbox_min": [
        -155.19993591308594,
        -2296.5,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2294.5,
        644.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2296.5,
      "bbox_min": [
        -155.19993591308594,
        -2296.5,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2294.5,
        644.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2294.5,
      "bbox_min": [
        -155.19993591308594,
        -2296.5,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2294.5,
        644.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -644.0999755859375,
      "bbox_min": [
        -155.19993591308594,
        -2296.5,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2294.5,
        644.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19612763822078705,
        0.0,
        -0.9805783629417419
      ],
      "plane_d": 659.95068359375,
      "bbox_min": [
        -155.19993591308594,
        -2296.5,
        641.5
      ],
      "bbox_max": [
        -152.60008239746094,
        -2294.5,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 642.0999755859375,
      "bbox_min": [
        -155.19993591308594,
        -2296.5,
        642.0999755859375
      ],
      "bbox_max": [
        -153.80003356933594,
        -2294.5,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -154.19993591308594,
      "bbox_min": [
        -154.19993591308594,
        -2295.699951171875,
        642.1799926757812
      ],
      "bbox_max": [
        -153.80003356933594,
        -2295.2998046875,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2295.699951171875,
      "bbox_min": [
        -154.19993591308594,
        -2295.699951171875,
        642.1799926757812
      ],
      "bbox_max": [
        -153.80003356933594,
        -2295.2998046875,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2295.2998046875,
      "bbox_min": [
        -154.19993591308594,
        -2295.2998046875,
        642.1799926757812
      ],
      "bbox_max": [
        -153.80003356933594,
        -2295.2998046875,
        642.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7072147130966187,
        0.706998884677887
      ],
      "plane_d": -2077.37548828125,
      "bbox_min": [
        -154.60008239746094,
        -2296.099853515625,
        641.5
      ],
      "bbox_max": [
        -153.39988708496094,
        -2294.89990234375,
        642.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7072147130966187,
        0.706998884677887
      ],
      "plane_d": 1169.4471435546875,
      "bbox_min": [
        -154.60008239746094,
        -2296.099853515625,
        641.5
      ],
      "bbox_max": [
        -153.39988708496094,
        -2294.89990234375,
        642.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.706998884677887,
        0.0,
        0.7072146534919739
      ],
      "plane_d": -562.9802856445312,
      "bbox_min": [
        -154.60008239746094,
        -2296.099853515625,
        641.5
      ],
      "bbox_max": [
        -153.39988708496094,
        -2294.89990234375,
        642.100341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.706998884677887,
        0.0,
        0.7072146534919739
      ],
      "plane_d": -345.2246398925781,
      "bbox_min": [
        -153.80003356933594,
        -2296.099853515625,
        641.5
      ],
      "bbox_max": [
        -153.39988708496094,
        -2294.89990234375,
        641.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -154.19993591308594,
      "bbox_min": [
        -154.19993591308594,
        -2295.699951171875,
        641.9000244140625
      ],
      "bbox_max": [
        -154.19993591308594,
        -2295.2998046875,
        642.100341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -154.19993591308594,
      "bbox_min": [
        -154.19993591308594,
        -2295.5,
        641.9000244140625
      ],
      "bbox_max": [
        -154.19993591308594,
        -2295.2998046875,
        642.1799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2295.699951171875,
      "bbox_min": [
        -154.19993591308594,
        -2295.699951171875,
        641.9000244140625
      ],
      "bbox_max": [
        -153.80003356933594,
        -2295.42041015625,
        642.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -154.19993591308594,
      "bbox_min": [
        -154.19993591308594,
        -2295.699951171875,
        641.9000244140625
      ],
      "bbox_max": [
        -154.19993591308594,
        -2295.42041015625,
        642.1799926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10146033763885498,
        0.9581761956214905,
        0.2675895094871521
      ],
      "plane_d": 1884.0174560546875,
      "bbox_min": [
        -109.39362335205078,
        -2191.024658203125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2007.3287353515625,
        772.3233642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -109.39362335205078,
        -2191.024658203125,
        606.0013427734375
      ],
      "bbox_max": [
        26.906936645507812,
        -2132.764404296875,
        758.349365234375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2182.5,
      "bbox_min": [
        -109.39362335205078,
        -2183.121826171875,
        626.0
      ],
      "bbox_max": [
        -75.300048828125,
        -2161.430908203125,
        675.2044067382812
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": 447.3790588378906,
      "bbox_min": [
        -98.0,
        -2183.121826171875,
        628.4490966796875
      ],
      "bbox_max": [
        -92.03517150878906,
        -2182.5,
        636.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 636.0,
      "bbox_min": [
        -98.0,
        -2183.121826171875,
        628.4490966796875
      ],
      "bbox_max": [
        -92.03517150878906,
        -2182.5,
        636.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        -98.0,
        -2183.121826171875,
        628.4490966796875
      ],
      "bbox_max": [
        -97.24935150146484,
        -2182.5,
        632.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": -286.1435852050781,
      "bbox_min": [
        -98.0,
        -2182.7587890625,
        628.4490966796875
      ],
      "bbox_max": [
        -97.24935150146484,
        -2182.5,
        629.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 101.5,
      "bbox_min": [
        -109.39362335205078,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -75.300048828125,
        -2161.430908203125,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07822323590517044,
        0.9795448184013367,
        0.1854003369808197
      ],
      "plane_d": 2009.3104248046875,
      "bbox_min": [
        -109.39362335205078,
        -2181.199951171875,
        651.6449584960938
      ],
      "bbox_max": [
        -101.5,
        -2165.965576171875,
        658.11767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2181.199951171875,
      "bbox_min": [
        -105.300048828125,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -101.5,
        -2181.199951171875,
        656.222900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08373019099235535,
        0.9710349440574646,
        0.22378645837306976
      ],
      "plane_d": 1966.399658203125,
      "bbox_min": [
        -109.39362335205078,
        -2166.39990234375,
        651.6449584960938
      ],
      "bbox_max": [
        -105.28955078125,
        -2165.965576171875,
        653.271728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2165.999755859375,
      "bbox_min": [
        -101.5,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -75.300048828125,
        -2161.430908203125,
        675.2044067382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 675.2044067382812,
      "bbox_min": [
        -101.5,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -75.300048828125,
        -2166.0,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2170.0,
      "bbox_min": [
        -101.5,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -75.300048828125,
        -2166.0,
        675.2044067382812
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -101.5,
        -2170.0,
        646.0
      ],
      "bbox_max": [
        -81.60009765625,
        -2166.0,
        668.6296997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        -101.5,
        -2170.0,
        646.0
      ],
      "bbox_max": [
        -85.0,
        -2166.0,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07822323590517044,
        0.9795448184013367,
        0.1854003369808197
      ],
      "plane_d": 2009.3104248046875,
      "bbox_min": [
        -101.5,
        -2167.473388671875,
        656.210693359375
      ],
      "bbox_max": [
        -101.07923889160156,
        -2167.3662109375,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -85.0,
      "bbox_min": [
        -85.0,
        -2170.0,
        646.0
      ],
      "bbox_max": [
        -85.0,
        -2166.677978515625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -81.60009765625,
        -2170.0,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2169.029541015625,
        661.5482788085938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2181.199951171875,
      "bbox_min": [
        -101.5,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -100.5,
        -2181.199951171875,
        657.1488037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1469.0142822265625,
      "bbox_min": [
        -100.5,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -75.300048828125,
        -2170.0,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1608.6678466796875,
      "bbox_min": [
        -100.5,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -75.300048828125,
        -2170.0,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1472.1962890625,
      "bbox_min": [
        -98.7499771118164,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -75.300048828125,
        -2170.0,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1474.317626953125,
      "bbox_min": [
        -96.5,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -75.300048828125,
        -2170.0,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 1608.16796875,
      "bbox_min": [
        -96.5,
        -2180.0,
        626.0
      ],
      "bbox_max": [
        -84.99983978271484,
        -2170.0,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -96.5,
        -2180.0,
        626.0
      ],
      "bbox_max": [
        -94.64644622802734,
        -2178.146484375,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -96.5,
        -2180.0,
        656.5999755859375
      ],
      "bbox_max": [
        -94.646484375,
        -2178.146484375,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -96.14644622802734,
        -2179.646484375,
        626.0
      ],
      "bbox_max": [
        -84.99983978271484,
        -2170.0,
        675.2000122070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.5999755859375,
      "bbox_min": [
        -92.0,
        -2177.0,
        654.5999755859375
      ],
      "bbox_max": [
        -84.99983978271484,
        -2170.0,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -92.0,
        -2177.0,
        654.5999755859375
      ],
      "bbox_max": [
        -84.99994659423828,
        -2170.0,
        675.2000122070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2172.5,
      "bbox_min": [
        -90.49994659423828,
        -2172.5,
        654.5999755859375
      ],
      "bbox_max": [
        -87.49991607666016,
        -2172.5,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 674.4000244140625,
      "bbox_min": [
        -92.0,
        -2177.0,
        674.4000244140625
      ],
      "bbox_max": [
        -88.39990234375,
        -2171.857421875,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070798277854919,
        0.0,
        -0.7071337699890137
      ],
      "plane_d": 539.9625244140625,
      "bbox_min": [
        -89.199951171875,
        -2174.199951171875,
        674.4000244140625
      ],
      "bbox_max": [
        -88.39990234375,
        -2171.91015625,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 1599.4754638671875,
      "bbox_min": [
        -95.0,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -75.300048828125,
        -2170.0,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1481.388671875,
      "bbox_min": [
        -95.0,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -80.0,
        -2173.5,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1601.5968017578125,
      "bbox_min": [
        -95.0,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -83.5,
        -2173.5,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1480.8887939453125,
      "bbox_min": [
        -90.0,
        -2180.0,
        626.0
      ],
      "bbox_max": [
        -83.5,
        -2173.5,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -85.353515625,
        -2180.0,
        626.0
      ],
      "bbox_max": [
        -83.5,
        -2178.146484375,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -85.35346984863281,
        -2180.0,
        626.0
      ],
      "bbox_max": [
        -83.5,
        -2178.146484375,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -90.0,
        -2179.646484375,
        626.0
      ],
      "bbox_max": [
        -83.85346984863281,
        -2173.5,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070798277854919,
        0.0,
        -0.7071337699890137
      ],
      "plane_d": 539.9625244140625,
      "bbox_min": [
        -90.0,
        -2176.60009765625,
        674.4000244140625
      ],
      "bbox_max": [
        -88.39990234375,
        -2173.5,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -95.0,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -85.0,
        -2180.0,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2181.0,
      "bbox_min": [
        -95.0,
        -2182.5,
        652.7044067382812
      ],
      "bbox_max": [
        -85.0,
        -2180.0,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2181.199951171875,
      "bbox_min": [
        -93.9999771118164,
        -2182.5,
        652.7044067382812
      ],
      "bbox_max": [
        -85.99996948242188,
        -2181.0,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.5999755859375,
      "bbox_min": [
        -93.9999771118164,
        -2181.199951171875,
        654.5999755859375
      ],
      "bbox_max": [
        -85.99996948242188,
        -2181.0,
        654.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.5999755859375,
      "bbox_min": [
        -93.80001831054688,
        -2182.5,
        654.5999755859375
      ],
      "bbox_max": [
        -86.19991302490234,
        -2181.199951171875,
        654.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -95.0,
        -2181.0,
        654.5999755859375
      ],
      "bbox_max": [
        -85.0,
        -2180.0,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.5999755859375,
      "bbox_min": [
        -95.0,
        -2181.0,
        654.5999755859375
      ],
      "bbox_max": [
        -85.0,
        -2180.0,
        654.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -95.0,
        -2180.0,
        626.0
      ],
      "bbox_max": [
        -85.0,
        -2175.0,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070798277854919,
        -0.0,
        -0.7071337699890137
      ],
      "plane_d": 412.4053955078125,
      "bbox_min": [
        -92.0,
        -2180.0,
        674.4000244140625
      ],
      "bbox_max": [
        -91.199951171875,
        -2176.199951171875,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        -87.49993133544922,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -80.0,
        -2178.5,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -87.49993133544922,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -80.0,
        -2178.5,
        675.2044067382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.5999755859375,
      "bbox_min": [
        -87.49993133544922,
        -2182.5,
        652.7044067382812
      ],
      "bbox_max": [
        -80.0,
        -2178.5,
        675.2044067382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2181.0,
      "bbox_min": [
        -86.20008850097656,
        -2181.199951171875,
        654.5999755859375
      ],
      "bbox_max": [
        -80.7999038696289,
        -2178.5,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2181.199951171875,
      "bbox_min": [
        -86.20008850097656,
        -2181.199951171875,
        654.5999755859375
      ],
      "bbox_max": [
        -80.7999038696289,
        -2181.199951171875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -86.00001525878906,
        -2181.0,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2178.5,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2181.199951171875,
      "bbox_min": [
        -86.20011138916016,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -80.7999496459961,
        -2181.199951171875,
        654.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1476.0853271484375,
      "bbox_min": [
        -88.49995422363281,
        -2182.0,
        626.0
      ],
      "bbox_max": [
        -75.300048828125,
        -2170.0,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1596.2935791015625,
      "bbox_min": [
        -87.25003051757812,
        -2182.0,
        626.0
      ],
      "bbox_max": [
        -75.300048828125,
        -2170.0,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1478.2066650390625,
      "bbox_min": [
        -87.25003051757812,
        -2182.0,
        626.0
      ],
      "bbox_max": [
        -76.30010223388672,
        -2172.5,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1596.79345703125,
      "bbox_min": [
        -87.25003051757812,
        -2176.25,
        626.0
      ],
      "bbox_max": [
        -83.5,
        -2172.5,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -85.353515625,
        -2174.353515625,
        626.0
      ],
      "bbox_max": [
        -83.5,
        -2172.5,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -85.35348510742188,
        -2174.353515625,
        626.0
      ],
      "bbox_max": [
        -83.5,
        -2172.5,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -87.25003051757812,
        -2176.25,
        626.0
      ],
      "bbox_max": [
        -83.85347747802734,
        -2172.853515625,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        -85.75001525878906,
        -2182.0,
        626.0
      ],
      "bbox_max": [
        -76.30010223388672,
        -2174.0,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2181.199951171875,
      "bbox_min": [
        -80.0,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -76.30010223388672,
        -2181.199951171875,
        657.0562744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -85.75001525878906,
        -2182.0,
        626.0
      ],
      "bbox_max": [
        -80.0,
        -2174.0,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -83.5,
        -2182.0,
        652.7044067382812
      ],
      "bbox_max": [
        -80.0,
        -2174.0,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 654.5999755859375,
      "bbox_min": [
        -81.60009765625,
        -2182.0,
        652.7044067382812
      ],
      "bbox_max": [
        -80.0,
        -2175.89990234375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2181.199951171875,
      "bbox_min": [
        -80.7999496459961,
        -2181.199951171875,
        654.5999755859375
      ],
      "bbox_max": [
        -80.0,
        -2181.199951171875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2181.199951171875,
      "bbox_min": [
        -80.79997253417969,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -80.0,
        -2181.199951171875,
        654.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 654.5999755859375,
      "bbox_min": [
        -83.5,
        -2180.39990234375,
        654.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2174.0,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -83.5,
        -2180.39990234375,
        654.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2174.0,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -83.5,
      "bbox_min": [
        -83.5,
        -2178.5,
        654.5999755859375
      ],
      "bbox_max": [
        -83.5,
        -2174.0,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        -85.0,
        -2181.199951171875,
        626.0
      ],
      "bbox_max": [
        -75.300048828125,
        -2170.0,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2181.199951171875,
      "bbox_min": [
        -76.30010986328125,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -75.300048828125,
        -2181.199951171875,
        653.63037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 654.5999755859375,
      "bbox_min": [
        -85.0,
        -2177.5,
        626.0
      ],
      "bbox_max": [
        -80.0,
        -2170.0,
        675.2044067382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -85.0,
        -2175.900146484375,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2170.0,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -85.0,
        -2175.900146484375,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2170.0,
        656.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -85.0,
        -2177.5,
        626.0
      ],
      "bbox_max": [
        -80.0,
        -2170.0,
        626.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.5999755859375,
      "bbox_min": [
        -88.49995422363281,
        -2174.75,
        626.0
      ],
      "bbox_max": [
        -82.49992370605469,
        -2170.0,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2172.5,
      "bbox_min": [
        -87.49991607666016,
        -2172.5,
        654.5999755859375
      ],
      "bbox_max": [
        -85.0,
        -2172.5,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -88.4999008178711,
        -2174.75,
        626.0
      ],
      "bbox_max": [
        -82.49992370605469,
        -2170.0,
        626.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -96.5,
        -2174.353515625,
        626.0
      ],
      "bbox_max": [
        -94.64644622802734,
        -2172.5,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -96.5,
        -2174.353515625,
        656.5999755859375
      ],
      "bbox_max": [
        -94.646484375,
        -2172.5,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -96.14645385742188,
        -2176.25,
        626.0
      ],
      "bbox_max": [
        -92.74996948242188,
        -2172.853515625,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 96.5,
      "bbox_min": [
        -98.7499771118164,
        -2178.5,
        626.0
      ],
      "bbox_max": [
        -94.25003051757812,
        -2174.0,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.5999755859375,
      "bbox_min": [
        -98.7499771118164,
        -2178.5,
        626.0
      ],
      "bbox_max": [
        -96.5,
        -2174.0,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -98.74996948242188,
        -2178.5,
        656.5999755859375
      ],
      "bbox_max": [
        -96.5,
        -2174.0,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -98.7499771118164,
        -2178.5,
        626.0
      ],
      "bbox_max": [
        -96.5,
        -2174.0,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -95.0,
        -2174.0,
        654.5999755859375
      ],
      "bbox_max": [
        -87.9999771118164,
        -2170.0,
        675.2000122070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2172.5,
      "bbox_min": [
        -95.0,
        -2172.5,
        654.5999755859375
      ],
      "bbox_max": [
        -90.49994659423828,
        -2172.5,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070798277854919,
        -0.0,
        -0.7071337699890137
      ],
      "plane_d": 412.4053955078125,
      "bbox_min": [
        -92.0,
        -2174.0,
        674.4000244140625
      ],
      "bbox_max": [
        -89.8573989868164,
        -2171.749755859375,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 674.4000244140625,
      "bbox_min": [
        -91.199951171875,
        -2173.199951171875,
        674.4000244140625
      ],
      "bbox_max": [
        -89.8573989868164,
        -2171.749755859375,
        674.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -95.0,
        -2174.75,
        626.0
      ],
      "bbox_max": [
        -87.99988555908203,
        -2170.0,
        626.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -100.5,
        -2182.5,
        626.0
      ],
      "bbox_max": [
        -92.49994659423828,
        -2176.25,
        675.2044067382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.5999755859375,
      "bbox_min": [
        -100.5,
        -2182.5,
        652.7044067382812
      ],
      "bbox_max": [
        -92.49994659423828,
        -2176.25,
        675.2044067382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2181.0,
      "bbox_min": [
        -100.5,
        -2181.199951171875,
        654.5999755859375
      ],
      "bbox_max": [
        -93.79989624023438,
        -2176.25,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2181.199951171875,
      "bbox_min": [
        -100.5,
        -2181.199951171875,
        654.5999755859375
      ],
      "bbox_max": [
        -93.79989624023438,
        -2181.199951171875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2181.0,
        656.5999755859375
      ],
      "bbox_max": [
        -94.00003814697266,
        -2176.25,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -98.89990234375,
        -2181.0,
        656.5999755859375
      ],
      "bbox_max": [
        -94.00003814697266,
        -2176.25,
        656.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2181.199951171875,
      "bbox_min": [
        -100.5,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -93.79991912841797,
        -2181.199951171875,
        654.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.5999755859375,
      "bbox_min": [
        -100.5,
        -2178.0,
        626.0
      ],
      "bbox_max": [
        -92.49994659423828,
        -2170.0,
        675.2034301757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2176.39990234375,
        656.5999755859375
      ],
      "bbox_max": [
        -92.5000228881836,
        -2170.0,
        675.2034301757812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -98.89990234375,
        -2176.39990234375,
        656.5999755859375
      ],
      "bbox_max": [
        -92.5000228881836,
        -2170.0,
        656.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        -101.5,
        -2162.5,
        626.0
      ],
      "bbox_max": [
        -88.18306732177734,
        -2161.430908203125,
        626.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -78.5,
        -2166.0,
        638.5
      ],
      "bbox_max": [
        -78.5,
        -2165.72900390625,
        639.8824462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.5,
      "bbox_min": [
        -101.5,
        -2166.0,
        626.0
      ],
      "bbox_max": [
        -78.5,
        -2150.5,
        646.0895385742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2162.5,
      "bbox_min": [
        -101.5,
        -2165.72900390625,
        626.0
      ],
      "bbox_max": [
        -78.5,
        -2150.5,
        638.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -101.5,
        -2165.72900390625,
        626.0
      ],
      "bbox_max": [
        -78.5,
        -2162.5,
        638.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 101.5,
      "bbox_min": [
        -101.5,
        -2163.88232421875,
        631.451416015625
      ],
      "bbox_max": [
        -101.5,
        -2162.5,
        638.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -101.5,
        -2162.5,
        626.0
      ],
      "bbox_max": [
        -78.5,
        -2150.5,
        638.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 101.5,
      "bbox_min": [
        -101.5,
        -2162.5,
        626.0
      ],
      "bbox_max": [
        -78.5,
        -2150.5,
        638.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2150.5,
      "bbox_min": [
        -88.99424743652344,
        -2150.5,
        626.0
      ],
      "bbox_max": [
        -78.5,
        -2150.5,
        629.979248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 101.5,
      "bbox_min": [
        -101.5,
        -2166.0,
        638.5
      ],
      "bbox_max": [
        -78.5,
        -2155.31494140625,
        646.0895385742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2165.999755859375,
      "bbox_min": [
        -90.69471740722656,
        -2166.0,
        638.5
      ],
      "bbox_max": [
        -78.5,
        -2158.89404296875,
        644.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -78.5,
        -2166.0,
        638.5
      ],
      "bbox_max": [
        -78.5,
        -2158.89404296875,
        643.0485229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16232024133205414,
        0.6113411784172058,
        0.7745412588119507
      ],
      "plane_d": 836.6249389648438,
      "bbox_min": [
        -109.3934097290039,
        -2172.677978515625,
        631.6541748046875
      ],
      "bbox_max": [
        -20.5302734375,
        -2150.10498046875,
        675.2044067382812
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 101.5,
      "bbox_min": [
        -101.5,
        -2167.0966796875,
        639.9039916992188
      ],
      "bbox_max": [
        -78.5,
        -2155.70703125,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2165.999755859375,
      "bbox_min": [
        -101.5,
        -2167.0966796875,
        643.0485229492188
      ],
      "bbox_max": [
        -78.5,
        -2165.07763671875,
        650.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -85.0,
      "bbox_min": [
        -85.0,
        -2167.0966796875,
        646.0
      ],
      "bbox_max": [
        -85.0,
        -2166.0,
        648.1356811523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        -101.5,
        -2166.0,
        650.0
      ],
      "bbox_max": [
        -98.02632904052734,
        -2165.07763671875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        -101.5,
        -2172.677978515625,
        634.7183837890625
      ],
      "bbox_max": [
        -78.5,
        -2151.82373046875,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -98.89990234375,
        -2172.677978515625,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2158.262451171875,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 675.2044067382812,
      "bbox_min": [
        -98.89990234375,
        -2172.677978515625,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2158.7919921875,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -98.89990234375,
        -2172.677978515625,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2158.7919921875,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2172.13134765625,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2158.7919921875,
        675.2000122070312
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7070798277854919,
        -0.0,
        -0.7071337699890137
      ],
      "plane_d": 412.4053955078125,
      "bbox_min": [
        -92.0,
        -2171.84228515625,
        674.4000244140625
      ],
      "bbox_max": [
        -91.199951171875,
        -2164.250244140625,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2160.0,
      "bbox_min": [
        -98.00824737548828,
        -2160.0,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2158.7919921875,
        662.8214721679688
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7208325266838074,
        0.0,
        0.6931092739105225
      ],
      "plane_d": -518.7118530273438,
      "bbox_min": [
        -94.0,
        -2160.0,
        656.5999755859375
      ],
      "bbox_max": [
        -83.60009765625,
        -2158.7919921875,
        662.0630493164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -86.60009765625,
      "bbox_min": [
        -86.60009765625,
        -2160.0,
        656.5999755859375
      ],
      "bbox_max": [
        -86.60009765625,
        -2158.7919921875,
        658.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 94.0,
      "bbox_min": [
        -94.0,
        -2160.0,
        656.5999755859375
      ],
      "bbox_max": [
        -83.60009765625,
        -2159.57568359375,
        662.0630493164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -83.60009765625,
      "bbox_min": [
        -83.60009765625,
        -2160.0,
        661.4400024414062
      ],
      "bbox_max": [
        -83.60009765625,
        -2159.825927734375,
        662.0630493164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -101.5,
        -2167.46240234375,
        634.7183837890625
      ],
      "bbox_max": [
        -78.5,
        -2151.82373046875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 101.5,
      "bbox_min": [
        -101.5,
        -2167.46240234375,
        643.3668823242188
      ],
      "bbox_max": [
        -78.5,
        -2156.674072265625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2166.0,
      "bbox_min": [
        -98.02664184570312,
        -2167.46240234375,
        645.9078979492188
      ],
      "bbox_max": [
        -78.5,
        -2166.0,
        650.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -85.0,
      "bbox_min": [
        -95.0,
        -2167.46240234375,
        647.2700805664062
      ],
      "bbox_max": [
        -85.0,
        -2166.0,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.826246440410614,
        -0.5570085048675537,
        0.08401353657245636
      ],
      "plane_d": -1092.1922607421875,
      "bbox_min": [
        -107.84700012207031,
        -2164.645263671875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2007.3287353515625,
        772.3233642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8734391927719116,
        -0.19791147112846375,
        -0.44489893317222595
      ],
      "plane_d": -14.895965576171875,
      "bbox_min": [
        121.512451171875,
        -2113.157470703125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2044.892578125,
        637.62353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 101.5,
      "bbox_min": [
        -101.5,
        -2155.70703125,
        626.0
      ],
      "bbox_max": [
        -78.5,
        -2150.5,
        639.9039916992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -78.5,
        -2151.570556640625,
        629.979248046875
      ],
      "bbox_max": [
        -78.5,
        -2150.5,
        633.8123168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6143797636032104,
        -0.7540411949157715,
        -0.23229148983955383
      ],
      "plane_d": -1301.553955078125,
      "bbox_min": [
        -107.84700012207031,
        -2164.645263671875,
        628.0859375
      ],
      "bbox_max": [
        145.22381591796875,
        -2007.3287353515625,
        772.3233642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46316424012184143,
        -0.7446286082267761,
        -0.4806317985057831
      ],
      "plane_d": -1112.9168701171875,
      "bbox_min": [
        -107.84700012207031,
        -2164.645263671875,
        628.0859375
      ],
      "bbox_max": [
        129.7200469970703,
        -2007.3287353515625,
        772.3233642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16232120990753174,
        0.611343502998352,
        0.7745391726493835
      ],
      "plane_d": 836.63134765625,
      "bbox_min": [
        -107.84700012207031,
        -2164.645263671875,
        628.0859375
      ],
      "bbox_max": [
        -64.5244140625,
        -2136.677978515625,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 101.5,
      "bbox_min": [
        -101.5,
        -2156.674072265625,
        633.1271362304688
      ],
      "bbox_max": [
        -78.5,
        -2150.5,
        643.3670043945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -78.5,
        -2151.823486328125,
        633.1271362304688
      ],
      "bbox_max": [
        -78.5,
        -2150.5,
        634.71826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        -101.5,
        -2164.645263671875,
        633.6736450195312
      ],
      "bbox_max": [
        -64.5244140625,
        -2136.677978515625,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 675.2044067382812,
      "bbox_min": [
        -98.89990234375,
        -2164.645263671875,
        650.0
      ],
      "bbox_max": [
        -71.8232192993164,
        -2136.677978515625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -98.89990234375,
        -2164.55810546875,
        650.0
      ],
      "bbox_max": [
        -71.8232192993164,
        -2136.677978515625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6532713174819946,
        0.27060064673423767,
        0.7071151733398438
      ],
      "plane_d": 169.50509643554688,
      "bbox_min": [
        -89.07524871826172,
        -2150.27197265625,
        650.0
      ],
      "bbox_max": [
        -71.8232192993164,
        -2136.677978515625,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27060848474502563,
        0.6532667279243469,
        0.7071163654327393
      ],
      "plane_d": 957.7940673828125,
      "bbox_min": [
        -89.07524871826172,
        -2142.64697265625,
        651.2399291992188
      ],
      "bbox_max": [
        -79.672119140625,
        -2136.677978515625,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -89.07524871826172,
        -2138.245849609375,
        651.2399291992188
      ],
      "bbox_max": [
        -88.0,
        -2137.033203125,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -68.14163208007812,
      "bbox_min": [
        -79.672119140625,
        -2150.27197265625,
        650.0
      ],
      "bbox_max": [
        -71.8232192993164,
        -2139.14013671875,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -50.819091796875,
      "bbox_min": [
        -75.278564453125,
        -2150.27197265625,
        650.0
      ],
      "bbox_max": [
        -71.8232192993164,
        -2146.3388671875,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2158.0,
      "bbox_min": [
        -98.89990234375,
        -2164.55810546875,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2140.72119140625,
        675.2044067382812
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -98.89990234375,
        -2164.55810546875,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2158.0,
        675.2044067382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -86.60009765625,
      "bbox_min": [
        -98.89990234375,
        -2164.55810546875,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2158.0,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2160.0,
      "bbox_min": [
        -86.60009765625,
        -2160.0,
        658.3200073242188
      ],
      "bbox_max": [
        -81.60009765625,
        -2158.0,
        675.2044067382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7784106135368347,
        0.0,
        -0.6277554631233215
      ],
      "plane_d": 352.4826354980469,
      "bbox_min": [
        -86.60009765625,
        -2160.0,
        658.3200073242188
      ],
      "bbox_max": [
        -83.60009765625,
        -2158.0,
        668.8800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7208325266838074,
        0.0,
        0.6931092739105225
      ],
      "plane_d": -518.7118530273438,
      "bbox_min": [
        -86.60009765625,
        -2160.0,
        658.3200073242188
      ],
      "bbox_max": [
        -83.60009765625,
        -2158.0,
        665.1600341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -83.60009765625,
      "bbox_min": [
        -83.60009765625,
        -2160.0,
        661.4400024414062
      ],
      "bbox_max": [
        -83.60009765625,
        -2158.0,
        665.1600341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070798277854919,
        0.0,
        -0.7071337699890137
      ],
      "plane_d": 539.9625244140625,
      "bbox_min": [
        -98.89990234375,
        -2164.55810546875,
        656.5999755859375
      ],
      "bbox_max": [
        -88.39990234375,
        -2158.0,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 674.4000244140625,
      "bbox_min": [
        -92.0,
        -2164.55810546875,
        674.4000244140625
      ],
      "bbox_max": [
        -89.199951171875,
        -2159.176513671875,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070798277854919,
        -0.0,
        -0.7071337699890137
      ],
      "plane_d": 412.4053955078125,
      "bbox_min": [
        -92.0,
        -2164.55810546875,
        674.4000244140625
      ],
      "bbox_max": [
        -91.199951171875,
        -2161.806884765625,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2160.0,
      "bbox_min": [
        -98.89990234375,
        -2161.959228515625,
        656.5999755859375
      ],
      "bbox_max": [
        -94.0,
        -2158.0,
        663.8783569335938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7208325266838074,
        0.0,
        0.6931092739105225
      ],
      "plane_d": -388.5294494628906,
      "bbox_min": [
        -98.89990234375,
        -2160.0,
        656.5999755859375
      ],
      "bbox_max": [
        -94.0,
        -2158.0,
        663.8783569335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2160.0,
        656.5999755859375
      ],
      "bbox_max": [
        -94.0,
        -2158.0,
        659.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 94.0,
      "bbox_min": [
        -94.0,
        -2160.0,
        656.5999755859375
      ],
      "bbox_max": [
        -94.0,
        -2158.0,
        658.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 97.0,
      "bbox_min": [
        -97.0,
        -2160.0,
        661.4400024414062
      ],
      "bbox_max": [
        -97.0,
        -2158.0,
        663.8783569335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2161.959228515625,
        656.5999755859375
      ],
      "bbox_max": [
        -98.89990234375,
        -2160.0,
        663.2769775390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -84.37012481689453,
        -2158.0,
        664.7044067382812
      ],
      "bbox_max": [
        -81.60009765625,
        -2144.13134765625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9272966384887695,
        -0.3743273615837097,
        -0.0
      ],
      "plane_d": -880.7164306640625,
      "bbox_min": [
        -84.37012481689453,
        -2150.65478515625,
        664.7044067382812
      ],
      "bbox_max": [
        -81.60009765625,
        -2144.13134765625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826918601989746,
        -0.9238760471343994,
        -0.0
      ],
      "plane_d": -2013.19921875,
      "bbox_min": [
        -84.37012481689453,
        -2144.19921875,
        664.7044067382812
      ],
      "bbox_max": [
        -84.2060546875,
        -2144.13134765625,
        665.0208129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2158.0,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2140.72119140625,
        664.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -81.60009765625,
      "bbox_min": [
        -88.57234954833984,
        -2158.0,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2140.72119140625,
        664.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6532713174819946,
        0.27060064673423767,
        0.7071151733398438
      ],
      "plane_d": 169.50509643554688,
      "bbox_min": [
        -81.60009765625,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2145.1904296875,
        664.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -81.60009765625,
        -2150.65478515625,
        659.7044067382812
      ],
      "bbox_max": [
        -80.690673828125,
        -2148.076416015625,
        659.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532713174819946,
        0.27060064673423767,
        0.7071151733398438
      ],
      "plane_d": 169.50509643554688,
      "bbox_min": [
        -85.2701644897461,
        -2148.076416015625,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2141.563232421875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27060848474502563,
        0.6532667279243469,
        0.7071163654327393
      ],
      "plane_d": 957.7940673828125,
      "bbox_min": [
        -87.42127990722656,
        -2144.19921875,
        656.5999755859375
      ],
      "bbox_max": [
        -84.2060546875,
        -2140.72119140625,
        659.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -86.96266174316406,
        -2144.19921875,
        659.7044067382812
      ],
      "bbox_max": [
        -84.2060546875,
        -2142.296875,
        659.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9205051064491272,
        -0.3907306492328644,
        0.0
      ],
      "plane_d": -760.1927490234375,
      "bbox_min": [
        -88.23503875732422,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -84.85640716552734,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9205050468444824,
        0.3907306492328644,
        0.0
      ],
      "plane_d": 757.6928100585938,
      "bbox_min": [
        -88.23503875732422,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -84.85640716552734,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2010255753993988,
        -0.4735967814922333,
        0.8574934005737305
      ],
      "plane_d": -1600.109375,
      "bbox_min": [
        -88.23503875732422,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -84.85640716552734,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3907240033149719,
        -0.9205079078674316,
        -0.0
      ],
      "plane_d": -2010.5838623046875,
      "bbox_min": [
        -88.23503875732422,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -84.85640716552734,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3350380063056946,
        0.7893170714378357,
        0.5145172476768494
      ],
      "plane_d": 1382.00146484375,
      "bbox_min": [
        -87.25821685791016,
        -2145.713623046875,
        660.5999755859375
      ],
      "bbox_max": [
        -84.85640716552734,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33503907918930054,
        -0.789319634437561,
        -0.5145128965377808
      ],
      "plane_d": -1384.9254150390625,
      "bbox_min": [
        -88.23503875732422,
        -2148.014892578125,
        659.0999755859375
      ],
      "bbox_max": [
        -85.83323669433594,
        -2146.80126953125,
        659.5287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3907240033149719,
        -0.9205079078674316,
        -0.0
      ],
      "plane_d": -2010.841064453125,
      "bbox_min": [
        -88.23503875732422,
        -2148.014892578125,
        659.5287475585938
      ],
      "bbox_max": [
        -85.93377685546875,
        -2147.0380859375,
        660.5287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2150.5,
      "bbox_min": [
        -101.5,
        -2158.526611328125,
        633.6736450195312
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -68.14163208007812,
      "bbox_min": [
        -75.32080078125,
        -2147.5068359375,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -50.819091796875,
      "bbox_min": [
        -72.33890533447266,
        -2147.5068359375,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2708.39404296875,
        -2996.92822265625,
        -22.699951171875
      ],
      "bbox_max": [
        200.0,
        7450.0,
        1420.5723876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467005133628845,
        0.01735524646937847
      ],
      "plane_d": 2314.876708984375,
      "bbox_min": [
        -969.41943359375,
        -2996.92822265625,
        608.0
      ],
      "bbox_max": [
        70.50594329833984,
        -1828.0,
        1420.5723876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3401496112346649,
        0.9401360750198364,
        0.02103203907608986
      ],
      "plane_d": 2779.226806640625,
      "bbox_min": [
        -860.804443359375,
        -2996.92822265625,
        608.0
      ],
      "bbox_max": [
        -191.0,
        -2168.956298828125,
        1420.5723876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910527229309082,
        0.41264408826828003,
        0.025789525359869003
      ],
      "plane_d": 1473.680908203125,
      "bbox_min": [
        -361.8818359375,
        -2996.92822265625,
        1053.942626953125
      ],
      "bbox_max": [
        -270.7467041015625,
        -2850.83837890625,
        1342.4395751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -361.8818359375,
        -2941.982666015625,
        1100.168212890625
      ],
      "bbox_max": [
        -320.3917236328125,
        -2854.516357421875,
        1318.00390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388457655906677,
        0.6731600761413574,
        0.031021639704704285
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -331.759765625,
        -2941.982666015625,
        1184.6998291015625
      ],
      "bbox_max": [
        -320.3917236328125,
        -2930.564453125,
        1318.00390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -331.759765625,
        -2941.982666015625,
        1249.1207275390625
      ],
      "bbox_max": [
        -321.0328369140625,
        -2932.19970703125,
        1318.00390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -322.538330078125,
        -2996.92822265625,
        1205.8133544921875
      ],
      "bbox_max": [
        -270.7467041015625,
        -2939.707275390625,
        1342.4395751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388457655906677,
        0.6731600761413574,
        0.031021639704704285
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -321.0328369140625,
        -2945.18115234375,
        1205.8133544921875
      ],
      "bbox_max": [
        -315.93524169921875,
        -2939.707275390625,
        1249.1207275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -860.804443359375,
        -2260.681396484375,
        733.704833984375
      ],
      "bbox_max": [
        -776.570068359375,
        -2168.956298828125,
        1131.8846435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9376025795936584,
        0.34713056683540344,
        0.02004357799887657
      ],
      "plane_d": 1496.150146484375,
      "bbox_min": [
        -786.48876953125,
        -2645.003662109375,
        608.0
      ],
      "bbox_max": [
        -191.0,
        -2264.956787109375,
        1420.5723876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 672.0,
      "bbox_min": [
        -435.0,
        -2645.003662109375,
        608.0
      ],
      "bbox_max": [
        -191.0,
        -2313.0,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5633555054664612,
        0.8184596300125122,
        0.11293553560972214
      ],
      "plane_d": 2242.135498046875,
      "bbox_min": [
        -391.1108093261719,
        -2645.003662109375,
        672.0
      ],
      "bbox_max": [
        -191.0,
        -2325.375244140625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": 2481.4453125,
      "bbox_min": [
        -391.1108093261719,
        -2445.0,
        672.0
      ],
      "bbox_max": [
        -191.0,
        -2325.375244140625,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2402.0,
      "bbox_min": [
        -230.0,
        -2445.0,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2386.4384765625,
        805.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        -215.0,
        -2402.0,
        774.0
      ],
      "bbox_max": [
        -195.5,
        -2386.4384765625,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2390.0,
      "bbox_min": [
        -215.0,
        -2402.0,
        774.0
      ],
      "bbox_max": [
        -195.5,
        -2386.4384765625,
        803.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2402.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2390.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2402.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2390.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -210.5,
        -2402.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2390.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -210.5,
        -2402.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2390.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857492983341217,
        0.0,
        -0.5144957900047302
      ],
      "plane_d": 586.9539794921875,
      "bbox_min": [
        -210.5,
        -2397.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2394.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2394.0,
      "bbox_min": [
        -210.5,
        -2397.5,
        792.5
      ],
      "bbox_max": [
        -206.0,
        -2394.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2397.5,
      "bbox_min": [
        -210.5,
        -2397.5,
        792.5
      ],
      "bbox_max": [
        -206.0,
        -2394.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -210.5,
        -2397.5,
        792.5
      ],
      "bbox_max": [
        -209.0,
        -2394.0,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 238.81179809570312,
      "bbox_min": [
        -200.0,
        -2397.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2394.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2394.0,
      "bbox_min": [
        -200.0,
        -2397.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2394.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2397.5,
      "bbox_min": [
        -200.0,
        -2397.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2394.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -197.0,
        -2397.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2394.0,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726728081703186,
        0.0,
        0.7399401068687439
      ],
      "plane_d": -431.7886962890625,
      "bbox_min": [
        -215.0,
        -2390.0,
        774.0
      ],
      "bbox_max": [
        -204.2466278076172,
        -2386.4384765625,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726728081703186,
        0.0,
        -0.7399400472640991
      ],
      "plane_d": 735.466796875,
      "bbox_min": [
        -215.0,
        -2390.0,
        774.0
      ],
      "bbox_max": [
        -204.2466278076172,
        -2386.7958984375,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 779.4000244140625,
      "bbox_min": [
        -210.5,
        -2390.0,
        774.0
      ],
      "bbox_max": [
        -204.2466278076172,
        -2387.974365234375,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -210.5,
        -2390.0,
        779.4000244140625
      ],
      "bbox_max": [
        -204.5704345703125,
        -2387.974365234375,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -210.5,
      "bbox_min": [
        -210.5,
        -2390.0,
        779.4000244140625
      ],
      "bbox_max": [
        -210.5,
        -2387.974365234375,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 803.5,
      "bbox_min": [
        -209.5,
        -2390.0,
        803.5
      ],
      "bbox_max": [
        -205.83834838867188,
        -2388.756103515625,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -774.0,
      "bbox_min": [
        -209.5,
        -2390.0,
        774.0
      ],
      "bbox_max": [
        -204.2466278076172,
        -2388.21533203125,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        -230.0,
        -2445.0,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2402.0,
        805.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 805.0,
      "bbox_min": [
        -230.0,
        -2445.0,
        788.7403564453125
      ],
      "bbox_max": [
        -215.0,
        -2425.0,
        805.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 230.0,
      "bbox_min": [
        -230.0,
        -2445.0,
        788.7403564453125
      ],
      "bbox_max": [
        -215.0,
        -2430.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2445.0,
      "bbox_min": [
        -230.0,
        -2445.0,
        788.7403564453125
      ],
      "bbox_max": [
        -215.0,
        -2437.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2437.0,
      "bbox_min": [
        -225.0,
        -2443.06103515625,
        788.7403564453125
      ],
      "bbox_max": [
        -215.0,
        -2437.0,
        805.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2440.0,
      "bbox_min": [
        -225.0,
        -2443.06103515625,
        788.7403564453125
      ],
      "bbox_max": [
        -215.0,
        -2437.0,
        805.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 222.5,
      "bbox_min": [
        -222.5,
        -2440.0,
        788.7403564453125
      ],
      "bbox_max": [
        -217.8910675048828,
        -2437.0,
        795.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -222.5,
        -2440.0,
        795.5
      ],
      "bbox_max": [
        -217.8910675048828,
        -2437.0,
        795.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 222.5,
      "bbox_min": [
        -222.5,
        -2443.06103515625,
        792.0861206054688
      ],
      "bbox_max": [
        -220.0,
        -2440.0,
        796.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.5,
      "bbox_min": [
        -222.5,
        -2443.06103515625,
        795.5
      ],
      "bbox_max": [
        -220.0,
        -2440.0,
        796.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        -220.0,
        -2440.446044921875,
        795.752685546875
      ],
      "bbox_max": [
        -220.0,
        -2440.0,
        796.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2407.0,
      "bbox_min": [
        -215.0,
        -2429.07373046875,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2402.0,
        803.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2419.0,
      "bbox_min": [
        -215.0,
        -2429.07373046875,
        779.6654663085938
      ],
      "bbox_max": [
        -195.5,
        -2407.0,
        803.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2419.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2407.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -210.5,
        -2419.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2407.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -210.5,
        -2414.5,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2407.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857492983341217,
        0.0,
        -0.5144957900047302
      ],
      "plane_d": 586.9539794921875,
      "bbox_min": [
        -210.5,
        -2414.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2407.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2411.0,
      "bbox_min": [
        -210.5,
        -2414.5,
        792.5
      ],
      "bbox_max": [
        -206.0,
        -2411.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2414.5,
      "bbox_min": [
        -210.5,
        -2414.5,
        792.5
      ],
      "bbox_max": [
        -206.0,
        -2411.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -210.5,
        -2414.5,
        792.5
      ],
      "bbox_max": [
        -209.0,
        -2411.0,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 238.81179809570312,
      "bbox_min": [
        -200.0,
        -2414.5,
        794.8819580078125
      ],
      "bbox_max": [
        -195.5,
        -2407.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2411.0,
      "bbox_min": [
        -200.0,
        -2414.5,
        794.8819580078125
      ],
      "bbox_max": [
        -195.5,
        -2407.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2414.5,
      "bbox_min": [
        -200.0,
        -2414.5,
        797.0459594726562
      ],
      "bbox_max": [
        -199.41799926757812,
        -2414.5,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -195.5,
        -2409.347412109375,
        794.8819580078125
      ],
      "bbox_max": [
        -195.5,
        -2407.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2424.0,
      "bbox_min": [
        -215.0,
        -2429.07373046875,
        785.2416381835938
      ],
      "bbox_max": [
        -198.748779296875,
        -2419.0,
        803.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2429.07373046875,
        791.8414916992188
      ],
      "bbox_max": [
        -206.6417999267578,
        -2424.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -210.5,
        -2429.07373046875,
        796.3027954101562
      ],
      "bbox_max": [
        -206.6417999267578,
        -2424.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2428.0,
      "bbox_min": [
        -210.5,
        -2428.0,
        796.3027954101562
      ],
      "bbox_max": [
        -209.6836700439453,
        -2428.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 803.5,
      "bbox_min": [
        -215.0,
        -2424.0,
        798.5
      ],
      "bbox_max": [
        -198.748779296875,
        -2419.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726728081703186,
        0.0,
        -0.7399401068687439
      ],
      "plane_d": 735.466796875,
      "bbox_min": [
        -215.0,
        -2424.0,
        798.5
      ],
      "bbox_max": [
        -209.5,
        -2419.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 803.5,
      "bbox_min": [
        -215.0,
        -2407.0,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2402.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -215.0,
        -2407.0,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2402.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726728081703186,
        0.0,
        0.7399401068687439
      ],
      "plane_d": -431.7886962890625,
      "bbox_min": [
        -215.0,
        -2407.0,
        774.0
      ],
      "bbox_max": [
        -202.2539825439453,
        -2402.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 779.4000244140625,
      "bbox_min": [
        -210.5,
        -2407.0,
        774.0
      ],
      "bbox_max": [
        -202.2539825439453,
        -2402.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -210.5,
      "bbox_min": [
        -210.5,
        -2407.0,
        779.4000244140625
      ],
      "bbox_max": [
        -210.5,
        -2402.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -774.0,
      "bbox_min": [
        -209.5,
        -2406.68701171875,
        774.0
      ],
      "bbox_max": [
        -205.9358673095703,
        -2402.0,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726728081703186,
        0.0,
        -0.7399401068687439
      ],
      "plane_d": 735.466796875,
      "bbox_min": [
        -215.0,
        -2407.0,
        795.9053955078125
      ],
      "bbox_max": [
        -191.0,
        -2402.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.0,
        -0.768221378326416
      ],
      "plane_d": 491.1495361328125,
      "bbox_min": [
        -197.0,
        -2407.0,
        795.9053955078125
      ],
      "bbox_max": [
        -191.0,
        -2402.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -191.0,
      "bbox_min": [
        -191.0,
        -2404.326416015625,
        795.9053955078125
      ],
      "bbox_max": [
        -191.0,
        -2402.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -3.082740931859007e-06
      ],
      "plane_d": 1907.825439453125,
      "bbox_min": [
        -391.1108093261719,
        -2375.3154296875,
        672.0
      ],
      "bbox_max": [
        -284.24261474609375,
        -2325.375244140625,
        773.2828369140625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6860026717185974,
        0.6859864592552185,
        -0.2425343543291092
      ],
      "plane_d": 2046.92529296875,
      "bbox_min": [
        -391.1108093261719,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2325.375244140625,
        768.1460571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1407.9442138671875,
      "bbox_min": [
        -376.607177734375,
        -2358.548583984375,
        729.987060546875
      ],
      "bbox_max": [
        -363.7572937011719,
        -2345.698486328125,
        750.2590942382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -376.607177734375,
        -2349.356201171875,
        729.987060546875
      ],
      "bbox_max": [
        -372.94940185546875,
        -2345.698486328125,
        750.2590942382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5883575081825256,
        0.588341474533081,
        -0.5546978712081909
      ],
      "plane_d": 2015.5765380859375,
      "bbox_min": [
        -391.1108093261719,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2325.375244140625,
        768.1460571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071097493171692,
        -0.7071037888526917,
        9.465044968237635e-06
      ],
      "plane_d": -1407.9432373046875,
      "bbox_min": [
        -372.9951477050781,
        -2354.936767578125,
        749.999755859375
      ],
      "bbox_max": [
        -356.67095947265625,
        -2338.6123046875,
        765.129150390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071097493171692,
        -0.7071037888526917,
        9.465044968237635e-06
      ],
      "plane_d": -1394.9432373046875,
      "bbox_min": [
        -372.9951477050781,
        -2345.744140625,
        750.000244140625
      ],
      "bbox_max": [
        -365.86334228515625,
        -2338.6123046875,
        765.129150390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.896294891834259,
        0.3712579011917114,
        -0.2425346076488495
      ],
      "plane_d": 1390.914794921875,
      "bbox_min": [
        -391.1108093261719,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2325.375244140625,
        768.1460571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238787889480591,
        0.38268521428108215,
        0.0
      ],
      "plane_d": 1251.2257080078125,
      "bbox_min": [
        -391.1108093261719,
        -2375.3154296875,
        712.0
      ],
      "bbox_max": [
        -323.39990234375,
        -2325.375244140625,
        768.1460571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7687152028083801,
        0.31841254234313965,
        -0.5546984672546387
      ],
      "plane_d": 1452.945068359375,
      "bbox_min": [
        -384.47674560546875,
        -2375.3154296875,
        729.6334228515625
      ],
      "bbox_max": [
        -323.39990234375,
        -2328.32568359375,
        768.1460571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39223402738571167,
        0.39222702383995056,
        -0.8320519328117371
      ],
      "plane_d": 1697.3385009765625,
      "bbox_min": [
        -376.53302001953125,
        -2375.3154296875,
        729.6334228515625
      ],
      "bbox_max": [
        -323.39990234375,
        -2332.965087890625,
        768.1460571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1394.85302734375,
      "bbox_min": [
        -365.92431640625,
        -2338.67333984375,
        764.9998168945312
      ],
      "bbox_max": [
        -363.1466979980469,
        -2335.895751953125,
        767.6869506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1407.9442138671875,
      "bbox_min": [
        -376.53302001953125,
        -2375.3154296875,
        729.6334228515625
      ],
      "bbox_max": [
        -323.39990234375,
        -2335.05029296875,
        768.0775146484375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -376.53302001953125,
        -2356.443115234375,
        729.6334228515625
      ],
      "bbox_max": [
        -353.46795654296875,
        -2335.05029296875,
        767.6184692382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5886816382408142,
        0.5886816382408142,
        -0.5539926886558533
      ],
      "plane_d": 2013.0999755859375,
      "bbox_min": [
        -372.687255859375,
        -2343.880615234375,
        748.7863159179688
      ],
      "bbox_max": [
        -363.1000671386719,
        -2335.05029296875,
        764.1880493164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3900159001350403,
        0.38995468616485596,
        -0.8341600298881531
      ],
      "plane_d": 1689.9451904296875,
      "bbox_min": [
        -366.056640625,
        -2337.249755859375,
        762.878173828125
      ],
      "bbox_max": [
        -363.1000671386719,
        -2335.05029296875,
        764.1880493164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862345933914185,
        0.6861268877983093,
        -0.24147889018058777
      ],
      "plane_d": 2043.697998046875,
      "bbox_min": [
        -366.864990234375,
        -2356.443115234375,
        729.6334228515625
      ],
      "bbox_max": [
        -353.46795654296875,
        -2343.045654296875,
        764.5992431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886816382408142,
        0.5886816382408142,
        -0.5539926886558533
      ],
      "plane_d": 2013.0999755859375,
      "bbox_min": [
        -363.494873046875,
        -2353.072998046875,
        748.7863159179688
      ],
      "bbox_max": [
        -353.46795654296875,
        -2343.045654296875,
        764.5992431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3900159001350403,
        0.38995468616485596,
        -0.8341600298881531
      ],
      "plane_d": 1689.944580078125,
      "bbox_min": [
        -356.8642578125,
        -2346.442138671875,
        762.878173828125
      ],
      "bbox_max": [
        -353.46795654296875,
        -2343.045654296875,
        764.5992431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2123335599899292,
        0.5124513506889343,
        -0.8320505023002625
      ],
      "plane_d": 1916.266845703125,
      "bbox_min": [
        -353.94921875,
        -2375.3154296875,
        729.9205322265625
      ],
      "bbox_max": [
        -323.39990234375,
        -2346.735107421875,
        768.0775146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2388.246826171875,
      "bbox_min": [
        -332.608154296875,
        -2375.3154296875,
        729.9205322265625
      ],
      "bbox_max": [
        -323.39990234375,
        -2366.266845703125,
        756.0728149414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -323.39990234375,
        -2375.3154296875,
        729.9205322265625
      ],
      "bbox_max": [
        -323.39990234375,
        -2374.669677734375,
        732.5827026367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2355.699951171875,
      "bbox_min": [
        -361.6596984863281,
        -2375.3154296875,
        672.0
      ],
      "bbox_max": [
        -284.24261474609375,
        -2336.40966796875,
        773.2828369140625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2388.246826171875,
      "bbox_min": [
        -342.36944580078125,
        -2375.3154296875,
        729.6334228515625
      ],
      "bbox_max": [
        -284.24261474609375,
        -2355.699951171875,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3184986114501953,
        0.7686806917190552,
        -0.5546968579292297
      ],
      "plane_d": 2141.408447265625,
      "bbox_min": [
        -342.36944580078125,
        -2375.3154296875,
        729.6334228515625
      ],
      "bbox_max": [
        -284.24261474609375,
        -2355.699951171875,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        -0.8320503234863281
      ],
      "plane_d": 1945.785888671875,
      "bbox_min": [
        -342.36944580078125,
        -2375.3154296875,
        729.6334228515625
      ],
      "bbox_max": [
        -298.9615478515625,
        -2355.699951171875,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -342.36944580078125,
        -2375.3154296875,
        729.6334228515625
      ],
      "bbox_max": [
        -298.9615478515625,
        -2355.699951171875,
        768.0769653320312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -342.36944580078125,
        -2374.669677734375,
        729.6334228515625
      ],
      "bbox_max": [
        -310.39990234375,
        -2355.699951171875,
        768.0769653320312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.9704055190086365,
        -0.24148114025592804
      ],
      "plane_d": 2478.322509765625,
      "bbox_min": [
        -342.36944580078125,
        -2372.337890625,
        729.6334228515625
      ],
      "bbox_max": [
        -323.39990234375,
        -2355.699951171875,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31849759817123413,
        0.7686783075332642,
        -0.5547007918357849
      ],
      "plane_d": 2343.970458984375,
      "bbox_min": [
        -332.439697265625,
        -2366.266845703125,
        756.0728149414062
      ],
      "bbox_max": [
        -331.64117431640625,
        -2365.45556640625,
        757.2897338867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2123335599899292,
        0.5124513506889343,
        -0.8320505023002625
      ],
      "plane_d": 1916.266845703125,
      "bbox_min": [
        -339.1446228027344,
        -2360.3154296875,
        765.0
      ],
      "bbox_max": [
        -329.7000427246094,
        -2355.699951171875,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": 1936.9571533203125,
      "bbox_min": [
        -325.60009765625,
        -2358.194580078125,
        762.878173828125
      ],
      "bbox_max": [
        -323.39990234375,
        -2355.699951171875,
        764.5275268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9704055190086365,
        -0.24148114025592804
      ],
      "plane_d": 2478.322509765625,
      "bbox_min": [
        -312.60009765625,
        -2372.337890625,
        729.6334228515625
      ],
      "bbox_max": [
        -310.39990234375,
        -2355.699951171875,
        764.5275268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": 2385.87939453125,
      "bbox_min": [
        -312.60009765625,
        -2367.57177734375,
        748.7863159179688
      ],
      "bbox_max": [
        -310.39990234375,
        -2355.699951171875,
        764.5275268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": 1936.9571533203125,
      "bbox_min": [
        -312.60009765625,
        -2358.194580078125,
        762.878173828125
      ],
      "bbox_max": [
        -310.39990234375,
        -2355.699951171875,
        764.5275268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21233268082141876,
        0.5124491453170776,
        -0.8320521116256714
      ],
      "plane_d": 1781.218994140625,
      "bbox_min": [
        -306.2999267578125,
        -2360.3154296875,
        765.0
      ],
      "bbox_max": [
        -298.9615478515625,
        -2355.699951171875,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828069269657135,
        0.9238283634185791,
        -0.0
      ],
      "plane_d": 2302.473876953125,
      "bbox_min": [
        -361.6596984863281,
        -2355.699951171875,
        672.0
      ],
      "bbox_max": [
        -303.3257141113281,
        -2336.40966796875,
        773.2828369140625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2123335599899292,
        0.5124513506889343,
        -0.8320505023002625
      ],
      "plane_d": 1916.266845703125,
      "bbox_min": [
        -351.3341064453125,
        -2355.699951171875,
        764.648681640625
      ],
      "bbox_max": [
        -329.7000427246094,
        -2346.735107421875,
        768.0775146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31849759817123413,
        0.7686783075332642,
        -0.5547007918357849
      ],
      "plane_d": 2343.970458984375,
      "bbox_min": [
        -342.80230712890625,
        -2355.699951171875,
        764.648681640625
      ],
      "bbox_max": [
        -341.75762939453125,
        -2355.26708984375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3828069269657135,
        0.9238283634185791,
        0.0
      ],
      "plane_d": 2059.008544921875,
      "bbox_min": [
        -361.6596984863281,
        -2355.699951171875,
        672.0
      ],
      "bbox_max": [
        -303.3257141113281,
        -2336.40966796875,
        773.2828369140625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8797038793563843,
        0.47552189230918884,
        -0.0
      ],
      "plane_d": 1397.2935791015625,
      "bbox_min": [
        -361.6596984863281,
        -2355.699951171875,
        672.0
      ],
      "bbox_max": [
        -305.6617126464844,
        -2336.40966796875,
        772.3961181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9771250486373901,
        -0.2126655876636505
      ],
      "plane_d": 2444.40576171875,
      "bbox_min": [
        -361.6596984863281,
        -2355.699951171875,
        672.0
      ],
      "bbox_max": [
        -315.1764831542969,
        -2336.40966796875,
        772.3961181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39223402738571167,
        0.39222702383995056,
        -0.8320519328117371
      ],
      "plane_d": 1697.3385009765625,
      "bbox_min": [
        -361.6596984863281,
        -2355.699951171875,
        764.5275268554688
      ],
      "bbox_max": [
        -323.39990234375,
        -2336.40966796875,
        772.3961181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1407.85302734375,
      "bbox_min": [
        -353.46783447265625,
        -2344.6015625,
        768.0775146484375
      ],
      "bbox_max": [
        -349.48187255859375,
        -2340.615478515625,
        771.8993530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": 1936.9571533203125,
      "bbox_min": [
        -355.0235595703125,
        -2355.699951171875,
        764.5275268554688
      ],
      "bbox_max": [
        -323.39990234375,
        -2339.76953125,
        772.2135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -323.39990234375,
        -2355.699951171875,
        764.5275268554688
      ],
      "bbox_max": [
        -323.39990234375,
        -2349.41943359375,
        772.2135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1407.85302734375,
      "bbox_min": [
        -355.0235595703125,
        -2344.6015625,
        764.5992431640625
      ],
      "bbox_max": [
        -349.43475341796875,
        -2339.76953125,
        771.8353271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3900159001350403,
        0.38995468616485596,
        -0.8341600298881531
      ],
      "plane_d": 1689.944580078125,
      "bbox_min": [
        -355.0235595703125,
        -2344.6015625,
        764.5992431640625
      ],
      "bbox_max": [
        -349.43475341796875,
        -2339.76953125,
        768.370361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -319.5,
        -2352.0,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2349.256103515625,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -318.2544250488281,
        -2355.699951171875,
        687.5
      ],
      "bbox_max": [
        -305.6617126464844,
        -2349.67919921875,
        769.307373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": 1936.9571533203125,
      "bbox_min": [
        -318.2544250488281,
        -2355.699951171875,
        687.5
      ],
      "bbox_max": [
        -310.39990234375,
        -2349.67919921875,
        766.2828979492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        -318.2544250488281,
        -2352.0,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2349.67919921875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -318.2544250488281,
        -2352.0,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2349.67919921875,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21233268082141876,
        0.5124491453170776,
        -0.8320521116256714
      ],
      "plane_d": 1781.218994140625,
      "bbox_min": [
        -306.4013671875,
        -2355.699951171875,
        768.0769653320312
      ],
      "bbox_max": [
        -305.6617126464844,
        -2355.190185546875,
        768.4168090820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 351.0,
      "bbox_min": [
        -435.0,
        -2411.5,
        608.0
      ],
      "bbox_max": [
        -302.06170654296875,
        -2313.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -435.0,
        -2388.5,
        620.0
      ],
      "bbox_max": [
        -351.0,
        -2313.0,
        672.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.707101583480835,
        0.7071120142936707,
        0.0
      ],
      "plane_d": 1907.833740234375,
      "bbox_min": [
        -371.0,
        -2368.5,
        620.0
      ],
      "bbox_max": [
        -351.0,
        -2332.297607421875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870322227478,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -2035.4044189453125,
      "bbox_min": [
        -371.0,
        -2368.5,
        635.0
      ],
      "bbox_max": [
        -351.0,
        -2348.5,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -563.635498046875,
      "bbox_min": [
        -371.0,
        -2368.5,
        635.0
      ],
      "bbox_max": [
        -365.14208984375,
        -2354.35791015625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2368.5,
      "bbox_min": [
        -371.0,
        -2368.5,
        635.0
      ],
      "bbox_max": [
        -370.3333435058594,
        -2368.5,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        -365.7722473144531,
        -2346.873779296875,
        620.0
      ],
      "bbox_max": [
        -351.0,
        -2332.297607421875,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3828069269657135,
        0.9238283634185791,
        -0.0
      ],
      "plane_d": 2302.473876953125,
      "bbox_min": [
        -351.334228515625,
        -2346.873779296875,
        620.0
      ],
      "bbox_max": [
        -351.0,
        -2346.7353515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 435.0,
      "bbox_min": [
        -435.0,
        -2388.5,
        637.0
      ],
      "bbox_max": [
        -351.0,
        -2313.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870322227478,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -2035.4044189453125,
      "bbox_min": [
        -435.0,
        -2388.5,
        637.0
      ],
      "bbox_max": [
        -351.0,
        -2319.0,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -3.082740931859007e-06
      ],
      "plane_d": 1907.825439453125,
      "bbox_min": [
        -435.0,
        -2346.873779296875,
        637.0
      ],
      "bbox_max": [
        -351.0,
        -2319.0,
        672.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 433.5,
      "bbox_min": [
        -435.0,
        -2336.800048828125,
        637.0
      ],
      "bbox_max": [
        -400.5,
        -2319.0,
        659.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2324.0,
      "bbox_min": [
        -435.0,
        -2329.5,
        637.0
      ],
      "bbox_max": [
        -433.5,
        -2319.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2329.5,
      "bbox_min": [
        -435.0,
        -2329.5,
        637.0
      ],
      "bbox_max": [
        -433.5,
        -2329.5,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.5,
      "bbox_min": [
        -435.0,
        -2320.5,
        637.0
      ],
      "bbox_max": [
        -433.5,
        -2319.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2319.0,
      "bbox_min": [
        -435.0,
        -2319.0,
        637.0
      ],
      "bbox_max": [
        -433.5,
        -2319.0,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 400.5,
      "bbox_min": [
        -402.5,
        -2336.800048828125,
        637.0
      ],
      "bbox_max": [
        -400.5,
        -2320.150390625,
        654.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 646.5,
      "bbox_min": [
        -402.5,
        -2329.5,
        637.0
      ],
      "bbox_max": [
        -400.5,
        -2320.150390625,
        646.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.49613893032073975,
        0.8682431578636169
      ],
      "plane_d": -1705.10546875,
      "bbox_min": [
        -402.5,
        -2322.0,
        637.0
      ],
      "bbox_max": [
        -400.5,
        -2320.150390625,
        646.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.49613893032073975,
        -0.8682431578636169
      ],
      "plane_d": -590.7153930664062,
      "bbox_min": [
        -402.5,
        -2322.0,
        645.5213012695312
      ],
      "bbox_max": [
        -400.5,
        -2320.287353515625,
        646.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828069269657135,
        0.9238283634185791,
        -0.0
      ],
      "plane_d": 2302.473876953125,
      "bbox_min": [
        -351.334228515625,
        -2346.873779296875,
        637.0
      ],
      "bbox_max": [
        -351.0,
        -2346.235107421875,
        672.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.22238557040691376,
        0.5366692543029785,
        -0.8139599561691284
      ],
      "plane_d": 1860.9285888671875,
      "bbox_min": [
        -351.334228515625,
        -2346.873779296875,
        643.0
      ],
      "bbox_max": [
        -351.0,
        -2346.235107421875,
        643.4210815429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -563.635498046875,
      "bbox_min": [
        -371.0,
        -2388.5,
        637.0
      ],
      "bbox_max": [
        -351.0,
        -2348.5,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -371.0,
        -2388.5,
        637.0
      ],
      "bbox_max": [
        -351.0,
        -2348.5,
        660.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.3826870322227478,
        0.923878014087677,
        -0.0
      ],
      "plane_d": 2341.005859375,
      "bbox_min": [
        -371.0,
        -2388.5,
        637.0
      ],
      "bbox_max": [
        -351.0,
        -2368.5,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        -0.0
      ],
      "plane_d": 1249.1529541015625,
      "bbox_min": [
        -371.0,
        -2386.5,
        637.0
      ],
      "bbox_max": [
        -351.0,
        -2368.5,
        660.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        0.3826742172241211,
        0.0
      ],
      "plane_d": 1247.27685546875,
      "bbox_min": [
        -371.0,
        -2386.5,
        637.0
      ],
      "bbox_max": [
        -351.0,
        -2368.5,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2368.5,
      "bbox_min": [
        -371.0,
        -2368.5,
        637.0
      ],
      "bbox_max": [
        -369.0,
        -2368.5,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826742172241211,
        0.9238833785057068,
        -0.0
      ],
      "plane_d": 2339.166259765625,
      "bbox_min": [
        -363.72802734375,
        -2386.5,
        641.0
      ],
      "bbox_max": [
        -351.0,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -608.0,
      "bbox_min": [
        -351.0,
        -2388.5,
        608.0
      ],
      "bbox_max": [
        -302.06170654296875,
        -2337.316650390625,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2355.699951171875,
      "bbox_min": [
        -351.0,
        -2388.5,
        608.0
      ],
      "bbox_max": [
        -302.06170654296875,
        -2337.316650390625,
        672.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -351.0,
        -2388.5,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2355.699951171875,
        668.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -600.5906982421875,
      "bbox_min": [
        -336.85791015625,
        -2382.64208984375,
        660.5
      ],
      "bbox_max": [
        -331.0,
        -2355.699951171875,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -336.302001953125,
        -2368.5,
        660.5
      ],
      "bbox_max": [
        -331.0,
        -2355.699951171875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 329.699951171875,
      "bbox_min": [
        -351.0,
        -2386.5,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2355.699951171875,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826742172241211,
        0.9238833785057068,
        0.0
      ],
      "plane_d": 2070.529052734375,
      "bbox_min": [
        -351.0,
        -2386.5,
        635.0
      ],
      "bbox_max": [
        -336.85791015625,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 1922.976806640625,
      "bbox_min": [
        -338.27197265625,
        -2382.64208984375,
        635.0
      ],
      "bbox_max": [
        -336.85791015625,
        -2381.22802734375,
        651.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2360.0,
      "bbox_min": [
        -329.699951171875,
        -2370.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2360.0,
        618.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2370.0,
      "bbox_min": [
        -329.699951171875,
        -2370.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2360.0,
        618.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -200.81832885742188,
      "bbox_min": [
        -327.0,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2360.0,
        616.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        -325.0,
        -2361.0,
        608.0
      ],
      "bbox_max": [
        -325.0,
        -2360.0,
        609.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2361.0,
        611.0
      ],
      "bbox_max": [
        -325.0,
        -2360.0,
        616.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 665.387451171875,
      "bbox_min": [
        -327.0,
        -2361.0,
        614.0
      ],
      "bbox_max": [
        -325.0,
        -2360.0,
        616.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828069269657135,
        0.9238283634185791,
        -0.0
      ],
      "plane_d": 2302.473876953125,
      "bbox_min": [
        -351.0,
        -2355.699951171875,
        608.0
      ],
      "bbox_max": [
        -302.06170654296875,
        -2337.316650390625,
        672.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -351.0,
        -2355.699951171875,
        649.5
      ],
      "bbox_max": [
        -329.699951171875,
        -2348.16796875,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.5,
      "bbox_min": [
        -351.0,
        -2355.699951171875,
        660.5
      ],
      "bbox_max": [
        -336.302001953125,
        -2348.5,
        664.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1212.1978759765625,
      "bbox_min": [
        -336.85791015625,
        -2355.699951171875,
        660.5
      ],
      "bbox_max": [
        -336.302001953125,
        -2354.35791015625,
        664.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -347.9140625,
        -2355.699951171875,
        649.5
      ],
      "bbox_max": [
        -329.699951171875,
        -2348.16796875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -577.5281372070312,
      "bbox_min": [
        -347.9140625,
        -2348.256591796875,
        649.5
      ],
      "bbox_max": [
        -347.8773193359375,
        -2348.16796875,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5299989581108093,
        0.847998321056366
      ],
      "plane_d": -1764.1014404296875,
      "bbox_min": [
        -351.0,
        -2355.699951171875,
        608.0
      ],
      "bbox_max": [
        -302.06170654296875,
        -2337.316650390625,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        -351.0,
        -2355.699951171875,
        608.0
      ],
      "bbox_max": [
        -302.06170654296875,
        -2337.316650390625,
        672.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.24253562092781067,
        0.0
      ],
      "plane_d": -251.48521423339844,
      "bbox_min": [
        -329.699951171875,
        -2355.699951171875,
        608.0
      ],
      "bbox_max": [
        -327.108154296875,
        -2345.332763671875,
        620.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -351.0,
        -2355.699951171875,
        620.0
      ],
      "bbox_max": [
        -302.06170654296875,
        -2342.578125,
        672.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.38281548023223877,
        0.9238248467445374,
        -0.0
      ],
      "plane_d": 2297.564453125,
      "bbox_min": [
        -348.55615234375,
        -2350.796142578125,
        646.5
      ],
      "bbox_max": [
        -317.74371337890625,
        -2342.578125,
        649.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.796142578125,
      "bbox_min": [
        -328.72412109375,
        -2350.796142578125,
        646.5
      ],
      "bbox_max": [
        -312.7554626464844,
        -2350.796142578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22233350574970245,
        0.536557674407959,
        -0.8140476942062378
      ],
      "plane_d": 1719.30078125,
      "bbox_min": [
        -306.88702392578125,
        -2355.699951171875,
        643.0
      ],
      "bbox_max": [
        -302.6208190917969,
        -2352.76416015625,
        645.0952758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -348.55615234375,
        -2355.699951171875,
        649.5
      ],
      "bbox_max": [
        -302.9136657714844,
        -2342.578125,
        672.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.796142578125,
      "bbox_min": [
        -328.72412109375,
        -2355.699951171875,
        656.0
      ],
      "bbox_max": [
        -303.0096435546875,
        -2350.796142578125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3828069269657135,
        0.9238283634185791,
        0.0
      ],
      "plane_d": 2059.008544921875,
      "bbox_min": [
        -317.6763610839844,
        -2355.699951171875,
        659.0
      ],
      "bbox_max": [
        -303.0096435546875,
        -2354.33642578125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9771250486373901,
        -0.2126655876636505
      ],
      "plane_d": 2444.40576171875,
      "bbox_min": [
        -317.6763610839844,
        -2355.699951171875,
        670.5
      ],
      "bbox_max": [
        -315.0,
        -2355.37353515625,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8797038793563843,
        0.47552189230918884,
        -0.0
      ],
      "plane_d": 1397.2935791015625,
      "bbox_min": [
        -315.1764831542969,
        -2355.699951171875,
        670.5
      ],
      "bbox_max": [
        -315.0,
        -2355.37353515625,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -577.5281372070312,
      "bbox_min": [
        -348.55615234375,
        -2348.16796875,
        649.5
      ],
      "bbox_max": [
        -346.0,
        -2342.578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828479051589966,
        0.9238113760948181,
        -0.0
      ],
      "plane_d": 2297.54443359375,
      "bbox_min": [
        -348.55615234375,
        -2343.637451171875,
        649.5
      ],
      "bbox_max": [
        -346.0,
        -2342.578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -674.18994140625,
        -2393.402587890625,
        610.304443359375
      ],
      "bbox_max": [
        70.50594329833984,
        -1828.0,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4577594995498657,
        -0.8173955082893372,
        0.3497438430786133
      ],
      "plane_d": -1698.0321044921875,
      "bbox_min": [
        -528.131103515625,
        -2032.99267578125,
        716.4224243164062
      ],
      "bbox_max": [
        -299.8731384277344,
        -1828.0,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.476491779088974,
        -0.7905871868133545,
        0.3846135139465332
      ],
      "plane_d": -1664.8924560546875,
      "bbox_min": [
        -528.131103515625,
        -2000.3544921875,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1828.0,
        938.8501586914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47970372438430786,
        -0.768060028553009,
        0.4242264926433563
      ],
      "plane_d": -1652.6461181640625,
      "bbox_min": [
        -528.131103515625,
        -2000.3544921875,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1828.0,
        938.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 359.0,
      "bbox_min": [
        -437.0,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1828.0,
        938.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1833.0,
      "bbox_min": [
        -437.0,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -359.0,
        -1828.0,
        938.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 892.0,
      "bbox_min": [
        -437.0,
        -1833.0,
        892.0
      ],
      "bbox_max": [
        -359.0,
        -1828.0,
        900.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9958931803703308,
        -0.0,
        0.09053574502468109
      ],
      "plane_d": 276.49615478515625,
      "bbox_min": [
        -359.5,
        -1833.0,
        895.0
      ],
      "bbox_max": [
        -359.0,
        -1829.5,
        900.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 892.0,
      "bbox_min": [
        -437.0,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -359.0,
        -1833.0,
        938.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999086856842041,
        -0.0,
        0.013512278907001019
      ],
      "plane_d": 349.87347412109375,
      "bbox_min": [
        -373.4189453125,
        -1875.5,
        895.0
      ],
      "bbox_max": [
        -362.0,
        -1863.0078125,
        938.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -1887.4222412109375,
      "bbox_min": [
        -373.4189453125,
        -1875.5,
        895.0
      ],
      "bbox_max": [
        -362.0,
        -1863.0078125,
        938.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300142765045166,
        -7.227063179016113e-07,
        -0.8479887247085571
      ],
      "plane_d": 597.7592163085938,
      "bbox_min": [
        -373.4189453125,
        -1866.6461181640625,
        932.9844360351562
      ],
      "bbox_max": [
        -364.4206237792969,
        -1863.0078125,
        938.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472549915313721,
        0.03998080641031265,
        -0.5296797156333923
      ],
      "plane_d": 877.8784790039062,
      "bbox_min": [
        -364.93896484375,
        -1864.2957763671875,
        932.9844360351562
      ],
      "bbox_max": [
        -364.4206237792969,
        -1863.0078125,
        933.8118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -414.0,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -359.0,
        -1833.5,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -359.0,
        -1833.5,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -406.8780822753906,
        -1972.0,
        788.1215209960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1939.0,
        778.7999267578125
      ],
      "bbox_max": [
        -359.0,
        -1833.5,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -362.5,
        -1939.0,
        778.7999267578125
      ],
      "bbox_max": [
        -359.0,
        -1833.5,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1833.5,
      "bbox_min": [
        -362.5,
        -1833.5,
        889.0
      ],
      "bbox_max": [
        -359.0,
        -1833.5,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -359.0,
        -1938.0833740234375,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -360.0,
        -1939.0,
        766.0
      ],
      "bbox_max": [
        -359.0,
        -1938.0833740234375,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 357.0,
      "bbox_min": [
        -357.0,
        -1880.0,
        892.0
      ],
      "bbox_max": [
        -357.0,
        -1828.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -359.0,
        -1938.0833740234375,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1829.5,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1833.5,
      "bbox_min": [
        -359.0,
        -1833.5,
        889.0
      ],
      "bbox_max": [
        -358.5,
        -1833.5,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -392.676025390625,
        -1927.9453125,
        811.4339599609375
      ],
      "bbox_max": [
        -348.0,
        -1863.548583984375,
        938.2431030273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999086856842041,
        -0.0,
        0.013512278907001019
      ],
      "plane_d": 349.87347412109375,
      "bbox_min": [
        -373.3090515136719,
        -1875.2969970703125,
        910.022216796875
      ],
      "bbox_max": [
        -362.2030029296875,
        -1863.548583984375,
        938.2431030273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -1887.4222412109375,
      "bbox_min": [
        -373.3090515136719,
        -1875.2969970703125,
        910.022216796875
      ],
      "bbox_max": [
        -362.2030029296875,
        -1863.548583984375,
        938.2431030273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300142765045166,
        -7.227063179016113e-07,
        -0.8479887247085571
      ],
      "plane_d": 597.7592163085938,
      "bbox_min": [
        -373.3090515136719,
        -1874.3739013671875,
        932.82421875
      ],
      "bbox_max": [
        -364.1619873046875,
        -1863.548583984375,
        938.2431030273438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8472549915313721,
        0.03998080641031265,
        -0.5296797156333923
      ],
      "plane_d": 877.8784790039062,
      "bbox_min": [
        -364.8952941894531,
        -1871.853271484375,
        932.82421875
      ],
      "bbox_max": [
        -364.1619873046875,
        -1863.548583984375,
        933.8004150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47035738825798035,
        -0.7688683271408081,
        0.4331344962120056
      ],
      "plane_d": -1666.1329345703125,
      "bbox_min": [
        -392.676025390625,
        -1927.9453125,
        839.7249755859375
      ],
      "bbox_max": [
        -379.3593444824219,
        -1912.418212890625,
        878.3258666992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -401.2017822265625,
        -1968.8211669921875,
        777.59326171875
      ],
      "bbox_max": [
        -348.0,
        -1871.16943359375,
        938.8501586914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.8987833261489868,
        0.38741838932037354
      ],
      "plane_d": -1978.563232421875,
      "bbox_min": [
        -401.2017822265625,
        -1968.8211669921875,
        777.59326171875
      ],
      "bbox_max": [
        -348.0,
        -1871.16943359375,
        938.8501586914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -373.3367004394531,
        -1950.219482421875,
        777.59326171875
      ],
      "bbox_max": [
        -348.0,
        -1871.16943359375,
        938.2603759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300138592720032,
        1.3651326298713684e-05,
        -0.8479889631271362
      ],
      "plane_d": 597.7864990234375,
      "bbox_min": [
        -373.3367004394531,
        -1950.219482421875,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1873.1556396484375,
        938.2603759765625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071607708930969,
        -0.0,
        0.7070528864860535
      ],
      "plane_d": -402.6274719238281,
      "bbox_min": [
        -369.0,
        -1882.516357421875,
        923.3193359375
      ],
      "bbox_max": [
        -362.3826904296875,
        -1871.16943359375,
        935.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472556471824646,
        -0.03996013477444649,
        -0.5296801328659058
      ],
      "plane_d": 728.06982421875,
      "bbox_min": [
        -369.0,
        -1882.516357421875,
        923.3193359375
      ],
      "bbox_max": [
        -362.3826904296875,
        -1871.16943359375,
        935.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300138592720032,
        1.3651326298713684e-05,
        -0.8479889631271362
      ],
      "plane_d": 597.7864990234375,
      "bbox_min": [
        -369.0,
        -1882.516357421875,
        932.7999267578125
      ],
      "bbox_max": [
        -364.099853515625,
        -1871.16943359375,
        935.5499877929688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8472549915313721,
        0.03998080641031265,
        -0.5296797156333923
      ],
      "plane_d": 877.8784790039062,
      "bbox_min": [
        -364.63897705078125,
        -1873.0,
        932.7999267578125
      ],
      "bbox_max": [
        -364.099853515625,
        -1871.16943359375,
        933.638916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -1887.4222412109375,
      "bbox_min": [
        -364.60009765625,
        -1875.1173095703125,
        923.3193359375
      ],
      "bbox_max": [
        -362.3826904296875,
        -1875.0,
        933.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1874.9998779296875,
      "bbox_min": [
        -364.60009765625,
        -1875.0,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1875.0,
        933.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47035738825798035,
        -0.7688683271408081,
        0.4331344962120056
      ],
      "plane_d": -1666.1329345703125,
      "bbox_min": [
        -401.2017822265625,
        -1968.8211669921875,
        778.6005859375
      ],
      "bbox_max": [
        -364.8932800292969,
        -1882.1689453125,
        938.8501586914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -401.2017822265625,
        -1968.8211669921875,
        778.6005859375
      ],
      "bbox_max": [
        -366.646484375,
        -1939.0,
        805.4291381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.787353515625,
        778.7999267578125
      ],
      "bbox_max": [
        -366.646484375,
        -1939.0,
        805.4291381835938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1939.0,
        802.8732299804688
      ],
      "bbox_max": [
        -366.646484375,
        -1939.0,
        805.4291381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.0,
        778.6005859375
      ],
      "bbox_max": [
        -369.0,
        -1949.9140625,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300138592720032,
        1.3651326298713684e-05,
        -0.8479889631271362
      ],
      "plane_d": 597.7864990234375,
      "bbox_min": [
        -373.4189453125,
        -1940.6357421875,
        802.5252685546875
      ],
      "bbox_max": [
        -364.8932800292969,
        -1882.1689453125,
        938.8501586914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03390716016292572,
        -0.9992004632949829,
        0.021187448874115944
      ],
      "plane_d": -1915.627197265625,
      "bbox_min": [
        -373.4189453125,
        -1884.650146484375,
        937.541259765625
      ],
      "bbox_max": [
        -372.1861572265625,
        -1884.592041015625,
        938.8501586914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1940.6357421875,
        802.5252685546875
      ],
      "bbox_max": [
        -366.1399230957031,
        -1939.0,
        806.3482666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1940.6357421875,
        802.5252685546875
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        806.3482666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -299.8731384277344,
        -1897.6322021484375,
        875.5444946289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.8987833261489868,
        0.38741838932037354
      ],
      "plane_d": -1978.563232421875,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -348.0,
        -1917.5384521484375,
        852.142822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -366.1399230957031,
        -1939.0,
        794.5689697265625
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        808.5042724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -366.1399230957031,
        -1939.0,
        794.5689697265625
      ],
      "bbox_max": [
        -360.0,
        -1939.0,
        802.60498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -361.6381530761719,
        -1939.0,
        809.7638549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -361.6381530761719,
        -1939.0,
        809.7638549804688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.47035738825798035,
        -0.7688683271408081,
        0.4331344962120056
      ],
      "plane_d": -1666.1329345703125,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1940.63623046875,
        804.3279418945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -405.1983337402344,
        -1972.0,
        788.1215209960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47035738825798035,
        -0.7688683271408081,
        0.4331344962120056
      ],
      "plane_d": -1666.1329345703125,
      "bbox_min": [
        -369.0,
        -1946.408447265625,
        789.0957641601562
      ],
      "bbox_max": [
        -361.6381530761719,
        -1939.0,
        809.7638549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1939.0,
        800.2208251953125
      ],
      "bbox_max": [
        -361.6381530761719,
        -1939.0,
        809.7638549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -300.0,
        -1920.0697021484375,
        765.0
      ],
      "bbox_max": [
        -299.8731384277344,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        781.3281860351562
      ],
      "bbox_max": [
        -348.0,
        -1881.876220703125,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.8987833261489868,
        0.38741838932037354
      ],
      "plane_d": -1978.563232421875,
      "bbox_min": [
        -414.0,
        -1972.0,
        781.3281860351562
      ],
      "bbox_max": [
        -359.96099853515625,
        -1881.876220703125,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472556471824646,
        -0.03996013477444649,
        -0.5296801328659058
      ],
      "plane_d": 728.06982421875,
      "bbox_min": [
        -364.89288330078125,
        -1882.5179443359375,
        932.958984375
      ],
      "bbox_max": [
        -364.3332214355469,
        -1881.876220703125,
        933.749755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300138592720032,
        1.3651326298713684e-05,
        -0.8479889631271362
      ],
      "plane_d": 597.7864990234375,
      "bbox_min": [
        -364.89288330078125,
        -1882.5177001953125,
        932.958984375
      ],
      "bbox_max": [
        -364.8546142578125,
        -1882.5050048828125,
        932.98291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472556471824646,
        -0.03996013477444649,
        -0.5296801328659058
      ],
      "plane_d": 728.06982421875,
      "bbox_min": [
        -364.9238586425781,
        -1884.54638671875,
        932.959228515625
      ],
      "bbox_max": [
        -364.3394470214844,
        -1882.059326171875,
        933.789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -674.18994140625,
        -2393.402587890625,
        610.304443359375
      ],
      "bbox_max": [
        70.50594329833984,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4736105501651764,
        -0.6577551960945129,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -511.7373046875,
        -2133.08251953125,
        635.0
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        716.4224243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518882870674133
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -468.130615234375,
        -2072.005126953125,
        635.0
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        716.4224243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -281.0429992675781,
        -1987.0,
        636.369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30801334977149963,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -417.841796875,
        -2072.005126953125,
        639.28125
      ],
      "bbox_max": [
        -388.1926574707031,
        -2040.92138671875,
        657.188232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995802164078,
        -0.02905004657804966,
        0.9984686374664307
      ],
      "plane_d": -717.8628540039062,
      "bbox_min": [
        -417.841796875,
        -2072.005126953125,
        639.28125
      ],
      "bbox_max": [
        -388.1926574707031,
        -2051.13671875,
        640.9827270507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -416.1728515625,
        -2069.01513671875,
        639.28125
      ],
      "bbox_max": [
        -412.73211669921875,
        -2064.272216796875,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -417.841796875,
        -2072.005126953125,
        639.28125
      ],
      "bbox_max": [
        -413.2454833984375,
        -2064.272216796875,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07853952795267105,
        0.978276252746582,
        0.19185161590576172
      ],
      "plane_d": 2002.348876953125,
      "bbox_min": [
        -468.130615234375,
        -2393.402587890625,
        610.304443359375
      ],
      "bbox_max": [
        70.50594329833984,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -432.43115234375,
        -2393.402587890625,
        610.304443359375
      ],
      "bbox_max": [
        -97.92158508300781,
        -2137.503173828125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -432.43115234375,
        -2393.402587890625,
        610.304443359375
      ],
      "bbox_max": [
        -97.92158508300781,
        -2137.503173828125,
        854.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -276.5,
        -2371.5,
        809.5
      ],
      "bbox_max": [
        -195.5,
        -2187.44677734375,
        854.5
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        809.5
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        809.5
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        825.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        809.5
      ],
      "bbox_max": [
        -210.5,
        -2360.5,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -375.0731201171875,
      "bbox_min": [
        -276.5,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -195.5,
        -2187.44677734375,
        854.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -276.5,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -195.5,
        -2189.358642578125,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 848.0,
      "bbox_min": [
        -230.800048828125,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -195.5,
        -2297.300048828125,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 228.0,
      "bbox_min": [
        -230.800048828125,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -195.5,
        -2297.300048828125,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 834.7999877929688,
      "bbox_min": [
        -230.800048828125,
        -2311.300048828125,
        834.7999877929688
      ],
      "bbox_max": [
        -228.0,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857492983341217,
        0.0,
        -0.5144957900047302
      ],
      "plane_d": 626.6558837890625,
      "bbox_min": [
        -228.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -195.5,
        -2297.300048828125,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0,
      "bbox_min": [
        -228.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -195.5,
        -2297.300048828125,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -198.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -198.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -198.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        838.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 838.0,
      "bbox_min": [
        -198.0,
        -2371.5,
        838.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8384436368942261,
        -0.0,
        -0.5449883341789246
      ],
      "plane_d": 290.6883850097656,
      "bbox_min": [
        -228.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2297.300048828125,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2359.0,
      "bbox_min": [
        -228.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2297.300048828125,
        848.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2359.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 838.0,
      "bbox_min": [
        -210.5,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2359.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2360.5,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2359.0,
        838.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 207.0,
      "bbox_min": [
        -207.0,
        -2360.5,
        825.0
      ],
      "bbox_max": [
        -199.0,
        -2359.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 836.0,
      "bbox_min": [
        -207.0,
        -2360.5,
        836.0
      ],
      "bbox_max": [
        -199.0,
        -2359.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 834.7999877929688,
      "bbox_min": [
        -228.0,
        -2345.5,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2297.300048828125,
        848.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2313.199951171875,
      "bbox_min": [
        -228.0,
        -2345.5,
        834.7999877929688
      ],
      "bbox_max": [
        -198.0,
        -2313.199951171875,
        848.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        -0.44721364974975586
      ],
      "plane_d": -1702.9896240234375,
      "bbox_min": [
        -220.5,
        -2345.5,
        847.0
      ],
      "bbox_max": [
        -206.0,
        -2325.0,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 206.0,
      "bbox_min": [
        -206.0,
        -2328.0,
        847.0
      ],
      "bbox_max": [
        -206.0,
        -2325.0,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        -0.44721364974975586
      ],
      "plane_d": -1718.6422119140625,
      "bbox_min": [
        -220.5,
        -2345.5,
        847.0
      ],
      "bbox_max": [
        -206.0,
        -2342.5,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 206.0,
      "bbox_min": [
        -206.0,
        -2345.5,
        847.0
      ],
      "bbox_max": [
        -206.0,
        -2342.5,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2313.199951171875,
      "bbox_min": [
        -228.0,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2311.300048828125,
        834.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 223.199951171875,
      "bbox_min": [
        -223.199951171875,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -223.199951171875,
        -2311.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7727664709091187,
        0.44615715742111206,
        -0.45141535997390747
      ],
      "plane_d": 1543.02392578125,
      "bbox_min": [
        -432.43115234375,
        -2393.402587890625,
        610.304443359375
      ],
      "bbox_max": [
        -97.92158508300781,
        -2137.503173828125,
        810.165771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.0428289897390641e-05,
        4.359517788543599e-06
      ],
      "plane_d": 376.8681640625,
      "bbox_min": [
        -432.43115234375,
        -2393.402587890625,
        610.304443359375
      ],
      "bbox_max": [
        -191.0,
        -2137.503173828125,
        810.165771484375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.9701424837112427,
        0.0,
        -0.24253562092781067
      ],
      "plane_d": 561.676513671875,
      "bbox_min": [
        -432.43115234375,
        -2331.0830078125,
        629.0
      ],
      "bbox_max": [
        -376.8466491699219,
        -2137.503173828125,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -432.43115234375,
        -2314.282470703125,
        637.0
      ],
      "bbox_max": [
        -419.7129211425781,
        -2137.503173828125,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -432.43115234375,
        -2139.602783203125,
        639.28125
      ],
      "bbox_max": [
        -429.2311096191406,
        -2137.503173828125,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        -0.5547001957893372
      ],
      "plane_d": 741.741943359375,
      "bbox_min": [
        -419.7129211425781,
        -2331.0830078125,
        629.0
      ],
      "bbox_max": [
        -376.8466491699219,
        -2232.569091796875,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314761519432068,
        -0.5555604696273804,
        0.0
      ],
      "plane_d": -916.6072998046875,
      "bbox_min": [
        -419.7129211425781,
        -2331.0830078125,
        629.0
      ],
      "bbox_max": [
        -376.8466491699219,
        -2232.569091796875,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555604696273804,
        -0.8314761519432068,
        0.0
      ],
      "plane_d": -1643.3692626953125,
      "bbox_min": [
        -419.7129211425781,
        -2331.0830078125,
        629.0
      ],
      "bbox_max": [
        -376.8466491699219,
        -2232.569091796875,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509564340114594,
        -0.9807842373847961,
        0.0
      ],
      "plane_d": -2116.147216796875,
      "bbox_min": [
        -419.7129211425781,
        -2331.0830078125,
        629.0
      ],
      "bbox_max": [
        -376.8466491699219,
        -2232.569091796875,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807842373847961,
        -0.19509564340114594,
        0.0
      ],
      "plane_d": -46.6435432434082,
      "bbox_min": [
        -419.7129211425781,
        -2331.0830078125,
        629.0
      ],
      "bbox_max": [
        -376.8466491699219,
        -2232.569091796875,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -419.7129211425781,
        -2316.484130859375,
        637.0
      ],
      "bbox_max": [
        -412.5399475097656,
        -2313.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.896294891834259,
        0.3712579011917114,
        -0.2425346076488495
      ],
      "plane_d": 1390.914794921875,
      "bbox_min": [
        -413.2330017089844,
        -2331.0830078125,
        629.0
      ],
      "bbox_max": [
        -376.8466491699219,
        -2232.569091796875,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807842373847961,
        0.19509564340114594,
        0.0
      ],
      "plane_d": 834.2132568359375,
      "bbox_min": [
        -413.2330017089844,
        -2331.0830078125,
        629.0
      ],
      "bbox_max": [
        -376.8466491699219,
        -2232.569091796875,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238787889480591,
        0.38268521428108215,
        0.0
      ],
      "plane_d": 1251.2257080078125,
      "bbox_min": [
        -413.2330017089844,
        -2325.759521484375,
        637.0
      ],
      "bbox_max": [
        -388.06610107421875,
        -2291.639892578125,
        751.0049438476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 400.5,
      "bbox_min": [
        -413.2330017089844,
        -2323.77490234375,
        637.0
      ],
      "bbox_max": [
        -391.77362060546875,
        -2312.800048828125,
        654.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -413.2330017089844,
        -2320.973876953125,
        637.0
      ],
      "bbox_max": [
        -400.5,
        -2313.0,
        645.9136962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.49613893032073975,
        -0.8682431578636169
      ],
      "plane_d": -590.7153930664062,
      "bbox_min": [
        -402.5,
        -2320.973876953125,
        637.6726684570312
      ],
      "bbox_max": [
        -400.5,
        -2318.5,
        645.9136962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.49613893032073975,
        0.8682431578636169
      ],
      "plane_d": -1705.10546875,
      "bbox_min": [
        -402.5,
        -2320.82275390625,
        637.6726684570312
      ],
      "bbox_max": [
        -400.5,
        -2318.5,
        639.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -400.5,
        -2323.77490234375,
        637.0
      ],
      "bbox_max": [
        -391.77362060546875,
        -2312.800048828125,
        637.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 396.462890625,
      "bbox_min": [
        -396.462890625,
        -2325.03466796875,
        637.0
      ],
      "bbox_max": [
        -388.06610107421875,
        -2291.639892578125,
        751.0049438476562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -396.462890625,
        -2325.03466796875,
        637.0
      ],
      "bbox_max": [
        -388.06610107421875,
        -2302.39990234375,
        751.0049438476562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9704055190086365,
        0.0,
        -0.24148114025592804
      ],
      "plane_d": 558.0330810546875,
      "bbox_min": [
        -393.4853515625,
        -2304.60009765625,
        724.8782348632812
      ],
      "bbox_max": [
        -392.1309509277344,
        -2302.39990234375,
        735.076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.961749255657196,
        -0.0,
        0.2739313840866089
      ],
      "plane_d": 178.5647430419922,
      "bbox_min": [
        -393.4853515625,
        -2304.60009765625,
        724.8782348632812
      ],
      "bbox_max": [
        -392.1309509277344,
        -2302.39990234375,
        729.6334228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1575925201177597,
        -0.987504243850708,
        0.0
      ],
      "plane_d": -2224.256103515625,
      "bbox_min": [
        -396.3184509277344,
        -2325.03466796875,
        637.0
      ],
      "bbox_max": [
        -388.06610107421875,
        -2311.326416015625,
        751.0049438476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -396.3184509277344,
        -2315.472412109375,
        637.0
      ],
      "bbox_max": [
        -390.1296081542969,
        -2311.326416015625,
        751.0049438476562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -395.2126770019531,
        -2325.03466796875,
        637.0
      ],
      "bbox_max": [
        -388.06610107421875,
        -2314.6611328125,
        750.0100708007812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7687152028083801,
        0.31841254234313965,
        -0.5546984672546387
      ],
      "plane_d": 1452.945068359375,
      "bbox_min": [
        -390.1364440917969,
        -2314.69482421875,
        750.0
      ],
      "bbox_max": [
        -390.1228942871094,
        -2314.6611328125,
        750.0100708007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -401.5,
        -2331.0830078125,
        637.0
      ],
      "bbox_max": [
        -376.8466491699219,
        -2232.569091796875,
        768.0769653320312
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.6859944462776184,
        -0.6859944462776184,
        -0.24253489077091217
      ],
      "plane_d": -1104.3076171875,
      "bbox_min": [
        -392.5685729980469,
        -2331.0830078125,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2244.73193359375,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7687152028083801,
        0.31841254234313965,
        -0.5546984672546387
      ],
      "plane_d": 1452.945068359375,
      "bbox_min": [
        -392.5685729980469,
        -2331.0830078125,
        712.0
      ],
      "bbox_max": [
        -376.84716796875,
        -2244.73193359375,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9704055190086365,
        0.0,
        -0.24148114025592804
      ],
      "plane_d": 558.0330810546875,
      "bbox_min": [
        -392.5685729980469,
        -2320.61376953125,
        712.0
      ],
      "bbox_max": [
        -376.8472900390625,
        -2251.802978515625,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -392.1309509277344,
        -2304.60009765625,
        735.076171875
      ],
      "bbox_max": [
        -388.71923828125,
        -2304.60009765625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.961749255657196,
        -0.0,
        0.2739313840866089
      ],
      "plane_d": 178.5647430419922,
      "bbox_min": [
        -392.56854248046875,
        -2320.61376953125,
        712.0
      ],
      "bbox_max": [
        -376.8472900390625,
        -2251.802978515625,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -392.1309509277344,
        -2304.60009765625,
        712.0
      ],
      "bbox_max": [
        -388.462890625,
        -2304.60009765625,
        724.8782348632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124784708023071,
        0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 1322.2498779296875,
      "bbox_min": [
        -381.462890625,
        -2320.61376953125,
        750.0
      ],
      "bbox_max": [
        -376.8472900390625,
        -2251.802978515625,
        768.0769653320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -687.1036987304688,
      "bbox_min": [
        -380.27880859375,
        -2257.5263671875,
        750.0
      ],
      "bbox_max": [
        -376.847900390625,
        -2251.802978515625,
        756.070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269031047821045,
        -0.9238767027854919,
        0.0
      ],
      "plane_d": -1989.30810546875,
      "bbox_min": [
        -399.596923828125,
        -2328.8466796875,
        637.0
      ],
      "bbox_max": [
        -376.8466491699219,
        -2232.569091796875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314761519432068,
        0.5555604696273804,
        -0.0
      ],
      "plane_d": 1591.7481689453125,
      "bbox_min": [
        -399.596923828125,
        -2314.806640625,
        637.0
      ],
      "bbox_max": [
        -376.84771728515625,
        -2232.569091796875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1575925201177597,
        -0.987504243850708,
        0.0
      ],
      "plane_d": -2224.256103515625,
      "bbox_min": [
        -390.1296081542969,
        -2314.806640625,
        637.0
      ],
      "bbox_max": [
        -389.511474609375,
        -2314.5625,
        654.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -390.1296081542969,
        -2314.806640625,
        637.0
      ],
      "bbox_max": [
        -389.511474609375,
        -2314.5625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.149342879652977,
        -0.7507419586181641,
        -0.6434929966926575
      ],
      "plane_d": -1198.31591796875,
      "bbox_min": [
        -386.067138671875,
        -2237.1748046875,
        655.0
      ],
      "bbox_max": [
        -376.84771728515625,
        -2232.569091796875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2119.08251953125,
      "bbox_min": [
        -384.919189453125,
        -2237.1748046875,
        658.5
      ],
      "bbox_max": [
        -376.84771728515625,
        -2235.569091796875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -390.1006774902344,
        -2328.8466796875,
        637.0
      ],
      "bbox_max": [
        -376.8466491699219,
        -2310.735595703125,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -378.359130859375,
        -2319.005859375,
        652.0
      ],
      "bbox_max": [
        -376.8468322753906,
        -2314.728515625,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826833665370941,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": -1941.4697265625,
      "bbox_min": [
        -376.8479309082031,
        -2393.402587890625,
        610.304443359375
      ],
      "bbox_max": [
        -191.0,
        -2218.38427734375,
        810.165771484375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.3712579011917114,
        -0.896294891834259,
        -0.2425346076488495
      ],
      "plane_d": -1687.4219970703125,
      "bbox_min": [
        -376.8479309082031,
        -2257.527099609375,
        629.0
      ],
      "bbox_max": [
        -292.3707580566406,
        -2218.38427734375,
        768.0772705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -1975.0977783203125,
      "bbox_min": [
        -376.8479309082031,
        -2257.527099609375,
        629.0
      ],
      "bbox_max": [
        -292.3707580566406,
        -2218.38427734375,
        768.0772705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268521428108215,
        -0.9238787889480591,
        0.0
      ],
      "plane_d": -1921.8516845703125,
      "bbox_min": [
        -376.8479309082031,
        -2257.527099609375,
        629.0
      ],
      "bbox_max": [
        -292.3707580566406,
        -2218.38427734375,
        768.0772705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509564340114594,
        -0.9807842373847961,
        0.0
      ],
      "plane_d": -2116.147216796875,
      "bbox_min": [
        -376.8477478027344,
        -2236.295166015625,
        629.0
      ],
      "bbox_max": [
        -370.54498291015625,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -376.8477478027344,
        -2236.295166015625,
        655.0
      ],
      "bbox_max": [
        -370.54498291015625,
        -2232.5,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1951041966676712,
        -0.9807825088500977,
        -0.0
      ],
      "plane_d": -2265.99609375,
      "bbox_min": [
        -376.84771728515625,
        -2235.711181640625,
        658.5
      ],
      "bbox_max": [
        -375.43804931640625,
        -2235.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2119.08251953125,
      "bbox_min": [
        -376.84771728515625,
        -2235.569091796875,
        658.5
      ],
      "bbox_max": [
        -376.5,
        -2235.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.149342879652977,
        -0.7507419586181641,
        -0.6434929966926575
      ],
      "plane_d": -1198.31591796875,
      "bbox_min": [
        -376.8477478027344,
        -2235.569091796875,
        655.0
      ],
      "bbox_max": [
        -376.5,
        -2232.5,
        658.6612548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2119.08251953125,
      "bbox_min": [
        -376.84771728515625,
        -2235.569091796875,
        658.5
      ],
      "bbox_max": [
        -376.5,
        -2235.5,
        658.6612548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31841254234313965,
        -0.7687152028083801,
        -0.5546984672546387
      ],
      "plane_d": -1187.2174072265625,
      "bbox_min": [
        -376.8479309082031,
        -2257.527099609375,
        652.1422119140625
      ],
      "bbox_max": [
        -292.3707580566406,
        -2218.38427734375,
        768.0772705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": -1433.9423828125,
      "bbox_min": [
        -376.8479309082031,
        -2257.527099609375,
        652.1422119140625
      ],
      "bbox_max": [
        -292.3707580566406,
        -2218.38427734375,
        768.0772705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6859944462776184,
        -0.6859944462776184,
        -0.24253489077091217
      ],
      "plane_d": -1104.3076171875,
      "bbox_min": [
        -376.8479309082031,
        -2257.527099609375,
        652.1422119140625
      ],
      "bbox_max": [
        -292.3707580566406,
        -2218.38427734375,
        768.0772705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071443796157837,
        0.7070691585540771,
        -2.1935584300081246e-05
      ],
      "plane_d": 1841.429931640625,
      "bbox_min": [
        -368.22998046875,
        -2239.5986328125,
        729.7393188476562
      ],
      "bbox_max": [
        -364.6529846191406,
        -2236.02197265625,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -687.1036987304688,
      "bbox_min": [
        -376.8479309082031,
        -2257.527099609375,
        652.1422119140625
      ],
      "bbox_max": [
        -292.3707580566406,
        -2218.38427734375,
        768.0772705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -376.8479309082031,
        -2257.527099609375,
        652.1422119140625
      ],
      "bbox_max": [
        -292.3707580566406,
        -2218.38427734375,
        768.0771484375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1320.79345703125,
      "bbox_min": [
        -376.8479309082031,
        -2249.615478515625,
        712.0
      ],
      "bbox_max": [
        -292.3707580566406,
        -2218.38427734375,
        768.0771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1841.484130859375,
      "bbox_min": [
        -368.22998046875,
        -2236.06787109375,
        712.0
      ],
      "bbox_max": [
        -368.1839599609375,
        -2236.02197265625,
        729.9921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3712576925754547,
        -0.8962944149971008,
        -0.2425367832183838
      ],
      "plane_d": -1923.539306640625,
      "bbox_min": [
        -368.1852722167969,
        -2249.615478515625,
        712.0
      ],
      "bbox_max": [
        -292.3707580566406,
        -2218.38427734375,
        768.0771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071443796157837,
        0.7070691585540771,
        -2.1935584300081246e-05
      ],
      "plane_d": 1841.429931640625,
      "bbox_min": [
        -368.1852722167969,
        -2249.615478515625,
        712.0
      ],
      "bbox_max": [
        -298.90374755859375,
        -2218.38427734375,
        768.0771484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6861807107925415,
        -0.6861807107925415,
        -0.24147887527942657
      ],
      "plane_d": -1108.3411865234375,
      "bbox_min": [
        -367.68017578125,
        -2249.615478515625,
        712.0
      ],
      "bbox_max": [
        -356.123779296875,
        -2238.12744140625,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6800597310066223,
        -0.6800597310066223,
        0.273929625749588
      ],
      "plane_d": -1472.9420166015625,
      "bbox_min": [
        -367.68017578125,
        -2249.615478515625,
        712.0
      ],
      "bbox_max": [
        -356.123779296875,
        -2238.12744140625,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886849164962769,
        -0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": -691.1708984375,
      "bbox_min": [
        -364.31005859375,
        -2249.615478515625,
        748.7863159179688
      ],
      "bbox_max": [
        -356.123779296875,
        -2241.49755859375,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -330.62353515625,
        -2238.0,
        729.6334228515625
      ],
      "bbox_max": [
        -298.90374755859375,
        -2218.38427734375,
        768.0771484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -330.62353515625,
        -2238.0,
        729.6334228515625
      ],
      "bbox_max": [
        -310.39990234375,
        -2218.38427734375,
        768.0771484375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9704055190086365,
        -0.24148114025592804
      ],
      "plane_d": -1979.4290771484375,
      "bbox_min": [
        -330.62353515625,
        -2238.0,
        729.6334228515625
      ],
      "bbox_max": [
        -323.39990234375,
        -2221.36181640625,
        768.0771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": -1438.4847412109375,
      "bbox_min": [
        -330.62353515625,
        -2238.0,
        748.7863159179688
      ],
      "bbox_max": [
        -323.39990234375,
        -2226.1279296875,
        768.0771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -325.60009765625,
        -2236.299560546875,
        762.878173828125
      ],
      "bbox_max": [
        -323.6819152832031,
        -2235.505126953125,
        763.4034423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9704055190086365,
        -0.24148114025592804
      ],
      "plane_d": -1979.4290771484375,
      "bbox_min": [
        -323.39990234375,
        -2235.38818359375,
        729.6334228515625
      ],
      "bbox_max": [
        -310.39990234375,
        -2221.36181640625,
        766.3359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": -1438.4847412109375,
      "bbox_min": [
        -323.39990234375,
        -2235.38818359375,
        748.7863159179688
      ],
      "bbox_max": [
        -310.39990234375,
        -2226.1279296875,
        766.3359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -602.3402709960938,
      "bbox_min": [
        -323.39990234375,
        -2235.38818359375,
        765.0
      ],
      "bbox_max": [
        -318.5620422363281,
        -2233.38427734375,
        766.3359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31841254234313965,
        -0.7687151432037354,
        -0.5546985864639282
      ],
      "plane_d": -1389.7275390625,
      "bbox_min": [
        -304.1925964355469,
        -2227.43212890625,
        750.0
      ],
      "bbox_max": [
        -298.90374755859375,
        -2223.38427734375,
        756.0718994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14934109151363373,
        -0.7507328987121582,
        -0.6435039639472961
      ],
      "plane_d": -1310.742919921875,
      "bbox_min": [
        -375.43804931640625,
        -2237.1748046875,
        652.1422119140625
      ],
      "bbox_max": [
        -326.0,
        -2233.132080078125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1951041966676712,
        -0.9807825088500977,
        -0.0
      ],
      "plane_d": -2265.99609375,
      "bbox_min": [
        -375.43804931640625,
        -2237.1748046875,
        652.1422119140625
      ],
      "bbox_max": [
        -326.0,
        -2233.132080078125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        652.1422119140625
      ],
      "bbox_max": [
        -326.0,
        -2233.132080078125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        0.3826833665370941,
        -9.773058309292537e-07
      ],
      "plane_d": 1231.606689453125,
      "bbox_min": [
        -376.847900390625,
        -2393.402587890625,
        610.304443359375
      ],
      "bbox_max": [
        -191.0,
        -2222.535400390625,
        810.165771484375
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.5124784708023071,
        0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 1322.2498779296875,
      "bbox_min": [
        -376.8474426269531,
        -2334.93896484375,
        637.0
      ],
      "bbox_max": [
        -365.9174499511719,
        -2308.552734375,
        768.0772094726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -376.8472900390625,
        -2334.93896484375,
        637.0
      ],
      "bbox_max": [
        -365.9174499511719,
        -2311.052490234375,
        768.0772094726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7687152028083801,
        0.31841254234313965,
        -0.5546984672546387
      ],
      "plane_d": 1452.945068359375,
      "bbox_min": [
        -376.8472900390625,
        -2334.93896484375,
        758.9906005859375
      ],
      "bbox_max": [
        -365.9174499511719,
        -2320.61376953125,
        768.0772094726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39223402738571167,
        0.39222702383995056,
        -0.8320519328117371
      ],
      "plane_d": 1697.3385009765625,
      "bbox_min": [
        -371.9085998535156,
        -2334.93896484375,
        764.8101196289062
      ],
      "bbox_max": [
        -365.9174499511719,
        -2330.18115234375,
        768.0772094726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883575081825256,
        0.588341474533081,
        -0.5546978712081909
      ],
      "plane_d": 2015.5765380859375,
      "bbox_min": [
        -371.9085998535156,
        -2332.965087890625,
        764.8101196289062
      ],
      "bbox_max": [
        -371.63214111328125,
        -2332.7958984375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -376.84686279296875,
        -2330.45849609375,
        637.0
      ],
      "bbox_max": [
        -368.92333984375,
        -2311.052490234375,
        652.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -376.84674072265625,
        -2330.45849609375,
        637.0
      ],
      "bbox_max": [
        -372.102783203125,
        -2319.006103515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38271352648735046,
        -0.9238670468330383,
        0.0
      ],
      "plane_d": -1994.2769775390625,
      "bbox_min": [
        -376.84686279296875,
        -2314.728515625,
        638.002197265625
      ],
      "bbox_max": [
        -375.58740234375,
        -2314.206787109375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3828117847442627,
        -0.9238263368606567,
        0.0
      ],
      "plane_d": -1991.14599609375,
      "bbox_min": [
        -376.735595703125,
        -2311.435302734375,
        638.002197265625
      ],
      "bbox_max": [
        -375.811767578125,
        -2311.052490234375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1458.1033935546875,
      "bbox_min": [
        -376.847900390625,
        -2393.402587890625,
        610.304443359375
      ],
      "bbox_max": [
        -191.0,
        -2222.535400390625,
        810.165771484375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -296.4061279296875,
        -2393.402587890625,
        723.0453491210938
      ],
      "bbox_max": [
        -191.0,
        -2306.606689453125,
        810.165771484375
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2385.0,
      "bbox_min": [
        -215.0,
        -2393.402587890625,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2371.5,
        803.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2385.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2371.5,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2385.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2371.5,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -210.5,
        -2385.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2371.5,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -210.5,
        -2385.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2371.5,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2373.0,
      "bbox_min": [
        -210.5,
        -2382.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2371.5,
        797.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        784.0
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 207.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        784.0
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 795.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        784.0
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -784.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        784.0
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.40613850951194763,
        0.9138116240501404
      ],
      "plane_d": -1680.195068359375,
      "bbox_min": [
        -210.5,
        -2382.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2373.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -1.1444091796875e-05
      ],
      "plane_d": -206.99102783203125,
      "bbox_min": [
        -207.0,
        -2382.0,
        780.0
      ],
      "bbox_max": [
        -199.0,
        -2373.0,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 199.0,
      "bbox_min": [
        -199.0,
        -2382.0,
        780.0
      ],
      "bbox_max": [
        -199.0,
        -2373.0,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        0.0,
        -0.5144957304000854
      ],
      "plane_d": 586.953857421875,
      "bbox_min": [
        -210.5,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2377.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2377.0,
      "bbox_min": [
        -210.5,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -206.0,
        -2377.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2380.5,
      "bbox_min": [
        -210.5,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -206.0,
        -2377.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -210.5,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -209.0,
        -2377.0,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.0,
        -0.5144957304000854
      ],
      "plane_d": 238.811767578125,
      "bbox_min": [
        -200.0,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2377.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2377.0,
      "bbox_min": [
        -200.0,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2377.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2380.5,
      "bbox_min": [
        -200.0,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2377.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 792.5,
      "bbox_min": [
        -197.0,
        -2380.5,
        792.5
      ],
      "bbox_max": [
        -195.5,
        -2377.0,
        792.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        -215.0,
        -2393.402587890625,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2385.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -191.0,
      "bbox_min": [
        -215.0,
        -2393.402587890625,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2385.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2390.0,
      "bbox_min": [
        -215.0,
        -2393.402587890625,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2385.0,
        803.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -205.51467895507812,
        -2393.402587890625,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2390.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -205.51467895507812,
        -2393.402587890625,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2390.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -204.5704345703125,
        -2393.081787109375,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2390.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -215.0,
        -2390.0,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2385.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 779.4000244140625,
      "bbox_min": [
        -215.0,
        -2390.0,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2385.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 195.5,
      "bbox_min": [
        -210.5,
        -2390.0,
        779.4000244140625
      ],
      "bbox_max": [
        -195.5,
        -2385.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -210.5,
      "bbox_min": [
        -210.5,
        -2387.9853515625,
        779.4000244140625
      ],
      "bbox_max": [
        -210.5,
        -2385.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -774.0,
      "bbox_min": [
        -215.0,
        -2390.0,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2385.0,
        779.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        0.768221378326416
      ],
      "plane_d": -720.7196655273438,
      "bbox_min": [
        -215.0,
        -2390.0,
        774.0
      ],
      "bbox_max": [
        -191.0,
        -2385.0,
        779.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726728081703186,
        0.0,
        0.7399401068687439
      ],
      "plane_d": -431.7886962890625,
      "bbox_min": [
        -215.0,
        -2388.21533203125,
        774.0
      ],
      "bbox_max": [
        -209.5,
        -2385.0,
        779.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 803.5,
      "bbox_min": [
        -215.0,
        -2390.0,
        798.5
      ],
      "bbox_max": [
        -191.0,
        -2385.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.0,
        -0.7682212591171265
      ],
      "plane_d": 491.1494445800781,
      "bbox_min": [
        -215.0,
        -2390.0,
        798.5
      ],
      "bbox_max": [
        -191.0,
        -2385.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726728081703186,
        0.0,
        -0.7399400472640991
      ],
      "plane_d": 735.466796875,
      "bbox_min": [
        -215.0,
        -2388.756103515625,
        798.5
      ],
      "bbox_max": [
        -209.5,
        -2385.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -296.4061279296875,
        -2371.5,
        723.0453491210938
      ],
      "bbox_max": [
        -195.5,
        -2306.606689453125,
        810.165771484375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.3922361731529236,
        0.3922291696071625,
        -0.8320499062538147
      ],
      "plane_d": 1447.8804931640625,
      "bbox_min": [
        -296.4061279296875,
        -2360.5,
        748.7863159179688
      ],
      "bbox_max": [
        -244.537109375,
        -2306.606689453125,
        768.0772705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3184986114501953,
        0.7686806917190552,
        -0.5546968579292297
      ],
      "plane_d": 2141.408447265625,
      "bbox_min": [
        -296.4061279296875,
        -2360.5,
        748.7863159179688
      ],
      "bbox_max": [
        -244.537109375,
        -2306.606689453125,
        768.0772705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707072377204895,
        0.7071411609649658,
        -3.234087489545345e-05
      ],
      "plane_d": 1854.579833984375,
      "bbox_min": [
        -293.1972961425781,
        -2355.266845703125,
        748.7863159179688
      ],
      "bbox_max": [
        -244.537109375,
        -2306.606689453125,
        768.0772705078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5886849164962769,
        0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": 1638.560302734375,
      "bbox_min": [
        -293.1972961425781,
        -2355.266845703125,
        748.7863159179688
      ],
      "bbox_max": [
        -271.930908203125,
        -2342.353271484375,
        768.0772705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21233268082141876,
        0.5124491453170776,
        -0.8320521116256714
      ],
      "plane_d": 1781.218994140625,
      "bbox_min": [
        -290.7259521484375,
        -2354.242919921875,
        765.0
      ],
      "bbox_max": [
        -282.05078125,
        -2346.7353515625,
        768.0772705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38998207449913025,
        0.38998207449913025,
        -0.8341630697250366
      ],
      "plane_d": 1441.8780517578125,
      "bbox_min": [
        -281.8392028808594,
        -2345.630859375,
        762.878173828125
      ],
      "bbox_max": [
        -278.5615234375,
        -2342.353271484375,
        764.48828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5886849164962769,
        0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": 1638.560302734375,
      "bbox_min": [
        -272.6468200683594,
        -2343.069091796875,
        748.7863159179688
      ],
      "bbox_max": [
        -244.537109375,
        -2306.606689453125,
        768.0770874023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124768614768982,
        0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 996.3134155273438,
      "bbox_min": [
        -271.09112548828125,
        -2336.38232421875,
        762.878173828125
      ],
      "bbox_max": [
        -260.60626220703125,
        -2324.123046875,
        768.0770874023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070838809013367,
        0.7071296572685242,
        -4.8993464588420466e-05
      ],
      "plane_d": 1841.56884765625,
      "bbox_min": [
        -271.09112548828125,
        -2336.38232421875,
        762.878173828125
      ],
      "bbox_max": [
        -267.869384765625,
        -2333.16064453125,
        768.0343017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        -0.0,
        -0.5547001957893372
      ],
      "plane_d": 212.5579833984375,
      "bbox_min": [
        -272.6468200683594,
        -2336.4384765625,
        750.0
      ],
      "bbox_max": [
        -244.537109375,
        -2306.606689453125,
        766.5380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124768614768982,
        0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 996.3134155273438,
      "bbox_min": [
        -272.6468200683594,
        -2336.4384765625,
        762.878173828125
      ],
      "bbox_max": [
        -259.58306884765625,
        -2321.65283203125,
        766.5380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38998207449913025,
        0.38998207449913025,
        -0.8341630697250366
      ],
      "plane_d": 1441.8780517578125,
      "bbox_min": [
        -272.6468200683594,
        -2336.4384765625,
        762.878173828125
      ],
      "bbox_max": [
        -269.369140625,
        -2333.160888671875,
        764.48828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -290.1011657714844,
        -2371.5,
        723.0453491210938
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        810.165771484375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.3184986114501953,
        0.7686806917190552,
        -0.5546968579292297
      ],
      "plane_d": 2141.408447265625,
      "bbox_min": [
        -290.1011657714844,
        -2362.380859375,
        750.0
      ],
      "bbox_max": [
        -279.7031555175781,
        -2360.5,
        755.9703979492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -195.5,
        -2371.5,
        746.9951171875
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        810.165771484375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -3.082740931859007e-06
      ],
      "plane_d": 1907.825439453125,
      "bbox_min": [
        -376.847900390625,
        -2358.475830078125,
        610.304443359375
      ],
      "bbox_max": [
        -244.53173828125,
        -2222.535400390625,
        775.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.39223402738571167,
        0.39222702383995056,
        -0.8320519328117371
      ],
      "plane_d": 1697.3385009765625,
      "bbox_min": [
        -367.88818359375,
        -2336.40966796875,
        763.480224609375
      ],
      "bbox_max": [
        -361.6597595214844,
        -2330.18115234375,
        768.1461181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1394.85302734375,
      "bbox_min": [
        -363.14764404296875,
        -2335.896728515625,
        767.6185913085938
      ],
      "bbox_max": [
        -362.6601257324219,
        -2335.4091796875,
        768.1461181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1394.85302734375,
      "bbox_min": [
        -365.4127197265625,
        -2335.895751953125,
        763.480224609375
      ],
      "bbox_max": [
        -362.6601257324219,
        -2333.853515625,
        768.0773315429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3900159001350403,
        0.38995468616485596,
        -0.8341600298881531
      ],
      "plane_d": 1689.9451904296875,
      "bbox_min": [
        -365.4127197265625,
        -2335.848876953125,
        763.480224609375
      ],
      "bbox_max": [
        -362.6602783203125,
        -2333.853515625,
        764.5992431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -526.3244018554688,
      "bbox_min": [
        -376.847900390625,
        -2358.475830078125,
        610.304443359375
      ],
      "bbox_max": [
        -244.53173828125,
        -2222.535400390625,
        775.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -376.847900390625,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -363.0396423339844,
        -2251.8076171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -687.1036987304688,
      "bbox_min": [
        -376.847900390625,
        -2260.8984375,
        660.0
      ],
      "bbox_max": [
        -363.0396423339844,
        -2251.8076171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -376.84747314453125,
        -2259.277587890625,
        660.0
      ],
      "bbox_max": [
        -375.40972900390625,
        -2256.931396484375,
        660.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -375.150390625,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -367.888427734375,
        -2263.512939453125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38266947865486145,
        0.9238852858543396,
        -0.0
      ],
      "plane_d": 2250.751220703125,
      "bbox_min": [
        -375.150390625,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -375.0616760253906,
        -2280.794677734375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1340.4090576171875,
      "bbox_min": [
        -376.8474426269531,
        -2358.475830078125,
        610.304443359375
      ],
      "bbox_max": [
        -244.53173828125,
        -2222.535400390625,
        775.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -367.888427734375,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -354.5302734375,
        -2249.518798828125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -687.1036987304688,
      "bbox_min": [
        -363.2724304199219,
        -2252.36962890625,
        762.7328491210938
      ],
      "bbox_max": [
        -357.5143737792969,
        -2249.518798828125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5886849164962769,
        -0.5886849164962769,
        -0.5539856553077698
      ],
      "plane_d": -691.1708984375,
      "bbox_min": [
        -357.7478332519531,
        -2249.683837890625,
        762.7328491210938
      ],
      "bbox_max": [
        -357.5143737792969,
        -2249.518798828125,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -367.888427734375,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -354.5302734375,
        -2250.0869140625,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3828069269657135,
        0.9238283634185791,
        0.0
      ],
      "plane_d": 2059.008544921875,
      "bbox_min": [
        -376.8474426269531,
        -2358.475830078125,
        610.304443359375
      ],
      "bbox_max": [
        -244.53173828125,
        -2222.535400390625,
        775.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.21233268082141876,
        0.5124491453170776,
        -0.8320521116256714
      ],
      "plane_d": 1781.218994140625,
      "bbox_min": [
        -305.6617431640625,
        -2358.475830078125,
        649.5
      ],
      "bbox_max": [
        -284.66571044921875,
        -2346.7353515625,
        768.0772705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -302.9367980957031,
        -2358.475830078125,
        649.5
      ],
      "bbox_max": [
        -288.0859375,
        -2348.16748046875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3184986114501953,
        0.7686806917190552,
        -0.5546968579292297
      ],
      "plane_d": 2141.408447265625,
      "bbox_min": [
        -298.9615478515625,
        -2358.475830078125,
        762.395751953125
      ],
      "bbox_max": [
        -293.1972961425781,
        -2355.266845703125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -302.7793273925781,
        -2354.249267578125,
        649.5
      ],
      "bbox_max": [
        -288.0859375,
        -2348.16748046875,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -376.8474426269531,
        -2355.435302734375,
        610.304443359375
      ],
      "bbox_max": [
        -244.53173828125,
        -2222.535400390625,
        775.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.3712576925754547,
        -0.8962944149971008,
        -0.2425367832183838
      ],
      "plane_d": -1923.539306640625,
      "bbox_min": [
        -329.7054138183594,
        -2238.0,
        646.4769287109375
      ],
      "bbox_max": [
        -270.53131103515625,
        -2222.535400390625,
        768.0771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31841254234313965,
        -0.7687151432037354,
        -0.5546985864639282
      ],
      "plane_d": -1389.7275390625,
      "bbox_min": [
        -329.7054138183594,
        -2238.0,
        646.4769287109375
      ],
      "bbox_max": [
        -270.53131103515625,
        -2225.241455078125,
        768.0771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -602.3402709960938,
      "bbox_min": [
        -329.7054138183594,
        -2238.0,
        646.4769287109375
      ],
      "bbox_max": [
        -270.53131103515625,
        -2227.43212890625,
        768.0771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2122735232114792,
        -0.5124768614768982,
        -0.832050085067749
      ],
      "plane_d": -572.86279296875,
      "bbox_min": [
        -327.0,
        -2238.0,
        646.4769287109375
      ],
      "bbox_max": [
        -270.53131103515625,
        -2230.00341796875,
        768.0771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6859944462776184,
        -0.6859944462776184,
        -0.24253489077091217
      ],
      "plane_d": -1540.60009765625,
      "bbox_min": [
        -327.0,
        -2238.0,
        646.4769287109375
      ],
      "bbox_max": [
        -270.53131103515625,
        -2230.00341796875,
        768.073974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -327.0,
        -2238.0,
        646.4769287109375
      ],
      "bbox_max": [
        -272.955078125,
        -2230.00341796875,
        768.073974609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.832523763179779,
        -0.5539893507957458
      ],
      "plane_d": -1438.4847412109375,
      "bbox_min": [
        -327.0,
        -2238.0,
        646.4769287109375
      ],
      "bbox_max": [
        -310.39990234375,
        -2230.00341796875,
        768.073974609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -323.39990234375,
        -2238.0,
        762.70263671875
      ],
      "bbox_max": [
        -323.39990234375,
        -2235.38818359375,
        768.073974609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        646.4769287109375
      ],
      "bbox_max": [
        -310.39990234375,
        -2235.505126953125,
        766.6275024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -327.0,
        -2238.0,
        647.4650268554688
      ],
      "bbox_max": [
        -310.39990234375,
        -2235.505126953125,
        766.6275024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -327.0,
        -2238.0,
        647.4650268554688
      ],
      "bbox_max": [
        -323.39990234375,
        -2235.505126953125,
        764.5277099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2237.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        647.4650268554688
      ],
      "bbox_max": [
        -323.773681640625,
        -2237.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        652.0
      ],
      "bbox_max": [
        -323.773681640625,
        -2237.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -312.60009765625,
        -2238.0,
        762.878173828125
      ],
      "bbox_max": [
        -310.39990234375,
        -2235.505126953125,
        764.5277099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -1061.293701171875,
      "bbox_min": [
        -278.6796875,
        -2238.0,
        750.0
      ],
      "bbox_max": [
        -272.955078125,
        -2234.568359375,
        756.0718994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -376.8474426269531,
        -2355.435302734375,
        610.304443359375
      ],
      "bbox_max": [
        -244.53173828125,
        -2238.0,
        775.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3826913833618164,
        -0.9238762259483337,
        0.0
      ],
      "plane_d": -2009.306640625,
      "bbox_min": [
        -368.92333984375,
        -2353.943603515625,
        610.304443359375
      ],
      "bbox_max": [
        -281.51007080078125,
        -2278.765625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 309.0,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        629.012451171875
      ],
      "bbox_max": [
        -305.317138671875,
        -2278.765625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314775824546814,
        0.5555582642555237,
        -0.0
      ],
      "plane_d": 1527.4034423828125,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        629.012451171875
      ],
      "bbox_max": [
        -305.317138671875,
        -2286.84716796875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3630538284778595,
        -0.8764702081680298,
        0.31621500849723816
      ],
      "plane_d": -2104.15576171875,
      "bbox_min": [
        -368.92333984375,
        -2353.943603515625,
        610.304443359375
      ],
      "bbox_max": [
        -281.51007080078125,
        -2308.989013671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        -368.157958984375,
        -2353.943603515625,
        610.304443359375
      ],
      "bbox_max": [
        -281.51007080078125,
        -2308.989013671875,
        637.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.5299989581108093,
        0.847998321056366
      ],
      "plane_d": -1764.1014404296875,
      "bbox_min": [
        -327.1314697265625,
        -2352.0126953125,
        610.304443359375
      ],
      "bbox_max": [
        -307.2218322753906,
        -2339.699951171875,
        620.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.24253562092781067,
        0.0
      ],
      "plane_d": -251.48521423339844,
      "bbox_min": [
        -327.1314697265625,
        -2345.426025390625,
        614.4794921875
      ],
      "bbox_max": [
        -325.699951171875,
        -2339.699951171875,
        620.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2308.989013671875,
      "bbox_min": [
        -323.794677734375,
        -2308.989013671875,
        626.0
      ],
      "bbox_max": [
        -312.205322265625,
        -2308.989013671875,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        0.3826833665370941,
        0.0
      ],
      "plane_d": 644.0186157226562,
      "bbox_min": [
        -376.8474426269531,
        -2355.435302734375,
        637.0
      ],
      "bbox_max": [
        -244.53173828125,
        -2238.0,
        775.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        -0.0,
        -0.5547001957893372
      ],
      "plane_d": 212.5579833984375,
      "bbox_min": [
        -268.1116638183594,
        -2330.181396484375,
        748.7863159179688
      ],
      "bbox_max": [
        -244.53173828125,
        -2277.750732421875,
        768.0772094726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124768614768982,
        0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 996.3134155273438,
      "bbox_min": [
        -268.1116638183594,
        -2330.181396484375,
        748.7863159179688
      ],
      "bbox_max": [
        -244.53173828125,
        -2277.750732421875,
        768.0772094726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.832523763179779,
        -0.0,
        -0.5539893507957458
      ],
      "plane_d": 208.95700073242188,
      "bbox_min": [
        -259.15289306640625,
        -2309.470703125,
        748.7863159179688
      ],
      "bbox_max": [
        -244.53173828125,
        -2277.750732421875,
        768.0772094726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -0.0,
        -0.8320502638816833
      ],
      "plane_d": 495.32666015625,
      "bbox_min": [
        -259.15289306640625,
        -2309.470703125,
        748.7863159179688
      ],
      "bbox_max": [
        -244.53173828125,
        -2277.750732421875,
        768.0772094726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -257.5157165527344,
        -2304.60009765625,
        748.7863159179688
      ],
      "bbox_max": [
        -244.53173828125,
        -2277.750732421875,
        766.9873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7687152028083801,
        -0.31841254234313965,
        -0.5546984672546387
      ],
      "plane_d": -498.6476745605469,
      "bbox_min": [
        -248.58514404296875,
        -2283.039794921875,
        750.0
      ],
      "bbox_max": [
        -244.537109375,
        -2277.750732421875,
        756.0720825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -257.5157165527344,
        -2304.60009765625,
        762.878173828125
      ],
      "bbox_max": [
        -254.53173828125,
        -2304.60009765625,
        766.9873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5515210628509521,
        -0.0,
        -0.8341609835624695
      ],
      "plane_d": 494.81390380859375,
      "bbox_min": [
        -257.5157165527344,
        -2304.60009765625,
        762.878173828125
      ],
      "bbox_max": [
        -256.652587890625,
        -2302.516357421875,
        764.1752319335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -257.5157165527344,
        -2304.60009765625,
        762.878173828125
      ],
      "bbox_max": [
        -256.652587890625,
        -2304.60009765625,
        764.1752319335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.260009765625,
      "bbox_min": [
        -376.8474426269531,
        -2355.435302734375,
        637.0
      ],
      "bbox_max": [
        -246.3943634033203,
        -2238.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071130871772766,
        -0.707100510597229,
        0.0
      ],
      "plane_d": -1422.54736328125,
      "bbox_min": [
        -376.8474426269531,
        -2320.260009765625,
        637.0
      ],
      "bbox_max": [
        -246.3943634033203,
        -2238.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070879340171814,
        0.7071256041526794,
        -0.0
      ],
      "plane_d": 1825.6146240234375,
      "bbox_min": [
        -376.8474426269531,
        -2320.260009765625,
        637.0
      ],
      "bbox_max": [
        -252.11990356445312,
        -2238.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.5105127861024812e-05,
        -1.1625744264165405e-05
      ],
      "plane_d": 294.6487731933594,
      "bbox_min": [
        -376.8474426269531,
        -2320.260009765625,
        637.0
      ],
      "bbox_max": [
        -284.97320556640625,
        -2242.115966796875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5364111065864563,
        -0.5364397168159485,
        -0.6515332460403442
      ],
      "plane_d": -934.5252075195312,
      "bbox_min": [
        -376.8474426269531,
        -2320.260009765625,
        637.0
      ],
      "bbox_max": [
        -294.697998046875,
        -2242.115966796875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7249156832695007,
        -0.3002679944038391,
        -0.61994868516922
      ],
      "plane_d": -477.7586975097656,
      "bbox_min": [
        -371.6578674316406,
        -2320.260009765625,
        702.0020751953125
      ],
      "bbox_max": [
        -294.6982116699219,
        -2254.058349609375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071154117584229,
        0.0,
        -0.707098126411438
      ],
      "plane_d": 706.1829223632812,
      "bbox_min": [
        -296.69622802734375,
        -2302.448974609375,
        702.0020751953125
      ],
      "bbox_max": [
        -294.6982116699219,
        -2295.487548828125,
        704.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21227414906024933,
        -0.5124784708023071,
        -0.8320490121841431
      ],
      "plane_d": -437.861083984375,
      "bbox_min": [
        -351.33404541015625,
        -2298.024658203125,
        698.1448364257812
      ],
      "bbox_max": [
        -294.697998046875,
        -2242.115966796875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071154117584229,
        0.0,
        -0.707098126411438
      ],
      "plane_d": 706.1829223632812,
      "bbox_min": [
        -300.55328369140625,
        -2298.024658203125,
        698.1448364257812
      ],
      "bbox_max": [
        -294.697998046875,
        -2287.057861328125,
        704.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -376.8474426269531,
        -2320.260009765625,
        637.0
      ],
      "bbox_max": [
        -294.6983947753906,
        -2246.958984375,
        774.1663208007812
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.923882246017456,
        -0.3826768100261688,
        0.0
      ],
      "plane_d": -595.1555786132812,
      "bbox_min": [
        -323.794677734375,
        -2308.989013671875,
        637.0
      ],
      "bbox_max": [
        -305.317138671875,
        -2286.84716796875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2308.989013671875,
      "bbox_min": [
        -323.794677734375,
        -2308.989013671875,
        637.0
      ],
      "bbox_max": [
        -305.317138671875,
        -2286.84716796875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314775824546814,
        0.5555582642555237,
        -0.0
      ],
      "plane_d": 1527.4034423828125,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        637.0
      ],
      "bbox_max": [
        -305.317138671875,
        -2286.84716796875,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9771250486373901,
        0.0,
        -0.2126655876636505
      ],
      "plane_d": 510.8121643066406,
      "bbox_min": [
        -376.8474426269531,
        -2320.260009765625,
        644.0
      ],
      "bbox_max": [
        -294.6983947753906,
        -2246.958984375,
        774.1663208007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47552189230918884,
        -0.8797038793563843,
        0.0
      ],
      "plane_d": -1844.5631103515625,
      "bbox_min": [
        -376.8474426269531,
        -2320.260009765625,
        670.5
      ],
      "bbox_max": [
        -362.1115417480469,
        -2298.5,
        774.1663208007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124784708023071,
        0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 1322.2498779296875,
      "bbox_min": [
        -376.8474426269531,
        -2320.260009765625,
        768.0769653320312
      ],
      "bbox_max": [
        -362.1115417480469,
        -2307.5205078125,
        774.1663208007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1345.3128662109375,
      "bbox_min": [
        -376.84716796875,
        -2320.260009765625,
        644.0
      ],
      "bbox_max": [
        -294.6983947753906,
        -2246.958984375,
        704.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3690088987350464,
        -0.3690088987350464,
        -0.8530327677726746
      ],
      "plane_d": -150.14930725097656,
      "bbox_min": [
        -372.79205322265625,
        -2275.351806640625,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -372.79205322265625,
        -2275.351806640625,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314638733863831,
        0.5555788278579712,
        0.0
      ],
      "plane_d": 1540.4844970703125,
      "bbox_min": [
        -351.334228515625,
        -2251.1162109375,
        657.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -372.79205322265625,
        -2275.351806640625,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        657.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8314638733863831,
        0.5555788278579712,
        0.0
      ],
      "plane_d": 1540.4844970703125,
      "bbox_min": [
        -351.334228515625,
        -2251.1162109375,
        644.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314638733863831,
        0.5555788278579712,
        0.0
      ],
      "plane_d": 1540.4844970703125,
      "bbox_min": [
        -351.334228515625,
        -2251.1162109375,
        649.0
      ],
      "bbox_max": [
        -348.556396484375,
        -2246.958984375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4821348190307617,
        -0.19970673322677612,
        -0.8530318140983582
      ],
      "plane_d": 274.6854248046875,
      "bbox_min": [
        -372.7919921875,
        -2275.351806640625,
        644.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2263.512939453125,
        647.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238790273666382,
        -0.38268470764160156,
        0.0
      ],
      "plane_d": -531.2314453125,
      "bbox_min": [
        -376.84716796875,
        -2320.260009765625,
        644.0
      ],
      "bbox_max": [
        -294.6983947753906,
        -2262.25732421875,
        704.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4821348190307617,
        -0.19970673322677612,
        -0.8530318140983582
      ],
      "plane_d": 274.6854248046875,
      "bbox_min": [
        -376.84716796875,
        -2286.1171875,
        644.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2266.290771484375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -375.0616760253906,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2266.290771484375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -375.0616760253906,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -363.73095703125,
        -2266.290771484375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38266947865486145,
        0.9238852858543396,
        -0.0
      ],
      "plane_d": 2250.751220703125,
      "bbox_min": [
        -375.0616760253906,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -370.531005859375,
        -2280.831298828125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 655.0,
      "bbox_min": [
        -341.653564453125,
        -2320.260009765625,
        655.0
      ],
      "bbox_max": [
        -294.6983947753906,
        -2262.25732421875,
        704.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        -0.5000008344650269,
        -0.7071056365966797
      ],
      "plane_d": -508.1038513183594,
      "bbox_min": [
        -341.653564453125,
        -2320.260009765625,
        655.0
      ],
      "bbox_max": [
        -294.6983947753906,
        -2262.25732421875,
        704.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.5461899238289334e-05,
        -0.7071036100387573,
        -0.7071099877357483
      ],
      "plane_d": -1142.8638916015625,
      "bbox_min": [
        -341.653564453125,
        -2320.260009765625,
        663.0
      ],
      "bbox_max": [
        -294.6983947753906,
        -2262.25732421875,
        704.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999842643737793,
        -0.5000151991844177,
        -0.7071071863174438
      ],
      "plane_d": -826.3067626953125,
      "bbox_min": [
        -341.653564453125,
        -2320.260009765625,
        663.0
      ],
      "bbox_max": [
        -294.6983947753906,
        -2262.25732421875,
        704.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -327.900634765625,
        -2306.50732421875,
        674.1215209960938
      ],
      "bbox_max": [
        -294.6983947753906,
        -2262.25732421875,
        704.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        -327.900634765625,
        -2306.50732421875,
        687.5
      ],
      "bbox_max": [
        -294.6983947753906,
        -2264.757080078125,
        704.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5461750081158243e-05,
        0.707112193107605,
        -0.7071013450622559
      ],
      "plane_d": 2105.2861328125,
      "bbox_min": [
        -327.900634765625,
        -2283.30517578125,
        694.0
      ],
      "bbox_max": [
        -317.0,
        -2273.304931640625,
        704.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5461750081158243e-05,
        0.707112193107605,
        -0.7071013450622559
      ],
      "plane_d": 2105.2861328125,
      "bbox_min": [
        -317.0,
        -2283.30517578125,
        694.0
      ],
      "bbox_max": [
        -310.8764343261719,
        -2276.395263671875,
        700.9097900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070958614349365,
        0.7071177363395691,
        -0.0
      ],
      "plane_d": 1835.5989990234375,
      "bbox_min": [
        -311.19805908203125,
        -2291.199951171875,
        687.5
      ],
      "bbox_max": [
        -304.6982421875,
        -2284.700439453125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693355143070221,
        0.6933924555778503,
        0.19612644612789154
      ],
      "plane_d": 1665.8143310546875,
      "bbox_min": [
        -312.59326171875,
        -2293.1728515625,
        674.1215209960938
      ],
      "bbox_max": [
        -304.6982421875,
        -2281.32958984375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 304.6982421875,
      "bbox_min": [
        -304.6982421875,
        -2293.1728515625,
        686.6312255859375
      ],
      "bbox_max": [
        -304.6982421875,
        -2291.9443359375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070958614349365,
        0.7071177363395691,
        -0.0
      ],
      "plane_d": 1835.5989990234375,
      "bbox_min": [
        -312.59326171875,
        -2292.18994140625,
        684.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.30517578125,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 304.6982421875,
      "bbox_min": [
        -304.6982421875,
        -2292.18994140625,
        686.10498046875
      ],
      "bbox_max": [
        -304.6982421875,
        -2291.199951171875,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 663.0,
      "bbox_min": [
        -325.82958984375,
        -2279.26025390625,
        663.0
      ],
      "bbox_max": [
        -324.47882080078125,
        -2278.30517578125,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.1866526367375627e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2310.26708984375,
      "bbox_min": [
        -323.75830078125,
        -2310.26025390625,
        686.10498046875
      ],
      "bbox_max": [
        -312.59326171875,
        -2310.260009765625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070987820625305,
        0.7071147561073303,
        0.0
      ],
      "plane_d": 1830.5931396484375,
      "bbox_min": [
        -336.6533203125,
        -2320.260009765625,
        655.0
      ],
      "bbox_max": [
        -294.69842529296875,
        -2278.30517578125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 663.0,
      "bbox_min": [
        -336.6533203125,
        -2320.260009765625,
        655.0
      ],
      "bbox_max": [
        -294.69842529296875,
        -2278.30517578125,
        694.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.9805760979652405,
        0.1961391568183899
      ],
      "plane_d": -2399.544921875,
      "bbox_min": [
        -325.829345703125,
        -2320.260009765625,
        663.0
      ],
      "bbox_max": [
        -294.69842529296875,
        -2281.30517578125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -1.9040728147956543e-05,
        0.0
      ],
      "plane_d": 302.6543884277344,
      "bbox_min": [
        -324.586669921875,
        -2312.26025390625,
        663.0
      ],
      "bbox_max": [
        -294.69842529296875,
        -2281.30517578125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070877552032471,
        0.7071258425712585,
        -0.0
      ],
      "plane_d": 1833.614990234375,
      "bbox_min": [
        -324.586669921875,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -302.697998046875,
        -2281.30517578125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071163058280945,
        -0.7070972323417664,
        0.0
      ],
      "plane_d": -1414.5389404296875,
      "bbox_min": [
        -324.586669921875,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -302.697998046875,
        -2281.30517578125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693382978439331,
        -0.6933642625808716,
        0.1961275041103363
      ],
      "plane_d": -1519.2562255859375,
      "bbox_min": [
        -324.586669921875,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -302.697998046875,
        -2281.30517578125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805803894996643,
        -1.867096398200374e-05,
        0.19611762464046478
      ],
      "plane_d": 164.5936737060547,
      "bbox_min": [
        -324.586669921875,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -302.697998046875,
        -2281.30517578125,
        692.3330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693355143070221,
        0.6933924555778503,
        0.19612644612789154
      ],
      "plane_d": 1665.8143310546875,
      "bbox_min": [
        -324.586669921875,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -302.697998046875,
        -2281.30517578125,
        685.64111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2312.26025390625,
      "bbox_min": [
        -324.586669921875,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -311.7646484375,
        -2310.460205078125,
        674.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 320.986572265625,
      "bbox_min": [
        -320.986572265625,
        -2312.26025390625,
        664.0
      ],
      "bbox_max": [
        -314.964599609375,
        -2310.460205078125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 672.0,
      "bbox_min": [
        -320.986572265625,
        -2312.26025390625,
        672.0
      ],
      "bbox_max": [
        -314.964599609375,
        -2310.460205078125,
        672.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070958614349365,
        0.7071177363395691,
        -0.0
      ],
      "plane_d": 1835.5989990234375,
      "bbox_min": [
        -306.1867370605469,
        -2291.199951171875,
        684.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2289.71142578125,
        685.64111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 304.6982421875,
      "bbox_min": [
        -305.0262451171875,
        -2302.365234375,
        684.0
      ],
      "bbox_max": [
        -302.6981201171875,
        -2290.871826171875,
        692.3330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070958614349365,
        0.7071177363395691,
        -0.0
      ],
      "plane_d": 1835.5989990234375,
      "bbox_min": [
        -305.0262451171875,
        -2291.199951171875,
        684.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2290.871826171875,
        686.10498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -304.68994140625,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -302.6981201171875,
        -2296.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2298.5,
      "bbox_min": [
        -304.68994140625,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -302.6981506347656,
        -2298.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 304.6982421875,
      "bbox_min": [
        -304.6982421875,
        -2302.365234375,
        684.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2300.0078125,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -302.6981506347656,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -299.6982421875,
        -2296.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -299.6982421875,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -294.69842529296875,
        -2296.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2298.5,
      "bbox_min": [
        -299.6982421875,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -294.6984558105469,
        -2298.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1412.5638427734375,
      "bbox_min": [
        -312.59326171875,
        -2310.26025390625,
        684.0
      ],
      "bbox_max": [
        -310.5927429199219,
        -2308.259765625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        -317.0,
        -2315.26025390625,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2310.260009765625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -319.5,
        -2320.260009765625,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2315.26025390625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        -317.0,
        -2320.260009765625,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2315.26025390625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806875228882,
        0.0,
        -0.1961161345243454
      ],
      "plane_d": 428.80621337890625,
      "bbox_min": [
        -323.75830078125,
        -2310.26025390625,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.30517578125,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.144189966202248e-05,
        -0.9805810451507568,
        -0.1961144208908081
      ],
      "plane_d": -2135.38037109375,
      "bbox_min": [
        -323.75830078125,
        -2310.26025390625,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.30517578125,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6933689117431641,
        -0.6933689117431641,
        -0.19616110622882843
      ],
      "plane_d": -1255.0654296875,
      "bbox_min": [
        -323.34423828125,
        -2310.26025390625,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.30517578125,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6933625936508179,
        0.693384051322937,
        -0.19612976908683777
      ],
      "plane_d": 1929.98193359375,
      "bbox_min": [
        -323.34423828125,
        -2309.26025390625,
        655.0
      ],
      "bbox_max": [
        -304.6982421875,
        -2283.30517578125,
        663.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.670008168730419e-05,
        -0.7070814967155457,
        -0.70713210105896
      ],
      "plane_d": -1167.5474853515625,
      "bbox_min": [
        -323.34423828125,
        -2309.26025390625,
        655.0
      ],
      "bbox_max": [
        -305.6982421875,
        -2284.30517578125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49997347593307495,
        0.49999019503593445,
        -0.7071324586868286
      ],
      "plane_d": 1763.9188232421875,
      "bbox_min": [
        -314.250244140625,
        -2309.26025390625,
        655.0
      ],
      "bbox_max": [
        -305.6982421875,
        -2284.30517578125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070814967155457,
        -1.670047640800476e-05,
        -0.70713210105896
      ],
      "plane_d": 681.408203125,
      "bbox_min": [
        -314.25,
        -2309.26025390625,
        655.0
      ],
      "bbox_max": [
        -305.6982421875,
        -2291.6142578125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500011146068573,
        -0.49997779726982117,
        -0.707114577293396
      ],
      "plane_d": -532.790283203125,
      "bbox_min": [
        -314.25,
        -2309.26025390625,
        655.0
      ],
      "bbox_max": [
        -305.698486328125,
        -2300.708251953125,
        658.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553337812423706,
        0.0,
        -0.655340313911438
      ],
      "plane_d": 711.479248046875,
      "bbox_min": [
        -294.698486328125,
        -2306.50732421875,
        687.5
      ],
      "bbox_max": [
        -284.97320556640625,
        -2287.057861328125,
        757.2086181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -294.698486328125,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -284.973388671875,
        -2296.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2298.5,
      "bbox_min": [
        -294.698486328125,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -286.6912841796875,
        -2298.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5349872708320618,
        0.5349872708320618,
        -0.6538938879966736
      ],
      "plane_d": 1869.0113525390625,
      "bbox_min": [
        -339.64227294921875,
        -2296.7822265625,
        670.5
      ],
      "bbox_max": [
        -252.11990356445312,
        -2238.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7584289312362671,
        -0.6517557501792908
      ],
      "plane_d": 2210.350341796875,
      "bbox_min": [
        -339.64227294921875,
        -2296.7822265625,
        746.0
      ],
      "bbox_max": [
        -268.6414794921875,
        -2238.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7215692400932312,
        0.298881858587265,
        -0.6245057582855225
      ],
      "plane_d": 1362.08642578125,
      "bbox_min": [
        -332.6547546386719,
        -2296.7822265625,
        746.0
      ],
      "bbox_max": [
        -268.6414794921875,
        -2248.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553337812423706,
        0.0,
        -0.655340313911438
      ],
      "plane_d": 711.479248046875,
      "bbox_min": [
        -332.6547546386719,
        -2296.7822265625,
        746.0
      ],
      "bbox_max": [
        -275.3641052246094,
        -2248.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3002129793167114,
        0.7247829437255859,
        -0.6201305389404297
      ],
      "plane_d": 2011.8299560546875,
      "bbox_min": [
        -332.6547546386719,
        -2269.08544921875,
        768.3970336914062
      ],
      "bbox_max": [
        -277.61895751953125,
        -2248.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071011066436768,
        -0.7071124315261841,
        5.3263302106643096e-06
      ],
      "plane_d": -1394.9625244140625,
      "bbox_min": [
        -323.39990234375,
        -2269.08544921875,
        774.40380859375
      ],
      "bbox_max": [
        -277.61895751953125,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -323.39990234375,
        -2248.452880859375,
        774.9201049804688
      ],
      "bbox_max": [
        -310.39990234375,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -310.39990234375,
        -2248.452880859375,
        774.9201049804688
      ],
      "bbox_max": [
        -310.39990234375,
        -2248.389892578125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071011066436768,
        -0.7071124315261841,
        5.3263302106643096e-06
      ],
      "plane_d": -1407.9625244140625,
      "bbox_min": [
        -277.9519348144531,
        -2269.08544921875,
        774.4052734375
      ],
      "bbox_max": [
        -277.61895751953125,
        -2268.75244140625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21227414906024933,
        -0.5124784708023071,
        -0.8320490121841431
      ],
      "plane_d": -437.861083984375,
      "bbox_min": [
        -332.6547546386719,
        -2250.063720703125,
        774.1633911132812
      ],
      "bbox_max": [
        -327.639892578125,
        -2248.38427734375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124784708023071,
        -0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 21.191041946411133,
      "bbox_min": [
        -276.9150390625,
        -2283.0625,
        772.7244262695312
      ],
      "bbox_max": [
        -268.6414794921875,
        -2269.395263671875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -602.3402709960938,
      "bbox_min": [
        -339.64227294921875,
        -2250.0625,
        764.5277099609375
      ],
      "bbox_max": [
        -298.52166748046875,
        -2238.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21227414906024933,
        -0.5124784708023071,
        -0.8320490121841431
      ],
      "plane_d": -437.861083984375,
      "bbox_min": [
        -339.64227294921875,
        -2250.0625,
        764.5277099609375
      ],
      "bbox_max": [
        -298.52166748046875,
        -2238.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -325.60009765625,
        -2250.0625,
        764.5277099609375
      ],
      "bbox_max": [
        -298.52166748046875,
        -2238.0,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -323.39990234375,
        -2250.0625,
        764.5277099609375
      ],
      "bbox_max": [
        -298.52166748046875,
        -2238.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2122735232114792,
        -0.5124768614768982,
        -0.832050085067749
      ],
      "plane_d": -572.86279296875,
      "bbox_min": [
        -310.39990234375,
        -2250.0625,
        768.4441528320312
      ],
      "bbox_max": [
        -298.52166748046875,
        -2241.5146484375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -310.39990234375,
        -2250.0625,
        768.4441528320312
      ],
      "bbox_max": [
        -310.39990234375,
        -2241.5146484375,
        774.9934692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39223313331604004,
        -0.39223313331604004,
        -0.8320494890213013
      ],
      "plane_d": -353.9089050292969,
      "bbox_min": [
        -321.5,
        -2296.781982421875,
        670.5
      ],
      "bbox_max": [
        -252.11990356445312,
        -2238.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826833665370941,
        -0.9238795638084412,
        -0.0
      ],
      "plane_d": -2184.8564453125,
      "bbox_min": [
        -321.5,
        -2296.781982421875,
        670.5
      ],
      "bbox_max": [
        -252.11990356445312,
        -2238.0,
        775.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -1061.293701171875,
      "bbox_min": [
        -306.2945861816406,
        -2259.681640625,
        739.5908813476562
      ],
      "bbox_max": [
        -253.9504852294922,
        -2238.0,
        768.0773315429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6859944462776184,
        -0.6859944462776184,
        -0.24253489077091217
      ],
      "plane_d": -1540.60009765625,
      "bbox_min": [
        -306.2945861816406,
        -2259.681640625,
        739.5908813476562
      ],
      "bbox_max": [
        -253.9504852294922,
        -2238.0,
        768.0773315429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -279.47259521484375,
        -2259.681640625,
        739.5908813476562
      ],
      "bbox_max": [
        -253.9504852294922,
        -2240.69091796875,
        765.9661865234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5887311100959778,
        -0.5886387228965759,
        -0.5539856553077698
      ],
      "plane_d": -1065.623046875,
      "bbox_min": [
        -279.47259521484375,
        -2250.021484375,
        739.5908813476562
      ],
      "bbox_max": [
        -269.6319274902344,
        -2240.69091796875,
        763.0377197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6861807107925415,
        -0.6861807107925415,
        -0.24147887527942657
      ],
      "plane_d": -1544.914794921875,
      "bbox_min": [
        -279.47259521484375,
        -2249.351318359375,
        739.5908813476562
      ],
      "bbox_max": [
        -269.6319274902344,
        -2240.69091796875,
        763.0377197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3900126814842224,
        -0.3899514675140381,
        -0.8341630697250366
      ],
      "plane_d": -349.54376220703125,
      "bbox_min": [
        -279.47259521484375,
        -2249.351318359375,
        762.878173828125
      ],
      "bbox_max": [
        -278.89019775390625,
        -2248.939453125,
        763.0377197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1407.9442138671875,
      "bbox_min": [
        -266.4726257324219,
        -2259.681640625,
        744.0996704101562
      ],
      "bbox_max": [
        -253.9504852294922,
        -2250.676513671875,
        759.0989990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5887311100959778,
        -0.5886387228965759,
        -0.5539856553077698
      ],
      "plane_d": -1065.6221923828125,
      "bbox_min": [
        -266.4726257324219,
        -2255.40625,
        744.0996704101562
      ],
      "bbox_max": [
        -261.23291015625,
        -2250.676513671875,
        755.1486206054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6861807107925415,
        -0.6861807107925415,
        -0.24147887527942657
      ],
      "plane_d": -1544.914794921875,
      "bbox_min": [
        -263.47900390625,
        -2253.05712890625,
        744.0996704101562
      ],
      "bbox_max": [
        -261.23291015625,
        -2250.676513671875,
        748.7863159179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7687152028083801,
        -0.31841254234313965,
        -0.5546984672546387
      ],
      "plane_d": -498.6476745605469,
      "bbox_min": [
        -259.1528015136719,
        -2259.681640625,
        750.0993041992188
      ],
      "bbox_max": [
        -253.9504852294922,
        -2255.469970703125,
        756.0718994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124784708023071,
        -0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 21.191041946411133,
      "bbox_min": [
        -321.5,
        -2296.781982421875,
        670.5
      ],
      "bbox_max": [
        -252.11990356445312,
        -2238.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        -321.5,
        -2296.781982421875,
        670.5
      ],
      "bbox_max": [
        -252.11990356445312,
        -2238.0,
        774.9501342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -321.5,
        -2264.757080078125,
        670.5
      ],
      "bbox_max": [
        -317.0,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.47552192211151123,
        0.8797038793563843
      ],
      "plane_d": -1672.97314453125,
      "bbox_min": [
        -321.5,
        -2241.699951171875,
        690.0
      ],
      "bbox_max": [
        -317.0,
        -2238.0,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9771250486373901,
        -0.2126655876636505
      ],
      "plane_d": -2044.213623046875,
      "bbox_min": [
        -321.5,
        -2241.699951171875,
        670.5
      ],
      "bbox_max": [
        -317.0,
        -2238.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.47552192211151123,
        0.8797038793563843
      ],
      "plane_d": -1672.97314453125,
      "bbox_min": [
        -317.0,
        -2241.699951171875,
        690.0
      ],
      "bbox_max": [
        -315.0,
        -2238.0,
        768.57861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -1061.293701171875,
      "bbox_min": [
        -315.4066162109375,
        -2296.781982421875,
        687.5
      ],
      "bbox_max": [
        -259.1528015136719,
        -2238.0,
        774.9501342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071011066436768,
        -0.7071124315261841,
        5.3263302106643096e-06
      ],
      "plane_d": -1407.9625244140625,
      "bbox_min": [
        -315.4066162109375,
        -2296.781982421875,
        687.5
      ],
      "bbox_max": [
        -264.2724304199219,
        -2238.0,
        774.9501342773438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3900126814842224,
        -0.3899514675140381,
        -0.8341630697250366
      ],
      "plane_d": -349.543212890625,
      "bbox_min": [
        -315.4066162109375,
        -2269.981201171875,
        710.093017578125
      ],
      "bbox_max": [
        -264.2724304199219,
        -2238.0,
        774.9500122070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071011066436768,
        -0.7071124315261841,
        5.3263302106643096e-06
      ],
      "plane_d": -1394.9625244140625,
      "bbox_min": [
        -288.0400390625,
        -2260.788818359375,
        762.4357299804688
      ],
      "bbox_max": [
        -277.2724609375,
        -2250.021484375,
        774.9500122070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1790.1290283203125,
      "bbox_min": [
        -315.4066162109375,
        -2259.687744140625,
        710.093017578125
      ],
      "bbox_max": [
        -264.2724304199219,
        -2238.0,
        771.545654296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5887311100959778,
        -0.5886387228965759,
        -0.5539856553077698
      ],
      "plane_d": -1065.6221923828125,
      "bbox_min": [
        -278.89019775390625,
        -2259.687744140625,
        753.77880859375
      ],
      "bbox_max": [
        -264.2724304199219,
        -2249.351318359375,
        762.878173828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -277.746337890625,
        -2250.495361328125,
        761.87109375
      ],
      "bbox_max": [
        -277.2724609375,
        -2250.021484375,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -602.3402709960938,
      "bbox_min": [
        -315.4066162109375,
        -2243.923583984375,
        764.5277099609375
      ],
      "bbox_max": [
        -306.2945861816406,
        -2238.0,
        771.545654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": -596.56494140625,
      "bbox_min": [
        -312.60009765625,
        -2243.923583984375,
        764.5277099609375
      ],
      "bbox_max": [
        -310.39990234375,
        -2238.0,
        770.4146728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -310.39990234375,
        -2243.923583984375,
        764.5277099609375
      ],
      "bbox_max": [
        -310.39990234375,
        -2238.0,
        770.4146728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -285.75537109375,
        -2296.781982421875,
        687.5
      ],
      "bbox_max": [
        -284.1914367675781,
        -2296.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5341558456420898,
        -0.5341463088989258,
        -0.6552596688270569
      ],
      "plane_d": -585.7737426757812,
      "bbox_min": [
        -308.450927734375,
        -2320.260009765625,
        746.0
      ],
      "bbox_max": [
        -269.537109375,
        -2282.084716796875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -269.5799560546875,
        -2304.60009765625,
        774.95068359375
      ],
      "bbox_max": [
        -269.54083251953125,
        -2291.60009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -269.5799560546875,
        -2304.60009765625,
        774.95068359375
      ],
      "bbox_max": [
        -269.54083251953125,
        -2304.60009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124784708023071,
        -0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 21.191041946411133,
      "bbox_min": [
        -271.2539367675781,
        -2287.207275390625,
        774.1482543945312
      ],
      "bbox_max": [
        -269.537109375,
        -2282.084716796875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124768614768982,
        0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 996.3134155273438,
      "bbox_min": [
        -275.24200439453125,
        -2320.260009765625,
        772.7099609375
      ],
      "bbox_max": [
        -269.537109375,
        -2306.487060546875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -0.0,
        -0.8320502638816833
      ],
      "plane_d": 495.32666015625,
      "bbox_min": [
        -286.69134521484375,
        -2320.260009765625,
        687.5
      ],
      "bbox_max": [
        -246.3943634033203,
        -2263.927978515625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7687152028083801,
        -0.31841254234313965,
        -0.5546984672546387
      ],
      "plane_d": -498.6476745605469,
      "bbox_min": [
        -286.69134521484375,
        -2320.260009765625,
        687.5
      ],
      "bbox_max": [
        -246.3943634033203,
        -2263.927978515625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124784708023071,
        -0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 21.191041946411133,
      "bbox_min": [
        -286.69134521484375,
        -2320.260009765625,
        687.5
      ],
      "bbox_max": [
        -248.58514404296875,
        -2271.581787109375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -259.15283203125,
      "bbox_min": [
        -286.69134521484375,
        -2320.260009765625,
        687.5
      ],
      "bbox_max": [
        -248.58514404296875,
        -2283.039794921875,
        775.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        -0.0,
        -0.5547001957893372
      ],
      "plane_d": 212.5579833984375,
      "bbox_min": [
        -259.15283203125,
        -2304.60009765625,
        754.7135009765625
      ],
      "bbox_max": [
        -248.58514404296875,
        -2283.039794921875,
        768.0775756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -259.15283203125,
        -2304.60009765625,
        754.7135009765625
      ],
      "bbox_max": [
        -251.21954345703125,
        -2289.39990234375,
        768.0775756835938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.832523763179779,
        -0.0,
        -0.5539893507957458
      ],
      "plane_d": 208.95700073242188,
      "bbox_min": [
        -259.15283203125,
        -2291.60009765625,
        754.7135009765625
      ],
      "bbox_max": [
        -251.21954345703125,
        -2289.39990234375,
        764.53125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5515210628509521,
        -0.0,
        -0.8341609835624695
      ],
      "plane_d": 494.81390380859375,
      "bbox_min": [
        -259.15283203125,
        -2291.60009765625,
        762.878173828125
      ],
      "bbox_max": [
        -256.652587890625,
        -2289.39990234375,
        764.53125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -259.15283203125,
        -2304.60009765625,
        762.8057250976562
      ],
      "bbox_max": [
        -256.6043701171875,
        -2302.39990234375,
        768.0775756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5515210628509521,
        -0.0,
        -0.8341609835624695
      ],
      "plane_d": 494.81390380859375,
      "bbox_min": [
        -259.15283203125,
        -2304.60009765625,
        762.8057250976562
      ],
      "bbox_max": [
        -256.6043701171875,
        -2302.39990234375,
        764.53125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.832523763179779,
        -0.0,
        -0.5539893507957458
      ],
      "plane_d": 208.95700073242188,
      "bbox_min": [
        -256.652587890625,
        -2302.516357421875,
        762.8057250976562
      ],
      "bbox_max": [
        -256.6043701171875,
        -2302.39990234375,
        762.878173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2298.5,
      "bbox_min": [
        -286.69134521484375,
        -2320.260009765625,
        687.5
      ],
      "bbox_max": [
        -259.15283203125,
        -2289.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -286.69134521484375,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -259.15283203125,
        -2289.39990234375,
        774.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5515210628509521,
        -0.0,
        -0.8341609835624695
      ],
      "plane_d": 494.81390380859375,
      "bbox_min": [
        -271.2099609375,
        -2291.60009765625,
        764.53125
      ],
      "bbox_max": [
        -259.15283203125,
        -2289.39990234375,
        774.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2291.60009765625,
      "bbox_min": [
        -271.2099609375,
        -2291.60009765625,
        764.53125
      ],
      "bbox_max": [
        -259.15283203125,
        -2291.60009765625,
        774.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124768614768982,
        0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 996.3134155273438,
      "bbox_min": [
        -271.52398681640625,
        -2320.260009765625,
        764.53125
      ],
      "bbox_max": [
        -259.15283203125,
        -2302.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2304.60009765625,
      "bbox_min": [
        -271.2099609375,
        -2304.60009765625,
        764.53125
      ],
      "bbox_max": [
        -259.15283203125,
        -2304.60009765625,
        774.9957885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5364239811897278,
        -0.536414384841919,
        -0.6515434980392456
      ],
      "plane_d": -934.4630126953125,
      "bbox_min": [
        -371.99786376953125,
        -2355.435302734375,
        643.0
      ],
      "bbox_max": [
        -264.002197265625,
        -2320.260009765625,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2996884286403656,
        -0.7232757806777954,
        -0.6221407055854797
      ],
      "plane_d": -1312.3388671875,
      "bbox_min": [
        -362.111328125,
        -2345.3154296875,
        746.0
      ],
      "bbox_max": [
        -264.002197265625,
        -2320.260009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5341558456420898,
        -0.5341463088989258,
        -0.6552596688270569
      ],
      "plane_d": -585.7737426757812,
      "bbox_min": [
        -362.111328125,
        -2345.3154296875,
        746.0
      ],
      "bbox_max": [
        -264.002197265625,
        -2320.260009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.720969557762146,
        -0.2986334562301636,
        -0.6253166794776917
      ],
      "plane_d": -9.845726013183594,
      "bbox_min": [
        -362.111328125,
        -2345.309814453125,
        768.4163818359375
      ],
      "bbox_max": [
        -273.8943176269531,
        -2320.260009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7249156832695007,
        -0.3002679944038391,
        -0.61994868516922
      ],
      "plane_d": -477.7586975097656,
      "bbox_min": [
        -362.111328125,
        -2345.309814453125,
        768.4163818359375
      ],
      "bbox_max": [
        -278.453369140625,
        -2320.260009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070838809013367,
        0.7071296572685242,
        -4.8993464588420466e-05
      ],
      "plane_d": 1854.56884765625,
      "bbox_min": [
        -323.39990234375,
        -2345.309814453125,
        774.6270751953125
      ],
      "bbox_max": [
        -278.453369140625,
        -2325.58935546875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -323.39990234375,
        -2345.309814453125,
        774.922607421875
      ],
      "bbox_max": [
        -310.39990234375,
        -2345.24853515625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -310.39990234375,
        -2345.309814453125,
        774.922607421875
      ],
      "bbox_max": [
        -310.39990234375,
        -2345.24853515625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070838809013367,
        0.7071296572685242,
        -4.8993464588420466e-05
      ],
      "plane_d": 1841.56884765625,
      "bbox_min": [
        -278.66265869140625,
        -2325.798583984375,
        774.6270751953125
      ],
      "bbox_max": [
        -278.453369140625,
        -2325.58935546875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124784708023071,
        0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 1322.2498779296875,
      "bbox_min": [
        -362.111328125,
        -2324.299072265625,
        774.1664428710938
      ],
      "bbox_max": [
        -359.0849609375,
        -2320.260009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124768614768982,
        0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 996.3134155273438,
      "bbox_min": [
        -276.9150390625,
        -2324.299072265625,
        774.169921875
      ],
      "bbox_max": [
        -273.8943176269531,
        -2320.260009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3922361731529236,
        0.3922291696071625,
        -0.8320499062538147
      ],
      "plane_d": 1447.8804931640625,
      "bbox_min": [
        -298.5257568359375,
        -2343.8994140625,
        764.48828125
      ],
      "bbox_max": [
        -264.002197265625,
        -2320.260009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5124768614768982,
        0.2122735232114792,
        -0.832050085067749
      ],
      "plane_d": 996.3134155273438,
      "bbox_min": [
        -298.5257568359375,
        -2343.8994140625,
        764.48828125
      ],
      "bbox_max": [
        -264.002197265625,
        -2320.260009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38998207449913025,
        0.38998207449913025,
        -0.8341630697250366
      ],
      "plane_d": 1441.8780517578125,
      "bbox_min": [
        -298.5257568359375,
        -2343.8994140625,
        764.48828125
      ],
      "bbox_max": [
        -271.0910949707031,
        -2324.589111328125,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7070838809013367,
        0.7071296572685242,
        -4.8993464588420466e-05
      ],
      "plane_d": 1841.56884765625,
      "bbox_min": [
        -298.5257568359375,
        -2343.8994140625,
        764.48828125
      ],
      "bbox_max": [
        -271.0910949707031,
        -2324.589111328125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21233268082141876,
        0.5124491453170776,
        -0.8320521116256714
      ],
      "plane_d": 1781.218994140625,
      "bbox_min": [
        -298.5257568359375,
        -2343.8994140625,
        767.6533813476562
      ],
      "bbox_max": [
        -281.9682922363281,
        -2333.781494140625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070838809013367,
        0.7071296572685242,
        -4.8993464588420466e-05
      ],
      "plane_d": 1854.56884765625,
      "bbox_min": [
        -288.855224609375,
        -2340.668212890625,
        767.6533813476562
      ],
      "bbox_max": [
        -281.9682922363281,
        -2333.781494140625,
        774.96826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2123335599899292,
        0.5124513506889343,
        -0.8320505023002625
      ],
      "plane_d": 1916.266845703125,
      "bbox_min": [
        -345.45166015625,
        -2345.3154296875,
        773.3577880859375
      ],
      "bbox_max": [
        -327.6337890625,
        -2337.9326171875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        -0.8320503234863281
      ],
      "plane_d": 1945.785888671875,
      "bbox_min": [
        -337.4929504394531,
        -2355.190185546875,
        764.48828125
      ],
      "bbox_max": [
        -277.26458740234375,
        -2338.96826171875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5515210628509521,
        -0.8341609835624695
      ],
      "plane_d": 1936.9571533203125,
      "bbox_min": [
        -337.4929504394531,
        -2353.84765625,
        764.48828125
      ],
      "bbox_max": [
        -277.26458740234375,
        -2338.96826171875,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 310.39990234375,
      "bbox_min": [
        -337.4929504394531,
        -2353.84765625,
        765.794677734375
      ],
      "bbox_max": [
        -310.39990234375,
        -2343.63720703125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2123335599899292,
        0.5124513506889343,
        -0.8320505023002625
      ],
      "plane_d": 1916.266845703125,
      "bbox_min": [
        -337.4929504394531,
        -2349.484130859375,
        768.6799926757812
      ],
      "bbox_max": [
        -323.39990234375,
        -2343.63720703125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 323.39990234375,
      "bbox_min": [
        -323.39990234375,
        -2349.484130859375,
        768.6799926757812
      ],
      "bbox_max": [
        -323.39990234375,
        -2343.63720703125,
        774.9935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3922361731529236,
        0.3922291696071625,
        -0.8320499062538147
      ],
      "plane_d": 1447.8804931640625,
      "bbox_min": [
        -287.61065673828125,
        -2346.7353515625,
        764.48828125
      ],
      "bbox_max": [
        -277.26458740234375,
        -2338.96826171875,
        771.5429077148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070838809013367,
        0.7071296572685242,
        -4.8993464588420466e-05
      ],
      "plane_d": 1854.56884765625,
      "bbox_min": [
        -283.6685791015625,
        -2342.353271484375,
        764.48828125
      ],
      "bbox_max": [
        -280.2834777832031,
        -2338.96826171875,
        769.62109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        -371.99786376953125,
        -2354.306396484375,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2320.260009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -371.99786376953125,
        -2350.10546875,
        687.5
      ],
      "bbox_max": [
        -317.0,
        -2320.260009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1407.85302734375,
      "bbox_min": [
        -349.4827575683594,
        -2340.616455078125,
        771.8353271484375
      ],
      "bbox_max": [
        -346.1705322265625,
        -2337.30419921875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124784708023071,
        0.21227414906024933,
        -0.8320490121841431
      ],
      "plane_d": 1322.2498779296875,
      "bbox_min": [
        -371.99786376953125,
        -2345.383544921875,
        764.5992431640625
      ],
      "bbox_max": [
        -335.5086975097656,
        -2320.260009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3900159001350403,
        0.38995468616485596,
        -0.8341600298881531
      ],
      "plane_d": 1689.9451904296875,
      "bbox_min": [
        -364.2159423828125,
        -2345.383544921875,
        764.5992431640625
      ],
      "bbox_max": [
        -335.5086975097656,
        -2325.400390625,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1394.85302734375,
      "bbox_min": [
        -362.6602783203125,
        -2345.383544921875,
        764.5992431640625
      ],
      "bbox_max": [
        -335.5086975097656,
        -2326.956298828125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071245908737183,
        -0.7070889472961426,
        -5.613890243694186e-05
      ],
      "plane_d": -1407.85302734375,
      "bbox_min": [
        -349.48187255859375,
        -2340.615478515625,
        768.370361328125
      ],
      "bbox_max": [
        -345.014892578125,
        -2336.148681640625,
        774.9572143554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22233350574970245,
        0.536557674407959,
        -0.8140476942062378
      ],
      "plane_d": 1719.30078125,
      "bbox_min": [
        -313.42950439453125,
        -2354.306396484375,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38280341029167175,
        0.9238297939300537,
        0.0
      ],
      "plane_d": 2054.107421875,
      "bbox_min": [
        -313.42950439453125,
        -2354.306396484375,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        659.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -309.9782409667969,
        -2354.306396484375,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        659.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8310803771018982,
        0.5561522841453552,
        -0.0
      ],
      "plane_d": 1541.722412109375,
      "bbox_min": [
        -287.44775390625,
        -2346.7353515625,
        656.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        659.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -309.8203430175781,
        -2354.24072265625,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        656.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8310803771018982,
        0.5561522841453552,
        -0.0
      ],
      "plane_d": 1541.722412109375,
      "bbox_min": [
        -287.44775390625,
        -2346.7353515625,
        643.0
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8310803771018982,
        0.5561522841453552,
        -0.0
      ],
      "plane_d": 1541.722412109375,
      "bbox_min": [
        -287.44775390625,
        -2346.7353515625,
        649.5
      ],
      "bbox_max": [
        -284.665771484375,
        -2342.578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.796142578125,
      "bbox_min": [
        -313.42950439453125,
        -2351.913818359375,
        646.5
      ],
      "bbox_max": [
        -307.280517578125,
        -2350.796142578125,
        659.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 656.0,
      "bbox_min": [
        -313.267822265625,
        -2351.913818359375,
        649.5
      ],
      "bbox_max": [
        -307.280517578125,
        -2350.796142578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -649.5,
      "bbox_min": [
        -312.9171447753906,
        -2351.848388671875,
        649.5
      ],
      "bbox_max": [
        -307.280517578125,
        -2350.796142578125,
        649.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5809391736984253,
        -0.8139470219612122
      ],
      "plane_d": 1891.8863525390625,
      "bbox_min": [
        -312.8372497558594,
        -2352.76416015625,
        645.0952758789062
      ],
      "bbox_max": [
        -306.88702392578125,
        -2350.796142578125,
        648.017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2350.796142578125,
      "bbox_min": [
        -312.8372497558594,
        -2350.796142578125,
        646.5
      ],
      "bbox_max": [
        -307.280517578125,
        -2350.796142578125,
        648.017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8327006101608276,
        0.4807601869106293,
        0.27473509311676025
      ],
      "plane_d": 1169.4652099609375,
      "bbox_min": [
        -376.392333984375,
        -2364.061767578125,
        619.9999389648438
      ],
      "bbox_max": [
        -97.92158508300781,
        -2143.212646484375,
        750.62548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -340.00372314453125,
        -2343.57958984375,
        619.9999389648438
      ],
      "bbox_max": [
        -267.07666015625,
        -2232.133544921875,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        -340.00372314453125,
        -2343.57958984375,
        619.9999389648438
      ],
      "bbox_max": [
        -267.07666015625,
        -2238.0,
        637.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 95.18456268310547,
      "bbox_min": [
        -340.00372314453125,
        -2343.57958984375,
        619.9999389648438
      ],
      "bbox_max": [
        -267.07666015625,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826833665370941,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": -1941.4697265625,
      "bbox_min": [
        -340.00372314453125,
        -2242.265625,
        620.0
      ],
      "bbox_max": [
        -327.0,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -329.705322265625,
        -2238.0,
        620.0
      ],
      "bbox_max": [
        -327.0,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 309.0,
      "bbox_min": [
        -309.0,
        -2343.57958984375,
        619.9999389648438
      ],
      "bbox_max": [
        -267.07666015625,
        -2255.06396484375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1458.1033935546875,
      "bbox_min": [
        -309.0,
        -2343.57958984375,
        619.9999389648438
      ],
      "bbox_max": [
        -267.07666015625,
        -2261.349853515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923894464969635,
        0.38264742493629456,
        0.0
      ],
      "plane_d": 643.930908203125,
      "bbox_min": [
        -309.0,
        -2330.181396484375,
        619.9999389648438
      ],
      "bbox_max": [
        -267.07666015625,
        -2261.349853515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472167193889618,
        0.0,
        0.894425630569458
      ],
      "plane_d": -690.9449462890625,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        619.9999389648438
      ],
      "bbox_max": [
        -297.2080078125,
        -2261.349853515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2274.0,
      "bbox_min": [
        -305.0,
        -2274.0,
        619.9999389648438
      ],
      "bbox_max": [
        -297.2080078125,
        -2274.0,
        623.8251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314775824546814,
        0.5555582642555237,
        -0.0
      ],
      "plane_d": 1527.4034423828125,
      "bbox_min": [
        -309.0,
        -2292.359130859375,
        626.0
      ],
      "bbox_max": [
        -305.317138671875,
        -2261.349853515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48564356565475464,
        -0.0,
        0.8741569519042969
      ],
      "plane_d": -406.7741394042969,
      "bbox_min": [
        -308.9999694824219,
        -2266.0,
        634.5615234375
      ],
      "bbox_max": [
        -305.5107116699219,
        -2261.349853515625,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2266.0,
      "bbox_min": [
        -308.9999694824219,
        -2266.0,
        634.5615234375
      ],
      "bbox_max": [
        -305.5107116699219,
        -2266.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1458.1033935546875,
      "bbox_min": [
        -331.98974609375,
        -2337.283935546875,
        637.0
      ],
      "bbox_max": [
        -268.83978271484375,
        -2232.133544921875,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 324.0,
      "bbox_min": [
        -326.0,
        -2237.0,
        637.4000244140625
      ],
      "bbox_max": [
        -323.38897705078125,
        -2232.133544921875,
        639.8541259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.4000244140625,
      "bbox_min": [
        -326.0,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -324.92236328125,
        -2232.133544921875,
        637.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -324.0,
        -2237.0,
        638.002197265625
      ],
      "bbox_max": [
        -323.38897705078125,
        -2235.94189453125,
        638.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        -331.98974609375,
        -2238.9462890625,
        637.0
      ],
      "bbox_max": [
        -322.4810485839844,
        -2237.0,
        647.4650268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -331.98974609375,
        -2238.9462890625,
        637.0
      ],
      "bbox_max": [
        -327.0,
        -2238.0,
        646.4769897460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826833665370941,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": -1941.4697265625,
      "bbox_min": [
        -331.98974609375,
        -2238.9462890625,
        637.0
      ],
      "bbox_max": [
        -329.705322265625,
        -2238.0,
        641.8458862304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -327.0,
        -2238.0,
        637.0
      ],
      "bbox_max": [
        -322.4810485839844,
        -2237.0,
        638.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -327.0,
        -2238.0,
        638.002197265625
      ],
      "bbox_max": [
        -322.811767578125,
        -2237.0,
        638.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -376.392333984375,
        -2364.061767578125,
        620.0
      ],
      "bbox_max": [
        -97.92158508300781,
        -2143.212646484375,
        750.62548828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        -328.39990234375,
        -2331.74609375,
        620.0
      ],
      "bbox_max": [
        -229.974853515625,
        -2217.199951171875,
        641.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        -328.39990234375,
        -2331.74609375,
        620.0
      ],
      "bbox_max": [
        -229.974853515625,
        -2217.199951171875,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826833665370941,
        -0.9238795638084412,
        -0.0
      ],
      "plane_d": -2184.8564453125,
      "bbox_min": [
        -309.0,
        -2330.909423828125,
        620.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2232.5,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509564340114594,
        -0.9807842373847961,
        0.0
      ],
      "plane_d": -2138.973388671875,
      "bbox_min": [
        -269.067138671875,
        -2234.403076171875,
        629.0
      ],
      "bbox_max": [
        -259.5,
        -2232.5,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        -0.3826833665370941,
        -0.0
      ],
      "plane_d": -1113.9117431640625,
      "bbox_min": [
        -309.0,
        -2330.909423828125,
        620.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1790.1290283203125,
      "bbox_min": [
        -309.0,
        -2330.909423828125,
        620.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -259.15283203125,
      "bbox_min": [
        -309.0,
        -2330.909423828125,
        620.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 309.0,
      "bbox_min": [
        -309.0,
        -2330.909423828125,
        620.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 95.18456268310547,
      "bbox_min": [
        -309.0,
        -2330.909423828125,
        620.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48564356565475464,
        -0.0,
        0.8741569519042969
      ],
      "plane_d": -406.7741394042969,
      "bbox_min": [
        -309.0,
        -2330.909423828125,
        620.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2266.0,
      "bbox_min": [
        -309.0,
        -2274.0,
        620.0
      ],
      "bbox_max": [
        -290.0999450683594,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -309.0,
        -2238.0,
        620.0
      ],
      "bbox_max": [
        -306.294677734375,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472167193889618,
        0.0,
        0.894425630569458
      ],
      "plane_d": -690.9449462890625,
      "bbox_min": [
        -301.3143615722656,
        -2274.0,
        621.8427734375
      ],
      "bbox_max": [
        -290.0999450683594,
        -2266.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2274.0,
      "bbox_min": [
        -297.349609375,
        -2274.0,
        623.39599609375
      ],
      "bbox_max": [
        -290.0999450683594,
        -2274.0,
        627.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2274.0,
      "bbox_min": [
        -291.0,
        -2274.0,
        626.5
      ],
      "bbox_max": [
        -286.5,
        -2274.0,
        627.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -309.0,
        -2238.0,
        635.4971313476562
      ],
      "bbox_max": [
        -306.294677734375,
        -2238.0,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1458.1033935546875,
      "bbox_min": [
        -268.83978271484375,
        -2330.909423828125,
        633.5195922851562
      ],
      "bbox_max": [
        -268.11181640625,
        -2330.181396484375,
        637.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -1790.1290283203125,
      "bbox_min": [
        -328.39990234375,
        -2331.74609375,
        637.0
      ],
      "bbox_max": [
        -229.974853515625,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509564340114594,
        -0.9807842373847961,
        0.0
      ],
      "plane_d": -2138.973388671875,
      "bbox_min": [
        -269.067138671875,
        -2234.403076171875,
        637.0
      ],
      "bbox_max": [
        -259.5,
        -2232.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826833665370941,
        -0.9238795638084412,
        0.0
      ],
      "plane_d": -2184.8564453125,
      "bbox_min": [
        -328.39990234375,
        -2331.74609375,
        637.0
      ],
      "bbox_max": [
        -229.974853515625,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.4000244140625,
      "bbox_min": [
        -328.39990234375,
        -2235.636962890625,
        637.4000244140625
      ],
      "bbox_max": [
        -310.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.4734824299812317,
        -0.8377031087875366,
        0.2721542716026306
      ],
      "plane_d": -1879.69091796875,
      "bbox_min": [
        -328.39990234375,
        -2235.636962890625,
        637.4000244140625
      ],
      "bbox_max": [
        -312.0,
        -2217.199951171875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48331403732299805,
        -0.8377364873886108,
        0.2541753351688385
      ],
      "plane_d": -1865.0765380859375,
      "bbox_min": [
        -328.39990234375,
        -2235.636962890625,
        637.4000244140625
      ],
      "bbox_max": [
        -312.0,
        -2217.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9079718589782715,
        0.41903114318847656,
        0.0
      ],
      "plane_d": 1229.4326171875,
      "bbox_min": [
        -328.39990234375,
        -2235.636962890625,
        637.4000244140625
      ],
      "bbox_max": [
        -312.0,
        -2220.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2229.837890625,
        637.4000244140625
      ],
      "bbox_max": [
        -326.0,
        -2227.60009765625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -315.9515075683594,
        -2235.636962890625,
        638.002197265625
      ],
      "bbox_max": [
        -312.0,
        -2234.0,
        638.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -259.15283203125,
      "bbox_min": [
        -326.0,
        -2331.74609375,
        637.0
      ],
      "bbox_max": [
        -229.974853515625,
        -2229.837646484375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -259.15283203125,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -229.974853515625,
        -2313.5,
        641.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2313.5,
      "bbox_min": [
        -259.15283203125,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -229.974853515625,
        -2313.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2331.5,
      "bbox_min": [
        -259.15283203125,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -229.974853515625,
        -2313.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -245.0,
      "bbox_min": [
        -259.15283203125,
        -2331.5,
        638.0
      ],
      "bbox_max": [
        -229.974853515625,
        -2313.5,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": -2255.843505859375,
      "bbox_min": [
        -245.0,
        -2331.142822265625,
        638.0
      ],
      "bbox_max": [
        -229.974853515625,
        -2314.357177734375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 243.39990234375,
      "bbox_min": [
        -245.0,
        -2331.142822265625,
        638.0
      ],
      "bbox_max": [
        -242.73895263671875,
        -2314.357177734375,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2325.0,
      "bbox_min": [
        -245.0,
        -2325.0,
        638.0
      ],
      "bbox_max": [
        -243.39990234375,
        -2320.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.0,
      "bbox_min": [
        -245.0,
        -2320.0,
        638.0
      ],
      "bbox_max": [
        -243.39990234375,
        -2320.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": 1524.355224609375,
      "bbox_min": [
        -243.39990234375,
        -2331.142822265625,
        638.0
      ],
      "bbox_max": [
        -242.73895263671875,
        -2329.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5747867226600647,
        -0.8183032274246216,
        0.0
      ],
      "plane_d": -1746.5738525390625,
      "bbox_min": [
        -259.15283203125,
        -2315.35498046875,
        638.0
      ],
      "bbox_max": [
        -255.0,
        -2313.5,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38271352648735046,
        -0.9238670468330383,
        -0.0
      ],
      "plane_d": -2237.682861328125,
      "bbox_min": [
        -259.15283203125,
        -2315.35498046875,
        638.0
      ],
      "bbox_max": [
        -257.640869140625,
        -2314.728759765625,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        -0.3826833665370941,
        -0.0
      ],
      "plane_d": -1113.9117431640625,
      "bbox_min": [
        -326.0,
        -2331.74609375,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2229.837646484375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923877477645874,
        0.38268840312957764,
        0.0
      ],
      "plane_d": 644.0309448242188,
      "bbox_min": [
        -326.0,
        -2331.74609375,
        637.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2229.837646484375,
        641.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -267.07666015625,
        -2328.595703125,
        638.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2311.052490234375,
        641.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5731114149093628,
        0.8194774389266968,
        -0.0
      ],
      "plane_d": 2056.755126953125,
      "bbox_min": [
        -267.07666015625,
        -2328.595703125,
        638.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2311.052490234375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267284631729126,
        0.9238839149475098,
        -0.0
      ],
      "plane_d": 2249.711181640625,
      "bbox_min": [
        -265.004638671875,
        -2326.44140625,
        638.0
      ],
      "bbox_max": [
        -262.233154296875,
        -2325.29345703125,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38260337710380554,
        0.9239127039909363,
        0.0
      ],
      "plane_d": 2252.759765625,
      "bbox_min": [
        -267.07666015625,
        -2328.06494140625,
        638.002197265625
      ],
      "bbox_max": [
        -266.15283203125,
        -2327.682373046875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238551259040833,
        0.382742315530777,
        0.0
      ],
      "plane_d": 645.161376953125,
      "bbox_min": [
        -260.41259765625,
        -2314.728759765625,
        638.001220703125
      ],
      "bbox_max": [
        -259.15283203125,
        -2311.052490234375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38271352648735046,
        -0.9238670468330383,
        -0.0
      ],
      "plane_d": -2237.682861328125,
      "bbox_min": [
        -260.41259765625,
        -2314.728759765625,
        638.001220703125
      ],
      "bbox_max": [
        -259.15283203125,
        -2314.206787109375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3828117847442627,
        -0.9238263368606567,
        -0.0
      ],
      "plane_d": -2234.6142578125,
      "bbox_min": [
        -260.188232421875,
        -2311.435302734375,
        638.002197265625
      ],
      "bbox_max": [
        -259.264404296875,
        -2311.052490234375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -326.0,
        -2331.74609375,
        637.0
      ],
      "bbox_max": [
        -268.11181640625,
        -2229.837646484375,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.002197265625,
      "bbox_min": [
        -326.0,
        -2238.0,
        637.4000244140625
      ],
      "bbox_max": [
        -309.0,
        -2229.837646484375,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -637.4000244140625,
      "bbox_min": [
        -326.0,
        -2234.0,
        637.4000244140625
      ],
      "bbox_max": [
        -315.95172119140625,
        -2229.837646484375,
        638.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2232.4775390625,
        637.4000244140625
      ],
      "bbox_max": [
        -326.0,
        -2229.837646484375,
        638.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2237.0,
        638.002197265625
      ],
      "bbox_max": [
        -309.0,
        -2229.837646484375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2237.0,
      "bbox_min": [
        -324.3780517578125,
        -2237.0,
        638.002197265625
      ],
      "bbox_max": [
        -309.0,
        -2234.0,
        641.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 324.0,
      "bbox_min": [
        -324.0,
        -2237.0,
        638.002197265625
      ],
      "bbox_max": [
        -324.0,
        -2234.0,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1458.1033935546875,
      "bbox_min": [
        -269.67645263671875,
        -2331.74609375,
        637.0
      ],
      "bbox_max": [
        -268.11181640625,
        -2330.181396484375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07822323590517044,
        0.9795448184013367,
        0.1854003369808197
      ],
      "plane_d": 2009.3104248046875,
      "bbox_min": [
        -376.392333984375,
        -2364.061767578125,
        641.0
      ],
      "bbox_max": [
        -97.92158508300781,
        -2143.24560546875,
        750.62548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1790.1290283203125,
      "bbox_min": [
        -376.392333984375,
        -2364.061767578125,
        641.0
      ],
      "bbox_max": [
        -97.92158508300781,
        -2143.48388671875,
        750.62548828125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.6859944462776184,
        -0.6859944462776184,
        -0.24253489077091217
      ],
      "plane_d": -1540.60009765625,
      "bbox_min": [
        -376.392333984375,
        -2263.512939453125,
        641.0
      ],
      "bbox_max": [
        -97.92158508300781,
        -2143.48388671875,
        750.62548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2172.654052734375,
        673.2559204101562
      ],
      "bbox_max": [
        -97.92158508300781,
        -2170.90673828125,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 675.2044067382812,
      "bbox_min": [
        -98.89990234375,
        -2172.654052734375,
        675.2044067382812
      ],
      "bbox_max": [
        -97.92158508300781,
        -2171.2890625,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -376.392333984375,
        -2263.512939453125,
        641.0
      ],
      "bbox_max": [
        -253.54966735839844,
        -2143.48388671875,
        750.62548828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3712576925754547,
        -0.8962944149971008,
        -0.2425367832183838
      ],
      "plane_d": -1923.539306640625,
      "bbox_min": [
        -371.1348876953125,
        -2260.476318359375,
        660.0
      ],
      "bbox_max": [
        -253.54966735839844,
        -2146.712158203125,
        750.62548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999884068965912,
        -0.8660321235656738,
        -4.7862531573628075e-06
      ],
      "plane_d": -1682.5611572265625,
      "bbox_min": [
        -371.1348876953125,
        -2172.122314453125,
        660.0
      ],
      "bbox_max": [
        -348.4848937988281,
        -2146.712158203125,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5000041723251343,
        -0.8660230040550232,
        -5.232015610090457e-06
      ],
      "plane_d": -1674.5355224609375,
      "bbox_min": [
        -371.1348876953125,
        -2147.87353515625,
        660.0
      ],
      "bbox_max": [
        -369.123291015625,
        -2146.712158203125,
        662.7705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999884068965912,
        -0.8660321235656738,
        -4.7862531573628075e-06
      ],
      "plane_d": -1702.5611572265625,
      "bbox_min": [
        -357.13494873046875,
        -2172.122314453125,
        660.0
      ],
      "bbox_max": [
        -348.4848937988281,
        -2167.12841796875,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6861807107925415,
        -0.6861807107925415,
        -0.24147887527942657
      ],
      "plane_d": -1544.914794921875,
      "bbox_min": [
        -271.0533752441406,
        -2260.476318359375,
        729.6334228515625
      ],
      "bbox_max": [
        -253.54966735839844,
        -2238.38916015625,
        750.62548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1394.9442138671875,
      "bbox_min": [
        -269.6319274902344,
        -2260.476318359375,
        729.6334228515625
      ],
      "bbox_max": [
        -253.54966735839844,
        -2238.38916015625,
        750.62548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7687152028083801,
        -0.31841254234313965,
        -0.5546984672546387
      ],
      "plane_d": -498.6476745605469,
      "bbox_min": [
        -257.74468994140625,
        -2260.476318359375,
        750.0
      ],
      "bbox_max": [
        -253.54966735839844,
        -2253.21044921875,
        750.62548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        -0.5883489847183228,
        -0.5546989440917969
      ],
      "plane_d": -1061.293701171875,
      "bbox_min": [
        -257.74468994140625,
        -2255.469970703125,
        750.0
      ],
      "bbox_max": [
        -255.72119140625,
        -2253.21044921875,
        750.62548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509564340114594,
        -0.9807842373847961,
        0.0
      ],
      "plane_d": -2138.973388671875,
      "bbox_min": [
        -376.392333984375,
        -2263.512939453125,
        641.0
      ],
      "bbox_max": [
        -259.5,
        -2143.48388671875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000041723251343,
        -0.8660230040550232,
        -5.232015610090457e-06
      ],
      "plane_d": -1674.5355224609375,
      "bbox_min": [
        -376.392333984375,
        -2172.98876953125,
        641.0
      ],
      "bbox_max": [
        -345.82568359375,
        -2143.48388671875,
        660.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8617133498191833,
        -0.49754413962364197,
        -0.09949871897697449
      ],
      "plane_d": -1316.8052978515625,
      "bbox_min": [
        -364.5332336425781,
        -2144.06201171875,
        641.0
      ],
      "bbox_max": [
        -364.26806640625,
        -2143.48388671875,
        644.062255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999884068965912,
        -0.8660321235656738,
        -4.7862531573628075e-06
      ],
      "plane_d": -1682.5611572265625,
      "bbox_min": [
        -370.263671875,
        -2172.98876953125,
        654.0
      ],
      "bbox_max": [
        -345.82568359375,
        -2147.406494140625,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        -370.263671875,
        -2156.319580078125,
        654.0
      ],
      "bbox_max": [
        -355.82568359375,
        -2147.406494140625,
        656.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7588072419166565,
        -0.4381272494792938,
        -0.4819295108318329
      ],
      "plane_d": -900.006591796875,
      "bbox_min": [
        -366.310546875,
        -2154.037109375,
        654.0
      ],
      "bbox_max": [
        -359.748291015625,
        -2149.671142578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745586633682251,
        0.44722193479537964,
        -0.44727107882499695
      ],
      "plane_d": 1539.189697265625,
      "bbox_min": [
        -366.310546875,
        -2154.037109375,
        654.0
      ],
      "bbox_max": [
        -364.9443359375,
        -2152.671142578125,
        656.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999884068965912,
        -0.8660321235656738,
        -4.7862531573628075e-06
      ],
      "plane_d": -1702.5611572265625,
      "bbox_min": [
        -359.3679504394531,
        -2172.98876953125,
        654.0
      ],
      "bbox_max": [
        -345.82568359375,
        -2165.593017578125,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        -359.3679504394531,
        -2172.98876953125,
        654.0
      ],
      "bbox_max": [
        -355.810546875,
        -2170.49169921875,
        654.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555604696273804,
        -0.8314761519432068,
        0.0
      ],
      "plane_d": -1708.3697509765625,
      "bbox_min": [
        -282.596923828125,
        -2263.512939453125,
        645.0
      ],
      "bbox_max": [
        -259.5,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314761519432068,
        -0.5555604696273804,
        0.0
      ],
      "plane_d": -1013.8900146484375,
      "bbox_min": [
        -282.596923828125,
        -2263.512939453125,
        645.0
      ],
      "bbox_max": [
        -259.5,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -281.46978759765625,
        -2263.512939453125,
        649.0
      ],
      "bbox_max": [
        -259.5,
        -2232.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555597543716431,
        -0.831476628780365,
        0.0
      ],
      "plane_d": -1711.3134765625,
      "bbox_min": [
        -277.177734375,
        -2241.943603515625,
        657.0
      ],
      "bbox_max": [
        -264.6871337890625,
        -2236.531982421875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1779.7877197265625,
      "bbox_min": [
        -277.177734375,
        -2241.943603515625,
        657.0
      ],
      "bbox_max": [
        -275.056396484375,
        -2239.822265625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2141.90966796875,
      "bbox_min": [
        -267.919189453125,
        -2237.1748046875,
        658.5
      ],
      "bbox_max": [
        -264.6871337890625,
        -2236.531982421875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1951041966676712,
        -0.9807825088500977,
        0.0
      ],
      "plane_d": -2141.90966796875,
      "bbox_min": [
        -267.919189453125,
        -2237.1748046875,
        658.5
      ],
      "bbox_max": [
        -259.5,
        -2235.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4252528250217438,
        -0.6364519596099854,
        -0.6434974074363708
      ],
      "plane_d": -886.1778564453125,
      "bbox_min": [
        -281.46978759765625,
        -2250.155029296875,
        649.0
      ],
      "bbox_max": [
        -259.5,
        -2232.5,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1779.7877197265625,
      "bbox_min": [
        -277.177734375,
        -2241.034423828125,
        655.0
      ],
      "bbox_max": [
        -275.9655456542969,
        -2239.822265625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14933623373508453,
        -0.7507426738739014,
        -0.64349365234375
      ],
      "plane_d": -1215.7918701171875,
      "bbox_min": [
        -281.46978759765625,
        -2250.155029296875,
        649.0
      ],
      "bbox_max": [
        -259.5,
        -2232.5,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1392.0706787109375,
      "bbox_min": [
        -281.46978759765625,
        -2250.155029296875,
        649.0
      ],
      "bbox_max": [
        -281.401611328125,
        -2250.0869140625,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826833665370941,
        -0.9238795638084412,
        -0.0
      ],
      "plane_d": -2184.8564453125,
      "bbox_min": [
        -360.263671875,
        -2364.061767578125,
        641.0
      ],
      "bbox_max": [
        -195.5,
        -2172.2568359375,
        750.515380859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        -360.263671875,
        -2235.636962890625,
        641.0
      ],
      "bbox_max": [
        -312.0,
        -2172.2568359375,
        656.5740966796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49991968274116516,
        -0.8660717606544495,
        0.0
      ],
      "plane_d": -1702.6748046875,
      "bbox_min": [
        -360.263671875,
        -2173.639892578125,
        654.0
      ],
      "bbox_max": [
        -358.63592529296875,
        -2172.2568359375,
        656.5740966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        -360.263671875,
        -2173.639892578125,
        654.0
      ],
      "bbox_max": [
        -358.63592529296875,
        -2172.2568359375,
        654.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9079718589782715,
        0.41903114318847656,
        0.0
      ],
      "plane_d": 1229.4326171875,
      "bbox_min": [
        -328.39990234375,
        -2235.636962890625,
        641.0
      ],
      "bbox_max": [
        -312.0,
        -2216.699951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2229.837890625,
        641.0
      ],
      "bbox_max": [
        -326.0,
        -2227.60009765625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -327.5,
        -2220.5,
        651.0
      ],
      "bbox_max": [
        -325.60491943359375,
        -2218.606689453125,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 651.0,
      "bbox_min": [
        -327.0,
        -2220.5,
        651.0
      ],
      "bbox_max": [
        -321.800048828125,
        -2216.699951171875,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4385019838809967,
        -0.7758143544197083,
        -0.4536828398704529
      ],
      "plane_d": -1283.910888671875,
      "bbox_min": [
        -328.39990234375,
        -2235.636962890625,
        651.0
      ],
      "bbox_max": [
        -312.0,
        -2217.199951171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -315.9515075683594,
        -2235.636962890625,
        652.0
      ],
      "bbox_max": [
        -312.0,
        -2234.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -259.15283203125,
      "bbox_min": [
        -326.68756103515625,
        -2364.061767578125,
        641.0
      ],
      "bbox_max": [
        -195.5,
        -2229.837890625,
        750.515380859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -259.15283203125,
        -2364.061767578125,
        641.0
      ],
      "bbox_max": [
        -195.5,
        -2313.5,
        750.515380859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -255.0,
      "bbox_min": [
        -259.15283203125,
        -2331.5,
        641.0
      ],
      "bbox_max": [
        -226.8314208984375,
        -2313.5,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 649.2000122070312,
      "bbox_min": [
        -255.0,
        -2331.5,
        641.0
      ],
      "bbox_max": [
        -226.8314208984375,
        -2313.5,
        649.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -245.0,
      "bbox_min": [
        -255.0,
        -2331.5,
        641.0
      ],
      "bbox_max": [
        -226.8314208984375,
        -2313.5,
        649.2000122070312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        -245.0,
        -2331.5,
        641.0
      ],
      "bbox_max": [
        -226.8314208984375,
        -2314.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": -1508.3712158203125,
      "bbox_min": [
        -245.0,
        -2331.5,
        641.0
      ],
      "bbox_max": [
        -226.8314208984375,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2314.0,
      "bbox_min": [
        -245.0,
        -2331.5,
        641.0
      ],
      "bbox_max": [
        -227.31687927246094,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": -2255.843505859375,
      "bbox_min": [
        -245.0,
        -2331.5,
        641.0
      ],
      "bbox_max": [
        -229.36236572265625,
        -2314.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 243.39990234375,
      "bbox_min": [
        -245.0,
        -2331.5,
        641.0
      ],
      "bbox_max": [
        -236.33673095703125,
        -2314.0,
        648.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2325.0,
      "bbox_min": [
        -245.0,
        -2325.0,
        641.0
      ],
      "bbox_max": [
        -243.39990234375,
        -2320.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2320.0,
      "bbox_min": [
        -245.0,
        -2320.0,
        641.0
      ],
      "bbox_max": [
        -243.39990234375,
        -2320.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": 2271.82763671875,
      "bbox_min": [
        -243.39990234375,
        -2331.5,
        641.0
      ],
      "bbox_max": [
        -236.33673095703125,
        -2329.0,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2331.5,
      "bbox_min": [
        -243.39990234375,
        -2331.5,
        641.0
      ],
      "bbox_max": [
        -240.62411499023438,
        -2331.142822265625,
        644.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": 1524.355224609375,
      "bbox_min": [
        -243.39990234375,
        -2331.5,
        641.0
      ],
      "bbox_max": [
        -242.6696014404297,
        -2331.142822265625,
        641.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2331.5,
      "bbox_min": [
        -255.0,
        -2331.5,
        641.0
      ],
      "bbox_max": [
        -245.0,
        -2331.5,
        649.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        -259.15283203125,
        -2331.5,
        641.0
      ],
      "bbox_max": [
        -255.0,
        -2313.5,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5731114149093628,
        0.8194774389266968,
        -0.0
      ],
      "plane_d": 2056.755126953125,
      "bbox_min": [
        -259.15283203125,
        -2331.5,
        641.0
      ],
      "bbox_max": [
        -255.0,
        -2313.5,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38271352648735046,
        -0.9238670468330383,
        -0.0
      ],
      "plane_d": -2237.682861328125,
      "bbox_min": [
        -259.15283203125,
        -2319.005126953125,
        641.0
      ],
      "bbox_max": [
        -255.0,
        -2313.5,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5747867226600647,
        -0.8183032274246216,
        0.0
      ],
      "plane_d": -1746.5738525390625,
      "bbox_min": [
        -257.640869140625,
        -2315.35498046875,
        641.0
      ],
      "bbox_max": [
        -255.0,
        -2313.5,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -259.15283203125,
        -2319.005126953125,
        652.0
      ],
      "bbox_max": [
        -257.640869140625,
        -2314.728759765625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238755106925964,
        -0.38269320130348206,
        0.0
      ],
      "plane_d": -648.0425415039062,
      "bbox_min": [
        -259.15283203125,
        -2319.005126953125,
        652.0
      ],
      "bbox_max": [
        -257.640869140625,
        -2315.35498046875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2364.061767578125,
        721.0234985351562
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        750.515380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2362.31298828125,
        721.0234985351562
      ],
      "bbox_max": [
        -210.5,
        -2360.5,
        724.837158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        -0.3826833665370941,
        0.0
      ],
      "plane_d": -1113.9117431640625,
      "bbox_min": [
        -326.68756103515625,
        -2333.210205078125,
        641.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2229.837890625,
        716.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -268.111572265625,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -260.849609375,
        -2263.512939453125,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -268.111572265625,
        -2280.831298828125,
        649.0
      ],
      "bbox_max": [
        -260.849609375,
        -2263.512939453125,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238795638084412,
        0.3826833665370941,
        0.0
      ],
      "plane_d": 644.0186157226562,
      "bbox_min": [
        -326.68756103515625,
        -2333.210205078125,
        641.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2229.837890625,
        692.8920288085938
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -267.07666015625,
        -2328.595703125,
        641.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2311.052490234375,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        -262.233154296875,
        -2328.595703125,
        652.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2319.005126953125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238755106925964,
        -0.38269320130348206,
        0.0
      ],
      "plane_d": -648.0425415039062,
      "bbox_min": [
        -262.233154296875,
        -2328.595703125,
        652.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2319.005126953125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5731114149093628,
        0.8194774389266968,
        -0.0
      ],
      "plane_d": 2056.755126953125,
      "bbox_min": [
        -262.233154296875,
        -2328.595703125,
        652.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2326.44140625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38267284631729126,
        0.9238839149475098,
        -0.0
      ],
      "plane_d": 2249.711181640625,
      "bbox_min": [
        -265.004638671875,
        -2326.44140625,
        641.0
      ],
      "bbox_max": [
        -262.233154296875,
        -2325.29345703125,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38260337710380554,
        0.9239127039909363,
        0.0
      ],
      "plane_d": 2252.759765625,
      "bbox_min": [
        -267.07666015625,
        -2328.06494140625,
        641.0
      ],
      "bbox_max": [
        -266.15283203125,
        -2327.682373046875,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238551259040833,
        0.382742315530777,
        0.0
      ],
      "plane_d": 645.161376953125,
      "bbox_min": [
        -260.41259765625,
        -2314.728759765625,
        641.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2311.052490234375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38271352648735046,
        -0.9238670468330383,
        -0.0
      ],
      "plane_d": -2237.682861328125,
      "bbox_min": [
        -260.41259765625,
        -2314.728759765625,
        641.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2314.206787109375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3828117847442627,
        -0.9238263368606567,
        -0.0
      ],
      "plane_d": -2234.6142578125,
      "bbox_min": [
        -260.188232421875,
        -2311.435302734375,
        641.0
      ],
      "bbox_max": [
        -259.264404296875,
        -2311.052490234375,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2238.0,
      "bbox_min": [
        -326.68756103515625,
        -2333.210205078125,
        641.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2229.837890625,
        692.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -326.68756103515625,
        -2238.0,
        641.0
      ],
      "bbox_max": [
        -309.0,
        -2229.837890625,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        652.0
      ],
      "bbox_max": [
        -326.0,
        -2229.837890625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.0,
      "bbox_min": [
        -326.0,
        -2234.0,
        641.0
      ],
      "bbox_max": [
        -326.0,
        -2229.837890625,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2237.0,
      "bbox_min": [
        -312.0,
        -2237.0,
        641.0
      ],
      "bbox_max": [
        -309.0,
        -2237.0,
        652.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47552192211151123,
        -0.8797038793563843,
        -0.0
      ],
      "plane_d": -2146.990234375,
      "bbox_min": [
        -287.443603515625,
        -2333.210205078125,
        641.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2246.958984375,
        692.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4821368455886841,
        -0.19970838725566864,
        -0.853030264377594
      ],
      "plane_d": -31.957632064819336,
      "bbox_min": [
        -287.443603515625,
        -2300.5,
        644.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2246.958984375,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9771250486373901,
        0.0,
        -0.2126655876636505
      ],
      "plane_d": -110.62958526611328,
      "bbox_min": [
        -287.443603515625,
        -2300.5,
        644.0
      ],
      "bbox_max": [
        -259.14990234375,
        -2250.155029296875,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -284.937255859375,
        -2275.35205078125,
        649.0
      ],
      "bbox_max": [
        -263.2077941894531,
        -2250.155029296875,
        657.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1392.0706787109375,
      "bbox_min": [
        -284.937255859375,
        -2253.62255859375,
        649.0
      ],
      "bbox_max": [
        -281.46978759765625,
        -2250.155029296875,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        -0.3826741576194763,
        8.165456529241055e-05
      ],
      "plane_d": -1118.849365234375,
      "bbox_min": [
        -272.26904296875,
        -2298.5,
        644.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2266.290771484375,
        687.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.1950737088918686,
        -0.9807885885238647,
        0.0
      ],
      "plane_d": -2190.687255859375,
      "bbox_min": [
        -272.26904296875,
        -2286.1171875,
        644.0
      ],
      "bbox_max": [
        -259.15283203125,
        -2266.290771484375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.0,
      "bbox_min": [
        -272.26904296875,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -260.9382629394531,
        -2266.290771484375,
        657.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -649.0,
      "bbox_min": [
        -272.26904296875,
        -2282.7080078125,
        649.0
      ],
      "bbox_max": [
        -260.9382629394531,
        -2266.290771484375,
        649.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -267.4749755859375,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -262.849853515625,
        -2296.0,
        687.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1795.0328369140625,
      "bbox_min": [
        -287.443603515625,
        -2266.290771484375,
        647.0
      ],
      "bbox_max": [
        -272.26904296875,
        -2250.877197265625,
        652.0241088867188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1392.0706787109375,
      "bbox_min": [
        -284.937255859375,
        -2253.62255859375,
        649.0
      ],
      "bbox_max": [
        -282.19207763671875,
        -2250.87744140625,
        651.1942749023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1458.1033935546875,
      "bbox_min": [
        -271.140625,
        -2333.210205078125,
        641.0
      ],
      "bbox_max": [
        -262.849853515625,
        -2296.0,
        690.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 687.5,
      "bbox_min": [
        -269.5498046875,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -262.849853515625,
        -2296.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2298.5,
      "bbox_min": [
        -268.1064453125,
        -2298.5,
        687.5
      ],
      "bbox_max": [
        -262.849853515625,
        -2298.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08373019099235535,
        0.9710349440574646,
        0.22378645837306976
      ],
      "plane_d": 1966.399658203125,
      "bbox_min": [
        -369.92108154296875,
        -2166.21435546875,
        641.0
      ],
      "bbox_max": [
        -108.95764923095703,
        -2143.24560546875,
        662.9379272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999701976776123,
        -0.8660271167755127,
        -5.528108886210248e-06
      ],
      "plane_d": -1674.5467529296875,
      "bbox_min": [
        -369.92108154296875,
        -2147.172607421875,
        641.0
      ],
      "bbox_max": [
        -363.3061828613281,
        -2143.24560546875,
        662.9379272460938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8617133498191833,
        -0.49754413962364197,
        -0.09949871897697449
      ],
      "plane_d": -1316.8052978515625,
      "bbox_min": [
        -364.6617126464844,
        -2144.13623046875,
        641.0
      ],
      "bbox_max": [
        -364.513427734375,
        -2143.24560546875,
        645.5458374023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -468.130615234375,
        -2210.680419921875,
        618.412841796875
      ],
      "bbox_max": [
        70.50594329833984,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.13389118015766144,
        -0.9908052682876587,
        -0.019443459808826447
      ],
      "plane_d": -1950.33837890625,
      "bbox_min": [
        -215.28790283203125,
        -2026.14208984375,
        667.627197265625
      ],
      "bbox_max": [
        68.57462310791016,
        -1920.0,
        797.1386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -215.28790283203125,
        -1936.797119140625,
        754.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -170.0,
        -1936.797119140625,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1932.8519287109375,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 184.0,
      "bbox_min": [
        -184.0,
        -1932.8519287109375,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13131414353847504,
        -0.8612962365150452,
        0.4908413887023926
      ],
      "plane_d": -2058.27392578125,
      "bbox_min": [
        -99.61474609375,
        -2026.14208984375,
        667.627197265625
      ],
      "bbox_max": [
        68.57462310791016,
        -1968.943359375,
        797.1386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46316424012184143,
        -0.7446286082267761,
        -0.4806317985057831
      ],
      "plane_d": -1112.9168701171875,
      "bbox_min": [
        -99.61474609375,
        -2026.14208984375,
        667.627197265625
      ],
      "bbox_max": [
        68.57462310791016,
        -1968.943359375,
        797.1386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        -99.61474609375,
        -2016.3717041015625,
        667.627197265625
      ],
      "bbox_max": [
        64.07967376708984,
        -1968.943359375,
        722.7684936523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6143797636032104,
        -0.7540411949157715,
        -0.23229148983955383
      ],
      "plane_d": -1301.553955078125,
      "bbox_min": [
        52.6015625,
        -2000.97314453125,
        708.733642578125
      ],
      "bbox_max": [
        64.07967376708984,
        -1989.6007080078125,
        722.7684936523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6409735679626465,
        -0.767240583896637,
        -0.02224147506058216
      ],
      "plane_d": -1476.856689453125,
      "bbox_min": [
        52.6015625,
        -1997.8653564453125,
        708.733642578125
      ],
      "bbox_max": [
        62.469017028808594,
        -1989.6007080078125,
        716.9403686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.086369089782238,
        0.9781539440155029,
        0.18909035623073578
      ],
      "plane_d": 2005.18896484375,
      "bbox_min": [
        -468.130615234375,
        -2210.680419921875,
        618.412841796875
      ],
      "bbox_max": [
        70.50594329833984,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -431.97802734375,
        -2205.357421875,
        639.28125
      ],
      "bbox_max": [
        -124.02082061767578,
        -2135.450927734375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -431.97802734375,
        -2197.67236328125,
        639.28125
      ],
      "bbox_max": [
        -124.02082061767578,
        -2135.450927734375,
        854.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -267.8814392089844,
        -2192.99853515625,
        825.0
      ],
      "bbox_max": [
        -197.5,
        -2186.18994140625,
        854.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -375.0731201171875,
      "bbox_min": [
        -267.8814392089844,
        -2189.648681640625,
        825.0
      ],
      "bbox_max": [
        -263.5,
        -2186.18994140625,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9444968104362488,
        -0.0,
        0.32852062582969666
      ],
      "plane_d": -22.15460205078125,
      "bbox_min": [
        -266.188720703125,
        -2187.44677734375,
        825.0
      ],
      "bbox_max": [
        -263.5,
        -2186.18994140625,
        832.7301025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -267.8814392089844,
        -2189.648681640625,
        836.5
      ],
      "bbox_max": [
        -267.6045837402344,
        -2188.050537109375,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999701976776123,
        -0.8660271167755127,
        -5.528108886210248e-06
      ],
      "plane_d": -1674.5467529296875,
      "bbox_min": [
        -431.97802734375,
        -2147.656005859375,
        639.28125
      ],
      "bbox_max": [
        -357.38592529296875,
        -2135.450927734375,
        665.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8617133498191833,
        -0.49754413962364197,
        -0.09949871897697449
      ],
      "plane_d": -1316.8052978515625,
      "bbox_min": [
        -431.97802734375,
        -2144.408935546875,
        639.28125
      ],
      "bbox_max": [
        -364.6510314941406,
        -2135.450927734375,
        651.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -431.97802734375,
        -2143.24560546875,
        639.28125
      ],
      "bbox_max": [
        -364.6510314941406,
        -2135.450927734375,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -365.06195068359375,
        -2143.24560546875,
        641.0
      ],
      "bbox_max": [
        -364.6510314941406,
        -2143.04296875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -369.8477478027344,
        -2147.656005859375,
        641.0
      ],
      "bbox_max": [
        -357.38592529296875,
        -2142.0126953125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7727664709091187,
        0.44615715742111206,
        -0.45141535997390747
      ],
      "plane_d": 1543.02392578125,
      "bbox_min": [
        -369.8477478027344,
        -2147.656005859375,
        662.9379272460938
      ],
      "bbox_max": [
        -368.33984375,
        -2146.60888671875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -468.130615234375,
        -2210.680419921875,
        618.412841796875
      ],
      "bbox_max": [
        70.50594329833984,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -431.5350646972656,
        -2194.61083984375,
        639.28125
      ],
      "bbox_max": [
        -229.9622802734375,
        -2073.484619140625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -431.5350646972656,
        -2193.82470703125,
        639.28125
      ],
      "bbox_max": [
        -229.9622802734375,
        -2078.143798828125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -390.1484375,
        -2193.82470703125,
        639.9999389648438
      ],
      "bbox_max": [
        -229.9622802734375,
        -2111.903076171875,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -272.8636169433594,
        -2193.82470703125,
        821.0
      ],
      "bbox_max": [
        -231.81451416015625,
        -2179.781982421875,
        861.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -269.2121276855469,
        -2181.5,
        821.0
      ],
      "bbox_max": [
        -254.15249633789062,
        -2179.781982421875,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -254.73513793945312,
        -2179.781982421875,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -272.8636169433594,
        -2193.82470703125,
        825.0
      ],
      "bbox_max": [
        -255.84568786621094,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927337765693665,
        0.0,
        -0.12033136934041977
      ],
      "plane_d": 366.3939514160156,
      "bbox_min": [
        -267.5,
        -2187.44677734375,
        835.0494384765625
      ],
      "bbox_max": [
        -266.0673522949219,
        -2182.4697265625,
        849.8194580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 267.5,
      "bbox_min": [
        -267.5,
        -2187.44677734375,
        835.0494384765625
      ],
      "bbox_max": [
        -266.9954528808594,
        -2182.4697265625,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9444968104362488,
        -0.0,
        0.32852062582969666
      ],
      "plane_d": -22.15460205078125,
      "bbox_min": [
        -267.6540832519531,
        -2188.336181640625,
        825.0
      ],
      "bbox_max": [
        -263.5,
        -2181.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -267.61553955078125,
        -2188.11376953125,
        836.5
      ],
      "bbox_max": [
        -267.5,
        -2187.44677734375,
        836.8322143554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 267.5,
      "bbox_min": [
        -267.6540832519531,
        -2188.336181640625,
        836.5
      ],
      "bbox_max": [
        -267.5,
        -2186.3974609375,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -267.6540832519531,
        -2188.336181640625,
        836.5
      ],
      "bbox_max": [
        -267.5,
        -2187.44677734375,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -390.1484375,
        -2146.03662109375,
        639.9999389648438
      ],
      "bbox_max": [
        -314.135009765625,
        -2111.903076171875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.1881934319244465e-06,
        4.155281203566119e-06,
        1.0
      ],
      "plane_d": -639.989990234375,
      "bbox_min": [
        -390.1484375,
        -2146.03662109375,
        639.9999389648438
      ],
      "bbox_max": [
        -357.16650390625,
        -2116.482421875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999828040599823,
        -0.8660353422164917,
        -2.6044453989015892e-06
      ],
      "plane_d": -1674.571533203125,
      "bbox_min": [
        -379.109375,
        -2146.03662109375,
        640.0
      ],
      "bbox_max": [
        -357.16650390625,
        -2128.060546875,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.49997738003730774,
        -0.86603844165802,
        0.0
      ],
      "plane_d": -1658.581787109375,
      "bbox_min": [
        -379.109375,
        -2134.00244140625,
        640.0
      ],
      "bbox_max": [
        -370.44921875,
        -2128.060546875,
        653.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.86605304479599,
        0.49995216727256775,
        0.0
      ],
      "plane_d": 1393.328125,
      "bbox_min": [
        -378.614013671875,
        -2133.052490234375,
        640.0
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        649.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.86605304479599,
        -0.49995216727256775,
        -0.0
      ],
      "plane_d": -1387.3282470703125,
      "bbox_min": [
        -373.41796875,
        -2130.052490234375,
        640.0
      ],
      "bbox_max": [
        -372.26806640625,
        -2128.060546875,
        649.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.0,
      "bbox_min": [
        -360.98345947265625,
        -2142.249755859375,
        641.0
      ],
      "bbox_max": [
        -358.2976379394531,
        -2140.908935546875,
        641.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -419.1666564941406,
        -2194.61083984375,
        639.28125
      ],
      "bbox_max": [
        -233.3797149658203,
        -2073.484619140625,
        861.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -251.56141662597656,
        -2179.60009765625,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -419.1666564941406,
        -2113.5361328125,
        639.28125
      ],
      "bbox_max": [
        -328.260009765625,
        -2073.484619140625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -330.61334228515625,
        -2113.5361328125,
        667.9999389648438
      ],
      "bbox_max": [
        -328.260009765625,
        -2110.559326171875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -273.0,
        -2194.61083984375,
        830.7266845703125
      ],
      "bbox_max": [
        -246.9434814453125,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927337765693665,
        0.0,
        -0.12033136934041977
      ],
      "plane_d": 366.3939514160156,
      "bbox_min": [
        -273.0,
        -2189.02392578125,
        830.7266845703125
      ],
      "bbox_max": [
        -265.49188232421875,
        -2181.5,
        854.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -273.0,
        -2189.02392578125,
        832.9719848632812
      ],
      "bbox_max": [
        -265.5,
        -2181.5,
        854.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783715009689331,
        -0.16948629915714264,
        -0.11859048902988434
      ],
      "plane_d": -9.649063110351562,
      "bbox_min": [
        -266.0673522949219,
        -2189.02392578125,
        849.8194580078125
      ],
      "bbox_max": [
        -265.5,
        -2187.44677734375,
        854.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9444968104362488,
        -0.0,
        0.32852062582969666
      ],
      "plane_d": -22.15460205078125,
      "bbox_min": [
        -268.1094665527344,
        -2183.27490234375,
        830.7266845703125
      ],
      "bbox_max": [
        -265.49188232421875,
        -2181.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -268.1094665527344,
        -2181.5,
        830.7266845703125
      ],
      "bbox_max": [
        -265.49188232421875,
        -2181.5,
        836.5323486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -300.0,
        -2018.70361328125,
        635.0
      ],
      "bbox_max": [
        14.773176193237305,
        -1895.00830078125,
        862.176513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.021437248215079308,
        -0.8702447414398193,
        0.49215301871299744
      ],
      "plane_d": -2067.314453125,
      "bbox_min": [
        -300.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -170.0,
        -1895.00830078125,
        862.176513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 765.0,
      "bbox_min": [
        -300.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -170.0,
        -1944.1578369140625,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1936.2301025390625,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -286.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -184.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -286.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -187.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -286.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -275.0,
        -1920.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1952.72265625,
        754.0
      ],
      "bbox_max": [
        -275.0,
        -1920.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -275.0,
        -1952.92919921875,
        754.0
      ],
      "bbox_max": [
        -187.0,
        -1920.0,
        765.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -272.0,
        -1952.92919921875,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1920.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 184.0,
      "bbox_min": [
        -187.0,
        -1951.7657470703125,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1931.6046142578125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -187.0,
        -1951.7657470703125,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1931.7392578125,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        692.1473388671875
      ],
      "bbox_max": [
        -187.0,
        -1979.3470458984375,
        705.5819702148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -188.31881713867188,
        -1987.0,
        700.22021484375
      ],
      "bbox_max": [
        -187.0,
        -1987.0,
        700.4097900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -170.0,
        -1954.15869140625,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1941.3096923828125,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1981.5091552734375,
        710.8372192382812
      ],
      "bbox_max": [
        -184.0,
        -1945.2628173828125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 184.0,
      "bbox_min": [
        -184.0,
        -1958.9871826171875,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1945.2628173828125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25527524948120117,
        0.9336197376251221,
        0.25137388706207275
      ],
      "plane_d": 1895.1923828125,
      "bbox_min": [
        -468.130615234375,
        -2210.680419921875,
        618.412841796875
      ],
      "bbox_max": [
        70.50594329833984,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -253.8267364501953,
        -2194.787109375,
        820.5801391601562
      ],
      "bbox_max": [
        -228.36619567871094,
        -2186.518310546875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -237.45729064941406,
        -2189.13232421875,
        825.0
      ],
      "bbox_max": [
        -230.1781005859375,
        -2187.141845703125,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.8987833261489868,
        0.38741838932037354
      ],
      "plane_d": -1978.563232421875,
      "bbox_min": [
        -468.130615234375,
        -2210.680419921875,
        618.412841796875
      ],
      "bbox_max": [
        70.50594329833984,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -361.6381530761719,
        -1939.0,
        798.0972900390625
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        896.2352294921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -361.6381530761719,
        -1939.0,
        798.0972900390625
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        818.5177001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -361.6381530761719,
        -1939.0,
        798.0972900390625
      ],
      "bbox_max": [
        -360.0,
        -1939.0,
        800.2208251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995802164078,
        -0.02905004657804966,
        0.9984686374664307
      ],
      "plane_d": -717.8628540039062,
      "bbox_min": [
        -418.1611022949219,
        -2112.143798828125,
        639.28125
      ],
      "bbox_max": [
        -246.357421875,
        -2021.324462890625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -413.2454833984375,
        -2077.516357421875,
        639.28125
      ],
      "bbox_max": [
        -246.357421875,
        -2043.1973876953125,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -413.2454833984375,
        -2077.516357421875,
        639.28125
      ],
      "bbox_max": [
        -405.8373718261719,
        -2068.68115234375,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30801334977149963,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -418.1611022949219,
        -2112.143798828125,
        639.28125
      ],
      "bbox_max": [
        -277.33551025390625,
        -2021.324462890625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -418.1611022949219,
        -2112.143798828125,
        639.28125
      ],
      "bbox_max": [
        -277.33551025390625,
        -2027.576171875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -304.71929931640625,
        -2067.337890625,
        645.7384643554688
      ],
      "bbox_max": [
        -277.33551025390625,
        -2035.7083740234375,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -418.1611022949219,
        -2112.143798828125,
        639.28125
      ],
      "bbox_max": [
        -329.3607177734375,
        -2069.01513671875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -418.1611022949219,
        -2091.495361328125,
        639.28125
      ],
      "bbox_max": [
        -345.68505859375,
        -2069.01513671875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        -0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -351.123291015625,
        -2091.495361328125,
        667.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.9896844625473022
      ],
      "plane_d": -646.744384765625,
      "bbox_min": [
        -246.357421875,
        -2163.4716796875,
        621.826171875
      ],
      "bbox_max": [
        -83.20115661621094,
        -2070.70849609375,
        661.6588745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16232053935527802,
        0.6113412380218506,
        0.7745410203933716
      ],
      "plane_d": 836.6253051757812,
      "bbox_min": [
        -163.181640625,
        -2163.4716796875,
        621.826171875
      ],
      "bbox_max": [
        -83.20115661621094,
        -2097.310302734375,
        661.6588745117188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.137159526348114,
        -0.01990017108619213,
        0.9903489947319031
      ],
      "plane_d": -646.2860107421875,
      "bbox_min": [
        -119.778564453125,
        -2136.7275390625,
        621.826171875
      ],
      "bbox_max": [
        -83.20115661621094,
        -2097.310302734375,
        628.0859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -119.778564453125,
        -2130.586669921875,
        623.8667602539062
      ],
      "bbox_max": [
        -101.89482116699219,
        -2130.282470703125,
        626.3668212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -119.778564453125,
        -2136.7275390625,
        623.885009765625
      ],
      "bbox_max": [
        -101.90265655517578,
        -2130.282470703125,
        628.0859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794832468032837,
        -0.8249639868736267,
        0.4013371169567108
      ],
      "plane_d": -1778.380859375,
      "bbox_min": [
        -468.130615234375,
        -2210.680419921875,
        618.412841796875
      ],
      "bbox_max": [
        70.50594329833984,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.47035738825798035,
        -0.7688683271408081,
        0.4331344962120056
      ],
      "plane_d": -1666.1329345703125,
      "bbox_min": [
        -407.1495056152344,
        -1972.0,
        710.3526000976562
      ],
      "bbox_max": [
        -334.72802734375,
        -1935.0213623046875,
        811.334228515625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -407.1495056152344,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1946.408935546875,
        792.2772827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -407.1495056152344,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1946.408935546875,
        792.2772827148438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -407.1495056152344,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -404.5986328125,
        -1972.0,
        781.3291625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -375.3880310058594,
        -1957.9093017578125,
        778.7999267578125
      ],
      "bbox_max": [
        -355.6596984863281,
        -1935.0213623046875,
        811.334228515625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -360.0,
        -1939.0,
        799.3532104492188
      ],
      "bbox_max": [
        -355.6596984863281,
        -1935.0213623046875,
        806.2848510742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -430.0,
        -2210.680419921875,
        765.0
      ],
      "bbox_max": [
        70.50594329833984,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -430.0,
        -2210.680419921875,
        857.0
      ],
      "bbox_max": [
        -68.068359375,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -430.0,
        -2210.680419921875,
        861.0
      ],
      "bbox_max": [
        -73.71693420410156,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1938.9998779296875,
      "bbox_min": [
        -430.0,
        -1970.16650390625,
        861.0
      ],
      "bbox_max": [
        -348.0,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -367.6210021972656,
        -1939.0,
        861.0
      ],
      "bbox_max": [
        -348.0,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -367.6210021972656,
        -1939.0,
        861.0
      ],
      "bbox_max": [
        -348.0,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6160963773727417,
        -0.6721051335334778,
        0.41073092818260193
      ],
      "plane_d": -1456.00390625,
      "bbox_min": [
        -367.6210021972656,
        -1939.0,
        912.0
      ],
      "bbox_max": [
        -348.0,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03390716016292572,
        -0.9992004632949829,
        0.021187448874115944
      ],
      "plane_d": -1915.627197265625,
      "bbox_min": [
        -367.6210021972656,
        -1884.9921875,
        933.0022583007812
      ],
      "bbox_max": [
        -364.4028015136719,
        -1883.9267578125,
        935.8007202148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300138592720032,
        1.3651326298713684e-05,
        -0.8479889631271362
      ],
      "plane_d": 597.7864990234375,
      "bbox_min": [
        -366.27044677734375,
        -1884.9921875,
        933.0022583007812
      ],
      "bbox_max": [
        -364.4028015136719,
        -1883.9267578125,
        933.8439331054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472556471824646,
        -0.03996013477444649,
        -0.5296801328659058
      ],
      "plane_d": 728.06982421875,
      "bbox_min": [
        -364.93896484375,
        -1884.9921875,
        933.0022583007812
      ],
      "bbox_max": [
        -364.4028015136719,
        -1883.9267578125,
        933.8118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1970.16650390625,
        861.0
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        896.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -2210.680419921875,
        861.0
      ],
      "bbox_max": [
        -73.71693420410156,
        -1948.777587890625,
        896.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -89.64111328125,
        -2210.680419921875,
        861.0
      ],
      "bbox_max": [
        -73.71693420410156,
        -2206.524169921875,
        872.276611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -2208.73486328125,
        857.0
      ],
      "bbox_max": [
        -68.068359375,
        -1909.68798828125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        857.0
      ],
      "bbox_max": [
        -348.0,
        -1909.68798828125,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -369.0,
        -1939.0,
        857.0
      ],
      "bbox_max": [
        -348.0,
        -1909.68798828125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -369.0,
        -1939.0,
        857.0
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1939.0,
        857.0
      ],
      "bbox_max": [
        -360.0,
        -1939.0,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -86.32891082763672,
        -2208.73486328125,
        857.0
      ],
      "bbox_max": [
        -68.068359375,
        -2205.0498046875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46316424012184143,
        -0.7446286082267761,
        -0.4806317985057831
      ],
      "plane_d": -1112.9168701171875,
      "bbox_min": [
        -414.0,
        -2208.044677734375,
        765.0
      ],
      "bbox_max": [
        70.50594329833984,
        -1911.4122314453125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -267.3659362792969,
        -2208.044677734375,
        765.0
      ],
      "bbox_max": [
        -14.74359130859375,
        -2181.5,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -267.3659362792969,
        -2208.044677734375,
        819.7821655273438
      ],
      "bbox_max": [
        -16.371803283691406,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -267.3659362792969,
        -2192.017578125,
        825.0
      ],
      "bbox_max": [
        -197.5,
        -2181.5,
        854.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9927337765693665,
        0.0,
        -0.12033136934041977
      ],
      "plane_d": 366.3939514160156,
      "bbox_min": [
        -267.3659362792969,
        -2186.631591796875,
        839.1060791015625
      ],
      "bbox_max": [
        -265.5,
        -2181.5,
        854.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -74.22229766845703,
        -2201.62353515625,
        765.0
      ],
      "bbox_max": [
        -14.74359130859375,
        -2191.036376953125,
        820.3914184570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1911.4122314453125,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -404.5986328125,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1911.4122314453125,
        857.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 778.7999267578125,
      "bbox_min": [
        -404.5986328125,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -369.0,
        -1954.8277587890625,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1911.4122314453125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -360.0,
        -1939.0,
        802.4100341796875
      ],
      "bbox_max": [
        -348.0,
        -1911.4122314453125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.685392236249754e-06,
        2.4760717565186496e-07,
        -1.0
      ],
      "plane_d": 778.798095703125,
      "bbox_min": [
        -369.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -349.0,
        -1960.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.44721364974975586,
        0.0
      ],
      "plane_d": 1194.0604248046875,
      "bbox_min": [
        -355.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -349.0,
        -1960.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -366.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -366.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.303213477716781e-06,
        -8.291568519780412e-06,
        -1.0
      ],
      "plane_d": 778.7843627929688,
      "bbox_min": [
        -366.0,
        -1987.0,
        768.5
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.44721364974975586,
        0.0
      ],
      "plane_d": 1194.0604248046875,
      "bbox_min": [
        -349.0,
        -1977.0,
        778.7999267578125
      ],
      "bbox_max": [
        -346.5,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 768.4999389648438,
      "bbox_min": [
        -325.0,
        -1987.0,
        768.5
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 323.0,
      "bbox_min": [
        -323.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1985.60009765625,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 768.4999389648438,
      "bbox_min": [
        -325.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1987.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1309.5618896484375,
      "bbox_min": [
        -180.0,
        -2032.0,
        768.5
      ],
      "bbox_max": [
        -170.0,
        -2022.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1309.5618896484375,
      "bbox_min": [
        -180.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -2022.0,
        768.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -257.3690185546875,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518882870674133
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -468.130615234375,
        -2192.172119140625,
        618.412841796875
      ],
      "bbox_max": [
        69.5562515258789,
        -1947.136962890625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.9896844625473022
      ],
      "plane_d": -646.744384765625,
      "bbox_min": [
        -388.58135986328125,
        -2192.172119140625,
        618.412841796875
      ],
      "bbox_max": [
        69.5562515258789,
        -1947.136962890625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -327.486328125,
        -2079.3271484375,
        618.412841796875
      ],
      "bbox_max": [
        -64.5244140625,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -109.34033203125,
        -2079.3271484375,
        618.412841796875
      ],
      "bbox_max": [
        -64.5244140625,
        -2064.5546875,
        626.2376098632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2071.8154296875,
        618.412841796875
      ],
      "bbox_max": [
        -64.5244140625,
        -2064.5546875,
        626.2376098632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9148070812225342,
        -0.40389132499694824,
        0.0
      ],
      "plane_d": -776.2926025390625,
      "bbox_min": [
        -66.12939453125,
        -2071.8154296875,
        618.412841796875
      ],
      "bbox_max": [
        -64.5244140625,
        -2068.18017578125,
        619.8964233398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.29034423828125,
        -2079.3271484375,
        618.412841796875
      ],
      "bbox_max": [
        -79.672119140625,
        -2066.72607421875,
        626.0420532226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        -0.9238802790641785,
        0.0
      ],
      "plane_d": -1882.1099853515625,
      "bbox_min": [
        -92.5,
        -2075.322998046875,
        618.412841796875
      ],
      "bbox_max": [
        -79.672119140625,
        -2070.1806640625,
        623.6787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2073.7763671875,
        618.5244140625
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        623.6787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -88.2706298828125,
        -2073.7421875,
        618.5244140625
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        623.0339965820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -88.47034454345703,
        -2075.322998046875,
        618.5244140625
      ],
      "bbox_max": [
        -88.27062225341797,
        -2073.7421875,
        623.0282592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -107.177978515625,
        -2079.3271484375,
        618.412841796875
      ],
      "bbox_max": [
        -88.4703369140625,
        -2069.026611328125,
        625.8348999023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20443725585938,
        -2079.3271484375,
        618.5244140625
      ],
      "bbox_max": [
        -88.4703369140625,
        -2073.7763671875,
        623.5911254882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -88.93833923339844,
        -2079.02734375,
        618.5244140625
      ],
      "bbox_max": [
        -88.4703369140625,
        -2075.322998046875,
        623.0239868164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30801334977149963,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -327.486328125,
        -2027.576171875,
        644.844482421875
      ],
      "bbox_max": [
        -309.987548828125,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995802164078,
        -0.02905004657804966,
        0.9984686374664307
      ],
      "plane_d": -717.8628540039062,
      "bbox_min": [
        -324.68878173828125,
        -2027.576171875,
        644.844482421875
      ],
      "bbox_max": [
        -309.987548828125,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        -112.20849609375,
        -2081.89990234375,
        618.5244140625
      ],
      "bbox_max": [
        -63.337127685546875,
        -2075.657958984375,
        626.3668212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.75544738769531,
        -2081.89990234375,
        618.5244140625
      ],
      "bbox_max": [
        -88.67304992675781,
        -2076.927490234375,
        623.3858032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -89.30126953125,
        -2081.89990234375,
        618.5244140625
      ],
      "bbox_max": [
        -88.67304992675781,
        -2076.927490234375,
        623.0142211914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -91.7616195678711,
        -2078.974365234375,
        622.9092407226562
      ],
      "bbox_max": [
        -88.6663589477539,
        -2076.87451171875,
        623.4599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30801334977149963,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -327.7740478515625,
        -2021.8822021484375,
        645.6550903320312
      ],
      "bbox_max": [
        -309.987548828125,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30801334977149963,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -388.58135986328125,
        -2032.8753662109375,
        645.7384643554688
      ],
      "bbox_max": [
        -240.59097290039062,
        -2007.10302734375,
        666.47265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -314.21600341796875,
        -2021.4366455078125,
        645.7384643554688
      ],
      "bbox_max": [
        -240.59097290039062,
        -2007.10302734375,
        656.7817993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -314.21600341796875,
        -2014.4228515625,
        645.7384643554688
      ],
      "bbox_max": [
        -296.6871337890625,
        -2007.10302734375,
        656.7817993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -385.0126037597656,
        -2192.172119140625,
        619.3864135742188
      ],
      "bbox_max": [
        69.5562515258789,
        -1947.136962890625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30801334977149963,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -385.0126037597656,
        -2080.27587890625,
        619.3864135742188
      ],
      "bbox_max": [
        -62.7277717590332,
        -2003.9818115234375,
        668.7655639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -316.01904296875,
        -2080.27587890625,
        619.3864135742188
      ],
      "bbox_max": [
        -62.7277717590332,
        -2003.9818115234375,
        661.4907836914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -109.34033203125,
        -2077.03662109375,
        619.7420654296875
      ],
      "bbox_max": [
        -64.5244140625,
        -2064.5546875,
        627.1937866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9148070812225342,
        -0.40389132499694824,
        0.0
      ],
      "plane_d": -776.2926025390625,
      "bbox_min": [
        -109.34033203125,
        -2071.8154296875,
        619.7420654296875
      ],
      "bbox_max": [
        -64.5244140625,
        -2064.5546875,
        627.1937866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2066.72607421875,
        626.0420532226562
      ],
      "bbox_max": [
        -108.29034423828125,
        -2064.5546875,
        627.1937866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        -0.9238802790641785,
        0.0
      ],
      "plane_d": -1882.1099853515625,
      "bbox_min": [
        -108.29034423828125,
        -2077.03662109375,
        621.8704833984375
      ],
      "bbox_max": [
        -79.672119140625,
        -2066.72607421875,
        626.850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -108.29034423828125,
        -2075.28662109375,
        623.0282592773438
      ],
      "bbox_max": [
        -88.0,
        -2066.72607421875,
        626.850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -108.29034423828125,
        -2073.776123046875,
        623.0282592773438
      ],
      "bbox_max": [
        -88.0,
        -2066.72607421875,
        626.850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -88.27063751220703,
        -2073.7421875,
        623.0282592773438
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        623.5809326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.29034423828125,
        -2067.21044921875,
        625.9984130859375
      ],
      "bbox_max": [
        -108.0561294555664,
        -2066.72607421875,
        626.850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -108.0561294555664,
        -2075.28662109375,
        623.5303955078125
      ],
      "bbox_max": [
        -91.9992904663086,
        -2067.21044921875,
        626.7743530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.0561294555664,
        -2069.026611328125,
        625.8348999023438
      ],
      "bbox_max": [
        -107.177978515625,
        -2067.21044921875,
        626.7743530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.2044448852539,
        -2075.28662109375,
        623.5303955078125
      ],
      "bbox_max": [
        -91.9992904663086,
        -2073.776123046875,
        623.9700927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -91.99930572509766,
        -2077.03662109375,
        623.0198364257812
      ],
      "bbox_max": [
        -88.2706298828125,
        -2073.7421875,
        623.8047485351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.99930572509766,
        -2077.03662109375,
        623.4599609375
      ],
      "bbox_max": [
        -91.7616195678711,
        -2075.28662109375,
        623.8047485351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        -112.20849609375,
        -2080.27587890625,
        619.7308349609375
      ],
      "bbox_max": [
        -66.13585662841797,
        -2076.786865234375,
        626.3668212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -91.51126861572266,
        -2079.38818359375,
        623.0130615234375
      ],
      "bbox_max": [
        -88.9316635131836,
        -2078.8798828125,
        623.3885498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.77179718017578,
        -2079.0888671875,
        623.3857421875
      ],
      "bbox_max": [
        -91.48284912109375,
        -2076.961669921875,
        623.6213989257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -316.01904296875,
        -2009.82958984375,
        654.2139892578125
      ],
      "bbox_max": [
        -291.2506103515625,
        -2003.9818115234375,
        661.4907836914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -382.3850402832031,
        -2192.172119140625,
        619.7196044921875
      ],
      "bbox_max": [
        69.5562515258789,
        -1947.136962890625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05980534851551056,
        -0.671236515045166,
        0.7388266921043396
      ],
      "plane_d": -1850.9669189453125,
      "bbox_min": [
        -195.0,
        -2074.71875,
        620.512451171875
      ],
      "bbox_max": [
        -10.330429077148438,
        -1987.0,
        700.3240966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        699.363525390625
      ],
      "bbox_max": [
        -188.31881713867188,
        -1987.0,
        700.3240966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -382.3850402832031,
        -2192.172119140625,
        619.7196044921875
      ],
      "bbox_max": [
        69.5562515258789,
        -1947.136962890625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05980534851551056,
        -0.671236515045166,
        0.7388266921043396
      ],
      "plane_d": -1850.9669189453125,
      "bbox_min": [
        -112.20849609375,
        -2094.86328125,
        619.7196044921875
      ],
      "bbox_max": [
        -55.8358154296875,
        -2032.661865234375,
        667.1800537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2071.8154296875,
        623.4908447265625
      ],
      "bbox_max": [
        -64.5244140625,
        -2064.5546875,
        638.447021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9148070812225342,
        -0.40389132499694824,
        0.0
      ],
      "plane_d": -776.2926025390625,
      "bbox_min": [
        -66.12939453125,
        -2071.8154296875,
        623.4908447265625
      ],
      "bbox_max": [
        -64.5244140625,
        -2068.18017578125,
        631.5252685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        -0.9238802790641785,
        0.0
      ],
      "plane_d": -1882.1099853515625,
      "bbox_min": [
        -107.177978515625,
        -2076.961669921875,
        622.5484008789062
      ],
      "bbox_max": [
        -79.672119140625,
        -2069.026611328125,
        634.208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -107.177978515625,
        -2075.286865234375,
        623.4247436523438
      ],
      "bbox_max": [
        -88.0,
        -2069.026611328125,
        634.208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -92.5,
        -2073.7763671875,
        623.4247436523438
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        630.682861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2073.7763671875,
        623.9700927734375
      ],
      "bbox_max": [
        -92.20442962646484,
        -2071.60009765625,
        630.682861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -107.177978515625,
        -2075.286865234375,
        623.8047485351562
      ],
      "bbox_max": [
        -91.99928283691406,
        -2069.026611328125,
        634.208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -91.99928283691406,
        -2076.961669921875,
        623.2027587890625
      ],
      "bbox_max": [
        -88.2706298828125,
        -2073.7421875,
        628.394287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.99928283691406,
        -2076.961669921875,
        623.6213989257812
      ],
      "bbox_max": [
        -91.77178955078125,
        -2075.28662109375,
        627.2301025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.48284912109375,
        -2079.56591796875,
        623.358154296875
      ],
      "bbox_max": [
        -91.4180679321289,
        -2079.0888671875,
        623.394287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -92.00619506835938,
        -2079.6904296875,
        623.0261840820312
      ],
      "bbox_max": [
        -66.0083236694336,
        -2071.541259765625,
        628.591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.00619506835938,
        -2079.526611328125,
        623.3885498046875
      ],
      "bbox_max": [
        -91.42340850830078,
        -2075.23583984375,
        627.3397827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -67.10551452636719,
        -2071.8154296875,
        628.0410766601562
      ],
      "bbox_max": [
        -66.0083236694336,
        -2071.541259765625,
        628.591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.25300598144531,
        -2081.89990234375,
        623.1181030273438
      ],
      "bbox_max": [
        -89.19314575195312,
        -2080.78125,
        623.4255981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        -0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -959.4097900390625,
      "bbox_min": [
        -109.34033203125,
        -2071.27294921875,
        636.38916015625
      ],
      "bbox_max": [
        -64.5244140625,
        -2061.257080078125,
        651.0582275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2066.72607421875,
        636.38916015625
      ],
      "bbox_max": [
        -108.29034423828125,
        -2064.5546875,
        638.8286743164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        -0.9238802790641785,
        0.0
      ],
      "plane_d": -1882.1099853515625,
      "bbox_min": [
        -108.29034423828125,
        -2081.89990234375,
        623.0509033203125
      ],
      "bbox_max": [
        -79.672119140625,
        -2066.72607421875,
        641.6576538085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -108.29034423828125,
        -2075.28662109375,
        627.2930297851562
      ],
      "bbox_max": [
        -88.0,
        -2066.72607421875,
        638.270751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -108.29034423828125,
        -2073.776123046875,
        628.394287109375
      ],
      "bbox_max": [
        -88.0,
        -2066.72607421875,
        638.270751953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -108.29034423828125,
        -2073.776123046875,
        628.681884765625
      ],
      "bbox_max": [
        -92.20442962646484,
        -2066.72607421875,
        637.2233276367188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.29034423828125,
        -2067.21044921875,
        635.9301147460938
      ],
      "bbox_max": [
        -108.0561294555664,
        -2066.72607421875,
        637.2233276367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -108.0561294555664,
        -2075.28662109375,
        627.2930297851562
      ],
      "bbox_max": [
        -91.99928283691406,
        -2067.21044921875,
        636.865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.0561294555664,
        -2069.026611328125,
        634.208984375
      ],
      "bbox_max": [
        -107.177978515625,
        -2067.21044921875,
        636.865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20443725585938,
        -2075.28662109375,
        627.2930297851562
      ],
      "bbox_max": [
        -91.99928283691406,
        -2073.776123046875,
        635.2988891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -91.99928283691406,
        -2081.89990234375,
        623.0509033203125
      ],
      "bbox_max": [
        -88.2706298828125,
        -2073.7421875,
        636.3485107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        687.8590087890625
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        704.5525512695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        687.8590087890625
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        692.0352783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -382.3850402832031,
        -2192.172119140625,
        621.103271484375
      ],
      "bbox_max": [
        69.5562515258789,
        -1947.136962890625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -286.0,
        -2192.172119140625,
        621.103271484375
      ],
      "bbox_max": [
        69.5562515258789,
        -1947.136962890625,
        765.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -286.0,
        -1987.0,
        692.0352783203125
      ],
      "bbox_max": [
        -184.0,
        -1947.136962890625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -275.0,
        -1951.9654541015625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -275.0,
        -1987.0,
        707.8583984375
      ],
      "bbox_max": [
        -184.0,
        -1947.136962890625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -275.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -187.0,
        -1947.136962890625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -275.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1952.72265625,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -187.0,
        -1958.0234375,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 184.0,
      "bbox_min": [
        -187.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1953.1949462890625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -187.0,
        -1987.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1958.7806396484375,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16232053935527802,
        0.6113412380218506,
        0.7745410203933716
      ],
      "plane_d": 836.6253051757812,
      "bbox_min": [
        -286.0,
        -2192.172119140625,
        621.103271484375
      ],
      "bbox_max": [
        69.5562515258789,
        -1987.0,
        765.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.137159526348114,
        -0.01990017108619213,
        0.9903489947319031
      ],
      "plane_d": -646.2860107421875,
      "bbox_min": [
        -286.0,
        -2192.172119140625,
        621.103271484375
      ],
      "bbox_max": [
        69.5562515258789,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.41665470600128174,
        -0.9090648293495178
      ],
      "plane_d": -143.7080078125,
      "bbox_min": [
        -286.0,
        -2192.172119140625,
        628.5608520507812
      ],
      "bbox_max": [
        69.5562515258789,
        -1987.0,
        765.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 272.0,
      "bbox_min": [
        -286.0,
        -2014.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -286.0,
        -1990.0,
        754.0
      ],
      "bbox_max": [
        -272.0,
        -1987.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 184.0,
      "bbox_min": [
        -198.0,
        -2014.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1987.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.0,
      "bbox_min": [
        -198.0,
        -1990.0,
        754.0
      ],
      "bbox_max": [
        -184.0,
        -1987.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46316424012184143,
        -0.7446286082267761,
        -0.4806317985057831
      ],
      "plane_d": -1112.9168701171875,
      "bbox_min": [
        -109.34033203125,
        -2192.172119140625,
        628.5608520507812
      ],
      "bbox_max": [
        69.5562515258789,
        -2016.7991943359375,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -58.13154220581055,
        -2192.172119140625,
        758.349365234375
      ],
      "bbox_max": [
        -51.65239334106445,
        -2191.024658203125,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        -0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -937.260986328125,
      "bbox_min": [
        -109.34033203125,
        -2081.89990234375,
        628.5608520507812
      ],
      "bbox_max": [
        -65.88987731933594,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        -0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": -1186.8843994140625,
      "bbox_min": [
        -109.34033203125,
        -2081.89990234375,
        628.5608520507812
      ],
      "bbox_max": [
        -65.89373779296875,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532886624336243,
        -0.2705933749675751,
        0.7071020007133484
      ],
      "plane_d": -1087.6129150390625,
      "bbox_min": [
        -109.34033203125,
        -2081.89990234375,
        628.5608520507812
      ],
      "bbox_max": [
        -65.89373779296875,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -109.34033203125,
        -2081.89990234375,
        628.5608520507812
      ],
      "bbox_max": [
        -65.89373779296875,
        -2064.5546875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2705991268157959,
        -0.6532875299453735,
        0.7071007490158081
      ],
      "plane_d": -1792.391845703125,
      "bbox_min": [
        -109.34033203125,
        -2071.8154296875,
        637.2233276367188
      ],
      "bbox_max": [
        -65.89373779296875,
        -2064.5546875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2705896496772766,
        -0.6532796025276184,
        0.7071117758750916
      ],
      "plane_d": -1841.240234375,
      "bbox_min": [
        -109.34033203125,
        -2071.8154296875,
        637.2233276367188
      ],
      "bbox_max": [
        -65.89373779296875,
        -2064.5546875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2071.8154296875,
        637.2233276367188
      ],
      "bbox_max": [
        -65.89373779296875,
        -2064.5546875,
        644.2874145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9148070812225342,
        -0.40389132499694824,
        0.0
      ],
      "plane_d": -776.2926025390625,
      "bbox_min": [
        -66.12939453125,
        -2071.8154296875,
        643.7562255859375
      ],
      "bbox_max": [
        -65.89373779296875,
        -2071.28173828125,
        644.2874145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.29034423828125,
        -2081.89990234375,
        628.5608520507812
      ],
      "bbox_max": [
        -79.672119140625,
        -2066.72607421875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -107.177978515625,
        -2081.89990234375,
        628.5608520507812
      ],
      "bbox_max": [
        -79.672119140625,
        -2067.895751953125,
        657.7044067382812
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.3826817274093628,
        -0.9238802790641785,
        0.0
      ],
      "plane_d": -1882.1099853515625,
      "bbox_min": [
        -92.90979766845703,
        -2081.89990234375,
        629.0275268554688
      ],
      "bbox_max": [
        -79.672119140625,
        -2068.582763671875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2705991268157959,
        -0.6532875299453735,
        0.7071007490158081
      ],
      "plane_d": -1792.391845703125,
      "bbox_min": [
        -92.90979766845703,
        -2074.573974609375,
        636.3485107421875
      ],
      "bbox_max": [
        -79.672119140625,
        -2068.582763671875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2705896496772766,
        -0.6532796025276184,
        0.7071117758750916
      ],
      "plane_d": -1841.240234375,
      "bbox_min": [
        -92.90979766845703,
        -2074.573974609375,
        636.3485107421875
      ],
      "bbox_max": [
        -88.0,
        -2068.582763671875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.5,
        -2074.573974609375,
        651.2399291992188
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.20443725585938,
        -2075.28662109375,
        651.2399291992188
      ],
      "bbox_max": [
        -90.27850341796875,
        -2073.776123046875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9921135902404785,
        -0.12534287571907043,
        0.0
      ],
      "plane_d": -172.35430908203125,
      "bbox_min": [
        -91.9992904663086,
        -2081.89990234375,
        629.0275268554688
      ],
      "bbox_max": [
        -88.2706069946289,
        -2073.7421875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.9126664400100708,
        0.4087052345275879
      ],
      "plane_d": -2160.234130859375,
      "bbox_min": [
        -91.385986328125,
        -2081.89990234375,
        636.5319213867188
      ],
      "bbox_max": [
        -89.0361328125,
        -2079.802001953125,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2079.802001953125,
      "bbox_min": [
        -91.385986328125,
        -2081.89990234375,
        641.2166748046875
      ],
      "bbox_max": [
        -89.0361328125,
        -2079.802001953125,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8258352279663086,
        -0.5639114379882812
      ],
      "plane_d": -1353.56982421875,
      "bbox_min": [
        -91.385986328125,
        -2081.89990234375,
        645.4983520507812
      ],
      "bbox_max": [
        -89.0361328125,
        -2079.802001953125,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2081.89990234375,
      "bbox_min": [
        -91.10107421875,
        -2081.89990234375,
        648.5706787109375
      ],
      "bbox_max": [
        -89.30126953125,
        -2081.89990234375,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -107.177978515625,
        -2070.1806640625,
        635.5226440429688
      ],
      "bbox_max": [
        -100.88525390625,
        -2069.026611328125,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        -0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -959.4097900390625,
      "bbox_min": [
        -87.16264343261719,
        -2071.8154296875,
        644.2788696289062
      ],
      "bbox_max": [
        -65.88987731933594,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9148070812225342,
        -0.40389132499694824,
        0.0
      ],
      "plane_d": -776.2926025390625,
      "bbox_min": [
        -66.12939453125,
        -2071.8154296875,
        644.2788696289062
      ],
      "bbox_max": [
        -65.88987731933594,
        -2071.27294921875,
        644.2874145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532716155052185,
        -0.270601361989975,
        0.7071146368980408
      ],
      "plane_d": -969.6830444335938,
      "bbox_min": [
        -87.16264343261719,
        -2070.1806640625,
        652.7044067382812
      ],
      "bbox_max": [
        -75.278564453125,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2705991268157959,
        -0.6532875299453735,
        0.7071007490158081
      ],
      "plane_d": -1792.391845703125,
      "bbox_min": [
        -87.16264343261719,
        -2070.1806640625,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2066.353759765625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2150.5,
      "bbox_min": [
        -101.5,
        -2153.473388671875,
        646.683837890625
      ],
      "bbox_max": [
        -99.23894500732422,
        -2150.5,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        -101.5,
        -2153.473388671875,
        650.0
      ],
      "bbox_max": [
        -99.23894500732422,
        -2150.5,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070798277854919,
        -0.0,
        -0.7071337699890137
      ],
      "plane_d": 412.4053955078125,
      "bbox_min": [
        -105.278564453125,
        -2171.28857421875,
        652.7044067382812
      ],
      "bbox_max": [
        -81.7981948852539,
        -2135.27197265625,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070798277854919,
        0.0,
        -0.7071337699890137
      ],
      "plane_d": 539.9625244140625,
      "bbox_min": [
        -92.00436401367188,
        -2161.806884765625,
        666.950439453125
      ],
      "bbox_max": [
        -81.7981948852539,
        -2141.683837890625,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 674.4000244140625,
      "bbox_min": [
        -92.00436401367188,
        -2161.806884765625,
        673.400146484375
      ],
      "bbox_max": [
        -88.39550018310547,
        -2141.683837890625,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2144.0,
      "bbox_min": [
        -92.00436401367188,
        -2144.0,
        674.4000244140625
      ],
      "bbox_max": [
        -88.39550018310547,
        -2141.683837890625,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826918601989746,
        -0.9238760471343994,
        -0.0
      ],
      "plane_d": -2013.19921875,
      "bbox_min": [
        -91.19991302490234,
        -2142.130615234375,
        673.400146484375
      ],
      "bbox_max": [
        -89.19995880126953,
        -2141.683837890625,
        674.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.382678747177124,
        -0.923881471157074,
        0.0
      ],
      "plane_d": -1944.1143798828125,
      "bbox_min": [
        -91.19991302490234,
        -2142.0654296875,
        673.478759765625
      ],
      "bbox_max": [
        -90.278564453125,
        -2141.683837890625,
        674.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826918601989746,
        -0.9238760471343994,
        -0.0
      ],
      "plane_d": -2013.19921875,
      "bbox_min": [
        -90.1999282836914,
        -2144.740234375,
        667.4066772460938
      ],
      "bbox_max": [
        -84.2060546875,
        -2141.71630859375,
        675.2044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -742.032958984375,
      "bbox_min": [
        -85.80389404296875,
        -2144.740234375,
        668.3304443359375
      ],
      "bbox_max": [
        -85.1298828125,
        -2143.81640625,
        669.00439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38263943791389465,
        -0.9238977432250977,
        -0.0
      ],
      "plane_d": -2014.2412109375,
      "bbox_min": [
        -85.80389404296875,
        -2144.740234375,
        668.7131958007812
      ],
      "bbox_max": [
        -85.5126953125,
        -2144.61962890625,
        669.00439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2160.0,
      "bbox_min": [
        -105.278564453125,
        -2171.28857421875,
        652.7044067382812
      ],
      "bbox_max": [
        -83.74978637695312,
        -2135.27197265625,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2158.0,
      "bbox_min": [
        -105.278564453125,
        -2160.0,
        652.7044067382812
      ],
      "bbox_max": [
        -83.74978637695312,
        -2135.27197265625,
        675.2044067382812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 94.0,
      "bbox_min": [
        -98.89990234375,
        -2160.0,
        658.8614501953125
      ],
      "bbox_max": [
        -94.0,
        -2158.0,
        675.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7784106135368347,
        0.0,
        -0.6277554631233215
      ],
      "plane_d": 493.06365966796875,
      "bbox_min": [
        -98.89990234375,
        -2160.0,
        658.8614501953125
      ],
      "bbox_max": [
        -94.0,
        -2158.0,
        668.8800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 97.0,
      "bbox_min": [
        -98.89990234375,
        -2160.0,
        658.8614501953125
      ],
      "bbox_max": [
        -97.0,
        -2158.0,
        665.1600341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2158.755859375,
        658.8614501953125
      ],
      "bbox_max": [
        -98.89990234375,
        -2158.0,
        659.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 664.7044067382812,
      "bbox_min": [
        -105.278564453125,
        -2158.0,
        652.7044067382812
      ],
      "bbox_max": [
        -83.74978637695312,
        -2135.27197265625,
        675.2044067382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2158.0,
        664.7044067382812
      ],
      "bbox_max": [
        -83.74978637695312,
        -2141.683837890625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9301387667655945,
        -0.36720818281173706,
        0.0
      ],
      "plane_d": -697.7473754882812,
      "bbox_min": [
        -98.89990234375,
        -2150.65478515625,
        664.7044067382812
      ],
      "bbox_max": [
        -83.74978637695312,
        -2141.683837890625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.382678747177124,
        -0.923881471157074,
        0.0
      ],
      "plane_d": -1944.1143798828125,
      "bbox_min": [
        -96.351318359375,
        -2145.329345703125,
        664.7044067382812
      ],
      "bbox_max": [
        -83.74978637695312,
        -2141.683837890625,
        675.2044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826918601989746,
        -0.9238760471343994,
        -0.0
      ],
      "plane_d": -2013.19921875,
      "bbox_min": [
        -95.427490234375,
        -2145.329345703125,
        664.7044067382812
      ],
      "bbox_max": [
        -83.74978637695312,
        -2141.683837890625,
        673.478759765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -669.00439453125,
      "bbox_min": [
        -95.427490234375,
        -2145.329345703125,
        665.020751953125
      ],
      "bbox_max": [
        -83.74978637695312,
        -2142.06640625,
        669.00439453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238263368606567,
        0.3828117549419403,
        0.0
      ],
      "plane_d": 737.4600219726562,
      "bbox_min": [
        -95.427490234375,
        -2145.329345703125,
        665.020751953125
      ],
      "bbox_max": [
        -83.74978637695312,
        -2142.06640625,
        669.00439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38263943791389465,
        -0.9238977432250977,
        -0.0
      ],
      "plane_d": -2014.2412109375,
      "bbox_min": [
        -89.737548828125,
        -2145.329345703125,
        665.020751953125
      ],
      "bbox_max": [
        -83.74978637695312,
        -2142.066650390625,
        669.00439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238263368606567,
        -0.3828117847442627,
        0.0
      ],
      "plane_d": -742.032958984375,
      "bbox_min": [
        -89.737548828125,
        -2145.329345703125,
        665.020751953125
      ],
      "bbox_max": [
        -83.74978637695312,
        -2142.066650390625,
        668.7131958007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.3354416043730453e-05,
        -5.639013761538081e-05,
        -1.0
      ],
      "plane_d": 666.7815551757812,
      "bbox_min": [
        -89.737548828125,
        -2144.740234375,
        666.9044189453125
      ],
      "bbox_max": [
        -85.1298828125,
        -2142.066650390625,
        666.9044799804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9272966384887695,
        -0.3743273615837097,
        -0.0
      ],
      "plane_d": -880.7164306640625,
      "bbox_min": [
        -84.2060546875,
        -2145.329345703125,
        665.020751953125
      ],
      "bbox_max": [
        -83.74978637695312,
        -2144.19921875,
        667.4066772460938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9239127039909363,
        -0.38260337710380554,
        0.0
      ],
      "plane_d": -908.3981323242188,
      "bbox_min": [
        -95.427490234375,
        -2144.740478515625,
        666.9044189453125
      ],
      "bbox_max": [
        -90.81982421875,
        -2142.06640625,
        669.00439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9239127039909363,
        0.38260337710380554,
        0.0
      ],
      "plane_d": 903.8248901367188,
      "bbox_min": [
        -91.202392578125,
        -2142.990234375,
        666.9044189453125
      ],
      "bbox_max": [
        -90.81982421875,
        -2142.06640625,
        669.00439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9301387667655945,
        -0.36720818281173706,
        0.0
      ],
      "plane_d": -697.7473754882812,
      "bbox_min": [
        -105.278564453125,
        -2158.0,
        652.7044067382812
      ],
      "bbox_max": [
        -84.37006378173828,
        -2135.27197265625,
        664.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6532719135284424,
        0.2706008851528168,
        0.7071145176887512
      ],
      "plane_d": 51.553009033203125,
      "bbox_min": [
        -105.278564453125,
        -2150.65478515625,
        652.7044067382812
      ],
      "bbox_max": [
        -93.32514190673828,
        -2136.533935546875,
        664.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -100.88525390625,
        -2143.4921875,
        652.7044067382812
      ],
      "bbox_max": [
        -93.32514190673828,
        -2136.533935546875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        659.7044067382812
      ],
      "bbox_max": [
        -95.8794174194336,
        -2143.00390625,
        664.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3681499660015106,
        0.9297664761543274,
        0.0
      ],
      "plane_d": 2036.0167236328125,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        659.7044067382812
      ],
      "bbox_max": [
        -98.89990234375,
        -2150.27197265625,
        664.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 98.89990234375,
      "bbox_min": [
        -98.89990234375,
        -2158.0,
        652.7044067382812
      ],
      "bbox_max": [
        -84.37006378173828,
        -2135.27197265625,
        664.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -98.89990234375,
        -2155.97216796875,
        652.7044067382812
      ],
      "bbox_max": [
        -84.37006378173828,
        -2135.27197265625,
        664.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -95.31521606445312,
        -2141.57470703125,
        652.7044067382812
      ],
      "bbox_max": [
        -86.8844223022461,
        -2135.27197265625,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27060848474502563,
        0.6532667279243469,
        0.7071163654327393
      ],
      "plane_d": 957.7940673828125,
      "bbox_min": [
        -90.278564453125,
        -2140.72119140625,
        652.7044067382812
      ],
      "bbox_max": [
        -86.8844223022461,
        -2135.27197265625,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.382678747177124,
        -0.923881471157074,
        0.0
      ],
      "plane_d": -1944.1143798828125,
      "bbox_min": [
        -96.351318359375,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -84.37006378173828,
        -2139.488525390625,
        664.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -95.8794174194336,
        -2143.00390625,
        656.5999755859375
      ],
      "bbox_max": [
        -87.62838745117188,
        -2139.488525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -90.278564453125,
        -2143.057373046875,
        656.5999755859375
      ],
      "bbox_max": [
        -86.38430786132812,
        -2140.586181640625,
        659.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27060848474502563,
        0.6532667279243469,
        0.7071163654327393
      ],
      "plane_d": 957.7940673828125,
      "bbox_min": [
        -89.07144165039062,
        -2141.867431640625,
        656.5999755859375
      ],
      "bbox_max": [
        -87.30269622802734,
        -2140.586181640625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3907240033149719,
        0.9205079078674316,
        0.0
      ],
      "plane_d": 1937.51904296875,
      "bbox_min": [
        -95.74359130859375,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -92.36495971679688,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9205050468444824,
        -0.3907306492328644,
        -0.0
      ],
      "plane_d": -926.4359741210938,
      "bbox_min": [
        -95.74359130859375,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -92.36495971679688,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9205051064491272,
        0.3907306492328644,
        -0.0
      ],
      "plane_d": 923.93603515625,
      "bbox_min": [
        -95.74359130859375,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -92.36495971679688,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2010255753993988,
        -0.4735967814922333,
        0.8574934005737305
      ],
      "plane_d": -1563.80419921875,
      "bbox_min": [
        -95.74359130859375,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -92.36495971679688,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3907240033149719,
        -0.9205079078674316,
        0.0
      ],
      "plane_d": -1940.01904296875,
      "bbox_min": [
        -95.74359130859375,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -92.36495971679688,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3350380063056946,
        0.7893170714378357,
        0.5145172476768494
      ],
      "plane_d": 1321.49365234375,
      "bbox_min": [
        -95.74359130859375,
        -2145.713623046875,
        660.5999755859375
      ],
      "bbox_max": [
        -93.34178161621094,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33503907918930054,
        -0.789319634437561,
        -0.5145128965377808
      ],
      "plane_d": -1324.4173583984375,
      "bbox_min": [
        -94.76676177978516,
        -2148.014892578125,
        659.0999755859375
      ],
      "bbox_max": [
        -92.36495971679688,
        -2146.80126953125,
        659.5287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3907240033149719,
        -0.9205079078674316,
        0.0
      ],
      "plane_d": -1940.2762451171875,
      "bbox_min": [
        -94.66622161865234,
        -2148.014892578125,
        659.5287475585938
      ],
      "bbox_max": [
        -92.36495971679688,
        -2147.0380859375,
        660.5287475585938
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: odr1",
      "entity_class": "CSlidingDoor",
      "piece_name": "odr1",
      "offset": 854,
      "centroid": [
        -168.5,
        -2313.0001220703125,
        643.0
      ],
      "bbox_min": [
        -171.0,
        -2313.400146484375,
        638.0
      ],
      "bbox_max": [
        -166.0,
        -2312.60009765625,
        648.0
      ],
      "dimensions_source": {
        "span_x": 5.0,
        "span_y": 0.800048828125,
        "height_z": 10.0,
        "door_width": 5.0,
        "door_depth": 0.800048828125,
        "leaf_depth": 0.760048828125,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -171.0,
          -2313.400146484375,
          638.0
        ],
        [
          -171.0,
          -2312.60009765625,
          648.0
        ],
        [
          -171.0,
          -2313.400146484375,
          648.0
        ],
        [
          -171.0,
          -2312.60009765625,
          638.0
        ],
        [
          -166.0,
          -2313.400146484375,
          638.0
        ],
        [
          -166.0,
          -2312.60009765625,
          648.0
        ],
        [
          -166.0,
          -2313.400146484375,
          648.0
        ],
        [
          -166.0,
          -2312.60009765625,
          638.0
        ]
      ],
      "plane_distance": -171.0,
      "authentic_texture": "spkgums1"
    },
    {
      "tag": "CSlidingDoor piece: odr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "odr2",
      "offset": 1911,
      "centroid": [
        -179.5,
        -2313.0001220703125,
        643.0
      ],
      "bbox_min": [
        -182.0,
        -2313.400146484375,
        638.0
      ],
      "bbox_max": [
        -177.0,
        -2312.60009765625,
        648.0
      ],
      "dimensions_source": {
        "span_x": 5.0,
        "span_y": 0.800048828125,
        "height_z": 10.0,
        "door_width": 5.0,
        "door_depth": 0.800048828125,
        "leaf_depth": 0.760048828125,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -182.0,
          -2313.400146484375,
          638.0
        ],
        [
          -182.0,
          -2312.60009765625,
          648.0
        ],
        [
          -182.0,
          -2313.400146484375,
          648.0
        ],
        [
          -182.0,
          -2312.60009765625,
          638.0
        ],
        [
          -177.0,
          -2313.400146484375,
          638.0
        ],
        [
          -177.0,
          -2312.60009765625,
          648.0
        ],
        [
          -177.0,
          -2313.400146484375,
          648.0
        ],
        [
          -177.0,
          -2312.60009765625,
          638.0
        ]
      ],
      "plane_distance": -2313.4001,
      "authentic_texture": "spkdoor1nkd"
    },
    {
      "tag": "CSlidingDoor piece: odr3",
      "entity_class": "CSlidingDoor",
      "piece_name": "odr3",
      "offset": 2968,
      "centroid": [
        -168.5,
        -2332.4000244140625,
        643.0
      ],
      "bbox_min": [
        -171.0,
        -2332.800048828125,
        638.0
      ],
      "bbox_max": [
        -166.0,
        -2332.0,
        648.0
      ],
      "dimensions_source": {
        "span_x": 5.0,
        "span_y": 0.800048828125,
        "height_z": 10.0,
        "door_width": 5.0,
        "door_depth": 0.800048828125,
        "leaf_depth": 0.760048828125,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -171.0,
          -2332.800048828125,
          638.0
        ],
        [
          -171.0,
          -2332.0,
          648.0
        ],
        [
          -171.0,
          -2332.800048828125,
          648.0
        ],
        [
          -171.0,
          -2332.0,
          638.0
        ],
        [
          -166.0,
          -2332.800048828125,
          638.0
        ],
        [
          -166.0,
          -2332.0,
          648.0
        ],
        [
          -166.0,
          -2332.800048828125,
          648.0
        ],
        [
          -166.0,
          -2332.0,
          638.0
        ]
      ],
      "plane_distance": -171.0,
      "authentic_texture": "spkgums1"
    },
    {
      "tag": "CSlidingDoor piece: odr4",
      "entity_class": "CSlidingDoor",
      "piece_name": "odr4",
      "offset": 4025,
      "centroid": [
        -179.5,
        -2332.4000244140625,
        643.0
      ],
      "bbox_min": [
        -182.0,
        -2332.800048828125,
        638.0
      ],
      "bbox_max": [
        -177.0,
        -2332.0,
        648.0
      ],
      "dimensions_source": {
        "span_x": 5.0,
        "span_y": 0.800048828125,
        "height_z": 10.0,
        "door_width": 5.0,
        "door_depth": 0.800048828125,
        "leaf_depth": 0.760048828125,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -182.0,
          -2332.800048828125,
          638.0
        ],
        [
          -182.0,
          -2332.0,
          648.0
        ],
        [
          -182.0,
          -2332.800048828125,
          648.0
        ],
        [
          -182.0,
          -2332.0,
          638.0
        ],
        [
          -177.0,
          -2332.800048828125,
          638.0
        ],
        [
          -177.0,
          -2332.0,
          648.0
        ],
        [
          -177.0,
          -2332.800048828125,
          648.0
        ],
        [
          -177.0,
          -2332.0,
          638.0
        ]
      ],
      "plane_distance": -2332.8,
      "authentic_texture": "spkdoor1nkd"
    },
    {
      "tag": "CSlidingDoor piece: elev3dr1",
      "entity_class": "CSlidingDoor",
      "piece_name": "elev3dr1",
      "offset": 5086,
      "centroid": [
        -203.0,
        -2359.699951171875,
        643.5
      ],
      "bbox_min": [
        -207.0,
        -2360.0,
        638.0
      ],
      "bbox_max": [
        -199.0,
        -2359.39990234375,
        649.0
      ],
      "dimensions_source": {
        "span_x": 8.0,
        "span_y": 0.60009765625,
        "height_z": 11.0,
        "door_width": 8.0,
        "door_depth": 0.60009765625,
        "leaf_depth": 0.56009765625,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -207.0,
          -2360.0,
          638.0
        ],
        [
          -207.0,
          -2359.39990234375,
          649.0
        ],
        [
          -207.0,
          -2360.0,
          649.0
        ],
        [
          -207.0,
          -2359.39990234375,
          638.0
        ],
        [
          -199.0,
          -2360.0,
          638.0
        ],
        [
          -199.0,
          -2359.39990234375,
          649.0
        ],
        [
          -199.0,
          -2360.0,
          649.0
        ],
        [
          -199.0,
          -2359.39990234375,
          638.0
        ]
      ],
      "plane_distance": 638.0,
      "authentic_texture": "spkgums1"
    },
    {
      "tag": "CSlidingDoor piece: elev3dr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "elev3dr2",
      "offset": 6161,
      "centroid": [
        -203.0,
        -2372.300048828125,
        789.5
      ],
      "bbox_min": [
        -207.0,
        -2372.60009765625,
        784.0
      ],
      "bbox_max": [
        -199.0,
        -2372.0,
        795.0
      ],
      "dimensions_source": {
        "span_x": 8.0,
        "span_y": 0.60009765625,
        "height_z": 11.0,
        "door_width": 8.0,
        "door_depth": 0.60009765625,
        "leaf_depth": 0.56009765625,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -207.0,
          -2372.60009765625,
          784.0
        ],
        [
          -207.0,
          -2372.0,
          795.0
        ],
        [
          -207.0,
          -2372.60009765625,
          795.0
        ],
        [
          -207.0,
          -2372.0,
          784.0
        ],
        [
          -199.0,
          -2372.60009765625,
          784.0
        ],
        [
          -199.0,
          -2372.0,
          795.0
        ],
        [
          -199.0,
          -2372.60009765625,
          795.0
        ],
        [
          -199.0,
          -2372.0,
          784.0
        ]
      ],
      "plane_distance": 784.0,
      "authentic_texture": "spkgums1"
    },
    {
      "tag": "CSlidingDoor piece: elev3dr3",
      "entity_class": "CSlidingDoor",
      "piece_name": "elev3dr3",
      "offset": 7236,
      "centroid": [
        -203.0,
        -2359.699951171875,
        830.5
      ],
      "bbox_min": [
        -207.0,
        -2360.0,
        825.0
      ],
      "bbox_max": [
        -199.0,
        -2359.39990234375,
        836.0
      ],
      "dimensions_source": {
        "span_x": 8.0,
        "span_y": 0.60009765625,
        "height_z": 11.0,
        "door_width": 8.0,
        "door_depth": 0.60009765625,
        "leaf_depth": 0.56009765625,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -207.0,
          -2360.0,
          825.0
        ],
        [
          -207.0,
          -2359.39990234375,
          836.0
        ],
        [
          -207.0,
          -2360.0,
          836.0
        ],
        [
          -207.0,
          -2359.39990234375,
          825.0
        ],
        [
          -199.0,
          -2360.0,
          825.0
        ],
        [
          -199.0,
          -2359.39990234375,
          836.0
        ],
        [
          -199.0,
          -2360.0,
          836.0
        ],
        [
          -199.0,
          -2359.39990234375,
          825.0
        ]
      ],
      "plane_distance": 825.0,
      "authentic_texture": "chkptdoor1"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 9407,
      "centroid": [
        -90.0,
        -2170.0,
        648.0
      ],
      "bbox_min": [
        -95.0,
        -2170.0,
        646.0
      ],
      "bbox_max": [
        -85.0,
        -2170.0,
        650.0
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 0.0,
        "height_z": 4.0,
        "door_width": 10.0,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -95.0,
          -2170.0,
          646.0
        ],
        [
          -85.0,
          -2170.0,
          650.0
        ],
        [
          -85.0,
          -2170.0,
          646.0
        ],
        [
          -95.0,
          -2170.0,
          650.0
        ]
      ],
      "plane_distance": -2170.0,
      "authentic_texture": "chkptroofgrate1-t"
    },
    {
      "tag": "CSlidingDoor piece: screen",
      "entity_class": "CSlidingDoor",
      "piece_name": "screen",
      "offset": 11477,
      "centroid": [
        -155.20994567871094,
        -2351.0001220703125,
        643.1000061035156
      ],
      "bbox_min": [
        -155.20994567871094,
        -2351.800048828125,
        642.2999877929688
      ],
      "bbox_max": [
        -155.20994567871094,
        -2350.2001953125,
        643.9000244140625
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 1.599853515625,
        "height_z": 1.60003662109375,
        "door_width": 1.599853515625,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          -0.0
        ]
      },
      "vertices": [
        [
          -155.20994567871094,
          -2350.2001953125,
          642.2999877929688
        ],
        [
          -155.20994567871094,
          -2350.2001953125,
          643.9000244140625
        ],
        [
          -155.20994567871094,
          -2351.800048828125,
          642.2999877929688
        ],
        [
          -155.20994567871094,
          -2351.800048828125,
          643.9000244140625
        ]
      ],
      "plane_distance": -155.2099
    }
  ],
  "tutorial_messages": []
}